webpackJsonp([127651196306611],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(67));
	__export(__webpack_require__(68));
	__export(__webpack_require__(200));
	__export(__webpack_require__(201));
	__export(__webpack_require__(33));
	__export(__webpack_require__(202));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(227);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuGlobal_1 = __webpack_require__(28);
	exports.GLOBAL_LISTENER_KEY = '*';
	exports.GENERIC_EVENT_KEY = 'event';
	var upperCaseFirstLetter = function (str) {
	    return str.charAt(0).toUpperCase() + str.slice(1);
	};
	var camelize = function (str) {
	    return str.replace(/\W+/g, ' ').replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
	        return (index === 0) ? letter.toLowerCase() : letter.toUpperCase();
	    }).replace(/\s+/g, '');
	};
	var upsertInstanceRegistry = function (className) {
	    if (!HaikuGlobal_1.default.models[className]) {
	        HaikuGlobal_1.default.models[className] = [];
	    }
	    return HaikuGlobal_1.default.models[className];
	};
	var getInstanceRegistry = function (instance) {
	    var className = instance.getClassName();
	    return upsertInstanceRegistry(className);
	};
	var addInstanceToGlobalModelRegistry = function (instance) {
	    getInstanceRegistry(instance).push(instance);
	    return ++HaikuGlobal_1.default.idCounter;
	};
	var removeInstanceFromGlobalModelRegistry = function (instance) {
	    var registry = getInstanceRegistry(instance);
	    for (var i = 0; i < registry.length; i++) {
	        if (registry[i] === instance) {
	            registry.splice(i, 1);
	            return;
	        }
	    }
	};
	var HaikuBase = /** @class */ (function () {
	    function HaikuBase() {
	        this.cache = {};
	        this.$id = addInstanceToGlobalModelRegistry(this);
	        this.listeners = {};
	    }
	    HaikuBase.prototype.getId = function () {
	        return this.$id;
	    };
	    HaikuBase.prototype.getPrimaryKey = function () {
	        return this.getClassName() + ":" + this.getId();
	    };
	    HaikuBase.prototype.getClassName = function () {
	        return this.constructor.__name__;
	    };
	    HaikuBase.prototype.cacheSet = function (key, value) {
	        this.cache[key] = value;
	    };
	    HaikuBase.prototype.cacheGet = function (key) {
	        return this.cache[key];
	    };
	    HaikuBase.prototype.cacheFetch = function (key, provider) {
	        var valueExisting = this.cacheGet(key);
	        if (valueExisting !== undefined) {
	            return valueExisting;
	        }
	        var valueProvided = provider();
	        this.cacheSet(key, valueProvided);
	        return valueProvided;
	    };
	    HaikuBase.prototype.cacheUnset = function (key) {
	        this.cache[key] = undefined;
	    };
	    HaikuBase.prototype.cacheClear = function () {
	        this.cache = {};
	    };
	    HaikuBase.prototype.subcacheGet = function (key) {
	        return this.cacheGet(key);
	    };
	    HaikuBase.prototype.subcacheEnsure = function (key) {
	        if (!this.cacheGet(key)) {
	            this.cacheSet(key, {});
	        }
	    };
	    HaikuBase.prototype.subcacheClear = function (key) {
	        this.cacheSet(key, {});
	    };
	    HaikuBase.prototype.on = function (key, listener) {
	        if (!this.listeners[key]) {
	            this.listeners[key] = [];
	        }
	        this.listeners[key].push(listener);
	    };
	    HaikuBase.prototype.addEventListener = function (key, listener) {
	        this.on(key, listener);
	    };
	    HaikuBase.prototype.off = function (key, listener) {
	        if (!this.listeners[key]) {
	            return;
	        }
	        for (var i = this.listeners[key].length - 1; i >= 0; i--) {
	            if (this.listeners[key][i] === listener) {
	                this.listeners[key].splice(i, 1);
	            }
	        }
	    };
	    HaikuBase.prototype.removeEventListener = function (key, listener) {
	        this.off(key, listener);
	    };
	    HaikuBase.prototype.removeListener = function (key, listener) {
	        this.off(key, listener);
	    };
	    HaikuBase.prototype.emitToListeners = function (key, args) {
	        if (this.listeners[key]) {
	            for (var i = 0; i < this.listeners[key].length; i++) {
	                this.listeners[key][i].apply(null, args);
	            }
	        }
	    };
	    HaikuBase.prototype.emitToGenericListeners = function (key, args) {
	        if (this.listeners[exports.GLOBAL_LISTENER_KEY]) {
	            for (var i = 0; i < this.listeners[exports.GLOBAL_LISTENER_KEY].length; i++) {
	                this.listeners[exports.GLOBAL_LISTENER_KEY][i].apply(null, [key].concat(args));
	            }
	        }
	    };
	    HaikuBase.prototype.emitToAncestors = function (key) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        return; // no-op; Implemented by subclass
	    };
	    HaikuBase.prototype.emit = function (key) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        // Specific direct listeners (this.on('foo:bar'))
	        this.emitToListeners(key, args);
	        // Specific config object listeners (`onHaikuEventFooBar`)
	        this.emitToConfigHandlers(key, args);
	        // Generic direct listeners (this.on('*'))
	        this.emitToGenericListeners(key, args);
	        // Emit up the chain
	        this.emitToAncestors.apply(this, [key].concat(args));
	        var allArgs = [key].concat(args);
	        // Generic config object listeners ('event', 'onEvent', 'onHaikuEvent')
	        // for when the subscription name isn't known in advance, e.g. custom events
	        this.emitToConfigHandlers(exports.GENERIC_EVENT_KEY, allArgs);
	    };
	    HaikuBase.prototype.emitToConfigHandlers = function (key, args) {
	        if (!this.config) {
	            return;
	        }
	        // 'somebody:Did-Thing' -> 'somebodyDidThing'
	        var keyCamelCase = upperCaseFirstLetter(camelize(key));
	        // 'somebodyDidThing' -> 'onSomebodyDidThing'
	        var keyCamelCaseWithOnPrefix = "on" + keyCamelCase;
	        if (typeof this.config[keyCamelCaseWithOnPrefix] === 'function') {
	            this.config[keyCamelCaseWithOnPrefix].apply(null, args);
	        }
	        // 'somebodyDidThing' -> 'onHaikuSomebodyDidThing' (legacy)
	        var keyCamelCaseWithOnHaikuPrefix = "onHaiku" + keyCamelCase;
	        if (typeof this.config[keyCamelCaseWithOnHaikuPrefix] === 'function') {
	            this.config[keyCamelCaseWithOnHaikuPrefix].apply(null, args);
	        }
	    };
	    HaikuBase.prototype.matchesCriteria = function (criteria) {
	        if (!criteria) {
	            return false;
	        }
	        var answer = true;
	        for (var key in criteria) {
	            if (this[key] !== criteria[key]) {
	                answer = false;
	            }
	        }
	        return answer;
	    };
	    HaikuBase.prototype.destroy = function () {
	        removeInstanceFromGlobalModelRegistry(this);
	    };
	    HaikuBase.getRegistryForClass = function (klass) {
	        return upsertInstanceRegistry(klass.__name__);
	    };
	    return HaikuBase;
	}());
	exports.default = HaikuBase;
	//# sourceMappingURL=HaikuBase.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ELEMENTS_2D = {
	    circle: true,
	    ellipse: true,
	    foreignObject: true,
	    g: true,
	    image: true,
	    line: true,
	    mesh: true,
	    path: true,
	    polygon: true,
	    polyline: true,
	    rect: true,
	    // svg: true, // Since we host <svg> only underneath <div> it should be fine to set this?
	    switch: true,
	    symbol: true,
	    text: true,
	    textPath: true,
	    tspan: true,
	    unknown: true,
	    use: true,
	};
	exports.AUTO_SIZING_TOKEN = 'auto';
	// Coordinate (0, 0, 0) is the top left of the screen
	exports.SIZE_PROPORTIONAL = 0; // A percentage of the parent
	exports.SIZE_ABSOLUTE = 1; // A fixed size in screen pixels
	var IDENTITY = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	// Used for rendering downstream
	var FORMATS = {
	    THREE: 3,
	    TWO: 2,
	};
	var DIV = 'div';
	var SVG = 'svg';
	var TYPE_STRING = 'string';
	var virtualElementIsLayoutContainer = function (virtualElement) {
	    // A virtual element is a layout container if the element is a component…
	    return typeof virtualElement.elementName !== TYPE_STRING ||
	        // …or if it is a layout container defining its own coordinate system.
	        virtualElement.elementName === SVG ||
	        virtualElement.elementName === DIV;
	};
	var initializeNodeAttributes = function (node, isRootNode) {
	    if (!node || typeof node !== 'object') {
	        return;
	    }
	    if (!node.attributes) {
	        node.attributes = {};
	    }
	    if (!node.attributes.style) {
	        node.attributes.style = {};
	    }
	    node.isRootNode = isRootNode;
	    return node;
	};
	var initializeNodeLayout = function (node) {
	    node.layout = createLayoutSpec(!node.isRootNode && virtualElementIsLayoutContainer(node));
	    node.layout.matrix = createMatrix();
	    node.layout.format = ELEMENTS_2D[node.elementName]
	        ? FORMATS.TWO
	        : FORMATS.THREE;
	};
	var createMatrix = function () { return copyMatrix(IDENTITY); };
	var copyMatrix = function (m) { return m.slice(); };
	var multiplyMatrices = function (a, b) { return [
	    a[0] * b[0] + a[1] * b[4] + a[2] * b[8] + a[3] * b[12],
	    a[0] * b[1] + a[1] * b[5] + a[2] * b[9] + a[3] * b[13],
	    a[0] * b[2] + a[1] * b[6] + a[2] * b[10] + a[3] * b[14],
	    a[0] * b[3] + a[1] * b[7] + a[2] * b[11] + a[3] * b[15],
	    a[4] * b[0] + a[5] * b[4] + a[6] * b[8] + a[7] * b[12],
	    a[4] * b[1] + a[5] * b[5] + a[6] * b[9] + a[7] * b[13],
	    a[4] * b[2] + a[5] * b[6] + a[6] * b[10] + a[7] * b[14],
	    a[4] * b[3] + a[5] * b[7] + a[6] * b[11] + a[7] * b[15],
	    a[8] * b[0] + a[9] * b[4] + a[10] * b[8] + a[11] * b[12],
	    a[8] * b[1] + a[9] * b[5] + a[10] * b[9] + a[11] * b[13],
	    a[8] * b[2] + a[9] * b[6] + a[10] * b[10] + a[11] * b[14],
	    a[8] * b[3] + a[9] * b[7] + a[10] * b[11] + a[11] * b[15],
	    a[12] * b[0] + a[13] * b[4] + a[14] * b[8] + a[15] * b[12],
	    a[12] * b[1] + a[13] * b[5] + a[14] * b[9] + a[15] * b[13],
	    a[12] * b[2] + a[13] * b[6] + a[14] * b[10] + a[15] * b[14],
	    a[12] * b[3] + a[13] * b[7] + a[14] * b[11] + a[15] * b[15],
	]; };
	var multiplyArrayOfMatrices = function (arrayOfMatrices) {
	    var product = createMatrix();
	    for (var i = 0; i < arrayOfMatrices.length; i++) {
	        product = multiplyMatrices(product, arrayOfMatrices[i]);
	    }
	    return product;
	};
	var computeOrthonormalBasisMatrix = function (rotation, shear) {
	    var orthonormalBasisLayout = __assign({}, createLayoutSpec(), { rotation: rotation,
	        shear: shear });
	    var ignoredSize = { x: 0, y: 0, z: 0 };
	    return computeMatrix(orthonormalBasisLayout, ignoredSize);
	};
	var computeScaledBasisMatrix = function (rotation, scale, shear) {
	    var scaledBasisLayout = __assign({}, createLayoutSpec(), { rotation: rotation,
	        scale: scale,
	        shear: shear });
	    var ignoredSize = { x: 0, y: 0, z: 0 };
	    return computeMatrix(scaledBasisLayout, ignoredSize);
	};
	var clone = function (layout) {
	    if (!layout) {
	        return layout;
	    }
	    var out = {
	        shown: layout.shown,
	        opacity: layout.opacity,
	        mount: Object.assign({}, layout.mount),
	        offset: Object.assign({}, layout.offset),
	        origin: Object.assign({}, layout.origin),
	        translation: Object.assign({}, layout.translation),
	        rotation: Object.assign({}, layout.rotation),
	        scale: Object.assign({}, layout.scale),
	        shear: Object.assign({}, layout.shear),
	        sizeMode: Object.assign({}, layout.sizeMode),
	        sizeProportional: Object.assign({}, layout.sizeProportional),
	        sizeDifferential: Object.assign({}, layout.sizeDifferential),
	        sizeAbsolute: Object.assign({}, layout.sizeAbsolute),
	        size: null,
	        matrix: null,
	        computed: null,
	    };
	    if (layout.computed) {
	        out.computed = clone(layout.computed);
	    }
	    // Handle either a raw layout (no size or matrix) or a computed one (has size and matrix)
	    if (layout.matrix) {
	        out.matrix = layout.matrix.map(function (n) { return n; });
	    }
	    if (layout.size) {
	        out.size = Object.assign({}, layout.size);
	    }
	    return out;
	};
	/**
	 * The code below includes modified code from https://github.com/famous/engine
	 *
	 * The original code was released under the MIT license.
	 *
	 * MIT License (MIT)
	 *
	 * Copyright (c) 2015 Famous Industries Inc.
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 */
	var createLayoutSpec = function (createCoordinateSystem) { return ({
	    shown: true,
	    opacity: 1.0,
	    offset: { x: 0, y: 0, z: 0 },
	    origin: createCoordinateSystem ? { x: 0.5, y: 0.5, z: 0.5 } : { x: 0, y: 0, z: 0 },
	    translation: { x: 0, y: 0, z: 0 },
	    rotation: { x: 0, y: 0, z: 0 },
	    scale: { x: 1, y: 1, z: 1 },
	    shear: { xy: 0, xz: 0, yz: 0 },
	    sizeMode: {
	        x: exports.SIZE_PROPORTIONAL,
	        y: exports.SIZE_PROPORTIONAL,
	        z: exports.SIZE_PROPORTIONAL,
	    },
	    sizeProportional: { x: 1, y: 1, z: 1 },
	    sizeDifferential: { x: 0, y: 0, z: 0 },
	    sizeAbsolute: { x: 0, y: 0, z: 0 },
	}); };
	var computeMatrix = function (layoutSpec, targetSize) {
	    var originX = layoutSpec.origin.x * targetSize.x;
	    var originY = layoutSpec.origin.y * targetSize.y;
	    var originZ = layoutSpec.origin.z * targetSize.z;
	    // We represent the matrix in column-major order, a convention in graphics programming.
	    var m = createMatrix();
	    // Only if necessary, apply rotation from Euler angles in order: Z then Y then X.
	    if (layoutSpec.rotation.x || layoutSpec.rotation.y || layoutSpec.rotation.z) {
	        var sx = Math.sin(layoutSpec.rotation.x);
	        var sy = Math.sin(layoutSpec.rotation.y);
	        var sz = Math.sin(layoutSpec.rotation.z);
	        var cx = Math.cos(layoutSpec.rotation.x);
	        var cy = Math.cos(layoutSpec.rotation.y);
	        var cz = Math.cos(layoutSpec.rotation.z);
	        var cxcz = cx * cz;
	        var cxsz = cx * sz;
	        var sxcz = sx * cz;
	        var sxsz = sx * sz;
	        m[0] = cy * cz;
	        m[4] = sy * sxcz - cxsz;
	        m[8] = sy * cxcz + sxsz;
	        m[1] = cy * sz;
	        m[5] = sy * sxsz + cxcz;
	        m[9] = sy * cxsz - sxcz;
	        m[2] = -sy;
	        m[6] = cy * sx;
	        m[10] = cy * cx;
	    }
	    // Only if necessary, apply shear.
	    if (layoutSpec.shear.xy || layoutSpec.shear.xz || layoutSpec.shear.yz) {
	        var shearXzProxy = layoutSpec.shear.xy * layoutSpec.shear.yz + layoutSpec.shear.xz;
	        m[8] += layoutSpec.shear.yz * m[4] + shearXzProxy * m[0];
	        m[9] += layoutSpec.shear.yz * m[5] + shearXzProxy * m[1];
	        m[10] += layoutSpec.shear.yz * m[6] + shearXzProxy * m[2];
	        m[4] += layoutSpec.shear.xy * m[0];
	        m[5] += layoutSpec.shear.xy * m[1];
	        m[6] += layoutSpec.shear.xy * m[2];
	    }
	    // Multiply nontrivial scale through.
	    if (layoutSpec.scale.x !== 1) {
	        m[0] *= layoutSpec.scale.x;
	        m[1] *= layoutSpec.scale.x;
	        m[2] *= layoutSpec.scale.x;
	    }
	    if (layoutSpec.scale.y !== 1) {
	        m[4] *= layoutSpec.scale.y;
	        m[5] *= layoutSpec.scale.y;
	        m[6] *= layoutSpec.scale.y;
	    }
	    if (layoutSpec.scale.z !== 1) {
	        m[8] *= layoutSpec.scale.z;
	        m[9] *= layoutSpec.scale.z;
	        m[10] *= layoutSpec.scale.z;
	    }
	    m[12] =
	        layoutSpec.offset.x +
	            layoutSpec.translation.x -
	            (m[0] * originX + m[4] * originY + m[8] * originZ);
	    m[13] =
	        layoutSpec.offset.y +
	            layoutSpec.translation.y -
	            (m[1] * originX + m[5] * originY + m[9] * originZ);
	    m[14] =
	        layoutSpec.offset.z +
	            layoutSpec.translation.z -
	            (m[2] * originX + m[6] * originY + m[10] * originZ);
	    return m;
	};
	exports.default = {
	    multiplyArrayOfMatrices: multiplyArrayOfMatrices,
	    clone: clone,
	    computeMatrix: computeMatrix,
	    computeOrthonormalBasisMatrix: computeOrthonormalBasisMatrix,
	    computeScaledBasisMatrix: computeScaledBasisMatrix,
	    createLayoutSpec: createLayoutSpec,
	    createMatrix: createMatrix,
	    copyMatrix: copyMatrix,
	    initializeNodeAttributes: initializeNodeAttributes,
	    initializeNodeLayout: initializeNodeLayout,
	    virtualElementIsLayoutContainer: virtualElementIsLayoutContainer,
	    FORMATS: FORMATS,
	    SIZE_ABSOLUTE: exports.SIZE_ABSOLUTE,
	    SIZE_PROPORTIONAL: exports.SIZE_PROPORTIONAL,
	};
	//# sourceMappingURL=Layout3D.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	
	module.exports = __webpack_require__(28).default;


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

	module.exports = {"name":"@haiku/core","version":"4.3.10","description":"Haiku Core is a JavaScript library for building user interfaces","homepage":"https://haiku.ai","directories":{"lib":"lib","dom":"dom","components":"components","dist":"dist"},"keywords":["animation","motion","component","web","browser","svg","rendering","engine"],"repository":"https://github.com/HaikuTeam/core","main":"index.js","scripts":{"lint":"tslint --exclude 'src/vendor/**' -p tsconfig.all.json -t stylish","lint-report":"yarn lint -t checkstyle -o checkstyle-result.xml","fix":"yarn lint --fix","ts":"cross-env NODE_ENV=test ts-node -r tsconfig-paths/register -P tsconfig.all.json","test":"yarn ts ./node_modules/.bin/tape 'test/**/*.test.ts' | tap-spec","test-report":"nyc yarn ts ./node_modules/.bin/tape 'test/**/*.test.ts' > test-result.tap","compile":"tsc","develop":"tsc --watch","bundle":"yarn compile && yarn ts ./scripts/bundle.ts","demos":"yarn ts ./scripts/demos.ts"},"authors":["Matthew Trost <matthew@haiku.ai>","Zack Brown <zack@haiku.ai>","Taylor Poe <taylor@haiku.ai>","Sasha Joseph <sasha@haiku.ai>"],"license":"MIT","devDependencies":{"@angular/core":"^6.0.9","async":"^2.5.0","chokidar":"^1.7.0","depcheck":"^0.6.7","express":"4.14.1","filesize":"3.5.10","fs-extra":"^4.0.2","haiku-testing":"4.3.10","cross-env":"^5.1.6","istanbul-reporter-cobertura-haiku":"^1.0.2","nyc":"^13.0.1","tap-spec":"^4.1.2","tape":"^4.9.0","ts-node":"^6.1.0","tsconfig-paths":"^3.3.2","tslint":"^5.11.0","tslint-config-haiku":"^1.0.16","typescript":"^3.0.3","handlebars":"^4.0.8","jsdom":"^11.1.0","leaked-handles":"^5.2.0","nodemon":"1.11.0","opn":"^5.3.0","react":"^16.0.0","react-dom":"^16.0.0","react-router-dom":"^4.1.1","rollup":"^0.53.3","rollup-plugin-commonjs":"^8.2.6","rollup-plugin-json":"^2.3.0","rollup-plugin-node-resolve":"^3.0.0","rollup-plugin-uglify-es":"^0.0.1","ts-loader":"^4.4.2","tslint-no-circular-imports":"^0.5.0","webpack":"^4.16.0","webpack-cli":"^3.0.8"},"peerDependencies":{"@angular/core":"^6.0.9","react":"^16.0.0 || ^15.4.2","react-dom":"^16.0.0 || ^15.4.2"}}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(311),
	    getValue = __webpack_require__(335);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) 2017 Ryan Florence
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function assign() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var t = args[0];
	    for (var s = void 0, i = 1, n = args.length; i < n; i++) {
	        s = args[i];
	        for (var p in s) {
	            if (Object.prototype.hasOwnProperty.call(s, p)) {
	                t[p] = s[p];
	            }
	        }
	    }
	    return t;
	}
	exports.default = assign;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var interactionModes_1 = __webpack_require__(61);
	exports.DEFAULTS = {
	    alwaysComputeSizing: false,
	    automount: true,
	    autoplay: true,
	    children: null,
	    clock: {},
	    contextMenu: 'enabled',
	    eventHandlers: null,
	    folder: null,
	    forceFlush: false,
	    frame: null,
	    freeze: false,
	    helpers: null,
	    hooks: null,
	    interactionMode: interactionModes_1.InteractionMode.LIVE,
	    loop: false,
	    mixpanel: '6f31d4f99cf71024ce27c3e404a79a61',
	    overflow: null,
	    overflowX: null,
	    overflowY: null,
	    placeholder: null,
	    position: 'relative',
	    preserve3d: 'auto',
	    seed: null,
	    sizing: null,
	    states: null,
	    timelines: null,
	    timestamp: null,
	    vanities: null,
	};
	/**
	 * Configuration from HaikuContext is forwarded to all HaikuComponent instances in its tree.
	 * For child instances, certain settings (such as `loop`) give unexpected behavior and
	 * other settings (such as `states`) don't make much sense to pass down. This specifies the
	 * settings that are considered safe to forward from the context to all subcomponents.
	 */
	var CHILD_SAFE_CONFIG = {
	    alwaysComputeSizing: true,
	    clock: true,
	    contextMenu: true,
	    folder: true,
	    freeze: true,
	    interactionMode: true,
	    mixpanel: true,
	    overflow: true,
	    overflowX: true,
	    overflowY: true,
	    preserve3d: true,
	    seed: true,
	    sizing: true,
	    timestamp: true,
	};
	var buildChildSafeConfig = function (config) {
	    var out = {};
	    for (var key in config) {
	        if (CHILD_SAFE_CONFIG[key]) {
	            out[key] = config[key];
	        }
	    }
	    return out;
	};
	function seed() {
	    return Math.random().toString(36).slice(2);
	}
	var CONFIG_KEYS_TO_MERGE = {
	    states: true,
	    eventHandlers: true,
	    timelines: true,
	    helpers: true,
	    vanities: true,
	    initialStates: true,
	};
	function build() {
	    var argums = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        argums[_i] = arguments[_i];
	    }
	    var config = {};
	    var args = argums.slice();
	    args.unshift(exports.DEFAULTS);
	    args.forEach(function (incoming) {
	        if (!incoming || typeof incoming !== 'object') {
	            return;
	        }
	        for (var key in incoming) {
	            if (incoming[key] === undefined) {
	                continue;
	            }
	            if (CONFIG_KEYS_TO_MERGE[key]) {
	                if (!config[key]) {
	                    config[key] = {};
	                }
	                config[key] = __assign({}, config[key], incoming[key]);
	            }
	            else {
	                config[key] = incoming[key];
	            }
	        }
	    });
	    // Validations
	    if (config.overflow && (config.overflowX || config.overflowY)) {
	        console.warn('[haiku core] `overflow` overrides `overflowY`/`overflowX`');
	        config.overflowX = null;
	        config.overflowY = null;
	    }
	    return config;
	}
	exports.default = {
	    build: build,
	    seed: seed,
	    DEFAULTS: exports.DEFAULTS,
	    buildChildSafeConfig: buildChildSafeConfig,
	};
	//# sourceMappingURL=Config.js.map

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var enhance_1 = __webpack_require__(30);
	var inject_1 = __webpack_require__(64);
	var VERSION = __webpack_require__(18).version;
	function buildRoot() {
	    // We need a global harness so we can...
	    // - have a single rAF loop even if we've got multiple Haiku Contexts on the same page
	    // - expose some global APIs that we hope to make available for all components
	    var ROOT = {};
	    // Window gets highest precedence since most likely we're running in DOM
	    if (typeof window !== 'undefined') {
	        ROOT = window;
	    }
	    else if (typeof global !== 'undefined') {
	        ROOT = global;
	    }
	    else {
	        // On the off-chance there is no real global, just use the orig object
	    }
	    if (!ROOT.haiku) {
	        ROOT.haiku = {};
	    }
	    // Avoid loading entities for incompatible versions.
	    if (!ROOT.haiku[VERSION]) {
	        ROOT.haiku[VERSION] = {};
	    }
	    if (!ROOT.haiku[VERSION].models) {
	        ROOT.haiku[VERSION].models = {};
	    }
	    if (!ROOT.haiku[VERSION].idCounter) {
	        // Legacy: we start the ID counter at 1000 to avoid edge case ID collisions when there are copies of Haiku
	        // sitting on the same page.
	        ROOT.haiku[VERSION].idCounter = 1000;
	    }
	    if (!ROOT.haiku[VERSION].enhance) {
	        /**
	         * @function enhance
	         * @description Given a function, decorate it with a .specification property that
	         * contains a descriptor of the serialized form of the function, including its params.
	         * This is used by the renderer as part of its automatic dependency injection mechanism.
	         */
	        ROOT.haiku[VERSION].enhance = enhance_1.default;
	    }
	    if (!ROOT.haiku[VERSION].inject) {
	        /**
	         * @function inject
	         * @description Variadic function that takes a function as the first argument and
	         * a collection of injection parameters as the remaining arguments, which are in turn
	         * used to 'enhance' (see above) the function, specifying the parameters it wants injected.
	         */
	        ROOT.haiku[VERSION].inject = inject_1.default;
	    }
	    return ROOT.haiku[VERSION];
	}
	var haiku = buildRoot();
	exports.default = haiku;
	//# sourceMappingURL=HaikuGlobal.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var Layout3D_1 = __webpack_require__(14);
	var array_unique_1 = __webpack_require__(158);
	var uniq = array_unique_1.default.uniq;
	var ALT_CLASS_NAME_ATTR = 'className'; // Ease of React integration
	var ATTR_EXEC_RE = /\[([a-zA-Z0-9]+)([$|^~])?(=)?"?(.+?)?"?( i)?]/;
	var ATTR_PREFIX = '[';
	var CLASS_NAME_ATTR = 'class';
	var CLASS_PREFIX = '.';
	var FUNCTION = 'function';
	var HAIKU_ID_ATTRIBUTE = 'haiku-id';
	var HAIKU_PREFIX = 'haiku:';
	var ID_PREFIX = '#';
	var PIECE_SEPARATOR = ',';
	var SPACE = ' ';
	var getFnName = function (fn) {
	    if (fn.name) {
	        return fn.name;
	    }
	    var str = fn.toString();
	    //                  | | <-- this space is always here via toString()
	    var reg = /function ([^(]*)/;
	    var ex = reg.exec(str);
	    return ex && ex[1];
	};
	exports.parseAttrSelector = function (selector) {
	    var matches = ATTR_EXEC_RE.exec(selector);
	    if (!matches) {
	        return null;
	    }
	    return {
	        key: matches[1],
	        operator: matches[3] && (matches[2] || '') + matches[3],
	        value: matches[4],
	        insensitive: !!matches[5],
	    };
	};
	exports.cssMatchByAttribute = function (node, attrKeyToMatch, attrOperator, attrValueToMatch, options) {
	    var attributes = node[options.attributes];
	    if (attributes) {
	        var attrValue = attributes[attrKeyToMatch];
	        // If no operator, do a simple presence check ([foo])
	        if (!attrOperator) {
	            return !!attrValue;
	        }
	        switch (attrOperator) {
	            case '=':
	                return attrValueToMatch === attrValue;
	            // case '~=':
	            // case '|=':
	            // case '^=':
	            // case '$=':
	            // case '*=':
	            default:
	                console.warn('Operator `' + attrOperator + '` not supported yet');
	                return false;
	        }
	    }
	};
	exports.cssMatchByClass = function (node, className, options) {
	    var attributes = node[options.attributes];
	    if (attributes) {
	        var foundClassName = attributes[CLASS_NAME_ATTR];
	        if (!foundClassName) {
	            foundClassName = attributes[ALT_CLASS_NAME_ATTR];
	        }
	        if (foundClassName) {
	            var classPieces = foundClassName.split(SPACE);
	            if (classPieces.indexOf(className) !== -1) {
	                return true;
	            }
	        }
	    }
	};
	exports.cssMatchByHaiku = function (node, haikuString, options) {
	    var attributes = node[options.attributes];
	    if (!attributes) {
	        return false;
	    }
	    if (!attributes[HAIKU_ID_ATTRIBUTE]) {
	        return false;
	    }
	    return attributes[HAIKU_ID_ATTRIBUTE] === haikuString;
	};
	exports.cssMatchById = function (node, id, options) {
	    var attributes = node[options.attributes];
	    if (attributes) {
	        if (attributes.id === id) {
	            return true;
	        }
	    }
	};
	exports.cssMatchByTagName = function (node, tagName, options) {
	    var val = node[options.name];
	    if (val) {
	        if (typeof val === 'string' && val === tagName) {
	            return true;
	        }
	        if (typeof val === FUNCTION) {
	            // Allow function constructors to act as the tag name
	            if (getFnName(val) === tagName) {
	                return true;
	            }
	        }
	        if (typeof val === 'object') {
	            // Allow for things like instances to act as the tag name
	            if (val.name === tagName || val.tagName === tagName) {
	                return true;
	            }
	        }
	    }
	};
	exports.cssMatchOne = function (node, piece, options) {
	    if (piece.slice(0, 6) === HAIKU_PREFIX) {
	        return exports.cssMatchByHaiku(node, piece.slice(6), options);
	    }
	    if (piece[0] === ID_PREFIX) {
	        return exports.cssMatchById(node, piece.slice(1, piece.length), options);
	    }
	    if (piece[0] === CLASS_PREFIX) {
	        return exports.cssMatchByClass(node, piece.slice(1, piece.length), options);
	    }
	    if (piece[0] === ATTR_PREFIX) {
	        var parsedAttr = exports.parseAttrSelector(piece);
	        if (!parsedAttr) {
	            return false;
	        }
	        return exports.cssMatchByAttribute(node, parsedAttr.key, parsedAttr.operator, parsedAttr.value, options);
	    }
	    return exports.cssMatchByTagName(node, piece, options);
	};
	exports.cssQueryList = function (list, query, options) {
	    var matches = [];
	    var pieces = query.split(PIECE_SEPARATOR);
	    for (var i = 0; i < pieces.length; i++) {
	        var piece = pieces[i].trim();
	        for (var j = 0; j < list.length; j++) {
	            var node = list[j];
	            if (exports.cssMatchOne(node, piece, options)) {
	                matches.push(node);
	            }
	        }
	    }
	    return matches;
	};
	exports.cssQueryTree = function (node, query, options) {
	    if (!node || typeof node !== 'object') {
	        return [];
	    }
	    return exports.cssQueryList(exports.manaFlattenTree(node, options), query, options);
	};
	exports.manaFlattenTree = function (node, options, unique, list, depth, index) {
	    if (unique === void 0) { unique = true; }
	    if (list === void 0) { list = []; }
	    if (depth === void 0) { depth = 0; }
	    if (index === void 0) { index = 0; }
	    list.push(node);
	    // Don't recurse down into the children of nested components, which should be 'invisible' to us.
	    // Nested components are indicated when their name is not a string, e.g. a component descriptor.
	    if (depth < 1 || typeof node[options.name] === 'string') {
	        var children = node[options.children];
	        if (!children || typeof children === 'string') {
	            return list;
	        }
	        if (Array.isArray(children)) {
	            var copies = children.slice(0);
	            // Without this, we'll have an infinite loop since the source child appears in both the
	            // original children and the snapshotted children arrays.
	            uniq(copies);
	            for (var i = 0; i < copies.length; i++) {
	                exports.manaFlattenTree(copies[i], options, false, list, depth + 1, i);
	            }
	        }
	        else if (typeof children === 'object') {
	            list.push(children);
	            return list;
	        }
	    }
	    return unique ? uniq(list) : list;
	};
	exports.visitManaTree = function (locator, mana, visitor, parent, index) {
	    if (!mana || typeof mana === 'string') {
	        return null;
	    }
	    visitor(mana.elementName, mana.attributes, mana.children, mana, locator, parent, index);
	    if (!mana.children) {
	        return null;
	    }
	    for (var i = 0; i < mana.children.length; i++) {
	        var child = mana.children[i];
	        exports.visitManaTree(locator + '.' + i, child, visitor, mana, i);
	    }
	};
	exports.visit = function (mana, visitor, parent) {
	    if (!mana || typeof mana !== 'object') {
	        return;
	    }
	    visitor(mana, parent);
	    var children = ((mana.__memory && mana.__memory.children) || mana.children);
	    if (children) {
	        for (var i = 0; i < children.length; i++) {
	            var child = children[i];
	            if (child && child.__memory && child.__memory.instance) {
	                continue;
	            }
	            exports.visit(child, visitor, mana);
	        }
	    }
	};
	exports.ascend = function (mana, ascender) {
	    if (!mana || typeof mana !== 'object') {
	        return;
	    }
	    ascender(mana);
	    if (mana.__memory) {
	        // Don't ascend beyond the scope of the host component instance
	        if (!mana.__memory.instance && mana.__memory.parent) {
	            exports.ascend(mana.__memory.parent, ascender);
	        }
	    }
	};
	exports.cloneNodeShallow = function (node) {
	    if (!node) {
	        return node;
	    }
	    return __assign({}, node, { attributes: exports.cloneAttributes(node.attributes), layout: Layout3D_1.default.clone(node.layout) });
	};
	exports.cloneAttributes = function (attributes) {
	    if (!attributes) {
	        return attributes;
	    }
	    var out = __assign({}, attributes);
	    if (attributes.style) {
	        out.style = Object.assign({}, attributes.style);
	    }
	    return out;
	};
	//# sourceMappingURL=HaikuNode.js.map

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var functionToRFO_1 = __webpack_require__(31);
	function enhance(fn, params) {
	    // Only create a specification if we don't already have one
	    if (!fn.specification) {
	        var rfo = functionToRFO_1.default(fn);
	        if (rfo && rfo.__function) {
	            // Cache this so we don't expensively parse each time
	            fn.specification = rfo.__function;
	            // Allow an explicit list of params to override ours
	            if (params) {
	                fn.specification.params = params;
	            }
	        }
	        else {
	            // Signal that this function is of an unknown kind
	            // so future runs don't try to parse this one again
	            fn.specification = true;
	        }
	    }
	}
	exports.default = enhance;
	//# sourceMappingURL=enhance.js.map

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Tokenizer_1 = __webpack_require__(63);
	function nth(n, type, arr) {
	    var none = { value: null, type: 'void' };
	    if (arr.length < 1 || n > arr.length) {
	        return none;
	    }
	    var f = 0;
	    for (var i = 0; i < arr.length; i++) {
	        if (arr[i].type === type) {
	            f += 1;
	        }
	        if (f === n) {
	            return arr[i];
	        }
	    }
	    return none;
	}
	function tokensToParams(tokens) {
	    if (tokens.length < 1) {
	        return [];
	    }
	    // HACK: Rather than property ast-ize this, we're just going to go through it linearly and make JSON.
	    var json = '';
	    var frag = '';
	    var next;
	    var token = tokens.shift();
	    var scopes = [];
	    while (token) {
	        switch (token.type) {
	            case 'whitespace':
	                frag = ' ';
	                break;
	            case 'comma':
	                frag = ',';
	                break;
	            case 'colon':
	                frag = ':';
	                break;
	            // Treat parens as an 'array' scope, e.g. at top level of function signature arguments
	            case 'paren_open':
	                frag = '[';
	                scopes.push('square');
	                break;
	            case 'paren_close':
	                frag = ']';
	                scopes.pop();
	                break;
	            case 'square_open':
	                frag = '[';
	                scopes.push('square');
	                break;
	            case 'square_close':
	                frag = ']';
	                scopes.pop();
	                break;
	            case 'curly_open':
	                frag = '{';
	                scopes.push('curly');
	                break;
	            case 'curly_close':
	                frag = '}';
	                scopes.pop();
	                break;
	            case 'rest':
	                next = tokens.shift();
	                frag = JSON.stringify({ __rest: next.value });
	                break;
	            case 'identifier':
	                frag = '"' + token.value + '"';
	                // If the next token is a comma, we are a self-referential property
	                if (tokens[0] &&
	                    (tokens[0].type === 'comma' ||
	                        tokens[0].type === 'square_close' ||
	                        tokens[0].type === 'curly_close')) {
	                    // Handle differently inside array vs object, e.g.:
	                    // { a: a, b: b } vs [ a, b, c ]
	                    var scope = scopes[scopes.length - 1];
	                    if (scope === 'square') {
	                        frag += '';
	                    }
	                    else {
	                        frag += ':"' + token.value + '"';
	                    }
	                }
	                break;
	            default:
	                frag = '';
	        }
	        json += frag;
	        token = tokens.shift();
	    }
	    return JSON.parse(json);
	}
	function signatureToParams(signature) {
	    var tokens = Tokenizer_1.tokenizeParameters(signature);
	    var clean = [];
	    for (var i = 0; i < tokens.length; i++) {
	        if (tokens[i].type !== 'whitespace') {
	            clean.push(tokens[i]);
	        }
	    }
	    try {
	        return tokensToParams(clean);
	    }
	    catch (exception) {
	        console.warn("Unable to parse signature " + signature, exception);
	        return [];
	    }
	}
	function functionToRFO(fn) {
	    var str = fn.toString();
	    // HACK: Remove paren wrapping if any was provided
	    if (str[str.length - 1] === ')') {
	        if (str[0] === '(') {
	            str = str.slice(1);
	        }
	    }
	    var pidx1 = str.indexOf('(');
	    var pidx2 = str.indexOf(')');
	    var prefix = str.slice(0, pidx1);
	    var signature = str.slice(pidx1, pidx2 + 1);
	    var suffix = str.slice(pidx2 + 1, str.length);
	    var body = suffix.slice(suffix.indexOf('{') + 1, suffix.length - 1).trim(); // Don't include braces or padding
	    var type = suffix.match(/^\s*=>\s*{/)
	        ? 'ArrowFunctionExpression'
	        : 'FunctionExpression';
	    var name = nth(2, 'identifier', Tokenizer_1.tokenizeParameters(prefix)).value;
	    var params = signatureToParams(signature);
	    var spec = {
	        type: type,
	        name: name,
	        params: params,
	        body: body,
	    };
	    // If the runtime function is labeled as an injectee, we *must* indicate as much
	    // in the specification so that serialization back to code wraps it properly
	    if (fn.injectee) {
	        spec.injectee = true;
	    }
	    return {
	        __function: spec,
	    };
	}
	exports.default = functionToRFO;
	//# sourceMappingURL=functionToRFO.js.map

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.easeOutBounce = function (x) {
	    var n1 = 7.5625;
	    var d1 = 2.75;
	    return x < 1 / d1
	        ? n1 * x * x
	        : x < 2 / d1
	            ? n1 * (x -= (1.5 / d1)) * x + .75
	            : x < 2.5 / d1
	                ? n1 * (x -= (2.25 / d1)) * x + .9375
	                : n1 * (x -= (2.625 / d1)) * x + .984375;
	};
	//# sourceMappingURL=easeOutBounce.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.abs = Math.abs;
	exports.asin = Math.asin;
	exports.floor = Math.floor;
	exports.cos = Math.cos;
	exports.pow = Math.pow;
	exports.sin = Math.sin;
	exports.sqrt = Math.sqrt;
	//# sourceMappingURL=math.js.map

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(81),
	    getRawTag = __webpack_require__(333),
	    objectToString = __webpack_require__(361);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(82),
	    baseAssignValue = __webpack_require__(224);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var EventEmitter = __webpack_require__(288);
	var supportPassiveEvent = __webpack_require__(415);
	
	module.exports = {
	    connections: {},
	    EE: new EventEmitter(),
	    enableResizeInfo: false,
	    enableScrollInfo: false,
	    listeners: {},
	    removers: [],
	    supportPassiveEvent: supportPassiveEvent
	};


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(347),
	    listCacheDelete = __webpack_require__(348),
	    listCacheGet = __webpack_require__(349),
	    listCacheHas = __webpack_require__(350),
	    listCacheSet = __webpack_require__(351);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(85);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(345);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(19);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(235),
	    isLength = __webpack_require__(236);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(221),
	    baseKeys = __webpack_require__(313),
	    isArrayLike = __webpack_require__(50);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var api_1 = __webpack_require__(58);
	var Config_1 = __webpack_require__(27);
	var HaikuBase_1 = __webpack_require__(13);
	var HaikuElement_1 = __webpack_require__(109);
	var HaikuHelpers_1 = __webpack_require__(110);
	var HaikuNode_1 = __webpack_require__(29);
	var HaikuTimeline_1 = __webpack_require__(111);
	var ColorUtils_1 = __webpack_require__(120);
	var consoleErrorOnce_1 = __webpack_require__(124);
	var interactionModes_1 = __webpack_require__(61);
	var isMutableProperty_1 = __webpack_require__(128);
	var KeyframeUtils_1 = __webpack_require__(59);
	var PathUtils_1 = __webpack_require__(121);
	var SVGPoints_1 = __webpack_require__(60);
	var Layout3D_1 = __webpack_require__(14);
	var Migration_1 = __webpack_require__(112);
	var enhance_1 = __webpack_require__(30);
	var functionToRFO_1 = __webpack_require__(31);
	var StateTransitionManager_1 = __webpack_require__(113);
	var Transitions_1 = __webpack_require__(114);
	var assign_1 = __webpack_require__(20);
	var invert_1 = __webpack_require__(161);
	var FUNCTION = 'function';
	var KEYFRAME_ZERO = 0;
	var OBJECT = 'object';
	var MAX_INT = 2147483646;
	var SCOPE_STRATA = { div: 'div', svg: 'svg' };
	var CDN_ROOT_STR = 'HAIKU|CDN|PROJECT|ROOT'.split('|').join('_'); // Split to avoid server-side munging
	// HACK: Required until DOM subtree-hydration race is fixed
	var ALWAYS_UPDATED_PROPERTIES = { 'controlFlow.placeholder': true };
	var parseD = function (value) {
	    // in case of d="" for any reason, don't try to expand this otherwise this will choke
	    // #TODO: arguably we should preprocess SVGs before things get this far; try svgo?
	    if (!value || value.length === 0) {
	        return [];
	    }
	    // Allow points to return an array for convenience, and let downstream marshal it
	    if (Array.isArray(value)) {
	        return value;
	    }
	    return SVGPoints_1.default.pathToPoints(value);
	};
	var generateD = function (value) {
	    if (typeof value === 'string') {
	        return value;
	    }
	    return SVGPoints_1.default.pointsToPath(value);
	};
	var parseColor = function (value) {
	    return ColorUtils_1.default.parseString(value);
	};
	var generateColor = function (value) {
	    return ColorUtils_1.default.generateString(value);
	};
	var parsePoints = function (value) {
	    if (Array.isArray(value)) {
	        return value;
	    }
	    return SVGPoints_1.default.polyPointsStringToPoints(value);
	};
	var generatePoints = function (value) {
	    if (typeof value === 'string') {
	        return value;
	    }
	    return SVGPoints_1.default.pointsToPolyString(value);
	};
	var isFunction = function (value) {
	    return typeof value === FUNCTION;
	};
	var INJECTABLES = {};
	var pkg = __webpack_require__(18);
	exports.VERSION = pkg.version;
	var STRING_TYPE = 'string';
	var OBJECT_TYPE = 'object';
	var HAIKU_ID_ATTRIBUTE = 'haiku-id';
	var DEFAULT_TIMELINE_NAME = 'Default';
	var CSS_QUERY_MAPPING = {
	    name: 'elementName',
	    attributes: 'attributes',
	    children: 'children',
	};
	// tslint:disable:variable-name function-name
	var HaikuComponent = /** @class */ (function (_super) {
	    __extends(HaikuComponent, _super);
	    function HaikuComponent(bytecode, context, host, config, container) {
	        var _this = _super.call(this) || this;
	        _this.parsedValueClusters = {};
	        _this.needsExpand = true;
	        _this.patches = [];
	        if (!bytecode.template) {
	            console.warn('[haiku core] adding missing template object');
	            bytecode.template = { elementName: 'div', attributes: {}, children: [] };
	        }
	        if (!bytecode.timelines) {
	            console.warn('[haiku core] adding missing timelines object');
	            bytecode.timelines = {};
	        }
	        if (!bytecode.timelines[DEFAULT_TIMELINE_NAME]) {
	            console.warn('[haiku core] adding missing default timeline');
	            bytecode.timelines[DEFAULT_TIMELINE_NAME] = {};
	        }
	        if (!context) {
	            throw new Error('Component requires a context');
	        }
	        if (!config) {
	            throw new Error('Config options required');
	        }
	        if (!config.seed) {
	            throw new Error('Seed value must be provided');
	        }
	        _this.PLAYER_VERSION = exports.VERSION; // #LEGACY
	        _this.CORE_VERSION = exports.VERSION;
	        _this.context = context;
	        _this.container = container;
	        _this.host = host;
	        _this.guests = {};
	        _this.bytecode = (config.hotEditingMode)
	            ? bytecode
	            : exports.clone(bytecode, _this); // Important because migrations mutate the bytecode
	        assertTemplate(_this.bytecode.template);
	        // Allow users to expose methods that can be called in event handlers
	        if (_this.bytecode.methods) {
	            for (var methodNameGiven in _this.bytecode.methods) {
	                if (!_this[methodNameGiven]) {
	                    _this[methodNameGiven] = _this.bytecode.methods[methodNameGiven].bind(_this);
	                }
	            }
	        }
	        _this._states = {}; // Storage for getter/setter actions in userland logic
	        _this.state = {}; // Public accessor object, e.g. this.state.foo = 1
	        // Instantiate StateTransitions. Responsible to store and execute any state transition.
	        _this.stateTransitionManager = new StateTransitionManager_1.default(_this);
	        _this.hooks = {};
	        _this.helpers = Object.assign({}, _this.bytecode.helpers, {
	            data: {},
	        });
	        // `assignConfig` calls bindStates because our incoming config, which
	        // could occur at any point during runtime, e.g. in React, may need to update internal states, etc.
	        // It also may populate hooks and helpers if passed in via configuration.
	        _this.assignConfig(config);
	        // Flag used internally to determine whether we need to re-render the full tree or can survive by just patching
	        _this.doesNeedFullFlush = false;
	        // If true, will continually flush the entire tree until explicitly set to false again
	        _this.doAlwaysFlush = false;
	        // If true, the component will assign 3D-preservation setting if one hasn't been set explicitly.
	        // If config.preserve3d is 'auto', the migration pre-phase will try to detect whether 3d is needed.
	        _this.doPreserve3d = (_this.config.preserve3d === true) ? true : false;
	        // Dictionary of event handler names to handler functions; used to efficiently manage multiple subscriptions
	        _this.registeredEventHandlers = {};
	        // The last HaikuElement in this scope to be hovered; used to help manage hover/unhover
	        _this.lastHoveredElement = null;
	        // Flag to determine whether this component should continue doing any work
	        _this.isDeactivated = false;
	        // Flag to indicate whether we are sleeping, an ephemeral condition where no rendering occurs
	        _this.isSleeping = false;
	        _this.helpers = {
	            data: {},
	        };
	        var helpers = Object.assign({}, HaikuHelpers_1.default.helpers, _this.getHelpers());
	        for (var helperName in helpers) {
	            _this.helpers[helperName] = helpers[helperName];
	        }
	        _this.helpers.now = function () {
	            if (_this.isLiveMode()) {
	                return (_this.config.timestamp || 1) + (_this.helpers.data.lastTimelineTime || 1);
	            }
	            return 1;
	        };
	        _this.helpers.rand = function () {
	            if (_this.isLiveMode()) {
	                var scopeKey = [
	                    _this.helpers.data.lastTimelineName,
	                    _this.helpers.data.lastTimelineTime,
	                    _this.helpers.data.lastPropertyName,
	                    _this.helpers.data.lastFlexId,
	                ].join('|');
	                var randKey = _this.config.seed + "@" + scopeKey;
	                var keyInt = stringToInt(randKey);
	                var outFloat = ((keyInt + 1) % MAX_INT) / MAX_INT;
	                return outFloat;
	            }
	            return 1;
	        };
	        _this.helpers.find = function (selector) {
	            return _this.querySelectorAll(selector);
	        };
	        var migrationOptions = {
	            attrsHyphToCamel: exports.ATTRS_HYPH_TO_CAMEL,
	            // During editing, we handle mutations directly in the app.
	            mutations: config.hotEditingMode ? undefined : {
	                // Random seed for adding instance uniqueness to ids at runtime.
	                referenceUniqueness: (config.hotEditingMode)
	                    ? undefined // During editing, Haiku.app pads ids unless this is undefined
	                    : Math.random().toString(36).slice(2),
	                haikuRoot: _this.getProjectRootPathWithTerminatingSlash(),
	            },
	        };
	        try {
	            Migration_1.runMigrationsPrePhase(_this, migrationOptions);
	        }
	        catch (exception) {
	            console.warn('[haiku core] caught error during migration pre-phase', exception);
	        }
	        // Ensure full tree is are properly set up and all render nodes are connected to their models
	        _this.render(__assign({}, _this.config));
	        try {
	            // If the bytecode we got happens to be in an outdated format, we automatically update it to the latest.
	            Migration_1.runMigrationsPostPhase(_this, migrationOptions, exports.VERSION);
	        }
	        catch (exception) {
	            console.warn('[haiku core] caught error during migration post-phase', exception);
	        }
	        _this.hydrateMutableTimelines();
	        if (!_this.host) {
	            _this.routeEventToHandlerAndEmit(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:did-initialize', [_this]);
	        }
	        else {
	            _this.routeEventToHandlerAndEmitWithoutBubbling(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:did-initialize', [_this]);
	        }
	        // #FIXME: some handlers may still reference `_bytecode` directly.
	        _this._bytecode = _this.bytecode;
	        return _this;
	    }
	    /**
	     * @description Track elements that are at the horizon of what we want to render, i.e., a list of
	     * virtual elements that we don't want to make any updates lower than in the tree.
	     */
	    HaikuComponent.prototype.markHorizonElement = function (virtualElement) {
	        if (virtualElement && virtualElement.attributes) {
	            virtualElement.__horizon = true;
	        }
	    };
	    /**
	     * @description Returns true/false whether this element is one that we don't want to make any
	     *  updates further down its tree.
	     */
	    HaikuComponent.prototype.isHorizonElement = function (virtualElement) {
	        if (virtualElement && virtualElement.attributes) {
	            return virtualElement.__horizon;
	        }
	        return false;
	    };
	    HaikuComponent.prototype.isLiveMode = function () {
	        return interactionModes_1.isLiveMode(this.config.interactionMode);
	    };
	    HaikuComponent.prototype.isEditMode = function () {
	        return !this.isLiveMode();
	    };
	    HaikuComponent.prototype.registerGuest = function (subcomponent) {
	        this.guests[subcomponent.getId()] = subcomponent;
	    };
	    HaikuComponent.prototype.visitGuestHierarchy = function (visitor) {
	        visitor(this, this.$id, this.host);
	        for (var $id in this.guests) {
	            this.guests[$id].visitGuestHierarchy(visitor);
	        }
	    };
	    HaikuComponent.prototype.visitGuests = function (visitor) {
	        for (var $id in this.guests) {
	            visitor(this.guests[$id], $id);
	        }
	    };
	    // If the component needs to remount itself for some reason, make sure we fire the right events
	    HaikuComponent.prototype.callRemount = function (incomingConfig, skipMarkForFullFlush) {
	        var _this = this;
	        if (skipMarkForFullFlush === void 0) { skipMarkForFullFlush = false; }
	        this.visitGuestHierarchy(function (guest) {
	            if (guest === _this) {
	                guest.routeEventToHandlerAndEmit(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:will-mount', [guest]);
	            }
	            else {
	                guest.routeEventToHandlerAndEmitWithoutBubbling(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:will-mount', [guest]);
	            }
	        });
	        // Note!: Only update config if we actually got incoming options!
	        if (incomingConfig) {
	            this.assignConfig(incomingConfig);
	        }
	        if (!skipMarkForFullFlush) {
	            this.markForFullFlush();
	            this.clearCaches(null);
	        }
	        // If autoplay is not wanted, stop the all timelines immediately after we've mounted
	        // (We have to mount first so that the component displays, but then pause it at that state.)
	        // If you don't want the component to show up at all, use options.automount=false.
	        var timelineInstances = this.getTimelines();
	        for (var timelineName in timelineInstances) {
	            var timelineInstance = timelineInstances[timelineName];
	            if (this.config.autoplay) {
	                if (timelineName === DEFAULT_TIMELINE_NAME) {
	                    // Assume we want to start the timeline from the beginning upon remount.
	                    // NOTE:
	                    // timeline.play() will normally trigger markForFullFlush because it assumes we need to render
	                    // from the get-go. However, in case of a callRemount, we might not want to do that since it can be kind of
	                    // like running the first frame twice. So we pass the option into play so it can conditionally skip the
	                    // markForFullFlush step.
	                    if (!timelineInstance.isPaused()) {
	                        timelineInstance.play({ skipMarkForFullFlush: skipMarkForFullFlush });
	                    }
	                }
	            }
	            else {
	                timelineInstance.pause();
	            }
	        }
	        this.context.contextMount();
	        this.visitGuestHierarchy(function (guest) {
	            if (guest === _this) {
	                guest.routeEventToHandlerAndEmit(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:did-mount', [guest]);
	            }
	            else {
	                guest.routeEventToHandlerAndEmitWithoutBubbling(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:did-mount', [guest]);
	            }
	        });
	    };
	    HaikuComponent.prototype.destroy = function () {
	        var _this = this;
	        _super.prototype.destroy.call(this);
	        // Destroy all timelines we host.
	        var timelineInstances = this.getTimelines();
	        for (var timelineName in timelineInstances) {
	            var timelineInstance = timelineInstances[timelineName];
	            timelineInstance.destroy();
	        }
	        this.visitGuestHierarchy(function (component) {
	            // Clean up HaikuComponent dependents.
	            // TODO: is this step necessary?
	            if (component !== _this) {
	                component.destroy();
	            }
	        });
	        this.visitDescendants(function (child) {
	            // Clean up HaikuElement dependents.
	            child.destroy();
	        });
	    };
	    HaikuComponent.prototype.callUnmount = function () {
	        var _this = this;
	        // Since we're unmounting, pause all animations to avoid unnecessary calc while detached
	        var timelineInstances = this.getTimelines();
	        for (var timelineName in timelineInstances) {
	            var timelineInstance = timelineInstances[timelineName];
	            timelineInstance.pause();
	        }
	        this.context.contextUnmount();
	        this.visitGuestHierarchy(function (guest) {
	            if (guest === _this) {
	                guest.routeEventToHandlerAndEmit(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:will-unmount', [guest]);
	            }
	            else {
	                guest.routeEventToHandlerAndEmitWithoutBubbling(HaikuBase_1.GLOBAL_LISTENER_KEY, 'component:will-unmount', [guest]);
	            }
	        });
	    };
	    HaikuComponent.prototype.assignConfig = function (incomingConfig) {
	        this.config = Config_1.default.build(this.config || {}, incomingConfig || {});
	        // Don't assign the context config if we're a guest component;
	        // assume only the top-level component should have this power
	        if (this.host) {
	            // Don't forget to update the configuration values shared by the context,
	            // but skip component assignment so we don't end up in an infinite loop
	            this.context.assignConfig(this.config, { skipComponentAssign: true });
	        }
	        var timelines = this.getTimelines();
	        for (var name_1 in timelines) {
	            var timeline = timelines[name_1];
	            timeline.assignOptions(this.config);
	        }
	        this.bindStates();
	        assign_1.default(this.hooks, this.config.hooks);
	        assign_1.default(this.helpers, this.config.helpers);
	        assign_1.default(this.bytecode.timelines, this.config.timelines);
	        return this;
	    };
	    HaikuComponent.prototype.set = function (key, value) {
	        this.callHook('state:change', { state: key, from: this.state[key], to: value });
	        this.state[key] = value;
	        return this;
	    };
	    HaikuComponent.prototype.get = function (key) {
	        return this.state[key];
	    };
	    HaikuComponent.prototype.setState = function (states, transitionParameter) {
	        // Do not set any state if invalid
	        if (!states || typeof states !== 'object') {
	            return this;
	        }
	        // Set states is delegated to stateTransitionManager
	        this.stateTransitionManager.setState(states, transitionParameter);
	        return this;
	    };
	    HaikuComponent.prototype.getStates = function () {
	        return this.state;
	    };
	    HaikuComponent.prototype.clearCaches = function (options) {
	        if (options === void 0) { options = {}; }
	        // HaikuBase implements a general-purpose caching mechanism which we also call here
	        this.cacheClear();
	        this.needsExpand = true;
	        // Don't forget to repopulate the states with originals when we clear cache
	        if (options.clearStates) {
	            this.clearStates();
	        }
	        this.hydrateMutableTimelines();
	        this.parsedValueClusters = {};
	        // Our managed timeline instances may have their own privately cached properties
	        var timelines = this.fetchTimelines();
	        for (var timelineName in timelines) {
	            timelines[timelineName].cacheClear();
	        }
	    };
	    HaikuComponent.prototype.cacheNodeWithSelectorKey = function (node) {
	        if (!node || typeof node !== 'object') {
	            return;
	        }
	        if (node.attributes && node.attributes[HAIKU_ID_ATTRIBUTE]) {
	            var selector = "haiku:" + node.attributes[HAIKU_ID_ATTRIBUTE];
	            var key = this.nodesCacheKey(selector);
	            var collection = this.cacheGet(key) || [];
	            if (collection.indexOf(node) === -1) {
	                collection.push(node);
	            }
	            this.cacheSet(key, collection);
	        }
	    };
	    HaikuComponent.prototype.clearStates = function () {
	        this._states = {};
	        this.bindStates();
	    };
	    HaikuComponent.prototype.getClock = function () {
	        return this.context.clock;
	    };
	    HaikuComponent.prototype.getTemplate = function () {
	        return this.bytecode.template;
	    };
	    HaikuComponent.prototype.getHelpers = function () {
	        return this.bytecode.helpers;
	    };
	    HaikuComponent.prototype.getTimelines = function () {
	        var _this = this;
	        return this.cacheFetch('getTimelines', function () {
	            return _this.fetchTimelines();
	        });
	    };
	    HaikuComponent.prototype.fetchTimelines = function () {
	        var names = Object.keys(this.bytecode.timelines);
	        for (var i = 0; i < names.length; i++) {
	            var name_2 = names[i];
	            if (!name_2) {
	                continue;
	            }
	            var existing = HaikuTimeline_1.default.where({
	                name: name_2,
	                component: this,
	            })[0];
	            if (!existing) {
	                HaikuTimeline_1.default.create(this, name_2, this.config);
	            }
	        }
	        var out = {};
	        var timelines = HaikuTimeline_1.default.where({ component: this });
	        for (var j = 0; j < timelines.length; j++) {
	            var timeline = timelines[j];
	            out[timeline.getName()] = timeline;
	        }
	        return out;
	    };
	    HaikuComponent.prototype.getTimeline = function (name) {
	        return this.getTimelines()[name];
	    };
	    HaikuComponent.prototype.fetchTimeline = function (name, descriptor) {
	        var found = this.getTimeline(name);
	        if (found) {
	            return found;
	        }
	        return HaikuTimeline_1.default.create(this, name, this.config);
	    };
	    HaikuComponent.prototype.getDefaultTimeline = function () {
	        var timelines = this.getTimelines();
	        return timelines[DEFAULT_TIMELINE_NAME];
	    };
	    HaikuComponent.prototype.stopAllTimelines = function () {
	        var timelines = this.getTimelines();
	        for (var name_3 in timelines) {
	            this.stopTimeline(name_3);
	        }
	    };
	    HaikuComponent.prototype.startAllTimelines = function () {
	        var timelines = this.getTimelines();
	        for (var name_4 in timelines) {
	            this.startTimeline(name_4);
	        }
	    };
	    HaikuComponent.prototype.startTimeline = function (timelineName) {
	        var descriptor = this.getTimelineDescriptor(timelineName);
	        var existing = this.fetchTimeline(timelineName, descriptor);
	        if (existing) {
	            existing.start();
	        }
	    };
	    HaikuComponent.prototype.stopTimeline = function (timelineName) {
	        var descriptor = this.getTimelineDescriptor(timelineName);
	        var existing = this.fetchTimeline(timelineName, descriptor);
	        if (existing) {
	            existing.stop();
	        }
	    };
	    /**
	     * @description Convenience alias for HaikuTimeline#gotoAndPlay
	     */
	    HaikuComponent.prototype.gotoAndPlay = function (amount, unit) {
	        if (unit === void 0) { unit = "fr" /* Frame */; }
	        this.getDefaultTimeline().gotoAndPlay(amount, unit);
	    };
	    /**
	     * @description Convenience alias for HaikuTimeline#gotoAndStop
	     */
	    HaikuComponent.prototype.gotoAndStop = function (amount, unit) {
	        if (unit === void 0) { unit = "fr" /* Frame */; }
	        this.getDefaultTimeline().gotoAndStop(amount, unit);
	    };
	    /**
	     * @description Convenience alias for HaikuTimeline#pause
	     */
	    HaikuComponent.prototype.pause = function () {
	        this.getDefaultTimeline().pause();
	    };
	    /**
	     * @description Convenience alias for HaikuTimeline#stop
	     */
	    HaikuComponent.prototype.stop = function () {
	        this.getDefaultTimeline().stop();
	    };
	    /**
	     * @description Convenience alias for HaikuTimeline#seek
	     */
	    HaikuComponent.prototype.seek = function (amount, unit) {
	        if (unit === void 0) { unit = "fr" /* Frame */; }
	        this.getDefaultTimeline().seek(amount, unit);
	    };
	    /**
	     * @description Convenience alias for HaikuTimeline#start
	     */
	    HaikuComponent.prototype.start = function () {
	        this.getDefaultTimeline().start();
	    };
	    /**
	     * @description Convenience alias for HaikuTimeline#play
	     */
	    HaikuComponent.prototype.play = function (options) {
	        if (options === void 0) { options = {}; }
	        this.getDefaultTimeline().play();
	    };
	    HaikuComponent.prototype.getTimelineDescriptor = function (timelineName) {
	        return this.bytecode.timelines[timelineName];
	    };
	    HaikuComponent.prototype.getInjectables = function () {
	        var injectables = {};
	        assign_1.default(injectables, this.getSummonablesSchema());
	        // Local states get precedence over global summonables, so assign them last
	        for (var key in this._states) {
	            var type = this._states[key] && this._states[key].type;
	            if (!type) {
	                type = typeof this._states[key];
	            }
	            injectables[key] = type;
	        }
	        return injectables;
	    };
	    /**
	     * @method _deactivate
	     * @description When hot-reloading a component during editing, this can be used to
	     * ensure that this component doesn't keep updating after its replacement is loaded.
	     */
	    HaikuComponent.prototype.deactivate = function () {
	        this.isDeactivated = true;
	    };
	    HaikuComponent.prototype.activate = function () {
	        this.isDeactivated = false;
	    };
	    HaikuComponent.prototype.sleepOn = function () {
	        this.isSleeping = true;
	    };
	    HaikuComponent.prototype.sleepOff = function () {
	        this.isSleeping = false;
	    };
	    /**
	     * @method dump
	     * @description Dump serializable info about this object
	     */
	    HaikuComponent.prototype.dump = function () {
	        var metadata = this.getBytecodeMetadata();
	        return metadata.relpath + ":" + this.getComponentId();
	    };
	    HaikuComponent.prototype.getBytecodeMetadata = function () {
	        return this.bytecode.metadata;
	    };
	    HaikuComponent.prototype.getBytecodeRelpath = function () {
	        var metadata = this.getBytecodeMetadata();
	        return metadata && metadata.relpath;
	    };
	    HaikuComponent.prototype.getBytecodeProject = function () {
	        var metadata = this.getBytecodeMetadata();
	        return metadata && metadata.project;
	    };
	    HaikuComponent.prototype.getBytecodeOrganization = function () {
	        var metadata = this.getBytecodeMetadata();
	        return metadata && metadata.organization;
	    };
	    HaikuComponent.prototype.getAddressableProperties = function (out) {
	        var _this = this;
	        if (out === void 0) { out = {}; }
	        if (!this.bytecode.states) {
	            return out;
	        }
	        var _loop_2 = function (name_5) {
	            var state = this_1.bytecode.states[name_5];
	            out[name_5] = {
	                name: name_5,
	                type: 'state',
	                prefix: name_5,
	                suffix: undefined,
	                fallback: state.value,
	                typedef: state.type,
	                mock: state.mock,
	                target: this_1,
	                value: function () {
	                    return _this.state[name_5]; // The current live value of this state as seen by the app
	                },
	            };
	        };
	        var this_1 = this;
	        for (var name_5 in this.bytecode.states) {
	            _loop_2(name_5);
	        }
	        return out;
	    };
	    HaikuComponent.prototype.bindStates = function () {
	        var allStates = assign_1.default({}, this.bytecode.states, this.config.states);
	        for (var stateSpecName in allStates) {
	            var stateSpec = allStates[stateSpecName];
	            // 'null' is the signal for an empty prop, not undefined.
	            if (!stateSpec || stateSpec.value === undefined) {
	                console.error('Property `' +
	                    stateSpecName +
	                    '` cannot be undefined; use null for empty states');
	                continue;
	            }
	            if (!this._states.hasOwnProperty(stateSpecName) || this.config.states.hasOwnProperty(stateSpecName)) {
	                this._states[stateSpecName] = stateSpec.value;
	                this.defineSettableState(stateSpec, stateSpecName);
	            }
	        }
	    };
	    HaikuComponent.prototype.defineSettableState = function (stateSpec, stateSpecName) {
	        var _this = this;
	        // Note: We define the getter/setter on the object itself, but the storage occurs on the pass-in statesTargetObject
	        Object.defineProperty(this.state, stateSpecName, {
	            configurable: true,
	            enumerable: true,
	            get: function () {
	                return _this._states[stateSpecName];
	            },
	            set: function (inputValue) {
	                if (stateSpec.setter) {
	                    // Important: We call the setter with a binding of the component, so it can access methods on `this`
	                    _this._states[stateSpecName] = stateSpec.setter.call(_this, inputValue);
	                }
	                else {
	                    _this._states[stateSpecName] = inputValue;
	                }
	                if (!_this.isDeactivated) {
	                    _this.emit('state:set', stateSpecName, _this._states[stateSpecName]);
	                }
	                return _this._states[stateSpecName];
	            },
	        });
	    };
	    HaikuComponent.prototype.allEventHandlers = function () {
	        return assign_1.default({}, this.bytecode.eventHandlers, this.config.eventHandlers);
	    };
	    HaikuComponent.prototype.eachEventHandler = function (iteratee) {
	        var eventHandlers = this.allEventHandlers();
	        for (var eventSelector in eventHandlers) {
	            for (var eventName in eventHandlers[eventSelector]) {
	                var descriptor = eventHandlers[eventSelector][eventName];
	                if (!descriptor || !descriptor.handler) {
	                    continue;
	                }
	                iteratee(eventSelector, eventName, descriptor);
	            }
	        }
	    };
	    HaikuComponent.prototype.routeEventToHandler = function (eventSelectorGiven, eventNameGiven, eventArgs) {
	        var _this = this;
	        if (this.isDeactivated) {
	            return;
	        }
	        this.eachEventHandler(function (eventSelector, eventName, _a) {
	            var handler = _a.handler;
	            if (eventNameGiven === eventName) {
	                if (eventSelectorGiven === eventSelector ||
	                    eventSelectorGiven === HaikuBase_1.GLOBAL_LISTENER_KEY) {
	                    _this.callEventHandler(eventSelector, eventName, handler, eventArgs);
	                    return;
	                }
	            }
	        });
	    };
	    HaikuComponent.prototype.setHook = function (hookName, hookFn) {
	        this.hooks[hookName] = hookFn;
	    };
	    HaikuComponent.prototype.callHook = function (hookName) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var _a;
	        if (typeof this.hooks[hookName] === 'function') {
	            (_a = this.hooks)[hookName].apply(_a, args);
	        }
	    };
	    HaikuComponent.prototype.callEventHandler = function (eventsSelector, eventName, handler, eventArgs) {
	        // Only fire the event listeners if the component is in 'live' interaction mode,
	        // i.e., not currently being edited inside the Haiku authoring environment
	        // However, some components rely on specific event hooks firing in Edit mode, too — they can
	        // whitelist their "edit mode" event names through `options`
	        if (!this.isLiveMode() &&
	            !(this.bytecode.options &&
	                this.bytecode.options.editModeEvents &&
	                this.bytecode.options.editModeEvents[eventName])) {
	            return;
	        }
	        this.callHook('action:before', this, eventName, eventsSelector, eventArgs);
	        try {
	            handler.apply(this, [this].concat(eventArgs));
	        }
	        catch (exception) {
	            consoleErrorOnce_1.default(exception);
	        }
	        this.callHook('action:after', this, eventName, eventsSelector, eventArgs);
	    };
	    HaikuComponent.prototype.routeEventToHandlerAndEmit = function (eventSelectorGiven, eventNameGiven, eventArgs) {
	        if (this.isDeactivated) {
	            return;
	        }
	        this.routeEventToHandler(eventSelectorGiven, eventNameGiven, eventArgs);
	        this.emit.apply(this, [eventNameGiven].concat(eventArgs));
	    };
	    HaikuComponent.prototype.routeEventToHandlerAndEmitWithoutBubbling = function (eventSelectorGiven, eventNameGiven, eventArgs) {
	        if (this.isDeactivated) {
	            return;
	        }
	        this.routeEventToHandler(eventSelectorGiven, eventNameGiven, eventArgs);
	        this.emitWithoutBubbling.apply(this, [eventNameGiven].concat(eventArgs));
	    };
	    HaikuComponent.prototype.routeEventToHandlerAndEmitWithoutBubblingAndWithoutGlobalHandlers = function (eventSelectorGiven, eventNameGiven, eventArgs) {
	        if (this.isDeactivated) {
	            return;
	        }
	        this.routeEventToHandler(eventSelectorGiven, eventNameGiven, eventArgs);
	        this.emitToListeners(eventNameGiven, eventArgs);
	        this.emitToGenericListeners(eventNameGiven, eventArgs);
	    };
	    /**
	     * @description A more expressive form of `emit` that allows the user to route
	     * events to specific collections of elements/components in the tree using labels,
	     * selectors, etc. This method is provided in lieu of providing an individual method
	     * for every possible topology.
	     */
	    HaikuComponent.prototype.send = function (route, name) {
	        var _this = this;
	        var args = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            args[_i - 2] = arguments[_i];
	        }
	        // Send to parent
	        if (route === 'emit' ||
	            route === 'up' ||
	            route === 'parent' ||
	            route === '<' // Cute: '>' is the opposite of CSS children selector '<'
	        ) {
	            this.emit.apply(this, [name].concat(args));
	            return;
	        }
	        // Send to children
	        if (route === 'down' ||
	            route === 'children' ||
	            route === '>' // CSS children selector
	        ) {
	            this.visitGuests(function (guest) {
	                guest.emitWithoutBubbling.apply(guest, [name].concat(args));
	            });
	            return;
	        }
	        // Send to siblings
	        if (route === 'sideways' ||
	            route === 'siblings' ||
	            route === '~' // CSS sibling selector
	        ) {
	            if (this.host) {
	                this.host.visitGuests(function (guest) {
	                    if (guest !== _this) {
	                        guest.emitWithoutBubbling.apply(guest, [name].concat(args));
	                    }
	                });
	            }
	            return;
	        }
	        // Send to everyone
	        if (route === '*') {
	            this.top.visitGuestHierarchy(function (guest) {
	                if (guest !== _this) {
	                    guest.emitWithoutBubbling.apply(guest, [name].concat(args));
	                }
	            });
	        }
	    };
	    HaikuComponent.prototype.emitToAncestors = function (name) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        if (this.host) {
	            // 1. Emit to listeners on the "wrapper" div
	            this.host.routeEventToHandler("haiku:" + exports.getNodeCompositeId(this.parentNode), name, [this].concat(args));
	            // 2. For convenience, emit to listeners on the root component of the hosts
	            this.host.routeEventToHandler("haiku:" + exports.getNodeCompositeId(this.host), name, [this].concat(args));
	        }
	    };
	    HaikuComponent.prototype.emitWithoutBubbling = function (key) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        this.routeEventToHandler(HaikuBase_1.GLOBAL_LISTENER_KEY, key, args);
	        this.emitToListeners(key, args);
	        this.emitToGenericListeners(key, args);
	    };
	    HaikuComponent.prototype.markForFullFlush = function () {
	        this.doesNeedFullFlush = true;
	    };
	    HaikuComponent.prototype.unmarkForFullFlush = function () {
	        this.doesNeedFullFlush = false;
	    };
	    HaikuComponent.prototype.shouldPerformFullFlush = function () {
	        return this.doesNeedFullFlush || this.doAlwaysFlush;
	    };
	    HaikuComponent.prototype.expandIfNeeded = function () {
	        if (this.needsExpand) {
	            expandNode(this.bytecode.template, this.container);
	            this.needsExpand = false;
	        }
	    };
	    HaikuComponent.prototype.performFullFlushRenderWithRenderer = function (renderer, options) {
	        if (options === void 0) { options = {}; }
	        this.context.getContainer(true); // Force recalc of container
	        // Since we will produce a full tree, we don't need a further full flush.
	        this.unmarkForFullFlush();
	        this.needsExpand = true;
	        this.render(options);
	        // Untyped code paths downstream depend on the output of this method
	        return renderer.render(this.container, this.bytecode.template, this);
	    };
	    HaikuComponent.prototype.performPatchRenderWithRenderer = function (renderer, options, skipCache) {
	        if (options === void 0) { options = {}; }
	        if (renderer.shouldCreateContainer) {
	            this.context.getContainer(true); // Force recalc of container
	        }
	        var patches = this.patch(options, skipCache);
	        renderer.patch(this, patches);
	        for (var $id in this.guests) {
	            var guest = this.guests[$id];
	            if (guest.shouldPerformFullFlush() && guest.target) {
	                guest.performFullFlushRenderWithRenderer(renderer, options);
	            }
	            else {
	                guest.performPatchRenderWithRenderer(renderer, options, skipCache);
	            }
	        }
	    };
	    HaikuComponent.prototype.render = function (options) {
	        var _this = this;
	        if (options === void 0) { options = {}; }
	        // We register ourselves with our host here because render is guaranteed to be called
	        // both in our constructor and in the case that we were deactivated/reactivated.
	        // This must run before the isDeactivated check since we may use the registry to activate later.
	        if (this.host) {
	            this.host.registerGuest(this);
	        }
	        if (this.isDeactivated) {
	            // If deactivated, pretend like there is nothing to render
	            return;
	        }
	        this.clearCaches();
	        HaikuElement_1.default.findOrCreateByNode(this.container);
	        if (!this.container.__memory.subcomponent) {
	            // A semantically different thing than .subcomponent/.instance
	            this.container.__memory.containee = this;
	        }
	        hydrateNode(this.bytecode.template, // node
	        this.container, // parent
	        this, // instance (component)
	        this.context, this.host, 'div', // scope (the default is a div)
	        options, true);
	        this.applyLocalBehaviors(false, // isPatchOperation
	        false);
	        if (this.context.renderer.mount) {
	            this.eachEventHandler(function (eventSelector, eventName) {
	                var registrationKey = eventSelector + ":" + eventName;
	                if (_this.registeredEventHandlers[registrationKey]) {
	                    return;
	                }
	                _this.registeredEventHandlers[registrationKey] = true;
	                _this.context.renderer.mountEventListener(_this, eventSelector, eventName, function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this.routeEventToHandlerAndEmit(eventSelector, eventName, args);
	                });
	            });
	        }
	        this.applyGlobalBehaviors(options);
	        // But also note we need to call subcomponent renders *after* our own behaviors,
	        // because we need the parent-to-child states to be set prior to this render call,
	        // otherwise the changes they produce won't be available for this render frame.
	        for (var $id in this.guests) {
	            this.guests[$id].render(__assign({}, this.guests[$id].config, Config_1.default.buildChildSafeConfig(options)));
	        }
	        this.expandIfNeeded();
	        return this.bytecode.template;
	    };
	    HaikuComponent.prototype.patch = function (options, skipCache) {
	        if (options === void 0) { options = {}; }
	        if (skipCache === void 0) { skipCache = false; }
	        if (this.isDeactivated) {
	            // If deactivated, pretend like there is nothing to render
	            return {};
	        }
	        this.applyLocalBehaviors(true, // isPatchOperation
	        skipCache);
	        this.applyGlobalBehaviors(options);
	        var patches = {};
	        this.expandIfNeeded();
	        for (var i = 0; i < this.patches.length; i++) {
	            var node = this.patches[i];
	            computeAndApplyLayout(node, node.__memory.parent);
	            patches[exports.getNodeCompositeId(node)] = node;
	        }
	        this.patches = [];
	        return patches;
	    };
	    HaikuComponent.prototype.applyGlobalBehaviors = function (options) {
	        if (options === void 0) { options = {}; }
	        if (!this.host && options.sizing) {
	            var didSizingChange = computeAndApplyPresetSizing(this.bytecode.template, this.container, options.sizing);
	            if (didSizingChange) {
	                this.patches.push(this.bytecode.template);
	            }
	        }
	    };
	    HaikuComponent.prototype.applyLocalBehaviors = function (isPatchOperation, skipCache) {
	        if (skipCache === void 0) { skipCache = false; }
	        var globalClockTime = this.context.clock.getExplicitTime();
	        var manaTree = this.manaTreeCached();
	        for (var timelineName in this.bytecode.timelines) {
	            var timelineInstance = this.getTimeline(timelineName);
	            timelineInstance.executePreUpdateHooks(globalClockTime);
	            var timelineTime = timelineInstance.getTime(); // Bounded time
	            var timelineDescriptor = this.bytecode.timelines[timelineName];
	            var mutableTimelineDescriptor = isPatchOperation
	                ? this.mutableTimelines[timelineName]
	                : timelineDescriptor;
	            if (!mutableTimelineDescriptor) {
	                mutableTimelineDescriptor = {};
	            }
	            for (var behaviorSelector in mutableTimelineDescriptor) {
	                var matchingElementsForBehavior = this.findMatchingNodesByCSSSelector(manaTree, behaviorSelector);
	                if (!matchingElementsForBehavior || matchingElementsForBehavior.length < 1) {
	                    continue;
	                }
	                var propertiesGroup = mutableTimelineDescriptor[behaviorSelector];
	                if (!propertiesGroup) {
	                    continue;
	                }
	                // This is our opportunity to group property operations that need to be in order
	                var propertyOperations = collatePropertyGroup(propertiesGroup);
	                for (var i = 0; i < matchingElementsForBehavior.length; i++) {
	                    var matchingElement = matchingElementsForBehavior[i];
	                    var compositeId = exports.getNodeCompositeId(matchingElement);
	                    for (var j = 0; j < propertyOperations.length; j++) {
	                        var propertyGroup = propertyOperations[j];
	                        for (var propertyName in propertyGroup) {
	                            var keyframeCluster = propertyGroup[propertyName];
	                            var grabbedValue = this.grabValue(timelineName, compositeId, matchingElement, propertyName, keyframeCluster, timelineTime, isPatchOperation, skipCache);
	                            var computedValue = grabbedValue.computedValue, didValueChangeSinceLastRequest = grabbedValue.didValueChangeSinceLastRequest, didValueOriginateFromExplicitKeyframeDefinition = grabbedValue.didValueOriginateFromExplicitKeyframeDefinition;
	                            if (computedValue === undefined) {
	                                continue;
	                            }
	                            // We always apply the property if...
	                            if (
	                            // - This is a full render
	                            !isPatchOperation ||
	                                // - The value in question has changed
	                                didValueChangeSinceLastRequest ||
	                                // - The value is in the whitelist of always-updated properties
	                                ALWAYS_UPDATED_PROPERTIES[propertyName] ||
	                                (
	                                // - The value was explicitly defined as a keyframe and...
	                                didValueOriginateFromExplicitKeyframeDefinition && (
	                                // - We haven't yet reached the end
	                                (timelineTime < timelineInstance.getMaxTime()) ||
	                                    // - The timeline is looping (we won't be hanging on the final keyframe)
	                                    timelineInstance.isLooping() ||
	                                    // - We just reached the final keyframe (but haven't already visited it)
	                                    timelineInstance.getLastFrame() !== timelineInstance.getBoundedFrame()))) {
	                                this.applyPropertyToNode(matchingElement, propertyName, computedValue, timelineInstance);
	                                if (isPatchOperation) {
	                                    this.patches.push(matchingElement);
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	            timelineInstance.executePostUpdateHooks(globalClockTime);
	        }
	    };
	    HaikuComponent.prototype.getProjectRootPathWithTerminatingSlash = function () {
	        var metadata = this.getBytecodeMetadata();
	        // If root is set and is not precisely this known magic string,
	        // assume the root actually defines a root path somewhere on the web we can resolve to.
	        if (metadata && metadata.root && metadata.root !== CDN_ROOT_STR) {
	            return metadata.root;
	        }
	        // Try to use a locally defined folder (i.e. during editing in Haiku),
	        // or fallback to a local path and hope we resolve to something meaningful.
	        return this.config.folder || (metadata && metadata.folder) || './';
	    };
	    HaikuComponent.prototype.applyPropertyToNode = function (node, name, value, timeline) {
	        var sender = (node.__memory.instance) ? node.__memory.instance : this; // Who sent the command
	        var receiver = node.__memory.subcomponent;
	        var type = (receiver && receiver.tagName) || node.elementName;
	        var addressables = receiver && receiver.getAddressableProperties();
	        var addressee = addressables && addressables[name] !== undefined && receiver;
	        if (addressee) {
	            // Note: Even though we apply the value to addressables of the subcomponent,
	            // we still proceed with application of properties directly to the wrapper.
	            // This is as a convenience, so that if a subcomponent wants to handle any property
	            // applied to its wrapper than it can do so, e.g. sizeAbsolute.x/sizeAbsolute.y.
	            addressee.set(name, value);
	        }
	        var vanity = exports.getVanity(type, name);
	        if (vanity) {
	            return vanity(name, node, value, this.context, timeline, receiver, sender);
	        }
	        var parts = name.split('.');
	        if (parts[0] === 'style' && parts[1]) {
	            return setStyle(parts[1], node, value);
	        }
	        return setAttribute(name, node, value);
	    };
	    HaikuComponent.prototype.findElementsByHaikuId = function (componentId) {
	        return this.findMatchingNodesByCSSSelector(this.manaTreeCached(), "haiku:" + componentId);
	    };
	    HaikuComponent.prototype.nodesCacheKey = function (selector) {
	        return 'nodes:' + selector;
	    };
	    HaikuComponent.prototype.manaTreeCached = function () {
	        var _this = this;
	        return this.cacheFetch('flatManaTree', function () { return HaikuNode_1.manaFlattenTree(_this.bytecode.template, CSS_QUERY_MAPPING); });
	    };
	    HaikuComponent.prototype.findMatchingNodesByCSSSelector = function (manaTree, selector) {
	        var nodes = this.cacheFetch(this.nodesCacheKey(selector), function () { return HaikuNode_1.cssQueryList(manaTree, selector, CSS_QUERY_MAPPING); });
	        var out = [];
	        for (var i = 0; i < nodes.length; i++) {
	            var node = nodes[i];
	            var repeatees = findRespectiveRepeatees(node);
	            // If the node in question is the descendant of a repeater, we need to find all repeated
	            // copies of it inside the host repeater. If any repeatees are returned that means the
	            // element is in fact a repeater, otherwise it is not a repeater, so just use the node.
	            if (repeatees.length > 0) {
	                out.push.apply(out, repeatees);
	            }
	            else {
	                out.push(node);
	            }
	        }
	        return out;
	    };
	    HaikuComponent.prototype.hydrateMutableTimelines = function () {
	        this.mutableTimelines = {};
	        if (this.bytecode.timelines) {
	            for (var timelineName in this.bytecode.timelines) {
	                for (var selector in this.bytecode.timelines[timelineName]) {
	                    for (var propertyName in this.bytecode.timelines[timelineName][selector]) {
	                        if (isMutableProperty_1.default(this.bytecode.timelines[timelineName][selector][propertyName], propertyName)) {
	                            if (!this.mutableTimelines[timelineName]) {
	                                this.mutableTimelines[timelineName] = {};
	                            }
	                            if (!this.mutableTimelines[timelineName][selector]) {
	                                this.mutableTimelines[timelineName][selector] = {};
	                            }
	                            this.mutableTimelines[timelineName][selector][propertyName] =
	                                this.bytecode.timelines[timelineName][selector][propertyName];
	                        }
	                    }
	                }
	            }
	        }
	    };
	    HaikuComponent.prototype.addHotComponent = function (hotComponent) {
	        if (!this.bytecode.timelines ||
	            !this.bytecode.timelines[hotComponent.timelineName] ||
	            !this.bytecode.timelines[hotComponent.timelineName][hotComponent.selector]) {
	            return;
	        }
	        var propertyGroup = this.bytecode.timelines[hotComponent.timelineName][hotComponent.selector];
	        if (!this.mutableTimelines[hotComponent.timelineName]) {
	            this.mutableTimelines[hotComponent.timelineName] = {};
	        }
	        if (!this.mutableTimelines[hotComponent.timelineName][hotComponent.selector]) {
	            this.mutableTimelines[hotComponent.timelineName][hotComponent.selector] = {};
	        }
	        Object.assign(this.mutableTimelines[hotComponent.timelineName][hotComponent.selector], hotComponent.propertyNames.reduce(function (hotProperties, propertyName) { return (hotProperties[propertyName] = propertyGroup[propertyName], hotProperties); }, {}));
	    };
	    HaikuComponent.prototype.controlTime = function (timelineName, timelineTime) {
	        var explicitTime = this.context.clock.getExplicitTime();
	        var timelineInstances = this.getTimelines();
	        for (var localTimelineName in timelineInstances) {
	            if (localTimelineName === timelineName) {
	                var timelineInstance = timelineInstances[timelineName];
	                timelineInstance.controlTime(timelineTime, explicitTime);
	            }
	        }
	        for (var $id in this.guests) {
	            this.guests[$id].controlTime(timelineName, 0);
	        }
	    };
	    HaikuComponent.prototype.getPropertiesGroup = function (timelineName, flexId) {
	        return (this.bytecode &&
	            this.bytecode.timelines &&
	            this.bytecode.timelines[timelineName] &&
	            this.bytecode.timelines[timelineName]["haiku:" + flexId]);
	    };
	    /**
	     * Execute state transitions.
	     */
	    HaikuComponent.prototype.tickStateTransitions = function () {
	        this.stateTransitionManager.tickStateTransitions();
	    };
	    /**
	     * Reset states to initial values by using State Transitions. Default to linear
	     */
	    HaikuComponent.prototype.resetStatesToInitialValuesWithTransition = function (duration, curve) {
	        if (curve === void 0) { curve = api_1.Curve.Linear; }
	        // Build initial states
	        var initialStates = assign_1.default({}, this.bytecode.states, this.config.states);
	        for (var key in initialStates) {
	            initialStates[key] = initialStates[key].value;
	        }
	        // Create state transition to initial state values
	        this.stateTransitionManager.setState(initialStates, { curve: curve, duration: duration });
	    };
	    Object.defineProperty(HaikuComponent.prototype, "top", {
	        /**
	         * @description Get the topmost component in the hierarchy.
	         */
	        get: function () {
	            if (this.host) {
	                return this.host.top;
	            }
	            return this;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    HaikuComponent.prototype.getRootComponent = function () {
	        if (this.host) {
	            return this.host.getRootComponent();
	        }
	        return this;
	    };
	    HaikuComponent.prototype.emitFromRootComponent = function (eventName, attachedObject) {
	        this.getRootComponent().emit(eventName, __assign({}, attachedObject, { componentTitle: this.title }));
	    };
	    HaikuComponent.prototype.evaluate = function (expr) {
	        // Make all injectables available within the scope of the function we'll create below,
	        // so users can freely evaluate an expression like this.evaluate('$user.mouse.x');
	        try {
	            // tslint:disable-next-line:no-function-constructor-with-string-args
	            var fn = new Function('$children', '$clock', '$component', '$container', '$context', '$core', '$element', '$host', '$if', '$index', '$mount', '$parent', '$payload', '$placeholder', '$repeat', '$state', '$timeline', '$top', '$tree', '$user', '$window', "return " + expr + ";\n");
	            return fn(this.summon('$children'), this.summon('$clock'), this.summon('$component'), this.summon('$container'), this.summon('$context'), this.summon('$core'), this.summon('$element'), this.summon('$host'), this.summon('$if'), this.summon('$index'), this.summon('$mount'), this.summon('$parent'), this.summon('$payload'), this.summon('$placeholder'), this.summon('$repeat'), this.summon('$state'), this.summon('$timeline'), this.summon('$top'), this.summon('$tree'), this.summon('$user'), this.summon('$window'));
	        }
	        catch (exception) {
	            console.warn("[haiku core] could not evaluate " + expr, exception);
	        }
	    };
	    HaikuComponent.prototype.summon = function (injectable) {
	        if (INJECTABLES[injectable] && INJECTABLES[injectable].summon) {
	            var out = {};
	            INJECTABLES[injectable].summon(out, // injectees
	            this, // component
	            this.bytecode.template, // node
	            DEFAULT_TIMELINE_NAME);
	            return out[injectable];
	        }
	    };
	    HaikuComponent.prototype.evaluateExpression = function (fn, timelineName, flexId, matchingElement, propertyName, keyframeMs, keyframeCluster) {
	        enhance_1.default(fn, null);
	        // We'll store the result of this evaluation in this variable
	        // (so we can cache it in case unexpected subsequent calls)
	        var evaluation;
	        if (fn.specification === true) {
	            // This function is of an unknown kind, so just evaluate it normally without magic dependency injection
	            evaluation = safeCall(fn, this, this._states);
	        }
	        else if (!Array.isArray(fn.specification.params)) {
	            // If for some reason we got a non-array params, just evaluate
	            evaluation = safeCall(fn, this, this._states);
	        }
	        else if (fn.specification.params.length < 1) {
	            // If for some reason we got 0 params, just evaluate it
	            evaluation = safeCall(fn, this, this._states);
	        }
	        else {
	            if (fn.specification.params.length < 1) {
	                // If the summon isn't in the destructured object format, just evaluate it
	                evaluation = safeCall(fn, this, this._states);
	            }
	            else {
	                var summoneesArray = this.summonSummonables(fn.specification.params, timelineName, flexId, matchingElement, propertyName, keyframeMs, keyframeCluster);
	                var previousSummoneesArray = this.getPreviousSummonees(timelineName, flexId, propertyName, keyframeMs);
	                if (areSummoneesDifferent(previousSummoneesArray, summoneesArray)) {
	                    this.cacheSummonees(timelineName, flexId, propertyName, keyframeMs, summoneesArray);
	                    evaluation = safeApply(fn, this, summoneesArray);
	                }
	                else {
	                    // Since nothing is different, return the previous evaluation
	                    evaluation = this.getPreviousEvaluation(timelineName, flexId, propertyName, keyframeMs);
	                }
	            }
	        }
	        // If the output is literally `NaN`, that is almost certainly useless and not what the user
	        // intended. This can happen commonly when editing in Haiku.app and creating dynamic behavior
	        // based on state payloads whose fields may be missing, especially with controlFlow.repeat.
	        if (Number.isNaN(evaluation)) {
	            evaluation = 1;
	        }
	        // Same for Infinity; as it's more likely than not that this is a mistake
	        if (typeof evaluation === 'number' && !isFinite(evaluation)) {
	            evaluation = 1;
	        }
	        // Store the result so we can return it on the next run without re-eval
	        if (fn.specification && fn.specification !== true) {
	            this.cacheEvaluation(timelineName, flexId, propertyName, keyframeMs, evaluation);
	        }
	        return evaluation;
	    };
	    HaikuComponent.prototype.summonSummonables = function (paramsArray, timelineName, flexId, matchingElement, propertyName, keyframeMs, keyframeCluster) {
	        var summonablesArray = [];
	        // Temporary storage, just creating one object here to avoid excessive allocations
	        var summonStorage = {};
	        for (var i = 0; i < paramsArray.length; i++) {
	            var summonsEntry = paramsArray[i];
	            // We'll store the output of the summons in this var, whether we're dealing with
	            // a complex nested summonable or a flat one
	            var summonsOutput = void 0;
	            // In case of a string, we will treat it as the key for the object to summon
	            if (typeof summonsEntry === 'string') {
	                // Treat the entry as the key to a known injectable
	                if (INJECTABLES[summonsEntry]) {
	                    summonStorage[summonsEntry] = undefined; // Clear out the old value before populating with the new one
	                    INJECTABLES[summonsEntry].summon(summonStorage, this, matchingElement, timelineName);
	                    summonsOutput = summonStorage[summonsEntry];
	                }
	                else {
	                    summonsOutput = this.state[summonsEntry];
	                }
	            }
	            // Whatever the request format was, populate the result in here
	            if (summonsOutput !== undefined) {
	                summonablesArray[i] = summonsOutput;
	            }
	        }
	        return summonablesArray;
	    };
	    HaikuComponent.prototype.fetchParsedValueCluster = function (timelineName, flexId, matchingElement, outputName, cluster, isPatchOperation, skipCache) {
	        var parseeWithKeys = this.getParseeWithKeys(timelineName, flexId, outputName, cluster);
	        if (!cluster) {
	            return parseeWithKeys;
	        }
	        var skipStableParsees = isPatchOperation && !skipCache;
	        if (skipStableParsees && this.clusterParseeIsStable(parseeWithKeys)) {
	            return parseeWithKeys;
	        }
	        for (var i = 0; i < parseeWithKeys.keys.length; i++) {
	            var ms = parseeWithKeys.keys[i];
	            var descriptor = cluster[ms];
	            if ((skipStableParsees && parseeWithKeys.parsee[ms] && !parseeWithKeys.parsee[ms].expression) ||
	                descriptor === undefined) {
	                continue;
	            }
	            if (isFunction(descriptor.value)) {
	                parseeWithKeys.parsee[ms] = {
	                    expression: true,
	                    value: this.evaluateExpression(descriptor.value, timelineName, flexId, matchingElement, outputName, ms, cluster),
	                };
	            }
	            else {
	                parseeWithKeys.parsee[ms] = {
	                    expression: false,
	                    value: descriptor.value,
	                };
	            }
	            if (descriptor.curve) {
	                parseeWithKeys.parsee[ms].curve = descriptor.curve;
	            }
	        }
	        if (parseeWithKeys.keys.length > 1) {
	            var parser = this.getParser(outputName);
	            if (!parser &&
	                // tslint:disable-next-line:triple-equals
	                parseFloat(parseeWithKeys.parsee[parseeWithKeys.keys[0]].value) ==
	                    parseeWithKeys.parsee[parseeWithKeys.keys[0]].value) {
	                parser = parseFloat;
	            }
	            if (!parser) {
	                return parseeWithKeys;
	            }
	            for (var j = 0; j < parseeWithKeys.keys.length; j++) {
	                var ms2 = parseeWithKeys.keys[j];
	                parseeWithKeys.parsee[ms2].value = parser(parseeWithKeys.parsee[ms2].value);
	            }
	            if (outputName === 'd') {
	                PathUtils_1.synchronizePathStructure.apply(void 0, parseeWithKeys.keys.map(function (ms) { return parseeWithKeys.parsee[ms].value; }));
	            }
	        }
	        return parseeWithKeys;
	    };
	    HaikuComponent.prototype.generateFinalValueFromParsedValue = function (timelineName, flexId, matchingElement, outputName, computedValue) {
	        if (computedValue === undefined) {
	            return;
	        }
	        var generator = this.getGenerator(outputName);
	        if (generator) {
	            return generator(computedValue);
	        }
	        return computedValue;
	    };
	    HaikuComponent.prototype.grabValue = function (timelineName, flexId, matchingElement, propertyName, keyframeCluster, timelineTime, isPatchOperation, skipCache) {
	        // Used by $helpers to calculate scope-specific values;
	        this.helpers.data = {
	            lastTimelineName: timelineName,
	            lastFlexId: flexId,
	            lastPropertyName: propertyName,
	            lastTimelineTime: timelineTime,
	        };
	        var parsedValueCluster = this.fetchParsedValueCluster(timelineName, flexId, matchingElement, propertyName, keyframeCluster, isPatchOperation, skipCache);
	        // If there is no property of that name, we would have gotten nothing back, so we can't forward this to Transitions
	        // since it expects to receive a populated cluster object
	        if (!parsedValueCluster) {
	            return {
	                computedValue: undefined,
	                didValueChangeSinceLastRequest: false,
	                didValueOriginateFromExplicitKeyframeDefinition: false,
	            };
	        }
	        var computedValueForTime;
	        if (!parsedValueCluster.parsee[KEYFRAME_ZERO]) {
	            parsedValueCluster.parsee[KEYFRAME_ZERO] = {
	                value: exports.getFallback(matchingElement && matchingElement.elementName, propertyName),
	            };
	        }
	        computedValueForTime = Transitions_1.calculateValue(parsedValueCluster.parsee, timelineTime, parsedValueCluster.keys);
	        // When expressions and other dynamic functionality is in play, data may be missing resulting in
	        // properties lacking defined values; in this case we try to do the right thing and fallback
	        // to a known usable value for the field. Especially needed with controlFlow.repeat.
	        if (computedValueForTime === undefined) {
	            computedValueForTime = exports.getFallback(matchingElement && matchingElement.elementName, propertyName);
	        }
	        var computedValue = this.generateFinalValueFromParsedValue(timelineName, flexId, matchingElement, propertyName, computedValueForTime);
	        var previousValue = this.cacheGet("values:" + timelineName + "|" + flexId + "|" + propertyName);
	        this.cacheSet("values:" + timelineName + "|" + flexId + "|" + propertyName, computedValue);
	        var didValueChangeSinceLastRequest = computedValue !== previousValue;
	        return {
	            computedValue: computedValue,
	            didValueChangeSinceLastRequest: didValueChangeSinceLastRequest,
	            didValueOriginateFromExplicitKeyframeDefinition: keyframeCluster && !!keyframeCluster[Math.round(timelineTime)],
	        };
	    };
	    HaikuComponent.prototype.getPreviousSummonees = function (timelineName, flexId, propertyName, keyframeMs) {
	        return this.cacheGet("summonees:" + timelineName + "|" + flexId + "|" + propertyName + "|" + keyframeMs);
	    };
	    HaikuComponent.prototype.cacheSummonees = function (timelineName, flexId, propertyName, keyframeMs, summonees) {
	        this.cacheSet("summonees:" + timelineName + "|" + flexId + "|" + propertyName + "|" + keyframeMs, summonees);
	        return summonees;
	    };
	    HaikuComponent.prototype.getPreviousEvaluation = function (timelineName, flexId, propertyName, keyframeMs) {
	        return this.cacheGet("evaluation:" + timelineName + "|" + flexId + "|" + propertyName + "|" + keyframeMs);
	    };
	    HaikuComponent.prototype.cacheEvaluation = function (timelineName, flexId, propertyName, keyframeMs, evaluation) {
	        this.cacheSet("evaluation:" + timelineName + "|" + flexId + "|" + propertyName + "|" + keyframeMs, evaluation);
	        return evaluation;
	    };
	    HaikuComponent.prototype.getParseeWithKeys = function (timelineName, flexId, outputName, cluster) {
	        if (!this.parsedValueClusters[timelineName]) {
	            this.parsedValueClusters[timelineName] = {};
	        }
	        if (!this.parsedValueClusters[timelineName][flexId]) {
	            this.parsedValueClusters[timelineName][flexId] = {};
	        }
	        if (!this.parsedValueClusters[timelineName][flexId][outputName]) {
	            this.parsedValueClusters[timelineName][flexId][outputName] = {
	                // The parsee object is mutated in place downstream
	                parsee: {},
	                keys: cluster ? KeyframeUtils_1.getSortedKeyframes(cluster) : [],
	            };
	        }
	        return this.parsedValueClusters[timelineName][flexId][outputName];
	    };
	    HaikuComponent.prototype.clusterParseeIsStable = function (parsedValueCluster) {
	        return parsedValueCluster.keys.every(function (ms) { return parsedValueCluster.parsee[ms] && !parsedValueCluster.parsee[ms].expression; });
	    };
	    HaikuComponent.prototype.didChangeValue = function (timelineName, flexId, matchingElement, outputName, outputValue) {
	        var answer = false;
	        var change = this.cacheGet("changes:" + timelineName + "|" + flexId + "|" + outputName);
	        if (change === undefined || change !== outputValue) {
	            this.cacheSet("changes:" + timelineName + "|" + flexId + "|" + outputName, outputValue);
	            answer = true;
	        }
	        return answer;
	    };
	    HaikuComponent.prototype.getSummonablesSchema = function () {
	        var summonablesSchema = {};
	        for (var key in INJECTABLES) {
	            summonablesSchema[key] = INJECTABLES[key].schema;
	        }
	        return summonablesSchema;
	    };
	    HaikuComponent.prototype.transformContextPointToLocalPoint = function (point) {
	        if (this.layoutAncestryMatrices) {
	            var matrix = Layout3D_1.default.multiplyArrayOfMatrices(this.layoutAncestryMatrices.reverse());
	            var inverse = invert_1.default([], matrix);
	            if (inverse !== null) {
	                HaikuElement_1.default.transformPointInPlace(point, inverse);
	            }
	        }
	        return point;
	    };
	    HaikuComponent.prototype.getParser = function (outputName) {
	        var foundParser = HaikuComponent.PARSERS[outputName];
	        return foundParser && foundParser.parse;
	    };
	    HaikuComponent.prototype.getGenerator = function (outputName) {
	        var foundGenerator = HaikuComponent.PARSERS[outputName];
	        return foundGenerator && foundGenerator.generate;
	    };
	    HaikuComponent.__name__ = 'HaikuComponent';
	    HaikuComponent.PLAYER_VERSION = exports.VERSION; // #LEGACY
	    HaikuComponent.CORE_VERSION = exports.VERSION;
	    HaikuComponent.INJECTABLES = INJECTABLES;
	    // When editing a component, any of these appearing inside an expression will trigger a warning.
	    // This is kept in the core so it's easier to compare these to the built-in injectables and
	    // other special treatment for JavaScript globals. "single source of truth" etc.
	    HaikuComponent.FORBIDDEN_EXPRESSION_TOKENS = {
	        // Keywords
	        new: true,
	        this: true,
	        with: true,
	        delete: true,
	        export: true,
	        extends: true,
	        super: true,
	        class: true,
	        abstract: true,
	        interface: true,
	        static: true,
	        label: true,
	        goto: true,
	        private: true,
	        import: true,
	        public: true,
	        // Future keywords
	        do: true,
	        native: true,
	        package: true,
	        transient: true,
	        implements: true,
	        protected: true,
	        throws: true,
	        synchronized: true,
	        final: true,
	        // Common globals
	        window: true,
	        document: true,
	        global: true,
	        // Danger
	        eval: true,
	        uneval: true,
	        Function: true,
	        EvalError: true,
	        // Module stuff to forbid
	        require: true,
	        module: true,
	        exports: true,
	        Module: true,
	        // Sandbox
	        arguments: true,
	        callee: true,
	        // Identifiers on built-in global objects
	        prototpye: true,
	        __proto__: true,
	        freeze: true,
	        setPrototypeOf: true,
	        constructor: true,
	        defineProperties: true,
	        defineProperty: true,
	    };
	    HaikuComponent.PARSERS = {
	        'style.stroke': { parse: parseColor, generate: generateColor },
	        'style.fill': { parse: parseColor, generate: generateColor },
	        'style.backgroundColor': { parse: parseColor, generate: generateColor },
	        'style.borderBottomColor': { parse: parseColor, generate: generateColor },
	        'style.borderColor': { parse: parseColor, generate: generateColor },
	        'style.borderLeftColor': { parse: parseColor, generate: generateColor },
	        'style.borderRightColor': { parse: parseColor, generate: generateColor },
	        'style.borderTopColor': { parse: parseColor, generate: generateColor },
	        'style.floodColor': { parse: parseColor, generate: generateColor },
	        'style.lightingColor': { parse: parseColor, generate: generateColor },
	        'style.stopColor': { parse: parseColor, generate: generateColor },
	        stroke: { parse: parseColor, generate: generateColor },
	        fill: { parse: parseColor, generate: generateColor },
	        floodColor: { parse: parseColor, generate: generateColor },
	        lightingColor: { parse: parseColor, generate: generateColor },
	        stopColor: { parse: parseColor, generate: generateColor },
	        backgroundColor: { parse: parseColor, generate: generateColor },
	        animateColor: { parse: parseColor, generate: generateColor },
	        feColor: { parse: parseColor, generate: generateColor },
	        // Note the hyphenated duplicates, for convenience
	        'flood-color': { parse: parseColor, generate: generateColor },
	        'lighting-color': { parse: parseColor, generate: generateColor },
	        'stop-color': { parse: parseColor, generate: generateColor },
	        'background-color': { parse: parseColor, generate: generateColor },
	        'animate-color': { parse: parseColor, generate: generateColor },
	        'fe-color': { parse: parseColor, generate: generateColor },
	        d: { parse: parseD, generate: generateD },
	        points: { parse: parsePoints, generate: generatePoints },
	    };
	    HaikuComponent.all = function () { return HaikuBase_1.default.getRegistryForClass(HaikuComponent); };
	    return HaikuComponent;
	}(HaikuElement_1.default));
	exports.default = HaikuComponent;
	var getNodeFlexId = function (node) {
	    var domId = (node &&
	        node.attributes &&
	        node.attributes.id);
	    var haikuId = (node &&
	        node.attributes &&
	        node.attributes[HAIKU_ID_ATTRIBUTE]);
	    return haikuId || domId;
	};
	exports.getNodeCompositeId = function (node) {
	    var flexId = getNodeFlexId(node);
	    // Treat the 0th repeater as the original (source) element
	    return (node.__memory && node.__memory.repeatee && node.__memory.repeatee.index)
	        ? flexId + "'" + node.__memory.repeatee.index
	        : flexId;
	};
	var collatePropertyGroup = function (propertiesGroup) {
	    var collation = [
	        {},
	        {},
	        {},
	        {},
	    ];
	    for (var propertyName in propertiesGroup) {
	        if (propertyName === 'controlFlow.if') {
	            collation[0][propertyName] = propertiesGroup[propertyName];
	        }
	        else if (propertyName === 'controlFlow.repeat') {
	            collation[1][propertyName] = propertiesGroup[propertyName];
	        }
	        else if (propertyName === 'controlFlow.placeholder') {
	            collation[2][propertyName] = propertiesGroup[propertyName];
	        }
	        else {
	            collation[3][propertyName] = propertiesGroup[propertyName];
	        }
	    }
	    return collation;
	};
	function isBytecode(thing) {
	    return thing && typeof thing === OBJECT_TYPE && thing.template;
	}
	function assertTemplate(template) {
	    if (!template) {
	        throw new Error('Empty template not allowed');
	    }
	    if (typeof template === OBJECT_TYPE) {
	        if (template.attributes) {
	            if (!template.attributes[HAIKU_ID_ATTRIBUTE]) {
	                console.warn('[haiku core] bytecode template has no id');
	            }
	        }
	        else {
	            console.warn('[haiku core] bytecode template has no attributes');
	        }
	        if (!template.elementName) {
	            console.warn('[haiku core] unexpected bytecode template format');
	        }
	        return template;
	    }
	    throw new Error('Unknown bytecode template format');
	}
	var needsVirtualChildren = function (child) { return typeof child === 'object' &&
	    child.__memory &&
	    ((child.__memory.if && !child.__memory.if.answer) ||
	        (child.__memory.repeater && !!child.__memory.repeater.repeatees)); };
	var reduceNodeMemoryChildren = function (children, out, doIncludeRepeatees) {
	    if (out === void 0) { out = []; }
	    if (doIncludeRepeatees === void 0) { doIncludeRepeatees = false; }
	    for (var i = 0; i < children.length; i++) {
	        var child = children[i];
	        if (!child) {
	            continue;
	        }
	        if (typeof child === 'object' && child.__memory) {
	            // Do not include any children that have been removed due to $if-logic
	            if (child.__memory.if && !child.__memory.if.answer) {
	                continue;
	            }
	            // If the child is a repeater, use the $repeats instead of itself
	            if (doIncludeRepeatees &&
	                child.__memory.repeater &&
	                child.__memory.repeater.repeatees) {
	                reduceNodeMemoryChildren(child.__memory.repeater.repeatees, out, false);
	                continue;
	            }
	            // If we got this far, the child is structurally normal
	            out.push(child);
	        }
	        else {
	            out.push(child);
	        }
	    }
	    return out;
	};
	var assembleNodeMemoryChildren = function (node, subtree) {
	    if (subtree) {
	        return [subtree];
	    }
	    if (node.__memory.placeholder) {
	        return [];
	    }
	    // To avoid creating garbage, only allow allocations here if we actually need virtual children.
	    if (!node.children || !node.children.some(needsVirtualChildren)) {
	        return;
	    }
	    return reduceNodeMemoryChildren(node.children, [], true);
	};
	var expandNode = function (node, parent) {
	    if (!node || typeof node !== 'object' || !node.__memory) {
	        return;
	    }
	    var children = node.children;
	    // Special case if our current original is the wrapper of a subcomponent.
	    var subtree = node.__memory.subcomponent && node.__memory.subcomponent.bytecode.template;
	    var assembled = assembleNodeMemoryChildren(node, subtree);
	    // Don't just overwrite, since node.__memory.children may've been set to vanity 'content'
	    if (assembled) {
	        node.__memory.children = assembled;
	    }
	    if (node.__memory.children) {
	        children = node.__memory.children;
	    }
	    /**
	     * When we compute layout, we have the following chicken/egg problem:
	     * 1. Nodes which are "auto"-sized consume their children's size to calculate their own size.
	     * 2. Nodes with a SIZE_PROPORTIONAL depend on parent absolute size to compute their target size. (DEPRECATED)
	     * 3. Nodes with an "auto"-sized parent consume their parent's bounds to calculate a translation offset.
	     *
	     * Thus, we perform the layout steps in the following order:
	     * 1. Compute the current node's layout.
	     *   1.a. If the current node is "auto"-sized, compute the size of the children. For each child,
	     *        we compute its bounding rect using its *local* transform (not using its parent size).
	     *        This is sufficient to obtain a bounding box in local coordinate space with respect to
	     *        an unknown container. We then use all of the rects to determine the outermost bbox,
	     *        which in turn is used to determine the current node's size.
	     *   1.b. If the current node is numerically sized, use that size.
	     * 2. Expand all children of the current node. By now, the parent should have a numeric size.
	     *   2.a. For SIZE_PROPORTIONAL nodes, compute the layout as proportion of the parent size.
	     *   2.b. For other nodes, compute its local size.
	     *   2.c. If the parent was "auto"-sized, it should have its bounds precalculated from the
	     *        previous pass. When this is the case, use the bounds to calculate an offset value
	     *        by which translation will be offset, aligning all children to be perfectly flush
	     *        with their container, no matter what size it is.
	     */
	    computeAndApplyLayout(node, parent);
	    if (children) {
	        for (var j = 0; j < children.length; j++) {
	            // Special case: The subtree of the subcomponent doesn't need to be re-expanded.
	            if (children[j] !== subtree) {
	                expandNode(children[j], node);
	            }
	        }
	    }
	};
	var computeAndApplyLayout = function (node, parent) {
	    // Don't assume the node has/needs a layout, for example, control-flow injectees
	    if (node.layout) {
	        node.layout.computed = HaikuElement_1.default.computeLayout(node, parent);
	    }
	};
	var hydrateNode = function (node, parent, component, context, host, scope, options, doConnectInstanceToNode) {
	    if (options === void 0) { options = {}; }
	    // Nothing to expand if the node happens to be text or unexpected type
	    if (!node || typeof node !== 'object') {
	        return;
	    }
	    // Hydrate a HaikuElement representation of all nodes in the tree.
	    // The instance is cached as node.__memory.element for performance purposes.
	    HaikuElement_1.default.findOrCreateByNode(node);
	    component.cacheNodeWithSelectorKey(node);
	    // Platform-specific renderers may depend on access to the parent.
	    node.__memory.parent = parent;
	    // So renderers can detect when different layout behavior is needed.
	    node.__memory.scope = scope || 'div';
	    // Give it a pointer back to the host context; used by HaikuElement
	    node.__memory.context = context;
	    Layout3D_1.default.initializeNodeAttributes(node, doConnectInstanceToNode);
	    // Give instances a pointer to their node and vice versa
	    if (doConnectInstanceToNode) {
	        node.__memory.instance = component;
	        // In the case that the node represents the root of an instance, treat the instance as the element;
	        // connect their references and override the equivalent action in findOrCreateByNode.
	        HaikuElement_1.default.connectNodeWithElement(node, node.__memory.instance);
	    }
	    // If the element name is missing it should still be safe to hydrate the children
	    if (typeof node.elementName === STRING_TYPE || !node.elementName) {
	        if (node.children) {
	            for (var i = 0; i < node.children.length; i++) {
	                hydrateNode(node.children[i], // node
	                node, // parent
	                component, // instance (component)
	                context, host, SCOPE_STRATA[node.elementName] || scope, // scope
	                options, false);
	            }
	        }
	        return;
	    }
	    if (isBytecode(node.elementName)) {
	        // Example structure showing how nodes and instances are related:
	        // <div root> instance id=1
	        //   <div>
	        //     <div>
	        //       <div wrap> subcomponent (instance id=2)
	        //         <div root> instance id=2
	        //           ...
	        if (!node.__memory.subcomponent) {
	            var config = Config_1.default.buildChildSafeConfig(__assign({}, context.config, options));
	            // Note: .render and thus .hydrateNode are called by the constructor,
	            // automatically connecting the root node to itself (see stanza above).
	            node.__memory.subcomponent = new HaikuComponent(node.elementName, context, // context
	            component, __assign({ loop: true }, config), node);
	            // Very important, as the guests collection is used in rendering/patching
	            component.registerGuest(node.__memory.subcomponent);
	        }
	        else {
	            // Reassigning is necessary since these objects may have changed between
	            // renders in the editing environment
	            node.__memory.subcomponent.context = context; // context
	            node.__memory.subcomponent.host = component; // host
	            node.__memory.subcomponent.container = node; // container
	            // Very important, as the guests collection is used in rendering/patching
	            component.registerGuest(node.__memory.subcomponent);
	            // Don't re-start any nested timelines that have been explicitly paused
	            if (!node.__memory.subcomponent.getDefaultTimeline().isPaused()) {
	                node.__memory.subcomponent.startTimeline(DEFAULT_TIMELINE_NAME);
	            }
	        }
	        return;
	    }
	    // In case we got a __reference node or other unknown
	    console.warn('[haiku core] cannot hydrate node');
	};
	var computeAndApplyPresetSizing = function (element, container, mode) {
	    var elementWidth = element.layout.sizeAbsolute.x;
	    var elementHeight = element.layout.sizeAbsolute.y;
	    // Some browsers does not work correctly with matrix3d transforms on SVGs
	    // with resulting subpixel rendering, so let's round up the size to avoid
	    // browser problems
	    var containerWidth = Math.ceil(container.layout.computed.size.x);
	    var containerHeight = Math.ceil(container.layout.computed.size.y);
	    // I.e., the amount by which we'd have to multiply the element's scale to make it
	    // exactly the same size as its container (without going above it)
	    var scaleDiffX = containerWidth / elementWidth;
	    var scaleDiffY = containerHeight / elementHeight;
	    // This makes sure that the sizing occurs with respect to a correct and consistent origin point,
	    // but only if the user didn't happen to explicitly set this value (we allow their override).
	    if (!element.attributes.style['transform-origin']) {
	        element.attributes.style['transform-origin'] = '0% 0% 0px';
	    }
	    // IMPORTANT: If any value has been changed on the element, you must set this to true.
	    // Otherwise the changed object won't go into the deltas dictionary, and the element won't update.
	    var changed = false;
	    switch (mode) {
	        // Make the base element its default scale, which is just a multiplier of one. This is the default.
	        case 'normal':
	            if (element.layout.scale.x !== 1.0 || element.layout.scale.y !== 1.0) {
	                changed = true;
	                element.layout.scale.x = element.layout.scale.y = 1.0;
	            }
	            break;
	        // Stretch the element to fit the container on both x and y dimensions (distortion allowed)
	        case 'stretch':
	            if (scaleDiffX !== element.layout.scale.x) {
	                changed = true;
	                element.layout.scale.x = scaleDiffX;
	            }
	            if (scaleDiffY !== element.layout.scale.y) {
	                changed = true;
	                element.layout.scale.y = scaleDiffY;
	            }
	            break;
	        // CONTAIN algorithm
	        // see https://developer.mozilla.org/en-US/docs/Web/CSS/background-size?v=example
	        // A keyword that scales the image as large as possible and maintains image aspect ratio
	        // (image doesn't get squished). Image is letterboxed within the container.
	        // When the image and container have different dimensions, the empty areas (either top/bottom of left/right)
	        // are filled with the background-color.
	        case 'contain':
	        case true: // (Legacy.)
	            var containScaleToUse = null;
	            // We're looking for the larger of the two scales that still allows both dimensions to fit in the box
	            // The rounding is necessary to avoid precision issues, where we end up comparing e.g. 2.0000000000001 to 2
	            if (~~(scaleDiffX * elementWidth) <= containerWidth &&
	                ~~(scaleDiffX * elementHeight) <= containerHeight) {
	                containScaleToUse = scaleDiffX;
	            }
	            if (~~(scaleDiffY * elementWidth) <= containerWidth &&
	                ~~(scaleDiffY * elementHeight) <= containerHeight) {
	                if (containScaleToUse === null) {
	                    containScaleToUse = scaleDiffY;
	                }
	                else {
	                    if (scaleDiffY >= containScaleToUse) {
	                        containScaleToUse = scaleDiffY;
	                    }
	                }
	            }
	            if (element.layout.scale.x !== containScaleToUse) {
	                changed = true;
	                element.layout.scale.x = containScaleToUse;
	            }
	            if (element.layout.scale.y !== containScaleToUse) {
	                changed = true;
	                element.layout.scale.y = containScaleToUse;
	            }
	            // Offset the translation so that the element remains centered within the letterboxing
	            var containTranslationOffsetX = -(containScaleToUse * elementWidth - containerWidth) / 2;
	            var containTranslationOffsetY = -(containScaleToUse * elementHeight - containerHeight) / 2;
	            if (element.layout.translation.x !== containTranslationOffsetX) {
	                changed = true;
	                element.layout.translation.x = containTranslationOffsetX;
	            }
	            if (element.layout.translation.y !== containTranslationOffsetY) {
	                changed = true;
	                element.layout.translation.y = containTranslationOffsetY;
	            }
	            break;
	        // COVER algorithm (inverse of CONTAIN)
	        // see https://developer.mozilla.org/en-US/docs/Web/CSS/background-size?v=example
	        // A keyword that is the inverse of contain. Scales the image as large as possible and maintains
	        // image aspect ratio (image doesn't get squished). The image "covers" the entire width or height
	        // of the container. When the image and container have different dimensions, the image is clipped
	        // either left/right or top/bottom.
	        case 'cover':
	            var coverScaleToUse = null;
	            // We're looking for the smaller of two scales that ensures the entire box is covered.
	            // The rounding is necessary to avoid precision issues, where we end up comparing e.g. 2.0000000000001 to 2
	            if (~~(scaleDiffX * elementHeight) >= containerHeight) {
	                coverScaleToUse = scaleDiffX;
	            }
	            else if (~~(scaleDiffY * elementWidth) >= containerWidth) {
	                coverScaleToUse = scaleDiffY;
	            }
	            else {
	                coverScaleToUse = Math.max(scaleDiffX, scaleDiffY);
	            }
	            if (element.layout.scale.x !== coverScaleToUse) {
	                changed = true;
	                element.layout.scale.x = coverScaleToUse;
	            }
	            if (element.layout.scale.y !== coverScaleToUse) {
	                changed = true;
	                element.layout.scale.y = coverScaleToUse;
	            }
	            // Offset the translation so that the element remains centered despite clipping
	            var coverTranslationOffsetX = -(coverScaleToUse * elementWidth - containerWidth) / 2;
	            var coverTranslationOffsetY = -(coverScaleToUse * elementHeight - containerHeight) / 2;
	            if (element.layout.translation.x !== coverTranslationOffsetX) {
	                changed = true;
	                element.layout.translation.x = coverTranslationOffsetX;
	            }
	            if (element.layout.translation.y !== coverTranslationOffsetY) {
	                changed = true;
	                element.layout.translation.y = coverTranslationOffsetY;
	            }
	            break;
	    }
	    return changed;
	};
	exports.clone = function (value, binding) {
	    if (!value) {
	        return value;
	    }
	    if (typeof value === 'boolean') {
	        return value;
	    }
	    if (typeof value === 'number') {
	        return value;
	    }
	    if (typeof value === 'string') {
	        return value;
	    }
	    if (typeof value === 'function') {
	        var fn = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            return value.call.apply(value, [binding].concat(args));
	        };
	        // Core decorates injectee functions with metadata properties
	        for (var key in value) {
	            if (value.hasOwnProperty(key)) {
	                fn[key] = exports.clone(value[key], binding);
	            }
	        }
	        fn.__rfo = functionToRFO_1.default(value).__function;
	        return fn;
	    }
	    if (Array.isArray(value)) {
	        return value.map(function (el) { return exports.clone(el, binding); });
	    }
	    // Don't try to clone anything other than plain objects
	    if (typeof value === 'object' && value.constructor === Object) {
	        var out = {};
	        for (var key in value) {
	            if (!value.hasOwnProperty(key) || key.slice(0, 2) === '__') {
	                continue;
	            }
	            // If it looks like guest bytecode, don't clone it since
	            // (a) we're passing down *our* function binding, which will break event handling and
	            // (b) each HaikuComponent#constructor calls clone() on its own anyway
	            if (key === 'elementName' && typeof value[key] !== 'string') {
	                out[key] = value[key];
	            }
	            else {
	                out[key] = exports.clone(value[key], binding);
	            }
	        }
	        return out;
	    }
	    return value;
	};
	var setStyle = function (subkey, element, value) {
	    element.attributes.style[subkey] = value;
	};
	var setAttribute = function (key, element, value) {
	    var final = exports.ATTRS_CAMEL_TO_HYPH[key] || key;
	    element.attributes[final] = value;
	};
	var isNumeric = function (n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	};
	var isInteger = function (x) {
	    return x % 1 === 0;
	};
	var REACT_MATCHING_OPTIONS = {
	    name: 'type',
	    attributes: 'props',
	};
	var HAIKU_MATCHING_OPTIONS = {
	    name: 'elementName',
	    attributes: 'attributes',
	};
	var querySelectSubtree = function (surrogate, value) {
	    // First try the Haiku format
	    if (HaikuNode_1.cssMatchOne(surrogate, value, HAIKU_MATCHING_OPTIONS)) {
	        return surrogate;
	    }
	    // If no match yet, try the React format (TODO: Does this belong here?)
	    if (HaikuNode_1.cssMatchOne(surrogate, value, REACT_MATCHING_OPTIONS)) {
	        return surrogate;
	    }
	    // Visit the descendants (if any) and see if we have a match there
	    var children = (surrogate.children || // Haiku's format
	        (surrogate.props && surrogate.props.children) // React's format
	    );
	    // If no children, we definitely don't have a match in this subtree
	    if (!children) {
	        return null;
	    }
	    // Check for arrays first since arrays pass the typeof object check
	    if (Array.isArray(children)) {
	        for (var i = 0; i < children.length; i++) {
	            var found = querySelectSubtree(children[i], value);
	            // First time a match is found, break the loop and return it
	            if (found) {
	                return found;
	            }
	        }
	    }
	    // React may store 'children' as a single object
	    if (typeof children === 'object') {
	        return querySelectSubtree(children, value);
	    }
	};
	var querySelectSurrogates = function (surrogates, value) {
	    if (Array.isArray(surrogates)) {
	        // Return the first match we locate in the collection
	        return surrogates.map(function (surrogate) { return querySelectSurrogates(surrogate, value); })[0];
	    }
	    if (surrogates && typeof surrogates === 'object') {
	        return querySelectSubtree(surrogates, value);
	    }
	};
	var selectSurrogate = function (surrogates, value) {
	    // If the placeholder value is intended as an array index
	    if (Array.isArray(surrogates) && isNumeric(value) && isInteger(value)) {
	        if (surrogates[value]) {
	            return surrogates[value];
	        }
	    }
	    // If the placeholder value is intended as a key
	    if (surrogates && typeof surrogates === 'object' && typeof value === 'string') {
	        if (surrogates[value]) {
	            return surrogates[value];
	        }
	    }
	    return querySelectSurrogates(surrogates, value + '');
	};
	var getCanonicalPlaybackValue = function (value) {
	    if (typeof value !== 'object') {
	        return {
	            Default: value,
	        };
	    }
	    return value;
	};
	/**
	 * 'Vanities' are functions that provide special handling for applied properties.
	 * So for example, if a component wants to apply 'foo.bar'=3 to a <div> in its template,
	 * the renderer will look in the vanities dictionary to see if there is a
	 * vanity 'foo.bar' available, and if so, pass the value 3 into that function.
	 * The function, in turn, knows how to apply that value to the virtual element passed into
	 * it. In the future these will be defined by components themselves as inputs; for now,
	 * we are keeping a whitelist of possible vanity handlers which the renderer directly
	 * loads and calls.
	 */
	exports.getVanity = function (elementName, propertyName) {
	    if (elementName) {
	        if (exports.VANITIES[elementName] && exports.VANITIES[elementName][propertyName]) {
	            return exports.VANITIES[elementName][propertyName];
	        }
	    }
	    return exports.VANITIES['*'][propertyName];
	};
	/**
	 * Ensures layout before applying a layout vanity.
	 */
	var ensureLayout = function (node) {
	    if (!node.layout) {
	        Layout3D_1.default.initializeNodeLayout(node);
	    }
	};
	exports.LAYOUT_3D_VANITIES = {
	    // Layout has a couple of special values that relate to display
	    // but not to position:
	    shown: function (_, element, value) {
	        ensureLayout(element);
	        element.layout.shown = value;
	    },
	    // Opacity needs to have its opacity *layout* property set
	    // as opposed to its element attribute so the renderer can make a decision about
	    // where to put it based on the rendering medium's rules
	    opacity: function (_, element, value) {
	        ensureLayout(element);
	        element.layout.opacity = value;
	    },
	    // If you really want to set what we call 'position' then
	    // we do so on the element's attributes; this is mainly to
	    // enable the x/y positioning system for SVG elements.
	    'position.x': function (name, element, value) {
	        ensureLayout(element);
	        element.attributes.x = value;
	    },
	    'position.y': function (name, element, value) {
	        ensureLayout(element);
	        element.attributes.y = value;
	    },
	    // Everything that follows is a standard 3-coord component
	    // relating to the element's position in space
	    'rotation.x': function (_, element, value) {
	        ensureLayout(element);
	        element.layout.rotation.x = value;
	    },
	    'rotation.y': function (_, element, value) {
	        ensureLayout(element);
	        element.layout.rotation.y = value;
	    },
	    'rotation.z': function (_, element, value) {
	        ensureLayout(element);
	        element.layout.rotation.z = value;
	    },
	    'offset.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.offset.x = value;
	    },
	    'offset.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.offset.y = value;
	    },
	    'offset.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.offset.z = value;
	    },
	    'origin.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.origin.x = value;
	    },
	    'origin.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.origin.y = value;
	    },
	    'origin.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.origin.z = value;
	    },
	    'scale.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.scale.x = value;
	    },
	    'scale.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.scale.y = value;
	    },
	    'scale.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.scale.z = value;
	    },
	    'sizeAbsolute.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeAbsolute.x = value;
	    },
	    'sizeAbsolute.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeAbsolute.y = value;
	    },
	    'sizeAbsolute.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeAbsolute.z = value;
	    },
	    'sizeDifferential.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeDifferential.x = value;
	    },
	    'sizeDifferential.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeDifferential.y = value;
	    },
	    'sizeDifferential.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeDifferential.z = value;
	    },
	    'sizeMode.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeMode.x = value;
	    },
	    'sizeMode.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeMode.y = value;
	    },
	    'sizeMode.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeMode.z = value;
	    },
	    'sizeProportional.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeProportional.x = value;
	    },
	    'sizeProportional.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeProportional.y = value;
	    },
	    'sizeProportional.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.sizeProportional.z = value;
	    },
	    'shear.xy': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.shear.xy = value;
	    },
	    'shear.xz': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.shear.xz = value;
	    },
	    'shear.yz': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.shear.yz = value;
	    },
	    'translation.x': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.translation.x = value;
	    },
	    'translation.y': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.translation.y = value;
	    },
	    'translation.z': function (name, element, value) {
	        ensureLayout(element);
	        element.layout.translation.z = value;
	    },
	};
	exports.VANITIES = {
	    '*': __assign({}, exports.LAYOUT_3D_VANITIES, { 
	        // CSS style properties that need special handling
	        'style.WebkitTapHighlightColor': function (_, element, value) {
	            element.attributes.style.webkitTapHighlightColor = value;
	        }, 
	        // Text and other inner-content related vanities
	        content: function (name, element, value, context, timeline, receiver, sender) {
	            element.__memory.children = [value];
	            // If we don't do this, then content changes resulting from setState calls
	            // don't have the effect of flushing the content, and the rendered text doesn't change.
	            // DEMO: bind-numeric-state-to-text
	            // TODO: What is the best way to make this less expensive (while still functional)?
	            sender.patches.push(element);
	        }, 
	        // Playback-related vanities that involve controlling timeline or clock time
	        playback: function (name, element, value, context, timeline, receiver, sender) {
	            var canonicalValue = getCanonicalPlaybackValue(value);
	            for (var timelineName in canonicalValue) {
	                var timelineInstance = receiver && receiver.getTimeline(timelineName);
	                if (timelineInstance) {
	                    timelineInstance.setPlaybackStatus(canonicalValue[timelineName]);
	                }
	            }
	        }, 
	        // Control-flow vanities that alter the output structure of the component
	        'controlFlow.placeholder': function (name, element, value, context, timeline, receiver, sender) {
	            // For MVP's sake, structural behaviors not rendered during hot editing.
	            if (sender.config.hotEditingMode) {
	                return;
	            }
	            if (value === null || value === undefined) {
	                return;
	            }
	            if (typeof value !== 'number' && typeof value !== 'string') {
	                return;
	            }
	            var surrogates;
	            // Surrogates can be passed in as:
	            //   - React children (an array)
	            //   - A React subtree (we'll use query selectors to match)
	            //   - A Haiku subtree (we'll use query selectors to match)
	            //   - Key/value pairs
	            if (context.config.children) {
	                surrogates = context.config.children;
	                if (!Array.isArray(surrogates)) {
	                    surrogates = [surrogates];
	                }
	            }
	            else if (context.config.placeholder) {
	                surrogates = context.config.placeholder;
	            }
	            if (!surrogates) {
	                return;
	            }
	            var surrogate = selectSurrogate(surrogates, value);
	            if (surrogate === null || surrogate === undefined) {
	                return;
	            }
	            if (!element.__memory.placeholder) {
	                element.__memory.placeholder = {};
	            }
	            element.__memory.placeholder.value = value;
	            // If we are running via a framework adapter, allow that framework to provide its own placeholder mechanism.
	            // This is necessary e.g. in React where their element format needs to be converted into our 'mana' format
	            if (context.config.vanities['controlFlow.placeholder']) {
	                context.config.vanities['controlFlow.placeholder'](element, surrogate, value, context, timeline, receiver, sender);
	            }
	            else {
	                element.__memory.placeholder.surrogate = surrogate;
	            }
	        }, 'controlFlow.repeat': function (name, element, value, context, timeline, receiver, sender) {
	            var instructions;
	            if (Array.isArray(value)) {
	                instructions = value;
	            }
	            else if (isNumeric(value)) {
	                var arr = [];
	                for (var i = 0; i < value; i++) {
	                    arr.push({}); // Empty repeat payload spec
	                }
	                instructions = arr;
	            }
	            else {
	                return;
	            }
	            if (element.__memory.repeatee) {
	                // Don't repeat the repeatee of an existing repeater
	                if (element.__memory.repeatee.index > 0) {
	                    return;
	                }
	            }
	            if (element.__memory.repeater) {
	                if (element.__memory.repeater.changed) {
	                    element.__memory.repeater.changed = false;
	                }
	                else {
	                    // Save CPU by avoiding recomputing a repeat when we've already done so.
	                    // Although upstream HaikuComponent#applyLocalBehaviors does do diff comparisons,
	                    // it intentionally skips this comparison for complex properties i.e. arrays
	                    // and objects due to the intractability of smartly comparing for all cases.
	                    // We do a comparison that is fairly sensible in the repeat-exclusive case.
	                    if (isSameRepeatBehavior(element.__memory.repeater.instructions, instructions)) {
	                        return;
	                    }
	                }
	            }
	            if (!element.__memory.repeater) {
	                element.__memory.repeater = {};
	            }
	            element.__memory.repeater.instructions = instructions;
	            // Structural behaviors are not rendered during hot editing.
	            if (sender.config.hotEditingMode) {
	                // If we got at least one instruction, render that by default into the repeater
	                if (instructions.length > 0) {
	                    element.__memory.repeatee = {
	                        instructions: instructions,
	                        index: 0,
	                        payload: instructions[0],
	                        source: element,
	                    };
	                    applyPayloadToNode(element, instructions[0], sender, timeline);
	                    sender.patches.push(element);
	                    expandNode(element, element.__memory.parent);
	                }
	                return;
	            }
	            if (!element.__memory.repeater.repeatees) {
	                element.__memory.repeater.repeatees = [];
	            }
	            else {
	                // If the instructions have decreased on this run, remove the excess repeatees
	                element.__memory.repeater.repeatees.splice(instructions.length);
	            }
	            instructions.forEach(function (payload, index) {
	                var repeatee = (index === 0)
	                    ? element // The first element should be the source element
	                    : element.__memory.repeater.repeatees[index] || exports.clone(element, sender);
	                // We have to initialize the element's component instance, etc.
	                hydrateNode(repeatee, element.__memory.parent, // parent
	                sender, // component
	                sender.context, // context
	                sender, // host
	                element.__memory.scope, // scope (use same scope as source node)
	                sender.config, // options
	                false);
	                repeatee.__memory.repeatee = {
	                    index: index,
	                    instructions: instructions,
	                    payload: payload,
	                    source: element,
	                };
	                applyPayloadToNode(repeatee, payload, sender, timeline);
	                element.__memory.repeater.repeatees[index] = repeatee;
	            });
	            sender.patches.push(element);
	            expandNode(element, element.__memory.parent);
	        }, 'controlFlow.if': function (name, element, value, context, timeline, receiver, sender) {
	            // For MVP's sake, structural behaviors not rendered during hot editing.
	            if (sender.config.hotEditingMode) {
	                return;
	            }
	            // Assume our if-answer is only false if we got an explicit false value
	            var answer = value !== false;
	            if (element.__memory.if) {
	                // Save CPU by avoiding recomputing an if when we've already done so.
	                if (isSameIfBehavior(element.__memory.if.answer, answer)) {
	                    return;
	                }
	            }
	            element.__memory.if = {
	                answer: answer,
	            };
	            // Ensure that a change in repeat will trigger the necessary re-repeat
	            if (element.__memory.repeater) {
	                element.__memory.repeater.changed = true;
	            }
	            sender.markForFullFlush();
	        } }),
	};
	var applyPayloadToNode = function (node, payload, sender, timeline) {
	    // Apply the repeat payload to the element as if it were a normal timeline output
	    for (var propertyName in payload) {
	        // Control-flow occurs after presentational behaviors, meaning we are overriding
	        // whatever may have been set on the source element instance.
	        sender.applyPropertyToNode(node, // matchingElement
	        propertyName, payload[propertyName], // finalValue
	        timeline);
	    }
	};
	var isSameIfBehavior = function (prev, next) {
	    return prev === next;
	};
	var isSameRepeatBehavior = function (prevs, nexts) {
	    if (prevs === nexts) {
	        return true;
	    }
	    if (prevs.length !== nexts.length) {
	        return false;
	    }
	    var answer = true;
	    for (var i = 0; i < prevs.length; i++) {
	        if (!answer) {
	            break;
	        }
	        var prev = prevs[i];
	        var next = nexts[i];
	        if (prev === next) {
	            continue;
	        }
	        for (var key in next) {
	            if (next[key] !== prev[key]) {
	                answer = false;
	                break;
	            }
	        }
	    }
	    return answer;
	};
	var findRespectiveRepeatees = function (target) {
	    var repeatees = [];
	    // Required to fix a race condition that can occur during copy+paste in Haiku.app
	    if (!target.__memory) {
	        return repeatees;
	    }
	    // The host repeatee of the given target node, if the target is a repeater's descendant
	    var host;
	    if (target.__memory.repeatee) {
	        host = target;
	    }
	    else {
	        // Note that we do not ascend beyond the nearest host component instance
	        HaikuNode_1.ascend(target, function (node) {
	            if (node.__memory.repeatee) {
	                host = node;
	            }
	        });
	    }
	    // If we've found a host repeatee, the target is a descendant of a repeater,
	    // and we need to find its respective node within each repeatee.
	    if (host) {
	        var repeater = host.__memory.repeatee.source;
	        if (repeater.__memory.repeater.repeatees) {
	            repeater.__memory.repeater.repeatees.forEach(function (repeatee) {
	                HaikuNode_1.visit(repeatee, function (candidate) {
	                    if (areNodesRespective(target, candidate)) {
	                        repeatees.push(candidate);
	                    }
	                });
	            });
	        }
	    }
	    return repeatees;
	};
	var areNodesRespective = function (n1, n2) {
	    if (n1 === n2) {
	        return true;
	    }
	    // We assume that all nodes within the tree of a component have unique haiku-ids, and that
	    // these haiku-ids are not directly modified within repeater groups
	    if (
	    // If the haiku-id attribute is empty, assume the comparison isn't valid
	    n1.attributes[HAIKU_ID_ATTRIBUTE] &&
	        n1.attributes[HAIKU_ID_ATTRIBUTE] === n2.attributes[HAIKU_ID_ATTRIBUTE]) {
	        return true;
	    }
	    return false;
	};
	exports.getFallback = function (elementName, propertyName) {
	    if (elementName) {
	        if (LAYOUT_COORDINATE_SYSTEM_FALLBACKS[elementName] &&
	            LAYOUT_COORDINATE_SYSTEM_FALLBACKS[elementName][propertyName] !== undefined) {
	            return LAYOUT_COORDINATE_SYSTEM_FALLBACKS[elementName][propertyName];
	        }
	        if (exports.FALLBACKS[elementName] && exports.FALLBACKS[elementName][propertyName] !== undefined) {
	            return exports.FALLBACKS[elementName][propertyName];
	        }
	    }
	    return exports.FALLBACKS['*'][propertyName];
	};
	var LAYOUT_COORDINATE_SYSTEM_FALLBACKS = {
	    svg: {
	        'origin.x': 0.5,
	        'origin.y': 0.5,
	        'origin.z': 0.5,
	    },
	};
	var LAYOUT_DEFAULTS = Layout3D_1.default.createLayoutSpec();
	exports.FALLBACKS = {
	    '*': {
	        shown: LAYOUT_DEFAULTS.shown,
	        opacity: LAYOUT_DEFAULTS.opacity,
	        content: '',
	        'offset.x': LAYOUT_DEFAULTS.offset.x,
	        'offset.y': LAYOUT_DEFAULTS.offset.y,
	        'offset.z': LAYOUT_DEFAULTS.offset.z,
	        'origin.x': LAYOUT_DEFAULTS.origin.x,
	        'origin.y': LAYOUT_DEFAULTS.origin.y,
	        'origin.z': LAYOUT_DEFAULTS.origin.z,
	        'translation.x': LAYOUT_DEFAULTS.translation.x,
	        'translation.y': LAYOUT_DEFAULTS.translation.y,
	        'translation.z': LAYOUT_DEFAULTS.translation.z,
	        'rotation.x': LAYOUT_DEFAULTS.rotation.x,
	        'rotation.y': LAYOUT_DEFAULTS.rotation.y,
	        'rotation.z': LAYOUT_DEFAULTS.rotation.z,
	        'scale.x': LAYOUT_DEFAULTS.scale.x,
	        'scale.y': LAYOUT_DEFAULTS.scale.y,
	        'scale.z': LAYOUT_DEFAULTS.scale.z,
	        'shear.xy': LAYOUT_DEFAULTS.shear.xy,
	        'shear.xz': LAYOUT_DEFAULTS.shear.xz,
	        'shear.yz': LAYOUT_DEFAULTS.shear.yz,
	        'sizeAbsolute.x': LAYOUT_DEFAULTS.sizeAbsolute.x,
	        'sizeAbsolute.y': LAYOUT_DEFAULTS.sizeAbsolute.y,
	        'sizeAbsolute.z': LAYOUT_DEFAULTS.sizeAbsolute.z,
	        'sizeProportional.x': LAYOUT_DEFAULTS.sizeProportional.x,
	        'sizeProportional.y': LAYOUT_DEFAULTS.sizeProportional.y,
	        'sizeProportional.z': LAYOUT_DEFAULTS.sizeProportional.z,
	        'sizeDifferential.x': LAYOUT_DEFAULTS.sizeDifferential.x,
	        'sizeDifferential.y': LAYOUT_DEFAULTS.sizeDifferential.y,
	        'sizeDifferential.z': LAYOUT_DEFAULTS.sizeDifferential.z,
	        'sizeMode.x': LAYOUT_DEFAULTS.sizeMode.x,
	        'sizeMode.y': LAYOUT_DEFAULTS.sizeMode.y,
	        'sizeMode.z': LAYOUT_DEFAULTS.sizeMode.z,
	        'style.overflowX': 'hidden',
	        'style.overflowY': 'hidden',
	        'style.zIndex': 1,
	        'style.WebkitTapHighlightColor': 'rgba(0,0,0,0)',
	        width: 0,
	        height: 0,
	        x: 0,
	        y: 0,
	        r: 0,
	        cx: 0,
	        cy: 0,
	        rx: 0,
	        ry: 0,
	        x1: 0,
	        y1: 0,
	        x2: 0,
	        y2: 0,
	        playback: "loop" /* LOOP */,
	        'controlFlow.repeat': null,
	        'controlFlow.placeholder': null,
	    },
	};
	exports.LAYOUT_3D_SCHEMA = {
	    shown: 'boolean',
	    opacity: 'number',
	    'offset.x': 'number',
	    'offset.y': 'number',
	    'offset.z': 'number',
	    'origin.x': 'number',
	    'origin.y': 'number',
	    'origin.z': 'number',
	    'translation.x': 'number',
	    'translation.y': 'number',
	    'translation.z': 'number',
	    'rotation.x': 'number',
	    'rotation.y': 'number',
	    'rotation.z': 'number',
	    'scale.x': 'number',
	    'scale.y': 'number',
	    'scale.z': 'number',
	    'shear.xy': 'number',
	    'shear.xz': 'number',
	    'shear.yz': 'number',
	    'sizeAbsolute.x': 'number',
	    'sizeAbsolute.y': 'number',
	    'sizeAbsolute.z': 'number',
	    'sizeProportional.x': 'number',
	    'sizeProportional.y': 'number',
	    'sizeProportional.z': 'number',
	    'sizeDifferential.x': 'number',
	    'sizeDifferential.y': 'number',
	    'sizeDifferential.z': 'number',
	    'sizeMode.x': 'number',
	    'sizeMode.y': 'number',
	    'sizeMode.z': 'number',
	};
	exports.ATTRS_CAMEL_TO_HYPH = {
	    accentHeight: 'accent-height',
	    alignmentBaseline: 'alignment-baseline',
	    arabicForm: 'arabic-form',
	    baselineShift: 'baseline-shift',
	    capHeight: 'cap-height',
	    clipPath: 'clip-path',
	    clipRule: 'clip-rule',
	    colorInterpolation: 'color-interpolation',
	    colorInterpolationFilters: 'color-interpolation-filters',
	    colorProfile: 'color-profile',
	    colorRendering: 'color-rendering',
	    dominantBaseline: 'dominant-baseline',
	    enableBackground: 'enable-background',
	    fillOpacity: 'fill-opacity',
	    fillRule: 'fill-rule',
	    floodColor: 'flood-color',
	    floodOpacity: 'flood-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    fontSizeAdjust: 'font-size-adjust',
	    fontStretch: 'font-stretch',
	    fontStyle: 'font-style',
	    fontVariant: 'font-variant',
	    fontWeight: 'font-weight',
	    glyphName: 'glyph-name',
	    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	    glyphOrientationVertical: 'glyph-orientation-vertical',
	    horizAdvX: 'horiz-adv-x',
	    horizOriginX: 'horiz-origin-x',
	    imageRendering: 'image-rendering',
	    letterSpacing: 'letter-spacing',
	    lightingColor: 'lighting-color',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    overlinePosition: 'overline-position',
	    overlineThickness: 'overline-thickness',
	    panose1: 'panose-1',
	    paintOrder: 'paint-order',
	    pointerEvents: 'pointer-events',
	    renderingIntent: 'rendering-intent',
	    shapeRendering: 'shape-rendering',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strikethroughPosition: 'strikethrough-position',
	    strikethroughThickness: 'strikethrough-thickness',
	    strokeDasharray: 'stroke-dasharray',
	    strokeDashoffset: 'stroke-dashoffset',
	    strokeLinecap: 'stroke-linecap',
	    strokeLinejoin: 'stroke-linejoin',
	    strokeMiterlimit: 'stroke-miterlimit',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    textDecoration: 'text-decoration',
	    textRendering: 'text-rendering',
	    underlinePosition: 'underline-position',
	    underlineThickness: 'underline-thickness',
	    unicodeBidi: 'unicode-bidi',
	    unicodeRange: 'unicode-range',
	    unitsPerEm: 'units-per-em',
	    vAlphabetic: 'v-alphabetic',
	    vHanging: 'v-hanging',
	    vIdeographic: 'v-ideographic',
	    vMathematical: 'v-mathematical',
	    vectorEffect: 'vector-effect',
	    vertAdvY: 'vert-adv-y',
	    vertOriginX: 'vert-origin-x',
	    vertOriginY: 'vert-origin-y',
	    wordSpacing: 'word-spacing',
	    writingMode: 'writing-mode',
	    xHeight: 'x-height',
	};
	exports.ATTRS_HYPH_TO_CAMEL = {};
	for (var camel in exports.ATTRS_CAMEL_TO_HYPH) {
	    exports.ATTRS_HYPH_TO_CAMEL[exports.ATTRS_CAMEL_TO_HYPH[camel]] = camel;
	}
	INJECTABLES.$window = {
	    schema: {},
	    summon: function (injectees) {
	        injectees.$window = (typeof window !== 'undefined') ? window : {};
	    },
	};
	INJECTABLES.$mount = {
	    schema: {},
	    summon: function (injectees, component) {
	        injectees.$mount = component.context.renderer.mount;
	    },
	};
	INJECTABLES.$core = {
	    schema: {},
	    summon: function (injectees, component, node, timelineName) {
	        injectees.$core = {
	            component: component,
	            context: component.context,
	            options: component.config,
	            timeline: component.getTimeline(timelineName),
	            clock: component.getClock(),
	        };
	    },
	};
	INJECTABLES.$context = {
	    schema: {},
	    summon: function (injectees, component) {
	        injectees.$context = component.context;
	    },
	};
	INJECTABLES.$component = {
	    schema: {},
	    summon: function (injectees, component) {
	        injectees.$component = component;
	    },
	};
	INJECTABLES.$host = {
	    schema: {},
	    summon: function (injectees, component) {
	        injectees.$host = component.host;
	    },
	};
	INJECTABLES.$top = {
	    schema: {},
	    summon: function (injectees, component) {
	        injectees.$host = component.top;
	    },
	};
	INJECTABLES.$clock = {
	    schema: {},
	    summon: function (injectees, component) {
	        injectees.$timeline = component.getClock();
	    },
	};
	INJECTABLES.$state = {
	    schema: {},
	    summon: function (injectees, component) {
	        injectees.$state = component.state;
	    },
	};
	INJECTABLES.$timeline = {
	    schema: {},
	    summon: function (injectees, component, node, timelineName) {
	        injectees.$timeline = component.getTimeline(timelineName);
	    },
	};
	INJECTABLES.$element = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        injectees.$element = HaikuElement_1.default.findOrCreateByNode(node);
	    },
	};
	INJECTABLES.$parent = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        injectees.$parent = HaikuElement_1.default.findOrCreateByNode(node).parent;
	    },
	};
	INJECTABLES.$container = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        var element = HaikuElement_1.default.findOrCreateByNode(node);
	        injectees.$container = element.owner;
	    },
	};
	INJECTABLES.$children = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        injectees.$children = HaikuElement_1.default.findOrCreateByNode(node).children;
	    },
	};
	INJECTABLES.$tree = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        var element = HaikuElement_1.default.findOrCreateByNode(node);
	        injectees.$tree = {
	            element: element,
	            component: component,
	            parent: element.parent,
	            children: element.children,
	            root: element.owner,
	        };
	    },
	};
	INJECTABLES.$user = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        if (component.isLiveMode()) {
	            injectees.$user = component.context.getGlobalUserState();
	            // If we're inside another component, produce mouse coords in terms
	            // of our own coordinate space
	            if (component.host) {
	                Object.assign(injectees.$user.mouse, component.transformContextPointToLocalPoint(Object.assign({}, injectees.$user.mouse)));
	            }
	        }
	        else {
	            injectees.$user = {
	                mouse: {
	                    x: 1,
	                    y: 1,
	                    down: 0,
	                    buttons: [0, 0, 0],
	                },
	                pan: {
	                    x: 0,
	                    y: 0,
	                },
	                keys: {},
	                touches: [],
	                mouches: [],
	            };
	        }
	    },
	};
	var getRepeatHostNode = function (node) {
	    if (!node) {
	        return;
	    }
	    if (node.__memory.repeatee) {
	        return node;
	    }
	    return getRepeatHostNode(node.__memory && node.__memory.parent);
	};
	var getIfHostNode = function (node) {
	    if (!node) {
	        return;
	    }
	    if (node.__memory.if) {
	        return node;
	    }
	    return getIfHostNode(node.__memory && node.__memory.parent);
	};
	INJECTABLES.$flow = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        if (!injectees.$flow) {
	            injectees.$flow = {};
	        }
	        var repeatNode = getRepeatHostNode(node);
	        injectees.$flow.repeat = (repeatNode && repeatNode.__memory.repeatee) || {
	            instructions: [],
	            payload: {},
	            source: repeatNode,
	            index: 0,
	        };
	        var ifNode = getIfHostNode(node);
	        injectees.$flow.if = (ifNode && ifNode.__memory.if) || {
	            answer: null,
	        };
	        injectees.$flow.placeholder = node.__memory.placeholder || {
	            value: null,
	            surrogate: null,
	        };
	    },
	};
	INJECTABLES.$repeat = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        if (!injectees.$repeat) {
	            injectees.$repeat = {};
	        }
	        var repeatNode = getRepeatHostNode(node);
	        injectees.$repeat = (repeatNode && repeatNode.__memory.repeatee) || {
	            instructions: [],
	            payload: {},
	            source: repeatNode,
	            index: 0,
	        };
	    },
	};
	INJECTABLES.$if = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        if (!injectees.$if) {
	            injectees.$if = {};
	        }
	        var ifNode = getIfHostNode(node);
	        injectees.$if = (ifNode && ifNode.__memory.if) || {
	            answer: null,
	        };
	    },
	};
	INJECTABLES.$placeholder = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        if (!injectees.$placeholder) {
	            injectees.$placeholder = {};
	        }
	        injectees.$placeholder = node.__memory.placeholder || {
	            value: null,
	            surrogate: null,
	        };
	    },
	};
	INJECTABLES.$index = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        var repeatNode = getRepeatHostNode(node);
	        injectees.$index = (repeatNode &&
	            repeatNode.__memory.repeatee &&
	            repeatNode.__memory.repeatee.index) || 0;
	    },
	};
	INJECTABLES.$payload = {
	    schema: {},
	    summon: function (injectees, component, node) {
	        var repeatNode = getRepeatHostNode(node);
	        injectees.$payload = (repeatNode &&
	            repeatNode.__memory.repeatee &&
	            repeatNode.__memory.repeatee.payload) || {};
	    },
	};
	INJECTABLES.$helpers = {
	    schema: {},
	    summon: function (injectees, component) {
	        injectees.$helpers = component.helpers;
	    },
	};
	// List of JavaScript global built-in objects that we want to provide as an injectable.
	// In the future, we might end up passing in modified versions of these objects/functions.
	var BUILTIN_INJECTABLES = {
	    Infinity: Infinity,
	    NaN: NaN,
	    Object: Object,
	    Boolean: Boolean,
	    Math: Math,
	    Date: Date,
	    JSON: JSON,
	    Number: Number,
	    String: String,
	    RegExp: RegExp,
	    Array: Array,
	    isFinite: isFinite,
	    isNaN: isNaN,
	    parseFloat: parseFloat,
	    parseInt: parseInt,
	    decodeURI: decodeURI,
	    decodeURIComponent: decodeURIComponent,
	    encodeURI: encodeURI,
	    encodeURIComponent: encodeURIComponent,
	    // escape,
	    // unescape,
	    Error: Error,
	    ReferenceError: ReferenceError,
	    SyntaxError: SyntaxError,
	    TypeError: TypeError,
	    undefined: void (0),
	};
	var _loop_1 = function (builtinInjectableKey) {
	    INJECTABLES[builtinInjectableKey] = {
	        summon: function (injectees) {
	            injectees[builtinInjectableKey] = BUILTIN_INJECTABLES[builtinInjectableKey];
	        },
	    };
	};
	for (var builtinInjectableKey in BUILTIN_INJECTABLES) {
	    _loop_1(builtinInjectableKey);
	}
	/**
	 * When evaluating expressions written by the user, don't crash everything.
	 * Log the error (but only once, since we're animating) and then return a
	 * fairly safe all-purpose value (1).
	 */
	var safeCall = function (fn, hostInstance, hostStates) {
	    try {
	        return fn.call(hostInstance, hostStates);
	    }
	    catch (exception) {
	        consoleErrorOnce_1.default(exception);
	        return 1;
	    }
	};
	var safeApply = function (fn, hostInstance, summoneesArray) {
	    try {
	        return fn.apply(hostInstance, summoneesArray);
	    }
	    catch (exception) {
	        consoleErrorOnce_1.default(exception);
	        return 1;
	    }
	};
	var areSummoneesDifferent = function (previous, incoming) {
	    if (Array.isArray(previous) && Array.isArray(incoming)) {
	        if (previous.length !== incoming.length) {
	            return true;
	        }
	        // Do a shallow comparison of elements. We don't go deep because:
	        //   - It easily becomes too expensive to do this while rendering
	        //   - We can avoid needing to check for recursion
	        for (var i = 0; i < previous.length; i++) {
	            // Assume that objects are different since we don't want to do a deep comparison
	            if (previous[i] && typeof previous[i] === 'object') {
	                return true;
	            }
	            if (previous[i] !== incoming[i]) {
	                return true;
	            }
	        }
	        for (var j = 0; j < previous.length; j++) {
	            // Assume that objects are different since we don't want to do a deep comparison
	            if (incoming[j] && typeof incoming[j] === 'object') {
	                return true;
	            }
	            if (incoming[j] !== previous[j]) {
	                return true;
	            }
	        }
	        return false;
	    }
	    if (typeof previous === OBJECT && typeof incoming === OBJECT) {
	        if (previous === null && incoming === null) {
	            return false;
	        }
	        if (previous === null) {
	            return true;
	        }
	        if (incoming === null) {
	            return true;
	        }
	        // Do a shallow comparison of properties. We don't go deep because:
	        //   - It easily becomes too expensive to do this while rendering
	        //   - We can avoid needing to check for recursion
	        for (var pkey in previous) {
	            if (previous[pkey] !== incoming[pkey]) {
	                return true;
	            }
	        }
	        for (var ikey in incoming) {
	            if (incoming[ikey] !== previous[ikey]) {
	                return true;
	            }
	        }
	        return false;
	    }
	    return previous !== incoming;
	};
	var stringToInt = function (str) {
	    var hash = 5381;
	    var i = str.length;
	    while (i) {
	        hash = (hash * 33) ^ str.charCodeAt(--i);
	    }
	    return hash >>> 0;
	};
	//# sourceMappingURL=HaikuComponent.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var just_curves_1 = __webpack_require__(199);
	var CENT = 1.0;
	var OBJECT = 'object';
	var NUMBER = 'number';
	var STRING = 'string';
	var PERCENT_REGEX = /^\d+(\.\d+)?%$/;
	var PERCENT_SYMBOL = '%';
	var isString = function (value) { return typeof value === STRING; };
	function percentOfTime(t0, t1, tnow) {
	    var span = t1 - t0;
	    if (span === 0) {
	        return CENT;
	    } // No divide-by-zero
	    var remaining = t1 - tnow;
	    return CENT - remaining / span;
	}
	function valueAtPercent(v0, v1, pc) {
	    var span = v1 - v0;
	    var gain = span * pc;
	    return v0 + gain;
	}
	function interpolateValue(v0, v1, t0, t1, tnow, curve) {
	    var pc = percentOfTime(t0, t1, tnow);
	    if (pc > CENT) {
	        pc = CENT;
	    }
	    if (curve) {
	        pc = curve(pc);
	    }
	    return valueAtPercent(v0, v1, pc);
	}
	exports.interpolate = function (now, curve, started, ends, origin, destination) {
	    // Return early if we aren't tweening anything.
	    if (origin === destination) {
	        return origin;
	    }
	    // If curve is a string, transform into a function using justCurves
	    var curveFunc = typeof curve === 'string' ? just_curves_1.default[curve] : curve;
	    if (typeof curveFunc !== 'function') {
	        return origin;
	    }
	    if (Array.isArray(origin) && Array.isArray(destination)) {
	        var arrayOutput = [];
	        for (var i = 0; i < origin.length; i++) {
	            arrayOutput[i] = exports.interpolate(now, curveFunc, started, ends, origin[i], destination[i]);
	        }
	        return arrayOutput;
	    }
	    if (origin && typeof origin === OBJECT && destination && typeof destination === OBJECT) {
	        var objectOutput = {};
	        for (var key in origin) {
	            objectOutput[key] = exports.interpolate(now, curveFunc, started, ends, origin[key], destination[key]);
	        }
	        return objectOutput;
	    }
	    if (typeof origin === NUMBER && typeof destination === NUMBER) {
	        return interpolateValue(origin, destination, started, ends, now, curveFunc);
	    }
	    if (isString(origin) &&
	        isString(destination) &&
	        PERCENT_REGEX.test(origin) &&
	        PERCENT_REGEX.test(destination)) {
	        return interpolateValue(parseFloat(origin), parseFloat(destination), started, ends, now, curveFunc) + PERCENT_SYMBOL;
	    }
	    return origin;
	};
	//# sourceMappingURL=Interpolate.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Curve;
	(function (Curve) {
	    Curve["EaseInBack"] = "easeInBack";
	    Curve["EaseInCirc"] = "easeInCirc";
	    Curve["EaseInCubic"] = "easeInCubic";
	    Curve["EaseInExpo"] = "easeInExpo";
	    Curve["EaseInQuad"] = "easeInQuad";
	    Curve["EaseInQuart"] = "easeInQuart";
	    Curve["EaseInBounce"] = "easeInBounce";
	    Curve["EaseInElastic"] = "easeInElastic";
	    Curve["EaseInQuint"] = "easeInQuint";
	    Curve["EaseInSine"] = "easeInSine";
	    Curve["EaseOutBack"] = "easeOutBack";
	    Curve["EaseOutCirc"] = "easeOutCirc";
	    Curve["EaseOutCubic"] = "easeOutCubic";
	    Curve["EaseOutExpo"] = "easeOutExpo";
	    Curve["EaseOutQuad"] = "easeOutQuad";
	    Curve["EaseOutQuart"] = "easeOutQuart";
	    Curve["EaseOutBounce"] = "easeOutBounce";
	    Curve["EaseOutElastic"] = "easeOutElastic";
	    Curve["EaseOutQuint"] = "easeOutQuint";
	    Curve["EaseOutSine"] = "easeOutSine";
	    Curve["EaseInOutBack"] = "easeInOutBack";
	    Curve["EaseInOutCirc"] = "easeInOutCirc";
	    Curve["EaseInOutCubic"] = "easeInOutCubic";
	    Curve["EaseInOutExpo"] = "easeInOutExpo";
	    Curve["EaseInOutQuad"] = "easeInOutQuad";
	    Curve["EaseInOutQuart"] = "easeInOutQuart";
	    Curve["EaseInOutBounce"] = "easeInOutBounce";
	    Curve["EaseInOutElastic"] = "easeInOutElastic";
	    Curve["EaseInOutQuint"] = "easeInOutQuint";
	    Curve["EaseInOutSine"] = "easeInOutSine";
	    Curve["Linear"] = "linear";
	})(Curve = exports.Curve || (exports.Curve = {}));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var sortNumeric = function (a, b) { return a - b; };
	exports.getSortedKeyframes = function (propertyGroup) {
	    return Object.keys(propertyGroup).map(Number).sort(sortNumeric);
	};
	//# sourceMappingURL=KeyframeUtils.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var svg_points_1 = __webpack_require__(207);
	var parseCssValueString_1 = __webpack_require__(130);
	// In leiu of good math, this gives pretty good results for converting arcs to cubic beziers
	var MAGIC_BEZIER_ARC_RATIO = 1.8106602;
	var SVG_TYPES = {
	    g: true,
	    rect: true,
	    polyline: true,
	    polygon: true,
	    path: true,
	    line: true,
	    ellipse: true,
	    circle: true,
	};
	var SVG_POINT_NUMERIC_FIELDS = {
	    cx: true,
	    cy: true,
	    r: true,
	    rx: true,
	    ry: true,
	    x1: true,
	    x2: true,
	    x: true,
	    y: true,
	};
	var SVG_POINT_COMMAND_FIELDS = {
	    d: true,
	    points: true,
	};
	var SVG_COMMAND_TYPES = {
	    path: true,
	    polyline: true,
	    polygon: true,
	};
	function polyPointsStringToPoints(pointsString) {
	    if (!pointsString) {
	        return [];
	    }
	    if (Array.isArray(pointsString)) {
	        return pointsString;
	    }
	    // Normalize "x1,y1 x2,y2" syntax to "x1 y1 x2 y2" syntax before splitting.
	    var chunkedPoints = [];
	    var points = pointsString.trim().replace(/,/g, ' ').split(/\s+/g).map(Number);
	    for (var i = 0; i < points.length; i += 2) {
	        chunkedPoints.push(points.slice(i, i + 2));
	    }
	    return chunkedPoints;
	}
	function pointsToPolyString(points) {
	    if (!points) {
	        return '';
	    }
	    if (typeof points === 'string') {
	        return points;
	    }
	    var arr = [];
	    for (var i = 0; i < points.length; i++) {
	        var point = points[i];
	        var seg = point.join(',');
	        arr.push(seg);
	    }
	    return arr.join(' ');
	}
	function rectToPoints(x, y, width, height, rxIn, ryIn) {
	    var rx = rxIn;
	    var ry = ryIn;
	    if (rx || ry) {
	        if (rx && isNaN(ry)) {
	            ry = rx;
	        } // Assume equal radius if ry is not defined (SVG)
	        if (isNaN(rx)) {
	            rx = 0;
	        }
	        if (isNaN(ry)) {
	            ry = 0;
	        }
	        return [
	            {
	                y: y,
	                x: x + rx,
	                moveTo: true,
	            },
	            {
	                y: y,
	                x: x + width - rx,
	            },
	            {
	                x: x + width,
	                y: y + ry,
	                curve: {
	                    type: 'cubic',
	                    x1: x + width - rx + rx / MAGIC_BEZIER_ARC_RATIO,
	                    y1: y,
	                    x2: x + width,
	                    y2: y + ry / MAGIC_BEZIER_ARC_RATIO,
	                },
	            },
	            {
	                x: x + width,
	                y: y + height - ry,
	            },
	            {
	                x: x + width - rx,
	                y: y + height,
	                curve: {
	                    type: 'cubic',
	                    x1: x + width,
	                    y1: y + height - ry / MAGIC_BEZIER_ARC_RATIO,
	                    x2: x + width - rx + rx / MAGIC_BEZIER_ARC_RATIO,
	                    y2: y + height,
	                },
	            },
	            {
	                x: x + rx,
	                y: y + height,
	            },
	            {
	                x: x,
	                y: y + height - ry,
	                curve: {
	                    type: 'cubic',
	                    x1: x + rx - rx / MAGIC_BEZIER_ARC_RATIO,
	                    y1: y + height,
	                    x2: x,
	                    y2: y + height - ry / MAGIC_BEZIER_ARC_RATIO,
	                },
	            },
	            {
	                x: x,
	                y: y + ry,
	            },
	            {
	                y: y,
	                x: x + rx,
	                closed: true,
	                curve: {
	                    type: 'cubic',
	                    x1: x,
	                    y1: y + ry - ry / MAGIC_BEZIER_ARC_RATIO,
	                    x2: x + rx - rx / MAGIC_BEZIER_ARC_RATIO,
	                    y2: y,
	                },
	            },
	        ];
	    }
	    // Non-rounded rect
	    return [
	        {
	            x: x,
	            y: y,
	            moveTo: true,
	        },
	        {
	            y: y,
	            x: x + width,
	        },
	        {
	            x: x + width,
	            y: y + height,
	        },
	        {
	            x: x,
	            y: y + height,
	            closed: true,
	        },
	        {
	            x: x,
	            y: y,
	        },
	    ];
	}
	function circleToPoints(cx, cy, r) {
	    return ellipseToPoints(cx, cy, r, r);
	}
	function ellipseToPoints(cx, cy, rx, ry) {
	    return [
	        {
	            x: cx,
	            y: cy - ry,
	            moveTo: true,
	        },
	        {
	            x: cx + rx,
	            y: cy,
	            curve: {
	                type: 'cubic',
	                x1: cx + rx / MAGIC_BEZIER_ARC_RATIO,
	                y1: cy - ry,
	                x2: cx + rx,
	                y2: cy - ry / MAGIC_BEZIER_ARC_RATIO,
	            },
	        },
	        {
	            x: cx,
	            y: cy + ry,
	            curve: {
	                type: 'cubic',
	                x1: cx + rx,
	                y1: cy + ry / MAGIC_BEZIER_ARC_RATIO,
	                x2: cx + rx / MAGIC_BEZIER_ARC_RATIO,
	                y2: cy + ry,
	            },
	        },
	        {
	            x: cx - rx,
	            y: cy,
	            curve: {
	                type: 'cubic',
	                x1: cx - rx / MAGIC_BEZIER_ARC_RATIO,
	                y1: cy + ry,
	                x2: cx - rx,
	                y2: cy + ry / MAGIC_BEZIER_ARC_RATIO,
	            },
	        },
	        {
	            x: cx,
	            y: cy - ry,
	            closed: true,
	            curve: {
	                type: 'cubic',
	                x1: cx - rx,
	                y1: cy - ry / MAGIC_BEZIER_ARC_RATIO,
	                x2: cx - rx / MAGIC_BEZIER_ARC_RATIO,
	                y2: cy - ry,
	            },
	        },
	    ];
	}
	function lineToPoints(x1, y1, x2, y2) {
	    var shape = { x1: x1, y1: y1, x2: x2, y2: y2, type: 'line' };
	    return svg_points_1.default.toPoints(shape);
	}
	function pathToPoints(pathString) {
	    if (!pathString) {
	        return [];
	    }
	    var shape = { type: 'path', d: pathString };
	    return svg_points_1.default.toPoints(shape);
	}
	function pointsToPath(pointsArray) {
	    return svg_points_1.default.toPath(pointsArray);
	}
	function manaToPoints(mana) {
	    if (typeof mana.elementName === 'string' &&
	        SVG_TYPES[mana.elementName] &&
	        mana.elementName !== 'rect' &&
	        mana.elementName !== 'g') {
	        var shape = { type: mana.elementName };
	        if (SVG_COMMAND_TYPES[shape.type]) {
	            for (var f2 in SVG_POINT_COMMAND_FIELDS) {
	                if (mana.attributes[f2]) {
	                    shape[f2] = mana.attributes[f2];
	                }
	            }
	        }
	        else {
	            for (var f1 in SVG_POINT_NUMERIC_FIELDS) {
	                if (mana.attributes[f1]) {
	                    shape[f1] = Number(mana.attributes[f1]);
	                }
	            }
	        }
	        return svg_points_1.default.toPoints(shape);
	    }
	    // div, rect, svg ...
	    var width = parseCssValueString_1.default((mana.layout &&
	        mana.layout.computed &&
	        mana.layout.computed.size &&
	        mana.layout.computed.size.x) ||
	        (mana.rect && mana.rect.width) ||
	        (mana.attributes &&
	            mana.attributes.style &&
	            mana.attributes.style.width) ||
	        (mana.attributes && mana.attributes.width) ||
	        (mana.attributes && mana.attributes.x) ||
	        0, null).value;
	    var height = parseCssValueString_1.default((mana.layout &&
	        mana.layout.computed &&
	        mana.layout.computed.size &&
	        mana.layout.computed.size.y) ||
	        (mana.rect && mana.rect.height) ||
	        (mana.attributes &&
	            mana.attributes.style &&
	            mana.attributes.style.height) ||
	        (mana.attributes && mana.attributes.height) ||
	        (mana.attributes && mana.attributes.y) ||
	        0, null).value;
	    var left = parseCssValueString_1.default((mana.rect && mana.rect.left) ||
	        (mana.attributes.style && mana.attributes.style.left) ||
	        mana.attributes.x ||
	        0, null).value;
	    var top = parseCssValueString_1.default((mana.rect && mana.rect.top) ||
	        (mana.attributes.style && mana.attributes.style.top) ||
	        mana.attributes.y ||
	        0, null).value;
	    return svg_points_1.default.toPoints({
	        width: width,
	        height: height,
	        type: 'rect',
	        x: left,
	        y: top,
	    });
	}
	exports.default = {
	    rectToPoints: rectToPoints,
	    circleToPoints: circleToPoints,
	    ellipseToPoints: ellipseToPoints,
	    lineToPoints: lineToPoints,
	    pathToPoints: pathToPoints,
	    pointsToPath: pointsToPath,
	    polyPointsStringToPoints: polyPointsStringToPoints,
	    pointsToPolyString: pointsToPolyString,
	    manaToPoints: manaToPoints,
	};
	//# sourceMappingURL=SVGPoints.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Interaction mode types.
	 * @namespace {object}
	 */
	// tslint:disable-next-line:no-namespace
	var InteractionMode;
	(function (InteractionMode) {
	    InteractionMode.EDIT = 0; // Default mode, all is editable
	    InteractionMode.LIVE = 1; // Live mode
	})(InteractionMode = exports.InteractionMode || (exports.InteractionMode = {}));
	/**
	 * @method isPreviewMode
	 * @argument mode The mode to compare, must ve a valid InteractionMode type.
	 * @description Utility that returns a boolean indicating if the provided
	 * mode is 'preview' mode.
	 * @returns boolean
	 */
	function isPreviewMode(mode) {
	    return mode === InteractionMode.LIVE;
	}
	exports.isPreviewMode = isPreviewMode;
	/**
	 * @method isLiveMode
	 * @argument mode The mode to compare, must ve a valid InteractionMode type.
	 * @description Utility that returns a boolean indicating if the provided
	 * mode is 'preview' mode.
	 * @returns boolean
	 */
	function isLiveMode(mode) {
	    return isPreviewMode(mode);
	}
	exports.isLiveMode = isLiveMode;
	//# sourceMappingURL=interactionModes.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Layout3D_1 = __webpack_require__(14);
	var formatTransform_1 = __webpack_require__(132);
	var scopeOfElement_1 = __webpack_require__(133);
	var SVG = 'svg';
	function hasExplicitStyle(domElement, key) {
	    if (!domElement.haiku) {
	        return false;
	    }
	    if (!domElement.haiku.explicitStyles) {
	        return false;
	    }
	    return domElement.haiku.explicitStyles[key] !== undefined;
	}
	/**
	 * SVG tags which can receive width and height styles.
	 * @see {@link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/width}
	 * @see {@link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/height}
	 */
	exports.SVG_SIZEABLES = {
	    feBlend: true,
	    feColorMatrix: true,
	    feComponentTransfer: true,
	    feComposite: true,
	    feConvolveMatrix: true,
	    feDiffuseLighting: true,
	    feDisplacementMap: true,
	    feDropShadow: true,
	    feFlood: true,
	    feGaussianBlur: true,
	    feImage: true,
	    feMerge: true,
	    feMorphology: true,
	    feOffset: true,
	    feSpecularLighting: true,
	    feTile: true,
	    feTurbulence: true,
	    filter: true,
	    foreignObject: true,
	    image: true,
	    mask: true,
	    pattern: true,
	    rect: true,
	    use: true,
	};
	function applyCssLayout(domElement, virtualElement, nodeLayout, computedLayout, context) {
	    // No point continuing if there's no computedLayout contents
	    if (computedLayout.opacity === undefined && !computedLayout.size && !computedLayout.matrix) {
	        return;
	    }
	    var elementScope = scopeOfElement_1.default(virtualElement);
	    if (nodeLayout.shown === false) {
	        if (domElement.style.visibility !== 'hidden') {
	            domElement.style.visibility = 'hidden';
	        }
	    }
	    else if (nodeLayout.shown === true) {
	        if (domElement.style.visibility !== 'visible') {
	            domElement.style.visibility = 'visible';
	        }
	    }
	    if (!hasExplicitStyle(domElement, 'opacity')) {
	        // No opacity defined means use whatever the previously defined opacity was
	        if (computedLayout.opacity === undefined) {
	            // no-op
	        }
	        else {
	            var finalOpacity = void 0;
	            if (computedLayout.opacity >= 0.999) {
	                finalOpacity = 1;
	            }
	            else if (computedLayout.opacity <= 0.0001) {
	                finalOpacity = 0;
	            }
	            else {
	                finalOpacity = computedLayout.opacity;
	            }
	            var opacityString = '' + finalOpacity;
	            if (domElement.style.opacity !== opacityString) {
	                domElement.style.opacity = opacityString;
	            }
	        }
	    }
	    if (computedLayout.size) {
	        if (elementScope === SVG) {
	            // Only set width/height attributes on SVG elements that can potentially receive them
	            // (and do something with them).
	            if (exports.SVG_SIZEABLES[virtualElement.elementName]) {
	                if (computedLayout.size.x !== undefined &&
	                    domElement.getAttribute('width') === null &&
	                    domElement.getAttribute('width') !== computedLayout.size.x) {
	                    domElement.setAttribute('width', computedLayout.size.x);
	                }
	                if (computedLayout.size.y !== undefined &&
	                    domElement.getAttribute('height') === null &&
	                    domElement.getAttribute('height') !== computedLayout.size.y) {
	                    domElement.setAttribute('height', computedLayout.size.y);
	                }
	            }
	        }
	        else {
	            if (!hasExplicitStyle(domElement, 'width')) {
	                if (computedLayout.size.x !== undefined) {
	                    var sizeXString = parseFloat(computedLayout.size.x.toFixed(2)) + 'px';
	                    if (domElement.style.width !== sizeXString) {
	                        domElement.style.width = sizeXString;
	                    }
	                }
	                if (computedLayout.size.y !== undefined) {
	                    var sizeYString = parseFloat(computedLayout.size.y.toFixed(2)) + 'px';
	                    if (domElement.style.height !== sizeYString) {
	                        domElement.style.height = sizeYString;
	                    }
	                }
	            }
	        }
	    }
	    if (Layout3D_1.default.virtualElementIsLayoutContainer(virtualElement) && !domElement.style.transformOrigin) {
	        // Reset the transform-origin so that our layout system can be self-contained.
	        domElement.style.transformOrigin = '0% 0% 0px';
	    }
	    if (computedLayout.matrix) {
	        var matrixString = formatTransform_1.default(computedLayout.matrix, nodeLayout.format);
	        if (matrixString === domElement.haiku.cachedTransform) {
	            return;
	        }
	        domElement.haiku.cachedTransform = matrixString;
	        if (elementScope === SVG &&
	            // IE doesn't support using transform on the CSS style in SVG elements, so if we are in SVG, and if we are
	            // inside an IE context, use the transform attribute itself. Always prefer the transform attribute for 2D inner
	            // SVG attributes, which have more consistent cross-browser behavior.
	            (nodeLayout.format === Layout3D_1.default.FORMATS.TWO ||
	                context.config.platform.isIE ||
	                context.config.platform.isEdge)) {
	            domElement.setAttribute('transform', matrixString);
	        }
	        else if (!hasExplicitStyle(domElement, 'transform') && !domElement.getAttribute('transform')) {
	            // A domElement might have an explicit transform override set, in which case, don't
	            // attach the style transform to this node, because we will likely clobber what they've set
	            domElement.style.transform = matrixString;
	        }
	    }
	}
	exports.default = applyCssLayout;
	//# sourceMappingURL=applyCssLayout.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.tokenize = function (source, regexps) {
	    var tokens = [];
	    var chunk = source;
	    var total = chunk.length;
	    var iterations = 0;
	    while (chunk.length > 0) {
	        for (var i = 0; i < regexps.length; i++) {
	            var regexp = regexps[i];
	            var match = regexp.re.exec(chunk);
	            if (match) {
	                var value = match[0];
	                tokens.push({ value: value, type: regexp.type });
	                // Need to slice the chunk at the value match length
	                chunk = chunk.slice(match[0].length, chunk.length);
	                break;
	            }
	        }
	        // We've probably failed to parse correctly if we get here
	        if (iterations++ > total) {
	            throw new Error("Unable to tokenize expression " + source);
	        }
	    }
	    return tokens;
	};
	// Order matters
	var PARAMETERS_REGEXPS = [
	    { type: 'whitespace', re: /^[\s]+/ },
	    { type: 'paren_open', re: /^\(/ },
	    { type: 'paren_close', re: /^\)/ },
	    { type: 'square_open', re: /^\[/ },
	    { type: 'square_close', re: /^]/ },
	    { type: 'curly_open', re: /^\{/ },
	    { type: 'curly_close', re: /^\}/ },
	    { type: 'rest', re: /^\.\.\./ },
	    { type: 'colon', re: /^:/ },
	    { type: 'comma', re: /^,/ },
	    { type: 'identifier', re: /^[a-zA-Z0-9_$]+/ },
	];
	exports.tokenizeParameters = function (source) {
	    return exports.tokenize(source, PARAMETERS_REGEXPS);
	};
	var SYMBOLS = '~!@#$%^&*-_=+/|:\'<,>.?'.split('').join('\\');
	var DIRECTIVE_REGEXPS = [
	    { type: 'whitespace', re: /^[\s]+/ },
	    { type: 'paren_open', re: /^\(/ },
	    { type: 'paren_close', re: /^\)/ },
	    // If you want to count -123 as a negative number, use ^-?\d at column 56
	    { type: 'number', re: /^0b[01]+|^0o[0-7]+|^0x[\da-f]+|^\d*\.?\d+(?:e[+-]?\d+)?/i },
	    { type: 'symbol', re: new RegExp('^([$' + SYMBOLS + '][$' + SYMBOLS + ']*)([^\\n\\S]*:(?!:))?') },
	    { type: 'identifier', re: new RegExp('^([$A-Za-z_\\x7f-\\uffff][$\\w\\x7f-\\uffff]*)([^\\n\\S]*:(?!:))?') },
	];
	exports.tokenizeDirective = function (source) {
	    var tokens = exports.tokenize(source, DIRECTIVE_REGEXPS).filter(function (token) {
	        return token.type !== 'whitespace';
	    });
	    tokens.forEach(function (token) {
	        if (token.type === 'number') {
	            token.value = Number(token.value);
	        }
	    });
	    return tokens;
	};
	exports.isNumeric = function (n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	};
	//# sourceMappingURL=Tokenizer.js.map

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var enhance_1 = __webpack_require__(30);
	function inject() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var fn = args.shift();
	    if (typeof fn !== 'function') {
	        console.warn('[haiku core] Inject expects a function as the first argument');
	        return fn;
	    }
	    if (args.length > 0) {
	        enhance_1.default(fn, args);
	    }
	    else {
	        enhance_1.default(fn, null); // If no args here, let 'enhance' try to parse them out
	    }
	    // Used by Haiku.app
	    fn.injectee = true;
	    return fn;
	}
	exports.default = inject;
	//# sourceMappingURL=inject.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function createTextNode(domElement, textContent) {
	    return domElement.ownerDocument.createTextNode(textContent);
	}
	exports.default = createTextNode;
	//# sourceMappingURL=createTextNode.js.map

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function isTextNode(virtualElement) {
	    return (typeof virtualElement !== 'object');
	}
	exports.default = isTextNode;
	//# sourceMappingURL=isTextNode.js.map

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pi = Math.PI;
	exports.tau = 2 * exports.pi;
	exports.epsilon = 0.0001;
	exports.c1 = 1.70158;
	exports.c2 = exports.c1 * 1.525;
	exports.c3 = exports.c1 + 1;
	exports.c4 = exports.tau / 3;
	exports.c5 = exports.tau / 4.5;
	//# sourceMappingURL=constants.js.map

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var c = "cubic-bezier";
	var s = "steps";
	exports.ease = c + "(.25,.1,.25,1)";
	exports.easeIn = c + "(.42,0,1,1)";
	exports.easeInBack = c + "(.6,-.28,.735,.045)";
	exports.easeInCirc = c + "(.6,.04,.98,.335)";
	exports.easeInCubic = c + "(.55,.055,.675,.19)";
	exports.easeInExpo = c + "(.95,.05,.795,.035)";
	exports.easeInOut = c + "(.42,0,.58,1)";
	exports.easeInOutBack = c + "(.68,-.55,.265,1.55)";
	exports.easeInOutCirc = c + "(.785,.135,.15,.86)";
	exports.easeInOutCubic = c + "(.645,.045,.355,1)";
	exports.easeInOutExpo = c + "(1,0,0,1)";
	exports.easeInOutQuad = c + "(.455,.03,.515,.955)";
	exports.easeInOutQuart = c + "(.77,0,.175,1)";
	exports.easeInOutQuint = c + "(.86,0,.07,1)";
	exports.easeInOutSine = c + "(.445,.05,.55,.95)";
	exports.easeInQuad = c + "(.55,.085,.68,.53)";
	exports.easeInQuart = c + "(.895,.03,.685,.22)";
	exports.easeInQuint = c + "(.755,.05,.855,.06)";
	exports.easeInSine = c + "(.47,0,.745,.715)";
	exports.easeOut = c + "(0,0,.58,1)";
	exports.easeOutBack = c + "(.175,.885,.32,1.275)";
	exports.easeOutCirc = c + "(.075,.82,.165,1)";
	exports.easeOutCubic = c + "(.215,.61,.355,1)";
	exports.easeOutExpo = c + "(.19,1,.22,1)";
	exports.easeOutQuad = c + "(.25,.46,.45,.94)";
	exports.easeOutQuart = c + "(.165,.84,.44,1)";
	exports.easeOutQuint = c + "(.23,1,.32,1)";
	exports.easeOutSine = c + "(.39,.575,.565,1)";
	exports.elegantSlowStartEnd = c + "(.175,.885,.32,1.275)";
	exports.linear = c + "(0,0,1,1)";
	exports.stepEnd = s + "(1,0)";
	exports.stepStart = s + "(1,1)";
	//# sourceMappingURL=cssEasings.js.map

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 *
	 * Internet Systems Consortium license (ISC)
	 *
	 * Copyright (c) 2016 Colin Meinke
	 *
	 * Permission to use, copy, modify, and/or distribute this software for any purpose
	 * with or without fee is hereby granted, provided that the above copyright notice
	 * and this permission notice appear in all copies.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	 * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
	 * FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT,
	 * OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE,
	 * DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
	 * ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var convertQuadraticToCubicBezier = function (spec, prevSpec) { return prevSpec ?
	    {
	        curve: {
	            type: 'cubic',
	            x1: prevSpec.x + 2 / 3 * (spec.curve.x1 - prevSpec.x),
	            y1: prevSpec.y + 2 / 3 * (spec.curve.y1 - prevSpec.y),
	            x2: spec.x + 2 / 3 * (spec.curve.x1 - spec.x),
	            y2: spec.y + 2 / 3 * (spec.curve.y1 - spec.y),
	        },
	        x: spec.x,
	        y: spec.y,
	    } :
	    // This should never happen, but just return the original spec if we didn't have a starting point.
	    spec; };
	var toPoints = function (spec) {
	    switch (spec.type) {
	        case 'circle':
	            return getPointsFromCircle(spec);
	        case 'ellipse':
	            return getPointsFromEllipse(spec);
	        case 'line':
	            return getPointsFromLine(spec);
	        case 'path':
	            return getPointsFromPath(spec);
	        case 'polygon':
	            return getPointsFromPolygon(spec);
	        case 'polyline':
	            return getPointsFromPolyline(spec);
	        case 'rect':
	            return getPointsFromRect(spec);
	        default:
	            return [];
	    }
	};
	var getPointsFromCircle = function (_a) {
	    var cx = _a.cx, cy = _a.cy, r = _a.r;
	    return [
	        {
	            x: cx,
	            y: cy - r,
	            moveTo: true,
	        },
	        {
	            x: cx,
	            y: cy + r,
	            curve: {
	                type: 'arc',
	                rx: r,
	                ry: r,
	                sweepFlag: 1,
	            },
	        },
	        {
	            x: cx,
	            y: cy - r,
	            curve: {
	                type: 'arc',
	                rx: r,
	                ry: r,
	                sweepFlag: 1,
	            },
	        },
	    ];
	};
	var getPointsFromEllipse = function (_a) {
	    var cx = _a.cx, cy = _a.cy, rx = _a.rx, ry = _a.ry;
	    return [
	        {
	            x: cx,
	            y: cy - ry,
	            moveTo: true,
	        },
	        {
	            x: cx,
	            y: cy + ry,
	            curve: {
	                rx: rx,
	                ry: ry,
	                type: 'arc',
	                sweepFlag: 1,
	            },
	        },
	        {
	            x: cx,
	            y: cy - ry,
	            curve: {
	                rx: rx,
	                ry: ry,
	                type: 'arc',
	                sweepFlag: 1,
	            },
	        },
	    ];
	};
	var getPointsFromLine = function (_a) {
	    var x1 = _a.x1, x2 = _a.x2, y1 = _a.y1, y2 = _a.y2;
	    return [
	        {
	            x: x1,
	            y: y1,
	            moveTo: true,
	        },
	        {
	            x: x2,
	            y: y2,
	        },
	    ];
	};
	var validCommands = /[MmLlHhVvCcSsQqTtAaZz]/g;
	var commandLengths = {
	    A: 7,
	    C: 6,
	    H: 1,
	    L: 2,
	    M: 2,
	    Q: 4,
	    S: 4,
	    T: 2,
	    V: 1,
	    Z: 0,
	};
	var relativeCommands = [
	    'a',
	    'c',
	    'h',
	    'l',
	    'm',
	    'q',
	    's',
	    't',
	    'v',
	];
	var PARSING_REGEXPS = {
	    command: /^[MmLlHhVvCcSsQqTtAaZz]/g,
	    whitespace: /^[\s]+/,
	    comma: /^,/,
	    number: /^0b[01]+|^0o[0-7]+|^0x[\da-f]+|^-?\d*\.?\d+(?:e[+-]?\d+)?/i,
	};
	var isRelative = function (command) { return relativeCommands.indexOf(command) !== -1; };
	var optionalArcKeys = ['xAxisRotation', 'largeArcFlag', 'sweepFlag'];
	var getCommands = function (d) { return d && d.match(validCommands); };
	function tokenize(d) {
	    var tokens = [];
	    var chunk = d;
	    while (chunk.length > 0) {
	        for (var regexpName in PARSING_REGEXPS) {
	            var match = PARSING_REGEXPS[regexpName].exec(chunk);
	            if (match) {
	                tokens.push({
	                    type: regexpName,
	                    raw: match[0],
	                });
	                // Need to slice the chunk at the original match length
	                chunk = chunk.slice(match[0].length, chunk.length);
	                break;
	            }
	        }
	    }
	    return tokens;
	}
	var getParams = function (d) {
	    var tokens = tokenize(d);
	    var fixed = tokens.filter(function (t) {
	        return t.type === 'number' || t.type === 'command' || t.type === 'comma';
	    }).map(function (t) {
	        return t.raw;
	    }).join(' ');
	    var segs = fixed.split(validCommands)
	        .map(function (p) {
	        return p.trim();
	    })
	        .filter(function (p) {
	        return p.length > 0;
	    });
	    return segs.map(function (s) {
	        return s.split(/[ ,]+/)
	            .map(function (n) {
	            return parseFloat(n);
	        })
	            .filter(function (n) {
	            return !isNaN(n);
	        });
	    });
	};
	var getPointsFromPath = function (_a) {
	    var d = _a.d;
	    var commands = getCommands(d);
	    if (!commands) {
	        return [];
	    }
	    var params = getParams(d);
	    var points = [];
	    var moveTo;
	    for (var i = 0, l = commands.length; i < l; i++) {
	        var command = commands[i];
	        var upperCaseCommand = command.toUpperCase();
	        var commandLength = commandLengths[upperCaseCommand];
	        var relative = isRelative(command);
	        var prevPoint = (points.length < 1) ? null : points[points.length - 1];
	        if (commandLength > 0) {
	            var commandParams = params.shift();
	            var iterations = commandParams.length / commandLength;
	            for (var j = 0; j < iterations; j++) {
	                prevPoint = (points.length < 1) ? null : points[points.length - 1];
	                switch (upperCaseCommand) {
	                    case 'M':
	                        var x = (relative && prevPoint ? prevPoint.x : 0) + commandParams.shift();
	                        var y = (relative && prevPoint ? prevPoint.y : 0) + commandParams.shift();
	                        moveTo = {
	                            x: x,
	                            y: y,
	                        };
	                        points.push({
	                            x: x,
	                            y: y,
	                            moveTo: true,
	                        });
	                        break;
	                    case 'L':
	                        points.push({
	                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                            y: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                        });
	                        break;
	                    case 'H':
	                        points.push({
	                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                            y: prevPoint.y,
	                        });
	                        break;
	                    case 'V':
	                        points.push({
	                            x: prevPoint.x,
	                            y: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                        });
	                        break;
	                    case 'A':
	                        points.push({
	                            curve: {
	                                type: 'arc',
	                                rx: commandParams.shift(),
	                                ry: commandParams.shift(),
	                                xAxisRotation: commandParams.shift(),
	                                largeArcFlag: commandParams.shift(),
	                                sweepFlag: commandParams.shift(),
	                            },
	                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                            y: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                        });
	                        for (var _i = 0, optionalArcKeys_1 = optionalArcKeys; _i < optionalArcKeys_1.length; _i++) {
	                            var k = optionalArcKeys_1[_i];
	                            if (points[points.length - 1].curve[k] === 0) {
	                                delete points[points.length - 1].curve[k];
	                            }
	                        }
	                        break;
	                    case 'C':
	                        points.push({
	                            curve: {
	                                type: 'cubic',
	                                x1: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                                y1: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                                x2: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                                y2: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                            },
	                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                            y: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                        });
	                        break;
	                    case 'S':
	                        var sx2 = (relative ? prevPoint.x : 0) + commandParams.shift();
	                        var sy2 = (relative ? prevPoint.y : 0) + commandParams.shift();
	                        var sx = (relative ? prevPoint.x : 0) + commandParams.shift();
	                        var sy = (relative ? prevPoint.y : 0) + commandParams.shift();
	                        var diff = {
	                            x: null,
	                            y: null,
	                        };
	                        var sx1 = void 0;
	                        var sy1 = void 0;
	                        if (prevPoint.curve && prevPoint.curve.type === 'cubic') {
	                            diff.x = Math.abs(prevPoint.x - prevPoint.curve.x2);
	                            diff.y = Math.abs(prevPoint.y - prevPoint.curve.y2);
	                            sx1 = prevPoint.x < prevPoint.curve.x2 ? prevPoint.x - diff.x : prevPoint.x + diff.x;
	                            sy1 = prevPoint.y < prevPoint.curve.y2 ? prevPoint.y - diff.y : prevPoint.y + diff.y;
	                        }
	                        else {
	                            diff.x = Math.abs(sx - sx2);
	                            diff.y = Math.abs(sy - sy2);
	                            sx1 = prevPoint.x;
	                            sy1 = prevPoint.y;
	                        }
	                        points.push({
	                            curve: {
	                                type: 'cubic',
	                                x1: sx1,
	                                y1: sy1,
	                                x2: sx2,
	                                y2: sy2,
	                            },
	                            x: sx,
	                            y: sy,
	                        });
	                        break;
	                    case 'Q':
	                        points.push(convertQuadraticToCubicBezier({
	                            curve: {
	                                type: 'quadratic',
	                                x1: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                                y1: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                            },
	                            x: (relative ? prevPoint.x : 0) + commandParams.shift(),
	                            y: (relative ? prevPoint.y : 0) + commandParams.shift(),
	                        }, prevPoint));
	                        break;
	                    case 'T':
	                        var tx = (relative ? prevPoint.x : 0) + commandParams.shift();
	                        var ty = (relative ? prevPoint.y : 0) + commandParams.shift();
	                        var tx1 = void 0;
	                        var ty1 = void 0;
	                        if (prevPoint.curve && prevPoint.curve.type === 'quadratic') {
	                            var diff_1 = {
	                                x: Math.abs(prevPoint.x - prevPoint.curve.x1),
	                                y: Math.abs(prevPoint.y - prevPoint.curve.y1),
	                            };
	                            tx1 = prevPoint.x < prevPoint.curve.x1 ? prevPoint.x - diff_1.x : prevPoint.x + diff_1.x;
	                            ty1 = prevPoint.y < prevPoint.curve.y1 ? prevPoint.y - diff_1.y : prevPoint.y + diff_1.y;
	                        }
	                        else {
	                            tx1 = prevPoint.x;
	                            ty1 = prevPoint.y;
	                        }
	                        points.push(convertQuadraticToCubicBezier({
	                            curve: {
	                                type: 'quadratic',
	                                x1: tx1,
	                                y1: ty1,
	                            },
	                            x: tx,
	                            y: ty,
	                        }, prevPoint));
	                        break;
	                }
	            }
	        }
	        else if (prevPoint !== null) {
	            if (upperCaseCommand === 'Z') {
	                prevPoint.closed = true;
	            }
	            if (moveTo !== undefined && (prevPoint.x !== moveTo.x || prevPoint.y !== moveTo.y)) {
	                points.push({
	                    x: moveTo.x,
	                    y: moveTo.y,
	                });
	            }
	        }
	    }
	    return points;
	};
	var getPointsFromPolygon = function (_a) {
	    var points = _a.points;
	    return getPointsFromPoints({
	        points: points,
	        closed: true,
	    });
	};
	var getPointsFromPolyline = function (_a) {
	    var points = _a.points;
	    return getPointsFromPoints({
	        points: points,
	        closed: false,
	    });
	};
	var getPointsFromPoints = function (_a) {
	    var closed = _a.closed, points = _a.points;
	    var numbers = points.split(/[\s,]+/).map(function (n) { return parseFloat(n); });
	    var p = numbers.reduce(function (arr, point, i) {
	        if (i % 2 === 0) {
	            arr.push({ x: point });
	        }
	        else {
	            arr[(i - 1) / 2].y = point;
	        }
	        return arr;
	    }, []);
	    if (closed) {
	        p.push(__assign({}, p[0]));
	    }
	    p[0].moveTo = true;
	    return p;
	};
	var getPointsFromRect = function (_a) {
	    var height = _a.height, rx = _a.rx, ry = _a.ry, width = _a.width, x = _a.x, y = _a.y;
	    if (rx || ry) {
	        return getPointsFromRectWithCornerRadius({
	            height: height,
	            width: width,
	            x: x,
	            y: y,
	            rx: rx || ry,
	            ry: ry || rx,
	            type: 'rect',
	        });
	    }
	    return getPointsFromBasicRect({
	        height: height,
	        width: width,
	        x: x,
	        y: y,
	    });
	};
	var getPointsFromBasicRect = function (_a) {
	    var height = _a.height, width = _a.width, x = _a.x, y = _a.y;
	    return [
	        {
	            x: x,
	            y: y,
	            moveTo: true,
	        },
	        {
	            y: y,
	            x: x + width,
	        },
	        {
	            x: x + width,
	            y: y + height,
	        },
	        {
	            x: x,
	            y: y + height,
	        },
	        {
	            x: x,
	            y: y,
	        },
	    ];
	};
	var getPointsFromRectWithCornerRadius = function (_a) {
	    var height = _a.height, rx = _a.rx, ry = _a.ry, width = _a.width, x = _a.x, y = _a.y;
	    var curve = {
	        rx: rx,
	        ry: ry,
	        type: 'arc',
	        sweepFlag: 1,
	    };
	    return [
	        {
	            y: y,
	            x: x + rx,
	            moveTo: true,
	        },
	        {
	            y: y,
	            x: x + width - rx,
	        },
	        {
	            curve: curve,
	            x: x + width,
	            y: y + ry,
	        },
	        {
	            x: x + width,
	            y: y + height - ry,
	        },
	        {
	            curve: curve,
	            x: x + width - rx,
	            y: y + height,
	        },
	        {
	            x: x + rx,
	            y: y + height,
	        },
	        {
	            curve: curve,
	            x: x,
	            y: y + height - ry,
	        },
	        {
	            x: x,
	            y: y + ry,
	        },
	        {
	            curve: curve,
	            y: y,
	            x: x + rx,
	        },
	    ];
	};
	exports.default = toPoints;
	//# sourceMappingURL=toPoints.js.map

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	
	module.exports = __webpack_require__(116).default;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	
	module.exports = __webpack_require__(119).default;


/***/ }),
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(19),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(11);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(224),
	    eq = __webpack_require__(85);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(299);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(305),
	    stubArray = __webpack_require__(238);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuBase_1 = __webpack_require__(13);
	var HaikuGlobal_1 = __webpack_require__(28);
	var assign_1 = __webpack_require__(20);
	var raf_1 = __webpack_require__(205);
	var NUMBER = 'number';
	var DEFAULT_OPTIONS = {
	    // frameDuration: Number
	    // Time to elapse per frame (ms)
	    frameDuration: 16.666,
	    // frameDelay: Number
	    // How long to wait between each tick (ms)
	    frameDelay: 16.666,
	    // marginOfErrorForDelta: Number
	    // A bit of grace when calculating whether a new frame should be run
	    marginOfErrorForDelta: 1.0,
	    // run: Boolean
	    // Whether or not the clock should run by default
	    run: true,
	};
	// The global animation harness is a singleton
	// We don't want to create new ones even on reload
	if (!HaikuGlobal_1.default.HaikuGlobalAnimationHarness) {
	    var queue_1 = [];
	    var frame_1 = function () {
	        var length = queue_1.length;
	        for (var i = 0; i < length; i++) {
	            queue_1[i]();
	        }
	        HaikuGlobal_1.default.HaikuGlobalAnimationHarness.raf = raf_1.default.request(frame_1);
	    };
	    HaikuGlobal_1.default.HaikuGlobalAnimationHarness = {
	        // Array of functions to call on every rAF tick
	        queue: queue_1,
	        // The main frame function, loops through all those who
	        // need an animation tick and calls them
	        frame: frame_1,
	        // Need a mechanism to cancel the rAF loop, or else some contexts
	        // (e.g. tests) will have leaked handles
	        cancel: function () {
	            if (HaikuGlobal_1.default.HaikuGlobalAnimationHarness.raf) {
	                raf_1.default.cancel(HaikuGlobal_1.default.HaikuGlobalAnimationHarness.raf);
	            }
	        },
	    };
	    // Trigger the loop to start; we'll push frame functions into its queue later
	    HaikuGlobal_1.default.HaikuGlobalAnimationHarness.frame();
	}
	// tslint:disable:variable-name
	var HaikuClock = /** @class */ (function (_super) {
	    __extends(HaikuClock, _super);
	    function HaikuClock(tickables, options) {
	        var _this = _super.call(this) || this;
	        _this.boundRunner = function () {
	            _this.run();
	        };
	        _this._tickables = tickables;
	        _this.assignOptions(options);
	        _this._isRunning = false;
	        _this.reinitialize();
	        if (_this.options.run) {
	            // Bind to avoid `this`-detachment when called by raf
	            HaikuGlobal_1.default.HaikuGlobalAnimationHarness.queue.push(_this.boundRunner);
	        }
	        // Tests and others may need this to cancel the rAF loop, to avoid leaked handles
	        _this.GLOBAL_ANIMATION_HARNESS = HaikuGlobal_1.default.HaikuGlobalAnimationHarness;
	        return _this;
	    }
	    HaikuClock.prototype.reinitialize = function () {
	        this._numLoopsRun = 0;
	        this._localFramesElapsed = 0;
	        this._localTimeElapsed = 0;
	        this._deltaSinceLastTick = 0;
	        this._localExplicitlySetTime = null;
	        return this;
	    };
	    HaikuClock.prototype.addTickable = function (tickable) {
	        this._tickables.push(tickable);
	        return this;
	    };
	    HaikuClock.prototype.assignOptions = function (options) {
	        this.options = assign_1.default(this.options || {}, DEFAULT_OPTIONS, options || {});
	        return this;
	    };
	    HaikuClock.prototype.run = function () {
	        if (this.isRunning()) {
	            // If time is "controlled" we are locked to an explicitly set local time, so no math is needed.
	            if (this.isTimeControlled()) {
	                this.tick();
	            }
	            else {
	                // If we got here, we need to evaluate the time elapsed, and determine if we've waited long enough for a frame
	                this._numLoopsRun++;
	                var prevTime = this._localTimeElapsed;
	                var nextTime = prevTime + this.options.frameDuration;
	                var deltaSinceLastTick = nextTime - prevTime + this._deltaSinceLastTick;
	                if (deltaSinceLastTick >=
	                    this.options.frameDelay - this.options.marginOfErrorForDelta) {
	                    this.tick();
	                    this._localFramesElapsed++;
	                    this._localTimeElapsed = nextTime;
	                    this._deltaSinceLastTick = 0; // Must reset delta when frame has been completed
	                }
	                else {
	                    // If we got here, this loop is faster than the desired speed; wait till next call
	                    this._deltaSinceLastTick = deltaSinceLastTick;
	                }
	            }
	        }
	    };
	    HaikuClock.prototype.tick = function () {
	        for (var i = 0; i < this._tickables.length; i++) {
	            this._tickables[i].performTick();
	        }
	    };
	    HaikuClock.prototype.getTime = function () {
	        return this.getExplicitTime();
	    };
	    HaikuClock.prototype.setTime = function (time) {
	        this._localExplicitlySetTime = parseInt(time || 0, 10);
	        return this;
	    };
	    HaikuClock.prototype.getFPS = function () {
	        return Math.round(1000 / this.options.frameDuration);
	    };
	    /**
	     * @method getExplicitTime
	     * @description Return either the running time or the controlled time, depending on whether this
	     * clock is in control mode or not.
	     */
	    HaikuClock.prototype.getExplicitTime = function () {
	        if (this.isTimeControlled()) {
	            return this.getControlledTime();
	        }
	        return this.getRunningTime();
	    };
	    /**
	     * @method getControlledTime
	     * @description Return the value of time that has been explicitly controlled.
	     */
	    HaikuClock.prototype.getControlledTime = function () {
	        return this._localExplicitlySetTime;
	    };
	    HaikuClock.prototype.isTimeControlled = function () {
	        return typeof this._localExplicitlySetTime === NUMBER;
	    };
	    /**
	     * @method getRunningTime
	     * @description Return the running time, which is the value of time that has elapsed whether or
	     * not time has been 'controlled' in control mode.
	     */
	    HaikuClock.prototype.getRunningTime = function () {
	        return this._localTimeElapsed;
	    };
	    HaikuClock.prototype.isRunning = function () {
	        return this._isRunning;
	    };
	    HaikuClock.prototype.start = function () {
	        this._isRunning = true;
	        return this;
	    };
	    HaikuClock.prototype.stop = function () {
	        this._isRunning = false;
	        return this;
	    };
	    HaikuClock.prototype.getFrameDuration = function () {
	        return this.options.frameDuration;
	    };
	    HaikuClock.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        for (var i = 0; i < HaikuGlobal_1.default.HaikuGlobalAnimationHarness.queue.length; i++) {
	            if (HaikuGlobal_1.default.HaikuGlobalAnimationHarness.queue[i] === this.boundRunner) {
	                HaikuGlobal_1.default.HaikuGlobalAnimationHarness.queue.splice(i, 1);
	                return;
	            }
	        }
	    };
	    Object.defineProperty(HaikuClock.prototype, "frameDuration", {
	        get: function () {
	            return this.options.frameDuration;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuClock.prototype, "frameDelay", {
	        get: function () {
	            return this.options.frameDelay;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuClock.prototype, "time", {
	        get: function () {
	            return this.getExplicitTime();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    HaikuClock.__name__ = 'HaikuClock';
	    return HaikuClock;
	}(HaikuBase_1.default));
	exports.default = HaikuClock;
	//# sourceMappingURL=HaikuClock.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var Config_1 = __webpack_require__(27);
	var HaikuBase_1 = __webpack_require__(13);
	var HaikuClock_1 = __webpack_require__(107);
	var HaikuComponent_1 = __webpack_require__(56);
	var pkg = __webpack_require__(18);
	var VERSION = pkg.version;
	/**
	 * @class HaikuContext
	 * @description Represents the root of a Haiku component tree within an application.
	 * A Haiku component tree may contain many components, but there is only one context.
	 * The context is where information shared by all components in the tree should go, e.g. clock time.
	 */
	// tslint:disable:variable-name
	var HaikuContext = /** @class */ (function (_super) {
	    __extends(HaikuContext, _super);
	    function HaikuContext(mount, renderer, platform, bytecode, config) {
	        var _this = _super.call(this) || this;
	        if (!renderer) {
	            throw new Error('Context requires a renderer');
	        }
	        if (!bytecode) {
	            throw new Error('Context requires bytecode');
	        }
	        _this.PLAYER_VERSION = VERSION; // #LEGACY
	        _this.CORE_VERSION = VERSION;
	        _this.assignConfig(config || {}, null);
	        _this.mount = mount;
	        // Make some Haiku internals available on the mount object for hot editing hooks, or for debugging convenience.
	        if (_this.mount && !_this.mount.haiku) {
	            _this.mount.haiku = {
	                context: _this,
	            };
	        }
	        _this.renderer = renderer;
	        // Initialize sets up top-level dom listeners so we don't run it if we don't have a mount
	        if (_this.mount && _this.renderer.initialize) {
	            _this.renderer.initialize();
	        }
	        _this.platform = platform;
	        // List of tickable objects managed by this context. These are invoked on every clock tick.
	        // These are removed when context unmounts and re-added in case of re-mount
	        _this.tickables = [];
	        // Our own tick method is the main driver for animation inside of this context
	        _this.tickables.push({ performTick: _this.tick.bind(_this) });
	        if (_this.config.frame) {
	            _this.tickables.push({ performTick: _this.config.frame });
	        }
	        _this.clock = new HaikuClock_1.default(_this.tickables, _this.config.clock || {});
	        // We need to start the loop even if we aren't autoplaying,
	        // because we still need time to be calculated even if we don't 'tick'.
	        _this.clock.run();
	        _this.container = _this.renderer.createContainer({
	            elementName: bytecode,
	            attributes: {},
	            children: [bytecode.template],
	        });
	        _this.component = new HaikuComponent_1.default(bytecode, _this, // context
	        null, // host
	        _this.config, _this.container);
	        // If configured, bootstrap the Haiku right-click context menu
	        if (_this.mount && _this.renderer.menuize && _this.config.contextMenu !== 'disabled') {
	            _this.renderer.menuize(_this.component);
	        }
	        // By default, Haiku tracks usage by transmitting component metadata to Mixpanel when initialized.
	        // Developers can disable this by setting the `mixpanel` option to a falsy value.
	        // To transmit metadata to your own Mixpanel account, set the `mixpanel` option to your Mixpanel API token.
	        // Don't set up Mixpanel if we're running on localhost since we don't want test data to be tracked
	        if (_this.mount &&
	            _this.platform &&
	            _this.platform.location &&
	            _this.platform.location.hostname !== 'localhost' &&
	            _this.platform.location.hostname !== '0.0.0.0') {
	            // If configured, initialize Mixpanel with the given API token
	            if (_this.renderer.mixpanel && _this.config.mixpanel) {
	                _this.renderer.mixpanel(_this.config.mixpanel, _this.component);
	            }
	        }
	        // Just a counter for the number of clock ticks that have occurred; used to determine first-frame for mounting
	        _this.ticks = 0;
	        // Assuming the user wants the app to mount immediately (the default), let's do the mount.
	        if (_this.config.automount) {
	            // Starting the clock has the effect of doing a render at time 0, a.k.a., mounting!
	            _this.component.getClock().start();
	        }
	        return _this;
	    }
	    /**
	     * @method getRootComponent
	     * @description Returns the HaikuComponent managed by this context.
	     */
	    HaikuContext.prototype.getRootComponent = function () {
	        return this.component;
	    };
	    /**
	     * @method getClock
	     * @description Returns the HaikuClock instance associated with this context.
	     */
	    HaikuContext.prototype.getClock = function () {
	        return this.clock;
	    };
	    /**
	     * @method contextMount
	     * @description Adds this context the global update loop.
	     */
	    HaikuContext.prototype.contextMount = function () {
	        if (this.unmountedTickables) {
	            // Gotta remember to _remove_ the tickables so we don't end up with dupes if we re-mount later
	            var unmounted = this.unmountedTickables.splice(0);
	            for (var i = 0; i < unmounted.length; i++) {
	                this.addTickable(unmounted[i]);
	            }
	        }
	    };
	    /**
	     * @method contextUnmount
	     * @description Removes this context from global update loop.
	     */
	    HaikuContext.prototype.contextUnmount = function () {
	        this.unmountedTickables = this.tickables.splice(0);
	    };
	    HaikuContext.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.component.destroy();
	        this.renderer.destroy();
	        this.clock.destroy();
	    };
	    /**
	     * @method addTickable
	     * @description Add a tickable object to the list of those that will be called on every clock tick.
	     * This only adds if the given object isn't already present in the list.
	     */
	    HaikuContext.prototype.addTickable = function (tickable) {
	        var alreadyAdded = false;
	        for (var i = 0; i < this.tickables.length; i++) {
	            if (tickable === this.tickables[i]) {
	                alreadyAdded = true;
	                break;
	            }
	        }
	        if (!alreadyAdded) {
	            this.tickables.push(tickable);
	        }
	    };
	    /**
	     * @method assignConfig
	     * @description Updates internal configuration options, assigning those passed in.
	     * Also updates the configuration of the clock instance and managed component instance.
	     */
	    HaikuContext.prototype.assignConfig = function (config, options) {
	        this.config = __assign({}, config);
	        if (this.clock) { // This method may run before the clock is initialized
	            this.clock.assignOptions(this.config.clock);
	        }
	        if (this.component) { // This method may run before the managed component is initialized
	            if (!options || !options.skipComponentAssign) { // Avoid an infinite loop if the managed component is updating us
	                this.component.assignConfig(this.config);
	            }
	        }
	    };
	    /**
	     * @method getContainer
	     * @description Returns the container, a virtual-element-like object that provides sizing
	     * constraints at the topmost/outermost level from which the descendant layout can be calculated.
	     */
	    HaikuContext.prototype.getContainer = function (doForceRecalc) {
	        if (doForceRecalc === void 0) { doForceRecalc = false; }
	        if (doForceRecalc || this.renderer.shouldCreateContainer) {
	            this.renderer.createContainer(this.container); // The container is mutated in place
	        }
	        return this.container;
	    };
	    /**
	     * @method performFullFlushRender
	     * @description Updates the entire component tree, flushing updates to the rendering medium.
	     */
	    HaikuContext.prototype.performFullFlushRender = function () {
	        if (!this.mount) {
	            return;
	        }
	        this.component.performFullFlushRenderWithRenderer(this.renderer, this.config);
	    };
	    /**
	     * @method performPatchRender
	     * @description Updates the component tree, but only updating properties we know have changed.
	     */
	    HaikuContext.prototype.performPatchRender = function (skipCache) {
	        if (skipCache === void 0) { skipCache = false; }
	        if (!this.mount) {
	            return;
	        }
	        this.component.performPatchRenderWithRenderer(this.renderer, this.config, skipCache);
	    };
	    /**
	     * @method updateMountRootStyles
	     * @description Reconciles the properties of the rendering medium's mount element with any
	     * configuration options that have been passed in, e.g. CSS overflow settings.
	     */
	    HaikuContext.prototype.updateMountRootStyles = function () {
	        if (!this.mount) {
	            return;
	        }
	        // We can assume the mount has only one child since we only mount one component into it (#?)
	        var root = this.mount && this.mount.children[0];
	        if (root) {
	            if (this.config.position && root.style.position !== this.config.position) {
	                root.style.position = this.config.position;
	            }
	            if (this.config.overflow) {
	                root.style.overflow = this.config.overflow;
	            }
	            else {
	                if (this.config.overflowX &&
	                    root.style.overflowX !== this.config.overflowX) {
	                    root.style.overflowX = this.config.overflowX;
	                }
	                if (this.config.overflowY &&
	                    root.style.overflowY !== this.config.overflowY) {
	                    root.style.overflowY = this.config.overflowY;
	                }
	            }
	        }
	    };
	    /**
	     * @method tick
	     * @description Advances the component animation by one tick. Note that one tick is not necessarily
	     * equivalent to one frame. If the animation frame loop is running too fast, the clock may wait before
	     * incrementing the frame number. In other words, a tick implies an update but not necessarily a change.
	     */
	    HaikuContext.prototype.tick = function (skipCache) {
	        var _this = this;
	        if (skipCache === void 0) { skipCache = false; }
	        try {
	            var flushed = false;
	            // Only continue ticking and updating if our root component is still activated and awake;
	            // this is mainly a hacky internal hook used during hot editing inside Haiku Desktop
	            if (!this.component.isDeactivated && !this.component.isSleeping) {
	                // This incrementation MUST occur before the blocks below, especially #callRemount,
	                // because #callRemount (and friends?) may result in a 'component:will-mount' action
	                // firing, which in turn may call this.pause()/this.gotoAndStop(). Internally those
	                // methods rely on #tick(), which means they can result in an infinite remount loop.
	                var ticks = this.ticks;
	                this.ticks++;
	                // Perform any necessary updates that have to occur in all copmonents in the scene
	                this.component.visitGuestHierarchy(function (component) {
	                    // State transitions are bound to clock time, so we update them on every tick
	                    component.tickStateTransitions();
	                    // The top-level component isn't controlled through playback status, so we must skip it
	                    // otherwise its behavior will not reflect the playback setting specified via options
	                    if (component === _this.component) {
	                        return;
	                    }
	                });
	                // After we've hydrated the tree the first time, we can proceed with patches --
	                // unless the component indicates it wants a full flush per its internal settings.
	                if (this.component.shouldPerformFullFlush() || this.config.forceFlush || ticks < 1) {
	                    this.performFullFlushRender();
	                    flushed = true;
	                }
	                else {
	                    this.performPatchRender(skipCache);
	                }
	                // We update the mount root *after* we complete the render pass because configuration
	                // from the top level should unset anything that the component set.
	                // Specifically important wrt overflow, where the component probably defines
	                // overflowX/overflowY: hidden, but our configuration might define them as visible.
	                this.updateMountRootStyles();
	                // Do any initialization that may need to occur if we happen to be on the very first tick
	                if (ticks < 1) {
	                    // If this is the 0th (first) tick, notify anybody listening that we've mounted
	                    // If we've already flushed, _don't_ request to trigger a re-flush (second arg)
	                    this.component.callRemount(null, flushed);
	                }
	            }
	        }
	        catch (exception) {
	            console.warn('[haiku core] caught error during tick', exception);
	            if (this.component) {
	                this.component.deactivate();
	            }
	        }
	    };
	    /**
	     * @method getGlobalUserState
	     * @description Since the core renderer is medium-agnostic, we rely on the renderer to provide data
	     * about the current user (the mouse position, for example). This method is just a convenience wrapper.
	     */
	    HaikuContext.prototype.getGlobalUserState = function () {
	        return this.renderer && this.renderer.getUser && this.renderer.getUser();
	    };
	    /**
	     * @function createComponentFactory
	     * @description Returns a factory function that can create a HaikuComponent and run it upon a mount.
	     * The created instance runs using the passed-in renderer, bytecode, options, and platform.
	     */
	    HaikuContext.createComponentFactory = function (rendererClass, bytecode, haikuConfigFromFactoryCreator, platform) {
	        if (!rendererClass) {
	            throw new Error('A runtime renderer class object is required');
	        }
	        if (!bytecode) {
	            throw new Error('A runtime `bytecode` object is required');
	        }
	        // Note that haiku Config may be passed at this level, or below at the factory invocation level.
	        var haikuConfigFromTop = Config_1.default.build({
	            // The seed value should remain constant from here on, because it is used for PRNG
	            seed: Config_1.default.seed(),
	            // The now-value is used to compute a current date with respect to the current time
	            timestamp: Date.now(),
	        }, 
	        // The bytecode itself may contain configuration for playback, etc., but is lower precedence than config passed in
	        bytecode && bytecode.options, haikuConfigFromFactoryCreator);
	        /**
	         * @function HaikuComponentFactory
	         * @description Creates a HaikuContext instance, with a component, and returns the component.
	         * The (renderer, bytecode) pair are bootstrapped into the given mount element, and played.
	         */
	        var HaikuComponentFactory = function (mount, haikuConfigFromFactory) {
	            // Merge any config received "late" with the config we might have already gotten during bootstrapping
	            var haikuConfigMerged = Config_1.default.build(haikuConfigFromTop, haikuConfigFromFactory);
	            // Previously these were initialized in the scope above, but I moved them here which seemed to resolve
	            // an initialization/mounting issue when running in React.
	            var renderer = new rendererClass(mount, haikuConfigMerged);
	            var context = new HaikuContext(mount, renderer, platform, bytecode, haikuConfigMerged);
	            var component = context.getRootComponent();
	            // These properties are added for convenience as hot editing hooks inside Haiku Desktop (and elsewhere?).
	            // It's a bit hacky to just expose these in this way, but it proves pretty convenient downstream.
	            HaikuComponentFactory.bytecode = bytecode;
	            HaikuComponentFactory.renderer = renderer;
	            // Note that these ones could theoretically change if this factory was called more than once; use with care
	            HaikuComponentFactory.mount = mount;
	            HaikuComponentFactory.context = context;
	            HaikuComponentFactory.component = component;
	            // Finally, return the HaikuComponent instance which can also be used for programmatic behavior
	            return component;
	        };
	        HaikuComponentFactory.PLAYER_VERSION = VERSION; // #LEGACY
	        HaikuComponentFactory.CORE_VERSION = VERSION;
	        return HaikuComponentFactory;
	    };
	    // Also expose so we can programatically choose an instance on the page
	    HaikuContext.PLAYER_VERSION = VERSION; // #LEGACY
	    HaikuContext.CORE_VERSION = VERSION; // #LEGACY
	    HaikuContext.__name__ = 'HaikuContext';
	    return HaikuContext;
	}(HaikuBase_1.default));
	exports.default = HaikuContext;
	//# sourceMappingURL=HaikuContext.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuBase_1 = __webpack_require__(13);
	var HaikuNode_1 = __webpack_require__(29);
	var Layout3D_1 = __webpack_require__(14);
	exports.HAIKU_ID_ATTRIBUTE = 'haiku-id';
	exports.HAIKU_TITLE_ATTRIBUTE = 'haiku-title';
	exports.HAIKU_VAR_ATTRIBUTE = 'haiku-var';
	exports.HAIKU_SOURCE_ATTRIBUTE = 'haiku-source';
	exports.HAIKU_LOCKED_ATTRIBUTE = 'haiku-locked';
	var SVG_PRIMITIVE_NAMES = {
	    rect: true,
	    line: true,
	    circle: true,
	    ellipse: true,
	    path: true,
	    polygon: true,
	    polyline: true,
	};
	var DEFAULT_DEPTH = 0;
	var DEFAULT_TAG_NAME = 'div';
	var COMPONENT_PSEUDO_TAG_NAME = DEFAULT_TAG_NAME;
	var SIZING_AXES = ['x', 'y', 'z'];
	var TEXT_PSEUDO_TAG_NAME = '__text__';
	var CSS_QUERY_MAPPING = {
	    name: 'elementName',
	    attributes: 'attributes',
	    children: 'children',
	};
	var LAYOUT_DEFAULTS = Layout3D_1.default.createLayoutSpec();
	var HaikuElement = /** @class */ (function (_super) {
	    __extends(HaikuElement, _super);
	    function HaikuElement() {
	        var _this = _super.call(this) || this;
	        _this.isHovered = false;
	        return _this;
	    }
	    Object.defineProperty(HaikuElement.prototype, "childNodes", {
	        get: function () {
	            return (this.node &&
	                ((this.memory && this.memory.children) || this.node.children)) || [];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "children", {
	        get: function () {
	            return this.childNodes.map(function (childNode) {
	                return HaikuElement.findOrCreateByNode(childNode);
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "attributes", {
	        get: function () {
	            return (this.node && this.node.attributes) || {};
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "type", {
	        get: function () {
	            return (this.node && this.node.elementName) || DEFAULT_TAG_NAME;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "title", {
	        get: function () {
	            return this.attributes[exports.HAIKU_TITLE_ATTRIBUTE];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "source", {
	        get: function () {
	            return this.attributes[exports.HAIKU_SOURCE_ATTRIBUTE];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "id", {
	        get: function () {
	            return this.attributes.id;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "className", {
	        get: function () {
	            return this.attributes.class;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "tagName", {
	        get: function () {
	            if (this.isTextNode()) {
	                return TEXT_PSEUDO_TAG_NAME;
	            }
	            if (this.isComponent()) {
	                return COMPONENT_PSEUDO_TAG_NAME;
	            }
	            return this.type || DEFAULT_TAG_NAME;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "nodeType", {
	        get: function () {
	            if (this.isTextNode()) {
	                return 3;
	            }
	            return 1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "subcomponent", {
	        /**
	         * @method subcomponent
	         * @description Returns the HaikuComponent instance that manages nodes below this one.
	         * This node is considered the 'wrapper' node and its child is considered the 'root'.
	         */
	        get: function () {
	            return this.memory && this.memory.subcomponent;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "instance", {
	        /**
	         * @method instance
	         * @description Returns the HaikuComponent instance that manages this node and those beneath.
	         * This node is considered the 'root' node of the instance.
	         */
	        get: function () {
	            return this.memory && this.memory.instance;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "containee", {
	        /**
	         * @method containee
	         * @description Returns the HaikuComponent instance into which this node was passed as a container.
	         */
	        get: function () {
	            return this.memory && this.memory.containee;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "owner", {
	        get: function () {
	            if (this.instance) {
	                return this.instance;
	            }
	            return this.parent && this.parent.owner;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "top", {
	        get: function () {
	            return this.instanceContext && this.instanceContext.component;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "instanceContext", {
	        get: function () {
	            return this.memory && this.memory.context;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "parentNode", {
	        get: function () {
	            return this.memory && this.memory.parent;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "memory", {
	        get: function () {
	            return this.node && this.node.__memory;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "parent", {
	        get: function () {
	            return this.parentNode && HaikuElement.findOrCreateByNode(this.parentNode);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "layout", {
	        get: function () {
	            return this.node && this.node.layout && this.node.layout.computed;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "layoutMatrix", {
	        get: function () {
	            return (this.layout && this.layout.matrix) || Layout3D_1.default.createMatrix();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "layoutAncestry", {
	        get: function () {
	            var ancestry = [];
	            if (this.layout) {
	                ancestry.unshift(this.layout);
	            }
	            // tslint:disable-next-line:no-this-assignment
	            var ancestor = this;
	            while (ancestor.parent) {
	                ancestor = ancestor.parent;
	                var layout = ancestor.layout;
	                if (layout) {
	                    ancestry.unshift(layout);
	                }
	            }
	            return ancestry;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "layoutAncestryMatrices", {
	        get: function () {
	            return this.layoutAncestry.filter(function (layout) { return !!layout.matrix; }).map(function (layout) { return layout.matrix; });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "rootSVG", {
	        get: function () {
	            var parent = this.parent;
	            while (parent) {
	                if (parent.type === 'svg') {
	                    return parent;
	                }
	                parent = parent.parent;
	            }
	            return undefined;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "isChildOfDefs", {
	        get: function () {
	            var parent = this.parent;
	            while (parent) {
	                if (parent.type === 'defs') {
	                    return true;
	                }
	                parent = parent.parent;
	            }
	            return false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    HaikuElement.prototype.getTranscludedElement = function () {
	        if (this.type !== 'use') {
	            return this;
	        }
	        var href = this.attributes['xlink:href'] || this.attributes.href;
	        if (!href) {
	            return;
	        }
	        var rootSVG = this.rootSVG;
	        if (!rootSVG) {
	            return;
	        }
	        var address = href.substr(1);
	        var out;
	        this.rootSVG.visit(function (desc) {
	            if (desc.id === address) {
	                out = desc;
	                return false;
	            }
	        });
	        return out;
	    };
	    Object.defineProperty(HaikuElement.prototype, "rawLayout", {
	        get: function () {
	            return this.node && this.node.layout;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "shown", {
	        get: function () {
	            return this.layout && this.layout.shown;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "opacity", {
	        get: function () {
	            return this.layout && this.layout.opacity;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "shear", {
	        get: function () {
	            return this.layout && this.layout.shear;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "matrix", {
	        get: function () {
	            return this.layout && this.layout.matrix;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "translation", {
	        get: function () {
	            return (this.layout && this.layout.translation) || __assign({}, LAYOUT_DEFAULTS.translation);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "rotation", {
	        get: function () {
	            return (this.layout && this.layout.rotation) || __assign({}, LAYOUT_DEFAULTS.rotation);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "scale", {
	        get: function () {
	            return (this.layout && this.layout.scale) || __assign({}, LAYOUT_DEFAULTS.scale);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "origin", {
	        get: function () {
	            return (this.layout && this.layout.origin) || __assign({}, LAYOUT_DEFAULTS.origin);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "offset", {
	        get: function () {
	            return (this.layout && this.layout.offset) || __assign({}, LAYOUT_DEFAULTS.offset);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "targets", {
	        get: function () {
	            return (this.memory && this.memory.targets) || [];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "target", {
	        get: function () {
	            // Assume the most recently added target is the canonical target due to an implementation
	            // detail in the Haiku editing environment; FIXME. On 3 Jun 2018 was changed from the first
	            // added to the last added one to fix a bug related to ungrouping
	            return this.targets[this.targets.length - 1];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "rotationX", {
	        get: function () {
	            return this.rotation && this.rotation.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "rotationY", {
	        get: function () {
	            return this.rotation && this.rotation.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "rotationZ", {
	        get: function () {
	            return this.rotation && this.rotation.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "scaleX", {
	        get: function () {
	            return this.scale && this.scale.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "scaleY", {
	        get: function () {
	            return this.scale && this.scale.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "scaleZ", {
	        get: function () {
	            return this.scale && this.scale.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "positionX", {
	        get: function () {
	            return this.translation && this.translation.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "positionY", {
	        get: function () {
	            return this.translation && this.translation.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "positionZ", {
	        get: function () {
	            return this.translation && this.translation.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "translationX", {
	        get: function () {
	            return this.translation && this.translation.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "translationY", {
	        get: function () {
	            return this.translation && this.translation.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "translationZ", {
	        get: function () {
	            return this.translation && this.translation.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "originX", {
	        get: function () {
	            return this.origin && this.origin.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "originY", {
	        get: function () {
	            return this.origin && this.origin.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "originZ", {
	        get: function () {
	            return this.origin && this.origin.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "offsetX", {
	        get: function () {
	            return this.offset && this.offset.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "offsetY", {
	        get: function () {
	            return this.offset && this.offset.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "offsetZ", {
	        get: function () {
	            return this.offset && this.offset.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizePrecomputed", {
	        /**
	         * @description Returns the size as computed when the layout was last rendered.
	         */
	        get: function () {
	            return this.layout && this.layout.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizePrecomputedX", {
	        get: function () {
	            return this.sizePrecomputed && this.sizePrecomputed.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizePrecomputedY", {
	        get: function () {
	            return this.sizePrecomputed && this.sizePrecomputed.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizePrecomputedZ", {
	        get: function () {
	            return this.sizePrecomputed && this.sizePrecomputed.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "size", {
	        get: function () {
	            return {
	                x: this.sizeX,
	                y: this.sizeY,
	                z: this.sizeZ,
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeX", {
	        get: function () {
	            return this.computeSizeX();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeY", {
	        get: function () {
	            return this.computeSizeY();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeZ", {
	        get: function () {
	            return this.computeSizeZ();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "width", {
	        get: function () {
	            return this.sizeX;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "height", {
	        get: function () {
	            return this.sizeY;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "depth", {
	        get: function () {
	            return this.sizeZ;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "attributeWidth", {
	        get: function () {
	            if (this.attributes && this.attributes.width) {
	                return Number(this.attributes.width);
	            }
	            return;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "attributeHeight", {
	        get: function () {
	            if (this.attributes && this.attributes.height) {
	                return Number(this.attributes.height);
	            }
	            return;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeAbsolute", {
	        get: function () {
	            return (this.rawLayout && this.rawLayout.sizeAbsolute) || __assign({}, LAYOUT_DEFAULTS.sizeAbsolute);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeAbsoluteX", {
	        get: function () {
	            return this.sizeAbsolute && this.sizeAbsolute.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeAbsoluteY", {
	        get: function () {
	            return this.sizeAbsolute && this.sizeAbsolute.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeAbsoluteZ", {
	        get: function () {
	            return this.sizeAbsolute && this.sizeAbsolute.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeMode", {
	        get: function () {
	            return this.rawLayout && this.rawLayout.sizeMode;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeModeX", {
	        get: function () {
	            return this.sizeMode && this.sizeMode.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeModeY", {
	        get: function () {
	            return this.sizeMode && this.sizeMode.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeModeZ", {
	        get: function () {
	            return this.sizeMode && this.sizeMode.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeProportional", {
	        get: function () {
	            return (this.rawLayout && this.rawLayout.sizeProportional) || __assign({}, LAYOUT_DEFAULTS.sizeProportional);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeProportionalX", {
	        get: function () {
	            return this.sizeProportional && this.sizeProportional.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeProportionalY", {
	        get: function () {
	            return this.sizeProportional && this.sizeProportional.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeProportionalZ", {
	        get: function () {
	            return this.sizeProportional && this.sizeProportional.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeDifferential", {
	        get: function () {
	            return (this.rawLayout && this.rawLayout.sizeDifferential) || __assign({}, LAYOUT_DEFAULTS.sizeDifferential);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeDifferentialX", {
	        get: function () {
	            return this.sizeDifferential && this.sizeDifferential.x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeDifferentialY", {
	        get: function () {
	            return this.sizeDifferential && this.sizeDifferential.y;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "sizeDifferentialZ", {
	        get: function () {
	            return this.sizeDifferential && this.sizeDifferential.z;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "properties", {
	        get: function () {
	            return {
	                shown: this.shown,
	                opacity: this.opacity,
	                offset: this.offset,
	                origin: this.origin,
	                translation: this.translation,
	                rotation: this.rotation,
	                scale: this.scale,
	                shear: this.shear,
	                sizeMode: this.sizeMode,
	                sizeProportional: this.sizeProportional,
	                sizeDifferential: this.sizeDifferential,
	                sizeAbsolute: this.sizeAbsolute,
	                size: this.size,
	                matrix: this.matrix,
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuElement.prototype, "componentId", {
	        get: function () {
	            return this.getComponentId();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    HaikuElement.prototype.computeSize = function () {
	        return {
	            x: this.computeSizeX(),
	            y: this.computeSizeY(),
	            z: this.computeSizeZ(),
	        };
	    };
	    HaikuElement.prototype.computeBoundsForAxis = function (axis) {
	        if (axis === 'x') {
	            return this.computeContentBoundsX();
	        }
	        if (axis === 'y') {
	            return this.computeContentBoundsY();
	        }
	        if (axis === 'z') {
	            return this.computeContentBoundsZ();
	        }
	    };
	    HaikuElement.prototype.computeContentBounds = function () {
	        return __assign({}, this.computeContentBoundsX(), this.computeContentBoundsY(), this.computeContentBoundsZ());
	    };
	    HaikuElement.prototype.computeContentBoundsX = function () {
	        if (typeof this.sizeAbsolute.x === 'number') {
	            return {
	                left: null,
	                right: null,
	            };
	        }
	        var lefts = [];
	        var rights = [];
	        var children = this.children;
	        if (children.length < 1) {
	            return {
	                left: null,
	                right: null,
	            };
	        }
	        for (var i = 0; i < children.length; i++) {
	            var child = children[i];
	            // These fields should account for the child's translation, rotation, scale, etc.
	            var _a = child.getLocallyTransformedBoundingClientRect(), left = _a.left, right = _a.right;
	            lefts.push(left);
	            rights.push(right);
	        }
	        return {
	            left: Math.min.apply(Math, lefts),
	            right: Math.max.apply(Math, rights),
	        };
	    };
	    HaikuElement.prototype.computeContentBoundsY = function () {
	        if (typeof this.sizeAbsolute.y === 'number') {
	            return {
	                top: null,
	                bottom: null,
	            };
	        }
	        var tops = [];
	        var bottoms = [];
	        var children = this.children;
	        if (children.length < 1) {
	            return {
	                top: null,
	                bottom: null,
	            };
	        }
	        for (var i = 0; i < children.length; i++) {
	            var child = children[i];
	            // These fields should account for the child's translation, rotation, scale, etc.
	            var _a = child.getLocallyTransformedBoundingClientRect(), top_1 = _a.top, bottom = _a.bottom;
	            tops.push(top_1);
	            bottoms.push(bottom);
	        }
	        return {
	            top: Math.min.apply(Math, tops),
	            bottom: Math.max.apply(Math, bottoms),
	        };
	    };
	    HaikuElement.prototype.computeContentBoundsZ = function () {
	        return {
	            front: null,
	            back: null,
	        };
	    };
	    HaikuElement.prototype.computeSizeForAxis = function (axis) {
	        if (axis === 'x') {
	            return this.computeSizeX();
	        }
	        if (axis === 'y') {
	            return this.computeSizeY();
	        }
	        if (axis === 'z') {
	            return this.computeSizeZ();
	        }
	    };
	    /**
	     * @description For elements that only have a single child, we can save some computation
	     * by looking up their defined absolute size instead of computing their bounding box.
	     * In particular this is useful in the case of the component wrapper div and its one child.
	     */
	    HaikuElement.prototype.getOnlyChildSize = function (axis) {
	        var children = this.children;
	        if (children.length !== 1) {
	            return;
	        }
	        var child = children[0];
	        if (!child || typeof child !== 'object') {
	            return;
	        }
	        if (typeof child.sizeAbsolute[axis] === 'number') {
	            return child.sizeAbsolute[axis];
	        }
	        return child.getOnlyChildSize(axis);
	    };
	    HaikuElement.prototype.computeSizeX = function () {
	        // SVG primitives use native SVG layout instead of our system
	        if (this.isSvgPrimitive() && typeof this.attributeWidth === 'number') {
	            return this.attributeWidth;
	        }
	        if (typeof this.sizeAbsolute.x === 'number') {
	            return this.sizeAbsolute.x;
	        }
	        var onlyChildSize = this.getOnlyChildSize('x');
	        if (typeof onlyChildSize === 'number') {
	            return onlyChildSize;
	        }
	        var _a = this.computeContentBoundsX(), left = _a.left, right = _a.right;
	        return right - left;
	    };
	    HaikuElement.prototype.computeSizeY = function () {
	        // SVG primitives use native SVG layout instead of our system
	        if (this.isSvgPrimitive() && typeof this.attributeHeight === 'number') {
	            return this.attributeHeight;
	        }
	        if (typeof this.sizeAbsolute.y === 'number') {
	            return this.sizeAbsolute.y;
	        }
	        var onlyChildSize = this.getOnlyChildSize('y');
	        if (typeof onlyChildSize === 'number') {
	            return onlyChildSize;
	        }
	        var _a = this.computeContentBoundsY(), top = _a.top, bottom = _a.bottom;
	        return bottom - top;
	    };
	    HaikuElement.prototype.computeSizeZ = function () {
	        if (typeof this.sizeAbsolute.z === 'number') {
	            return this.sizeAbsolute.z;
	        }
	        var onlyChildSize = this.getOnlyChildSize('z');
	        if (typeof onlyChildSize === 'number') {
	            return onlyChildSize;
	        }
	        var _a = this.computeContentBoundsZ(), front = _a.front, back = _a.back;
	        return back - front;
	    };
	    HaikuElement.prototype.getComponentId = function () {
	        return this.attributes[exports.HAIKU_ID_ATTRIBUTE];
	    };
	    HaikuElement.prototype.isSimpleNode = function () {
	        return !this.isComponent();
	    };
	    HaikuElement.prototype.isTextNode = function () {
	        return typeof this.node !== 'object';
	    };
	    HaikuElement.prototype.isComponent = function () {
	        return !!this.instance;
	    };
	    HaikuElement.prototype.isWrapper = function () {
	        return !!this.subcomponent;
	    };
	    HaikuElement.prototype.isSvgPrimitive = function () {
	        return !!SVG_PRIMITIVE_NAMES[this.tagName];
	    };
	    HaikuElement.prototype.componentMatches = function (selector) {
	        if (!this.isComponent()) {
	            return false;
	        }
	        var trimmed = selector.trim();
	        var source = this.source;
	        var title = this.title;
	        var id = this.id;
	        return (trimmed === COMPONENT_PSEUDO_TAG_NAME ||
	            trimmed === source ||
	            trimmed === title ||
	            trimmed === id);
	    };
	    HaikuElement.prototype.matches = function (selector) {
	        return (this.componentMatches(selector) ||
	            HaikuNode_1.cssMatchOne(this.node, selector, CSS_QUERY_MAPPING));
	    };
	    HaikuElement.prototype.visit = function (iteratee, filter) {
	        var result = iteratee(this);
	        if (result !== false) {
	            return this.visitDescendants(iteratee, filter);
	        }
	        return result;
	    };
	    HaikuElement.prototype.visitDescendants = function (iteratee, filter) {
	        if (this.parent && this.parent.isWrapper()) {
	            // Avoids traversing down into a subcomponent.
	            return true;
	        }
	        var children = filter ? this.children.filter(filter) : this.children;
	        for (var i = 0; i < children.length; i++) {
	            var result = children[i].visit(iteratee, filter);
	            if (result === false) {
	                return result;
	            }
	        }
	        return true;
	    };
	    HaikuElement.prototype.querySelector = function (selector) {
	        var _this = this;
	        return this.cacheFetch("querySelector:" + selector, function () {
	            var out;
	            _this.visitDescendants(function (element) {
	                if (element.matches(selector)) {
	                    out = element;
	                    // Returning `false` short-circuits the visitor
	                    return false;
	                }
	            });
	            return out;
	        });
	    };
	    HaikuElement.prototype.querySelectorAll = function (selector) {
	        var _this = this;
	        return this.cacheFetch("querySelectorAll:" + selector, function () {
	            var out = [];
	            _this.visitDescendants(function (element) {
	                if (element.matches(selector)) {
	                    out.push(element);
	                }
	            });
	            return out;
	        });
	    };
	    HaikuElement.prototype.getRawBoundingBoxPoints = function () {
	        var _a = this.computeSize(), x = _a.x, y = _a.y;
	        return [
	            { x: 0, y: 0, z: 0 }, { x: x / 2, y: 0, z: 0 }, { x: x, y: 0, z: 0 },
	            { x: 0, y: y / 2, z: 0 }, { x: x / 2, y: y / 2, z: 0 }, { x: x, y: y / 2, z: 0 },
	            { y: y, x: 0, z: 0 }, { y: y, x: x / 2, z: 0 }, { y: y, x: x, z: 0 },
	        ];
	    };
	    HaikuElement.prototype.getLocallyTransformedBoundingBoxPoints = function () {
	        return HaikuElement.transformPointsInPlace(this.getRawBoundingBoxPoints(), HaikuElement.computeLayout(this.node, null).matrix);
	    };
	    HaikuElement.prototype.getLocallyTransformedBoundingClientRect = function () {
	        var points = this.getLocallyTransformedBoundingBoxPoints();
	        return HaikuElement.getRectFromPoints(points);
	    };
	    HaikuElement.prototype.getNearestDefinedNonZeroAncestorSizeX = function () {
	        var x = this.sizeAbsolute.x;
	        if (typeof x === 'number' && x > 0) {
	            return x;
	        }
	        if (this.parent) {
	            return this.parent.getNearestDefinedNonZeroAncestorSizeX();
	        }
	        return 1;
	    };
	    HaikuElement.prototype.getNearestDefinedNonZeroAncestorSizeY = function () {
	        var y = this.sizeAbsolute.y;
	        if (typeof y === 'number' && y > 0) {
	            return y;
	        }
	        if (this.parent) {
	            return this.parent.getNearestDefinedNonZeroAncestorSizeY();
	        }
	        return 1;
	    };
	    HaikuElement.prototype.getNearestDefinedNonZeroAncestorSizeZ = function () {
	        var z = this.sizeAbsolute.z;
	        if (typeof z === 'number' && z > 0) {
	            return z;
	        }
	        if (this.parent) {
	            return this.parent.getNearestDefinedNonZeroAncestorSizeZ();
	        }
	        return 1;
	    };
	    HaikuElement.prototype.triggerHover = function (event) {
	        var manager = this.top;
	        // In case of the root container of a render tree
	        if (!manager) {
	            manager = this.containee;
	        }
	        // Not sure how we'd get here, but if we do, skip this process
	        if (!manager || manager.isDeactivated) {
	            return;
	        }
	        // tslint:disable-next-line:no-this-assignment
	        var hoverable = this;
	        // If no last hovered element, there's nothing to unhover.
	        var mustUnhover = manager.lastHoveredElement !== undefined;
	        var hovers = [];
	        while (hoverable) {
	            // If the last hovered element is an ancestor,
	            // we _don't_ want to unhover it—that's the
	            // annoying browser behavior we're trying to
	            // "fix" in the first place.
	            if (mustUnhover && manager.lastHoveredElement === hoverable) {
	                mustUnhover = false;
	            }
	            // If we are hovered here, by virtue of this algorithm we are hovered above.
	            if (hoverable.isHovered) {
	                break;
	            }
	            hovers.push(hoverable);
	            hoverable.isHovered = true;
	            hoverable = hoverable.parent;
	        }
	        hovers.forEach(function (hov) {
	            var delegator = HaikuElement.getElementEventDelegator(hov);
	            if (delegator && !delegator.isDeactivated) {
	                delegator.routeEventToHandlerAndEmitWithoutBubblingAndWithoutGlobalHandlers(hov.selector, 'hover', [hov, hov.target, event]);
	            }
	        });
	        var unhovers = [];
	        // We must be in a different branch of the tree.
	        if (mustUnhover) {
	            var unhoverable = manager.lastHoveredElement;
	            // Stop until we hit the common hovered ancestor (wherever we break'ed above).
	            while (unhoverable && unhoverable !== hoverable) {
	                unhovers.push(unhoverable);
	                unhoverable.isHovered = false;
	                unhoverable = unhoverable.parent;
	            }
	        }
	        unhovers.forEach(function (unhov) {
	            var delegator = HaikuElement.getElementEventDelegator(unhov);
	            if (delegator && !delegator.isDeactivated) {
	                delegator.routeEventToHandlerAndEmitWithoutBubblingAndWithoutGlobalHandlers(unhov.selector, 'unhover', [unhov, unhov.target, event]);
	            }
	        });
	        manager.lastHoveredElement = this;
	    };
	    Object.defineProperty(HaikuElement.prototype, "selector", {
	        get: function () {
	            return "haiku:" + this.getComponentId();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    HaikuElement.prototype.dump = function () {
	        return this.$id + ":<" + this.tagName + ">(" + (this.getComponentId() || '[container]') + ")";
	    };
	    HaikuElement.getElementEventDelegator = function (el) {
	        if (!el) {
	            return;
	        }
	        if (el.isComponent()) {
	            return el;
	        }
	        return el.owner;
	    };
	    HaikuElement.transformVectorByMatrix = function (out, v, m) {
	        out[0] = m[0] * v[0] + m[4] * v[1] + m[8] * v[2] + m[12];
	        out[1] = m[1] * v[0] + m[5] * v[1] + m[9] * v[2] + m[13];
	        out[2] = m[2] * v[0] + m[6] * v[1] + m[10] * v[2] + m[14];
	        return out;
	    };
	    HaikuElement.getRectFromPoints = function (points) {
	        var top = Math.min(points[0].y, points[2].y, points[6].y, points[8].y);
	        var bottom = Math.max(points[0].y, points[2].y, points[6].y, points[8].y);
	        var left = Math.min(points[0].x, points[2].x, points[6].x, points[8].x);
	        var right = Math.max(points[0].x, points[2].x, points[6].x, points[8].x);
	        var width = Math.abs(bottom - top);
	        var height = Math.abs(right - left);
	        return {
	            top: top,
	            right: right,
	            bottom: bottom,
	            left: left,
	            width: width,
	            height: height,
	        };
	    };
	    HaikuElement.getBoundingBoxPoints = function (points) {
	        var x1 = points[0].x;
	        var y1 = points[0].y;
	        var x2 = points[0].x;
	        var y2 = points[0].y;
	        points.forEach(function (point) {
	            if (point.x < x1) {
	                x1 = point.x;
	            }
	            else if (point.x > x2) {
	                x2 = point.x;
	            }
	            if (point.y < y1) {
	                y1 = point.y;
	            }
	            else if (point.y > y2) {
	                y2 = point.y;
	            }
	        });
	        var w = x2 - x1;
	        var h = y2 - y1;
	        return [
	            { x: x1, y: y1, z: 0 }, { x: x1 + w / 2, y: y1, z: 0 }, { x: x2, y: y1, z: 0 },
	            { x: x1, y: y1 + h / 2, z: 0 }, { x: x1 + w / 2, y: y1 + h / 2, z: 0 }, { x: x2, y: y1 + h / 2, z: 0 },
	            { x: x1, y: y2, z: 0 }, { x: x1 + w / 2, y: y2, z: 0 }, { x: x2, y: y2, z: 0 },
	        ];
	    };
	    HaikuElement.transformPointsInPlace = function (points, matrix) {
	        for (var i = 0; i < points.length; i++) {
	            HaikuElement.transformPointInPlace(points[i], matrix);
	        }
	        return points;
	    };
	    HaikuElement.transformPointInPlace = function (point, matrix) {
	        var offset = HaikuElement.transformVectorByMatrix([], [point.x, point.y, point.z], matrix);
	        point.x = offset[0];
	        point.y = offset[1];
	        point.z = offset[2];
	        return point;
	    };
	    HaikuElement.getAncestry = function (ancestors, element) {
	        ancestors.unshift(element);
	        if (element.parent) {
	            HaikuElement.getAncestry(ancestors, element.parent);
	        }
	        return ancestors;
	    };
	    // tslint:disable-next-line:variable-name
	    HaikuElement.__name__ = 'HaikuElement';
	    HaikuElement.findByNode = function (node) {
	        var registry = HaikuBase_1.default.getRegistryForClass(HaikuElement);
	        for (var i = 0; i < registry.length; i++) {
	            if (registry[i].node === node) {
	                return registry[i];
	            }
	        }
	        return;
	    };
	    HaikuElement.connectNodeWithElement = function (node, element) {
	        // In case the element wasn't initialized yet
	        if (element) {
	            element.node = node;
	        }
	        // In case we got a string or null node
	        if (node && typeof node === 'object') {
	            // The purpose of the __memory object is to allow a mutable reference to be
	            // passed around even when the node's base attributes are cloned. Also
	            // to consolidate a host of __* properties which were becoming unweildy.
	            //
	            // Important: Platform-specific renderers may attach properties to this object;
	            // for example the HaikuDOMRenderer attaches list of .targets (DOM nodes).
	            if (!node.__memory) {
	                node.__memory = {};
	            }
	            node.__memory.element = element;
	        }
	    };
	    HaikuElement.createByNode = function (node) {
	        var element = new HaikuElement();
	        HaikuElement.connectNodeWithElement(node, element);
	        return element;
	    };
	    HaikuElement.findOrCreateByNode = function (node) {
	        var found;
	        if (node && typeof node === 'object') {
	            found = node.__memory && node.__memory.element;
	        }
	        if (!found) {
	            found = HaikuElement.findByNode(node);
	        }
	        if (found) {
	            HaikuElement.connectNodeWithElement(node, found);
	            return found;
	        }
	        return HaikuElement.createByNode(node);
	    };
	    HaikuElement.useAutoSizing = function (givenValue) {
	        return (givenValue === Layout3D_1.AUTO_SIZING_TOKEN ||
	            // Legacy. Because HaikuComponent#render gets called before Migration.runMigrations,
	            // the legacy value won't be correctly migrated to 'auto' by the time this gets called
	            // for the very first time, so we keep it around for backwards compat. Jun 22, 2018.
	            givenValue === true);
	    };
	    HaikuElement.computeLayout = function (targetNode, parentNode) {
	        var layoutSpec = targetNode.layout;
	        var targetSize = {
	            x: null,
	            y: null,
	            z: null,
	        };
	        var parentBounds = (parentNode &&
	            parentNode.layout &&
	            parentNode.layout.computed &&
	            parentNode.layout.computed.bounds);
	        var targetBounds = {
	            left: null,
	            top: null,
	            right: null,
	            bottom: null,
	            front: null,
	            back: null,
	        };
	        var leftOffset = 0;
	        var topOffset = 0;
	        if (parentBounds) {
	            if (typeof parentBounds.left === 'number') {
	                leftOffset += parentBounds.left;
	            }
	            if (typeof parentBounds.top === 'number') {
	                topOffset += parentBounds.top;
	            }
	        }
	        var targetElement = HaikuElement.findOrCreateByNode(targetNode);
	        // We'll define this later if any axes are requesting SIZE_PROPORTIONAL. It isn't needed for SIZE_ABSOLUTE.
	        var parentsizeAbsolute;
	        for (var i = 0; i < SIZING_AXES.length; i++) {
	            var sizeAxis = SIZING_AXES[i];
	            switch (layoutSpec.sizeMode[sizeAxis]) {
	                case Layout3D_1.SIZE_PROPORTIONAL:
	                    if (!parentsizeAbsolute) {
	                        parentsizeAbsolute = (parentNode &&
	                            parentNode.layout &&
	                            parentNode.layout.computed &&
	                            parentNode.layout.computed.size) || { x: 0, y: 0, z: 0 };
	                        if (parentsizeAbsolute.z === undefined || parentsizeAbsolute.z === null) {
	                            parentsizeAbsolute.z = DEFAULT_DEPTH;
	                        }
	                        if (parentsizeAbsolute.x === 0 && parentsizeAbsolute.y === 0 && parentsizeAbsolute.z === 0) {
	                            // Size must be inherited from an ancestor above parent. Traverse upward until we find it.
	                            var traversalParentNode = targetNode;
	                            while (traversalParentNode) {
	                                traversalParentNode = traversalParentNode.__memory && traversalParentNode.__memory.parent;
	                                if (traversalParentNode && traversalParentNode.layout && traversalParentNode.layout.computed) {
	                                    Object.assign(parentsizeAbsolute, traversalParentNode.layout.computed.size);
	                                    break;
	                                }
	                            }
	                        }
	                    }
	                    // Size is calculated as: parentSizeValue * sizeProportional + sizeProportional.
	                    targetSize[sizeAxis] = parentsizeAbsolute[sizeAxis] * layoutSpec.sizeProportional[sizeAxis] +
	                        layoutSpec.sizeDifferential[sizeAxis];
	                    break;
	                case Layout3D_1.SIZE_ABSOLUTE:
	                    var givenValue = layoutSpec.sizeAbsolute[sizeAxis];
	                    // Implements "auto"-sizing: Use content size if available, otherwise fallback to parent
	                    if (HaikuElement.useAutoSizing(givenValue)) {
	                        targetSize[sizeAxis] = targetElement.computeSizeForAxis(sizeAxis);
	                        Object.assign(targetBounds, targetElement.computeBoundsForAxis(sizeAxis));
	                    }
	                    else {
	                        targetSize[sizeAxis] = givenValue; // Assume the given value is numeric
	                    }
	                    break;
	            }
	        }
	        var virtualSpec = __assign({}, layoutSpec, { offset: {
	                x: layoutSpec.offset.x - leftOffset,
	                y: layoutSpec.offset.y - topOffset,
	                z: layoutSpec.offset.z,
	            } });
	        var targetMatrix = Layout3D_1.default.computeMatrix(virtualSpec, targetSize);
	        return {
	            shown: layoutSpec.shown,
	            opacity: layoutSpec.opacity,
	            offset: layoutSpec.offset,
	            origin: layoutSpec.origin,
	            translation: layoutSpec.translation,
	            rotation: layoutSpec.rotation,
	            scale: layoutSpec.scale,
	            shear: layoutSpec.shear,
	            sizeMode: layoutSpec.sizeMode,
	            sizeProportional: layoutSpec.sizeProportional,
	            sizeDifferential: layoutSpec.sizeDifferential,
	            sizeAbsolute: layoutSpec.sizeAbsolute,
	            size: targetSize,
	            matrix: targetMatrix,
	            bounds: targetBounds,
	        };
	    };
	    return HaikuElement;
	}(HaikuBase_1.default));
	exports.default = HaikuElement;
	//# sourceMappingURL=HaikuElement.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var pkg = __webpack_require__(18);
	var VERSION = pkg.version;
	// We need a global harness so we can attach helpers
	var MAIN = ((typeof window !== 'undefined')
	    ? window
	    : (typeof global !== 'undefined')
	        ? global
	        : {});
	if (!MAIN.HaikuHelpers) {
	    MAIN.HaikuHelpers = {};
	}
	// Different versions may have different helpers, so keep that in mind...
	if (!MAIN.HaikuHelpers[VERSION]) {
	    MAIN.HaikuHelpers[VERSION] = {
	        helpers: {},
	    };
	}
	var exp = MAIN.HaikuHelpers[VERSION];
	exp.register = function (name, method) {
	    exp.helpers[name] = method;
	    return exp;
	};
	exports.default = exp;
	//# sourceMappingURL=HaikuHelpers.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuBase_1 = __webpack_require__(13);
	var getActionsMaxTime_1 = __webpack_require__(125);
	var getTimelineMaxTime_1 = __webpack_require__(127);
	var Tokenizer_1 = __webpack_require__(63);
	var assign_1 = __webpack_require__(20);
	var NUMBER = 'number';
	var DEFAULT_OPTIONS = {
	    // loop: Boolean
	    // Determines whether this timeline should loop (start at its beginning when finished)
	    loop: true,
	};
	var TimeUnit;
	(function (TimeUnit) {
	    TimeUnit["Millisecond"] = "ms";
	    TimeUnit["Frame"] = "fr";
	})(TimeUnit = exports.TimeUnit || (exports.TimeUnit = {}));
	var PlaybackFlag;
	(function (PlaybackFlag) {
	    PlaybackFlag["ONCE"] = "once";
	    PlaybackFlag["PLAY"] = "play";
	    PlaybackFlag["LOOP"] = "loop";
	    PlaybackFlag["STOP"] = "stop";
	    PlaybackFlag["SEEK"] = "seek";
	})(PlaybackFlag = exports.PlaybackFlag || (exports.PlaybackFlag = {}));
	var makePlaybackProc = function (body) {
	    // tslint:disable-next-line:no-function-constructor-with-string-args
	    return new Function('$time', body);
	};
	var PLAYBACK_FLAGS = {
	    once: true,
	    play: true,
	    loop: true,
	    stop: true,
	    seek: true,
	};
	// tslint:disable:variable-name
	var HaikuTimeline = /** @class */ (function (_super) {
	    __extends(HaikuTimeline, _super);
	    function HaikuTimeline(component, name, options) {
	        var _this = _super.call(this) || this;
	        _this.component = component;
	        _this.name = name;
	        _this.assignOptions(options || {});
	        _this.globalClockTime = 0;
	        _this.localElapsedTime = 0;
	        _this.localControlledTime = null; // Only set this to a number if time is 'controlled'
	        _this.areUpdatesFrozen = !!_this.options.freeze;
	        _this.isTimelineLooping = !!_this.options.loop;
	        _this.isTimelinePlaying = true;
	        _this.offsetCalculator = null;
	        _this.lastFrame = null;
	        _this.numLoops = 0;
	        return _this;
	    }
	    HaikuTimeline.prototype.getMs = function (amount, unit) {
	        switch (unit) {
	            case "fr" /* Frame */:
	                return Math.round(this.getFrameDuration() * amount);
	            case "ms" /* Millisecond */:
	            default:
	                // The only currently valid alternative to TimeUnit.Frame is TimeUnit.Millisecond.
	                return amount;
	        }
	    };
	    HaikuTimeline.prototype.getFrameDuration = function () {
	        return this.component.getClock().getFrameDuration();
	    };
	    HaikuTimeline.prototype.assignOptions = function (options) {
	        this.options = assign_1.default(this.options || {}, DEFAULT_OPTIONS, options || {});
	    };
	    HaikuTimeline.prototype.ensureClockIsRunning = function () {
	        var clock = this.component.getClock();
	        if (!clock.isRunning()) {
	            clock.start();
	        }
	    };
	    /**
	     * @method setComponent
	     * @description Internal hook to allow Haiku to hot swap on-stage components during editing.
	     */
	    HaikuTimeline.prototype.setComponent = function (component) {
	        this.component = component;
	    };
	    HaikuTimeline.prototype.doUpdateWithGlobalClockTime = function (globalClockTime) {
	        if (this.isFrozen()) {
	            return;
	        }
	        var prevGlobalClockTime = this.getClockTime();
	        var deltaGlobalClockTime = globalClockTime - prevGlobalClockTime;
	        this.globalClockTime = globalClockTime;
	        // If we update with the global clock time while a timeline is paused, the next
	        // time we resume playing it will "jump forward" to the time that has elapsed.
	        if (this.isPaused()) {
	            return;
	        }
	        this.doUpdateWithTimeDelta(deltaGlobalClockTime);
	    };
	    HaikuTimeline.prototype.doUpdateWithTimeDelta = function (deltaClockTime) {
	        var ceilTime = this.getCeilTime();
	        var prevElapsedTime = this.getElapsedTime();
	        var newElapsedTime = prevElapsedTime + deltaClockTime;
	        var didLoop = HaikuTimeline.didTimeLoop(prevElapsedTime, newElapsedTime, ceilTime);
	        this.setElapsedTime(newElapsedTime);
	        // If we are a looping timeline, reset to zero once we've gone past our max
	        if (this.isLooping() && didLoop) {
	            this.numLoops++;
	            // Avoid log DoS for too-short timelines
	            if (this.getMaxTime() > 200) {
	                this.component.callHook('timeline:loop', {
	                    localElapsedTime: newElapsedTime,
	                    maxExplicitlyDefinedTime: this.getMaxTime(),
	                    globalClockTime: this.getClockTime(),
	                    boundedFrame: this.getBoundedFrame(),
	                    loopCount: this.numLoops,
	                });
	            }
	        }
	    };
	    HaikuTimeline.prototype.executePreUpdateHooks = function (globalClockTime) {
	        this.doUpdateWithGlobalClockTime(globalClockTime);
	    };
	    HaikuTimeline.prototype.executePostUpdateHooks = function (globalClockTime) {
	        if (this.isFrozen() || this.isPaused()) {
	            return;
	        }
	        var frame = this.getBoundedFrame();
	        var time = Math.round(this.getBoundedTime());
	        this.component.routeEventToHandlerAndEmitWithoutBubbling(HaikuBase_1.GLOBAL_LISTENER_KEY, "timeline:" + this.getName() + ":" + frame, [frame, time]);
	        // Allow users to subscribe to the 'frame' event globally
	        this.component.routeEventToHandlerAndEmitWithoutBubbling(HaikuBase_1.GLOBAL_LISTENER_KEY, 'frame', [frame, time]);
	        // Deprecated; please use the 'frame' event instead. This is used by the Haiku Share Page.
	        this.emit('tick', frame, time);
	        this.lastFrame = frame;
	    };
	    HaikuTimeline.prototype.getLastFrame = function () {
	        return this.lastFrame;
	    };
	    HaikuTimeline.prototype.controlTime = function (controlledTimeToSet, newGlobalClockTime) {
	        this.setControlledTime(parseInt(controlledTimeToSet || 0, 10));
	        // Need to update the properties so that accessors like .getFrame() work after this update.
	        this.doUpdateWithGlobalClockTime(newGlobalClockTime);
	    };
	    HaikuTimeline.prototype.isTimeControlled = function () {
	        return typeof this.getControlledTime() === NUMBER;
	    };
	    /**
	     * @method getName
	     * @description Return the name of this timeline
	     */
	    HaikuTimeline.prototype.getName = function () {
	        return this.name;
	    };
	    /**
	     * @method getMaxTime
	     * @description Return the maximum time that this timeline will reach, in ms.
	     */
	    HaikuTimeline.prototype.getMaxTime = function () {
	        var _this = this;
	        return this.cacheFetch('getMaxTime', function () {
	            var descriptorMax = _this.getMaxKeyframeTime();
	            var actionsMax = _this.getMaxActionsTime();
	            return Math.max(descriptorMax, actionsMax);
	        });
	    };
	    HaikuTimeline.prototype.getMaxKeyframeTime = function () {
	        return getTimelineMaxTime_1.default(this.getDescriptor());
	    };
	    HaikuTimeline.prototype.getMaxActionsTime = function () {
	        return Math.round(getActionsMaxTime_1.default(this.name, this.component.bytecode.eventHandlers, this.getFrameDuration()));
	    };
	    HaikuTimeline.prototype.getDescriptor = function () {
	        return this.component.getTimelineDescriptor(this.name);
	    };
	    /**
	     * @description The millisecond value for the beginning of one frame past the max.
	     */
	    HaikuTimeline.prototype.getCeilTime = function () {
	        return this.getMaxTime() + this.getMs(1, "fr" /* Frame */);
	    };
	    /**
	     * @method getClockTime
	     * @description fseek the global clock time that this timeline is at, in ms,
	     * whether or not our local time matches it or it has exceeded our max.
	     * This value is ultimately managed by the clock and passed in.
	     */
	    HaikuTimeline.prototype.getClockTime = function () {
	        return this.globalClockTime;
	    };
	    /**
	     * @method getElapsedTime
	     * @description Return the amount of time that has elapsed on this timeline since
	     * it started updating, up to the most recent time update it received from the clock.
	     * Note that for inactive ftimelines, this value will cease increasing as of the last update.
	     */
	    HaikuTimeline.prototype.getElapsedTime = function () {
	        return this.localElapsedTime;
	    };
	    HaikuTimeline.prototype.setElapsedTime = function (t) {
	        this.localElapsedTime = t;
	    };
	    /**
	     * @description If time has been explicitly set here via time control, this value will
	     * be the number of that setting.
	     */
	    HaikuTimeline.prototype.getControlledTime = function () {
	        return this.localControlledTime;
	    };
	    HaikuTimeline.prototype.setControlledTime = function (t) {
	        this.localControlledTime = t;
	    };
	    /**
	     * @description Return the locally elapsed time, or the maximum time of this timeline,
	     * whichever is smaller. Useful if you want to know what the "effective" time of this
	     * timeline is, not necessarily how much has elapsed in an absolute sense. This is used
	     * in the renderer to determine what value to calculate "now" deterministically.
	     */
	    HaikuTimeline.prototype.getBoundedTime = function () {
	        var max = this.getMaxTime();
	        var time = (this.isTimeControlled())
	            ? this.getControlledTime()
	            : this.getElapsedTime();
	        if (this.offsetCalculator) {
	            try {
	                time = this.offsetCalculator.call(this, time);
	            }
	            catch (exception) {
	                // no-op
	            }
	        }
	        if (this.isLooping()) {
	            var looped = HaikuTimeline.modulo(Math.round(time), this.getCeilTime());
	            return looped;
	        }
	        // Don't allow negative time
	        if (time < 0.000001) {
	            time = 0;
	        }
	        return Math.min(time, max);
	    };
	    /**
	     * @description Convenience wrapper. Currently returns the bounded time. There's an argument
	     * that this should return the elapsed time, though. #TODO
	     */
	    HaikuTimeline.prototype.getTime = function () {
	        return this.getBoundedTime();
	    };
	    /**
	     * @description Return the current frame up to the maximum frame available for this timeline's duration.
	     */
	    HaikuTimeline.prototype.getBoundedFrame = function () {
	        var time = this.getTime(); // Returns the bounded time
	        var timeStep = this.component.getClock().getFrameDuration();
	        return Math.round(time / timeStep);
	    };
	    /**
	     * @method getUnboundedFrame
	     * @description Return the current frame, even if it is above the maximum frame.
	     */
	    HaikuTimeline.prototype.getUnboundedFrame = function () {
	        var time = this.getElapsedTime(); // The elapsed time can go larger than the max time; see timeline.js
	        var timeStep = this.component.getClock().getFrameDuration();
	        return Math.round(time / timeStep);
	    };
	    /**
	     * @method getFrame
	     * @description Return the bounded frame.
	     * There's an argument that this should return the absolute frame. #TODO
	     */
	    HaikuTimeline.prototype.getFrame = function () {
	        return this.getBoundedFrame();
	    };
	    /**
	     * @method isPlaying
	     * @description Returns T/F if the timeline is playing
	     */
	    HaikuTimeline.prototype.isPlaying = function () {
	        return this.isTimelinePlaying;
	    };
	    HaikuTimeline.prototype.setPlaying = function (isPlaying) {
	        if (isPlaying === void 0) { isPlaying = true; }
	        this.isTimelinePlaying = !!isPlaying;
	    };
	    HaikuTimeline.prototype.isPaused = function () {
	        return !this.isPlaying();
	    };
	    /**
	     * @method isFinished
	     * @description Returns T/F if the timeline is finished.
	     * If this timeline is set to loop, it is never "finished".
	     */
	    HaikuTimeline.prototype.isFinished = function () {
	        if (this.isLooping() || this.isTimeControlled()) {
	            return false;
	        }
	        return this.getElapsedTime() > this.getMaxTime();
	    };
	    HaikuTimeline.prototype.isUnfinished = function () {
	        return !this.isFinished();
	    };
	    HaikuTimeline.prototype.getDuration = function () {
	        return this.getMaxTime() || 0;
	    };
	    HaikuTimeline.prototype.setRepeat = function (bool) {
	        if (bool === void 0) { bool = true; }
	        this.isTimelineLooping = !!bool;
	    };
	    HaikuTimeline.prototype.getRepeat = function () {
	        return this.isTimelineLooping;
	    };
	    HaikuTimeline.prototype.isRepeating = function () {
	        return this.getRepeat();
	    };
	    HaikuTimeline.prototype.isLooping = function () {
	        return this.isRepeating();
	    };
	    /**
	     * @method isFrozen
	     * @description Returns T/F if the timeline is frozen
	     */
	    HaikuTimeline.prototype.isFrozen = function () {
	        return this.areUpdatesFrozen;
	    };
	    HaikuTimeline.prototype.freeze = function () {
	        this.areUpdatesFrozen = true;
	    };
	    HaikuTimeline.prototype.unfreeze = function () {
	        this.areUpdatesFrozen = false;
	    };
	    HaikuTimeline.prototype.start = function () {
	        this.startSoftly(0);
	        this.emit('start');
	    };
	    HaikuTimeline.prototype.startSoftly = function (maybeElapsedTime) {
	        this.setPlaying(true);
	        this.setElapsedTime(maybeElapsedTime || 0);
	    };
	    HaikuTimeline.prototype.stop = function () {
	        this.stopSoftly();
	        this.emit('stop');
	    };
	    HaikuTimeline.prototype.stopSoftly = function () {
	        this.setPlaying(false);
	    };
	    HaikuTimeline.prototype.pause = function () {
	        this.pauseSoftly();
	        this.emit('pause');
	    };
	    HaikuTimeline.prototype.pauseSoftly = function () {
	        this.setPlaying(false);
	    };
	    HaikuTimeline.prototype.play = function (options) {
	        if (options === void 0) { options = {}; }
	        this.playSoftly();
	        if (!options || !options.skipMarkForFullFlush) {
	            this.component.markForFullFlush();
	        }
	        this.emit('play');
	    };
	    HaikuTimeline.prototype.playSoftly = function () {
	        this.ensureClockIsRunning();
	        this.setPlaying(true);
	        // When playing after exiting controlled-time mode, start from the last controlled time.
	        if (this.isTimeControlled()) {
	            this.setElapsedTime(this.getControlledTime());
	            // To properly exit controlled-time mode, we need to set controlled time to null.
	            this.setControlledTime(null);
	        }
	    };
	    HaikuTimeline.prototype.seek = function (amount, unit) {
	        if (unit === void 0) { unit = "fr" /* Frame */; }
	        var ms = this.getMs(amount, unit);
	        this.seekSoftly(ms);
	        this.component.markForFullFlush();
	        this.emit('seek', ms);
	    };
	    HaikuTimeline.prototype.seekSoftly = function (ms) {
	        this.ensureClockIsRunning();
	        this.controlTime(ms, this.component.getClock().getTime());
	        this.setElapsedTime(this.getControlledTime());
	    };
	    HaikuTimeline.prototype.gotoAndPlay = function (amount, unit) {
	        if (unit === void 0) { unit = "fr" /* Frame */; }
	        var ms = this.getMs(amount, unit);
	        this.seekSoftly(ms);
	        this.play(null);
	    };
	    HaikuTimeline.prototype.gotoAndStop = function (amount, unit) {
	        if (unit === void 0) { unit = "fr" /* Frame */; }
	        this.seekSoftly(this.getMs(amount, unit));
	        if (this.component && this.component.context && this.component.context.tick) {
	            this.component.context.tick();
	        }
	        this.pause();
	    };
	    HaikuTimeline.prototype.setPlaybackStatus = function (input) {
	        var _a = this.parsePlaybackStatus(input), flag = _a.flag, time = _a.time, proc = _a.proc;
	        if (flag === "loop" /* LOOP */) {
	            this.setRepeat(true);
	        }
	        if (flag === "once" /* ONCE */) {
	            this.setRepeat(false);
	        }
	        // If the sending timeline is frozen, don't inadvertently unfreeze its component's guests
	        if (flag === "loop" /* LOOP */ || // In the current API, loop also connotes play
	            flag === "once" /* ONCE */ ||
	            flag === "play" /* PLAY */) {
	            if (!this.isPlaying()) {
	                this.play();
	            }
	        }
	        if (flag === "stop" /* STOP */) {
	            if (this.isPlaying()) {
	                this.stop();
	            }
	        }
	        if (flag === "seek" /* SEEK */) {
	            this.seek(time || 0, "ms" /* Millisecond */);
	        }
	        if (typeof proc === 'function') {
	            this.offsetCalculator = proc;
	        }
	    };
	    HaikuTimeline.prototype.parsePlaybackStatus = function (input) {
	        if (!input) {
	            return {
	                flag: "loop" /* LOOP */,
	            };
	        }
	        // If an object, assume it takes the format of a flag payload
	        if (typeof input === 'object') {
	            return input;
	        }
	        if (typeof input === 'number' && Tokenizer_1.isNumeric(input)) {
	            return {
	                flag: "seek" /* SEEK */,
	                // Assume the input is frames and convert to our internal format, milliseconds
	                time: this.getMs(Number(input), "fr" /* Frame */),
	            };
	        }
	        if (typeof input === 'string') {
	            var tokens = this.cacheFetch("getPlaybackStatusTokens:" + input, function () {
	                return Tokenizer_1.tokenizeDirective(input).map(function (_a) {
	                    var value = _a.value;
	                    return value;
	                });
	            });
	            // If no tokens, assume the default: A looping timeline
	            if (tokens.length < 1) {
	                return {
	                    flag: "loop" /* LOOP */,
	                };
	            }
	            // Fast-path if we got a single playback flag string
	            if (tokens.length === 1 && PLAYBACK_FLAGS[tokens[0]]) {
	                return {
	                    flag: tokens[0],
	                };
	            }
	            var finals = [];
	            // Convert any known number-unit tuples in the token stream into their canonical
	            // ms-based time value. For example [100,ms]->[100], or [10]->[166] (frames to ms).
	            for (var i = 0; i < tokens.length; i++) {
	                var curr = tokens[i];
	                var next = tokens[i + 1];
	                if (typeof curr === 'number') {
	                    if (next === 'ms') {
	                        finals.push(this.getMs(curr, "ms" /* Millisecond */));
	                        i++;
	                        continue;
	                    }
	                    if (next === 'fr') {
	                        finals.push(this.getMs(curr, "fr" /* Frame */));
	                        i++;
	                        continue;
	                    }
	                    // Frames are assumed to be the default that an end-user would write
	                    if (next !== 'fr') {
	                        finals.push(this.getMs(curr, "fr" /* Frame */));
	                        continue;
	                    }
	                }
	                finals.push(curr);
	            }
	            if (finals.length > 1) {
	                // E.g. if we got +100, make it loop+100
	                if (!PLAYBACK_FLAGS[finals[0]]) {
	                    finals.unshift("loop" /* LOOP */);
	                }
	            }
	            var expr = finals.map(function (val) {
	                if (PLAYBACK_FLAGS[val]) {
	                    return '$time';
	                }
	                return val;
	            }).join(' ');
	            var proc = void 0;
	            try {
	                proc = makePlaybackProc("return " + expr + ";");
	            }
	            catch (exception) {
	                // no-op
	            }
	            var out = {
	                proc: proc,
	                flag: finals[0],
	            };
	            return out;
	        }
	        return {
	            flag: "loop" /* LOOP */,
	        };
	    };
	    /**
	     * @deprecated
	     * TODO: Please change this to a getter.
	     */
	    HaikuTimeline.prototype.duration = function () {
	        return this.getDuration();
	    };
	    Object.defineProperty(HaikuTimeline.prototype, "repeat", {
	        get: function () {
	            return this.getRepeat();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuTimeline.prototype, "time", {
	        get: function () {
	            return this.getTime();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuTimeline.prototype, "max", {
	        get: function () {
	            return this.getMaxTime();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HaikuTimeline.prototype, "frame", {
	        get: function () {
	            return this.getFrame();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    HaikuTimeline.__name__ = 'HaikuTimeline';
	    HaikuTimeline.all = function () { return HaikuBase_1.default.getRegistryForClass(HaikuTimeline); };
	    HaikuTimeline.where = function (criteria) {
	        var all = HaikuTimeline.all();
	        return all.filter(function (timeline) {
	            return timeline.matchesCriteria(criteria);
	        });
	    };
	    HaikuTimeline.create = function (component, name, config) {
	        return new HaikuTimeline(component, name, config);
	    };
	    /**
	     * @description Modulus, but returns zero if the second number is zero,
	     * and calculates an appropriate "cycle" if the number is negative.
	     */
	    HaikuTimeline.modulo = function (n, ceil) {
	        if (ceil === 0) {
	            return 0;
	        }
	        return ((n % ceil) + ceil) % ceil;
	    };
	    /**
	     * @description Given a previous elapsed time (a), a new elapsed time (b), and a max
	     * time (max), determine whether the given timeline has looped between (a) and (b).
	     *
	     * E.g.:
	     *   0----------100
	     *        62        103  true
	     *
	     *   0----------100
	     *        62    100  true
	     *
	     *   0----------100
	     *        62   99  false
	     *
	     *   0----------100
	     *              100  110  false
	     *
	     *   0----------100
	     *               101  110  false
	     *
	     *   0----------100
	     *              100
	     *              100  false
	     *
	     *   0----------100
	     *   0          100  false
	     *
	     *   0----------100
	     *   0
	     *   0  false
	     */
	    HaikuTimeline.didTimeLoop = function (a, b, ceil) {
	        var ma = HaikuTimeline.modulo(a, ceil);
	        var mb = HaikuTimeline.modulo(b, ceil);
	        return mb < ma;
	    };
	    return HaikuTimeline;
	}(HaikuBase_1.default));
	exports.default = HaikuTimeline;
	//# sourceMappingURL=HaikuTimeline.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuNode_1 = __webpack_require__(29);
	var compareSemver_1 = __webpack_require__(123);
	var migrateAutoSizing_1 = __webpack_require__(129);
	var applyCssLayout_1 = __webpack_require__(62);
	var functionToRFO_1 = __webpack_require__(31);
	var reifyRFO_1 = __webpack_require__(138);
	var UpgradeVersionRequirement;
	(function (UpgradeVersionRequirement) {
	    UpgradeVersionRequirement["OriginSupport"] = "3.2.0";
	    UpgradeVersionRequirement["TimelineDefaultFrames"] = "3.2.23";
	    UpgradeVersionRequirement["CamelAutoSizingOffset3DOmnibus"] = "3.5.2";
	})(UpgradeVersionRequirement || (UpgradeVersionRequirement = {}));
	var HAIKU_ID_ATTRIBUTE = 'haiku-id';
	var HAIKU_SOURCE_ATTRIBUTE = 'haiku-source';
	var HAIKU_VAR_ATTRIBUTE = 'haiku-var';
	var HAIKU_ROOT_DEFAULT_REGEX = /^web\+haikuroot:\/\//;
	var HAIKU_ROOT_DEFAULT = 'web+haikuroot://';
	var SRC_ATTRIBUTE = 'src';
	var HREF_ATTRIBUTE = 'href';
	var XLINKHREF_ATTRIBUTE = 'xlink:href';
	var requiresUpgrade = function (coreVersion, requiredVersion) { return !coreVersion ||
	    compareSemver_1.default(coreVersion, requiredVersion) < 0; };
	var areKeyframesDefined = function (keyframeGroup) {
	    return (keyframeGroup &&
	        Object.keys(keyframeGroup).length > 0);
	};
	var ensure3dPreserved = function (node) {
	    if (!node || !node.attributes || !node.attributes.style) {
	        return;
	    }
	    var changed = false;
	    // Only preserve 3D behavior if the node hasn't been *explicitly* defined yet
	    if (!node.attributes.style.transformStyle) {
	        node.attributes.style.transformStyle = 'preserve-3d';
	        changed = true;
	        if (!node.attributes.style.perspective) {
	            node.attributes.style.perspective = 'inherit';
	        }
	    }
	    return changed;
	};
	/**
	 * Migrations are a mechanism to modify our bytecode from legacy format to the current format.
	 * This always runs against production components' bytecode to ensure their data is a format
	 * that the current version of the engine knows how to handle. There are two phases to migration:
	 * the pre-phase, which runs before an initial .render call, and a post-phase, which runs after.
	 */
	exports.runMigrationsPrePhase = function (component, options) {
	    var bytecode = component.bytecode;
	    if (!bytecode.states) {
	        bytecode.states = {};
	    }
	    if (!bytecode.metadata) {
	        bytecode.metadata = {};
	    }
	    var coreVersion = bytecode.metadata.core || bytecode.metadata.player;
	    // Convert the properties array to the states dictionary
	    if (bytecode.properties) {
	        var properties = bytecode.properties;
	        delete bytecode.properties;
	        for (var i = 0; i < properties.length; i++) {
	            var propertySpec = properties[i];
	            var updatedSpec = {};
	            if (propertySpec.value !== undefined) {
	                updatedSpec.value = propertySpec.value;
	            }
	            if (propertySpec.type !== undefined) {
	                updatedSpec.type = propertySpec.type;
	            }
	            if (propertySpec.setter !== undefined) {
	                updatedSpec.set = propertySpec.setter;
	            }
	            if (propertySpec.getter !== undefined) {
	                updatedSpec.get = propertySpec.getter;
	            }
	            if (propertySpec.set !== undefined) {
	                updatedSpec.set = propertySpec.set;
	            }
	            if (propertySpec.get !== undefined) {
	                updatedSpec.get = propertySpec.get;
	            }
	            bytecode.states[propertySpec.name] = updatedSpec;
	        }
	    }
	    // Convert the eventHandlers array into a dictionary
	    // [{selector:'foo',name:'onclick',handler:function}] => {'foo':{'onclick':{handler:function}}}
	    if (Array.isArray(bytecode.eventHandlers)) {
	        var eventHandlers = bytecode.eventHandlers;
	        delete bytecode.eventHandlers;
	        bytecode.eventHandlers = {};
	        for (var j = 0; j < eventHandlers.length; j++) {
	            var eventHandlerSpec = eventHandlers[j];
	            if (!bytecode.eventHandlers[eventHandlerSpec.selector]) {
	                bytecode.eventHandlers[eventHandlerSpec.selector] = {};
	            }
	            bytecode.eventHandlers[eventHandlerSpec.selector][eventHandlerSpec.name] = {
	                handler: eventHandlerSpec.handler,
	            };
	        }
	    }
	    if (bytecode.timelines) {
	        // Expand all bytecode properties represented as shorthand.
	        for (var timelineName in bytecode.timelines) {
	            for (var selector in bytecode.timelines[timelineName]) {
	                for (var property in bytecode.timelines[timelineName][selector]) {
	                    if (bytecode.timelines[timelineName][selector][property] === null) {
	                        delete bytecode.timelines[timelineName][selector][property];
	                    }
	                    else if (typeof bytecode.timelines[timelineName][selector][property] !== 'object') {
	                        bytecode.timelines[timelineName][selector][property] = {
	                            0: {
	                                value: bytecode.timelines[timelineName][selector][property],
	                            },
	                        };
	                    }
	                }
	            }
	        }
	    }
	    var needsOmnibusUpgrade = requiresUpgrade(coreVersion, "3.5.2" /* CamelAutoSizingOffset3DOmnibus */);
	    var referencesToUpdate = {};
	    if (bytecode.template) {
	        // y-overflow + preserve-3d leads to various rendering bugs, so for now, disable when overflow is available.
	        // #FIXME
	        var autoPreserve3d_1 = component.config.preserve3d === 'auto' && component.config.overflowY !== 'visible';
	        HaikuNode_1.visitManaTree('0', bytecode.template, function (_, attributes) {
	            if (typeof attributes !== 'object') {
	                return;
	            }
	            if (options.mutations) {
	                if (attributes.id) {
	                    var prev = attributes.id;
	                    var next = prev + '-' + options.mutations.referenceUniqueness;
	                    attributes.id = next;
	                    referencesToUpdate["#" + prev] = "#" + next;
	                    referencesToUpdate['url(#' + prev + ')'] = 'url(#' + next + ')';
	                }
	            }
	        }, null, 0);
	        HaikuNode_1.visitManaTree('0', bytecode.template, function (elementName, attributes) {
	            if (typeof attributes !== 'object') {
	                return;
	            }
	            var timelineProperties = bytecode.timelines.Default["haiku:" + attributes[HAIKU_ID_ATTRIBUTE]] || {};
	            // Hoist xlink:href up to the timeline if not already done. Older versions of Haiku installed xlink:href in the
	            // attributes dictionary.
	            if (attributes[XLINKHREF_ATTRIBUTE]) {
	                timelineProperties[XLINKHREF_ATTRIBUTE] = { 0: { value: attributes[XLINKHREF_ATTRIBUTE] } };
	                delete attributes[XLINKHREF_ATTRIBUTE];
	            }
	            if (options.mutations) {
	                for (var property in timelineProperties) {
	                    if (property !== SRC_ATTRIBUTE && property !== XLINKHREF_ATTRIBUTE && property !== HREF_ATTRIBUTE) {
	                        continue;
	                    }
	                    for (var keyframe in timelineProperties[property]) {
	                        var value = timelineProperties[property][keyframe].value;
	                        if (HAIKU_ROOT_DEFAULT_REGEX.test(value)) {
	                            timelineProperties[property][keyframe].value = value.replace(HAIKU_ROOT_DEFAULT, options.mutations.haikuRoot);
	                        }
	                        else if (referencesToUpdate[value]) {
	                            timelineProperties[property][keyframe].value = referencesToUpdate[value];
	                        }
	                    }
	                }
	            }
	            // Switch the legacy 'source' attribute to the new 'haiku-source'
	            if (attributes.source) {
	                attributes[HAIKU_SOURCE_ATTRIBUTE] = attributes.source;
	                delete attributes.source;
	            }
	            if (attributes.identifier) {
	                attributes[HAIKU_VAR_ATTRIBUTE] = attributes.identifier;
	                delete attributes.identifier;
	            }
	            // Legacy backgroundColor was a root prop; in newer versions it's style.backgroundColor.
	            // We only want to update this if the user *hasn't* explicitly set style.backroundColor.
	            if (timelineProperties.backgroundColor && !timelineProperties['style.backgroundColor']) {
	                timelineProperties['style.backgroundColor'] = timelineProperties.backgroundColor;
	                delete timelineProperties.backgroundColor;
	            }
	            if (needsOmnibusUpgrade) {
	                var transformStyleGroup = timelineProperties['style.transformStyle'];
	                if (transformStyleGroup && transformStyleGroup[0] && transformStyleGroup[0].value === 'flat') {
	                    delete timelineProperties['style.transformStyle'];
	                }
	                var perspectiveGroup = timelineProperties['style.perspective'];
	                if (perspectiveGroup && perspectiveGroup[0] && perspectiveGroup[0].value === 'none') {
	                    delete timelineProperties['style.perspective'];
	                }
	                // Retire sizing layout from any SVG sizeable in favor of explicit properties.
	                if (typeof elementName === 'string' && applyCssLayout_1.SVG_SIZEABLES[elementName]) {
	                    if (timelineProperties['sizeAbsolute.x']) {
	                        timelineProperties.width = { 0: { value: timelineProperties['sizeAbsolute.x'][0].value } };
	                        delete timelineProperties['sizeAbsolute.x'];
	                        delete timelineProperties['sizeMode.x'];
	                    }
	                    if (timelineProperties['sizeAbsolute.y']) {
	                        timelineProperties.height = { 0: { value: timelineProperties['sizeAbsolute.y'][0].value } };
	                        delete timelineProperties['sizeAbsolute.y'];
	                        delete timelineProperties['sizeMode.y'];
	                    }
	                    if (timelineProperties['sizeProportional.x']) {
	                        timelineProperties.width = {
	                            0: { value: Number(timelineProperties['sizeProportional.x'][0].value) * 100 + "%" },
	                        };
	                        delete timelineProperties['sizeProportional.x'];
	                        delete timelineProperties['sizeMode.x'];
	                    }
	                    if (timelineProperties['sizeProportional.y']) {
	                        timelineProperties.height = {
	                            0: { value: Number(timelineProperties['sizeProportional.y'][0].value) * 100 + "%" },
	                        };
	                        delete timelineProperties['sizeProportional.y'];
	                        delete timelineProperties['sizeMode.y'];
	                    }
	                }
	            }
	            // If we see that any 3D transformations are applied, automatically override flat perspective
	            // if it hasn't been automatically set, so that 3D perspective "just works"
	            if (!component.doPreserve3d &&
	                autoPreserve3d_1 && (areKeyframesDefined(timelineProperties['rotation.x']) ||
	                areKeyframesDefined(timelineProperties['rotation.y']) ||
	                areKeyframesDefined(timelineProperties['translation.z']) ||
	                areKeyframesDefined(timelineProperties['scale.z']))) {
	                component.doPreserve3d = true;
	            }
	            if (!bytecode.timelines.Default["haiku:" + attributes[HAIKU_ID_ATTRIBUTE]] &&
	                Object.keys(timelineProperties).length > 0) {
	                // Update with our hot object if we inadvertently created this object during migration.
	                bytecode.timelines.Default["haiku:" + attributes[HAIKU_ID_ATTRIBUTE]] = timelineProperties;
	            }
	        }, null, 0);
	    }
	    if (bytecode.timelines) {
	        // Although not ideal, it's likely beneficial to do another pass through the timelines to fill in
	        // reference uniqueness. This may allow us to avoid a rerender below.
	        for (var timelineName in bytecode.timelines) {
	            for (var selector in bytecode.timelines[timelineName]) {
	                if (needsOmnibusUpgrade) {
	                    // Migrate auto-sizing.
	                    migrateAutoSizing_1.default(bytecode.timelines[timelineName][selector]);
	                }
	                // Ensure ID-based selectors like #box work.
	                if (referencesToUpdate[selector]) {
	                    bytecode.timelines[timelineName][referencesToUpdate[selector]] = bytecode.timelines[timelineName][selector];
	                    delete bytecode.timelines[timelineName][selector];
	                    selector = referencesToUpdate[selector];
	                }
	                for (var propertyName in bytecode.timelines[timelineName][selector]) {
	                    if (needsOmnibusUpgrade) {
	                        // Migrate camel-case property names.
	                        var camelVariant = options.attrsHyphToCamel[propertyName];
	                        if (camelVariant) {
	                            bytecode.timelines[timelineName][selector][camelVariant] =
	                                bytecode.timelines[timelineName][selector][propertyName];
	                            delete bytecode.timelines[timelineName][selector][propertyName];
	                        }
	                    }
	                    for (var keyframeMs in bytecode.timelines[timelineName][selector][propertyName]) {
	                        var keyframeDesc = bytecode.timelines[timelineName][selector][propertyName][keyframeMs];
	                        if (keyframeDesc && referencesToUpdate[keyframeDesc.value]) {
	                            keyframeDesc.value = referencesToUpdate[keyframeDesc.value];
	                        }
	                    }
	                }
	            }
	        }
	    }
	};
	exports.runMigrationsPostPhase = function (component, options, version) {
	    var bytecode = component.bytecode;
	    var coreVersion = bytecode.metadata.core || bytecode.metadata.player;
	    var needsRerender = false;
	    if (component.doPreserve3d) {
	        var node = component.node;
	        if (node) {
	            var didNodePreserve3dChange = ensure3dPreserved(node);
	            if (didNodePreserve3dChange) {
	                component.patches.push(node);
	            }
	        }
	        // The wrapper also needs preserve-3d set for 3d-preservation to work
	        var parent_1 = component.parentNode; // This should be the "wrapper div" node
	        if (parent_1) {
	            var didParentPreserve3dChange = ensure3dPreserved(parent_1);
	            if (didParentPreserve3dChange) {
	                component.patches.push(parent_1);
	            }
	        }
	    }
	    var needsCamelAutoSizingOffsetOmnibus = requiresUpgrade(coreVersion, "3.5.2" /* CamelAutoSizingOffset3DOmnibus */);
	    if (needsCamelAutoSizingOffsetOmnibus) {
	        var alsoMigrateOrigin_1 = requiresUpgrade(coreVersion, "3.2.0" /* OriginSupport */);
	        component.visit(function (element) {
	            var offsetX = 0;
	            var offsetY = 0;
	            var timelineProperties = bytecode.timelines.Default["haiku:" + element.getComponentId()];
	            if (!timelineProperties) {
	                return;
	            }
	            // Note: the migrations below are incorrect if align properties were ever defined on an element with explicit
	            // size. Since in practice this never happened, this is fine.
	            if (timelineProperties['align.x']) {
	                var alignX = timelineProperties['align.x'][0] && timelineProperties['align.x'][0].value;
	                if (typeof alignX === 'number') {
	                    offsetX += alignX * element.getNearestDefinedNonZeroAncestorSizeX();
	                }
	            }
	            if (timelineProperties['align.y']) {
	                var alignY = timelineProperties['align.y'][0] && timelineProperties['align.y'][0].value;
	                if (typeof alignY === 'number') {
	                    offsetY += alignY * element.getNearestDefinedNonZeroAncestorSizeY();
	                }
	            }
	            if (timelineProperties['mount.x']) {
	                var mountX = timelineProperties['mount.x'][0] && timelineProperties['mount.x'][0].value;
	                if (typeof mountX === 'number') {
	                    offsetX -= mountX * element.getNearestDefinedNonZeroAncestorSizeX();
	                }
	            }
	            if (timelineProperties['mount.y']) {
	                var mountY = timelineProperties['mount.y'][0] && timelineProperties['mount.y'][0].value;
	                if (typeof mountY === 'number') {
	                    offsetY -= mountY * element.getNearestDefinedNonZeroAncestorSizeY();
	                }
	            }
	            if (alsoMigrateOrigin_1) {
	                // Prior to explicit origin support, we were applying a default origin of (0, 0, 0) for all objects, then
	                // allowing the browser default for SVG elements (50%, 50%, 0px) be the effective transform-origin. This led to
	                // inaccuracies in the layout system, specifically related to addressing translation on SVG elements and
	                // addressing origin in general. Since as of the introduction of explicit origin support we had not made layout
	                // offset addressable in Haiku, we can "backport" to the old coordinate system by simply offsetting layout
	                // by its "origin error".
	                if (element.tagName === 'svg') {
	                    offsetX += 0.5 * element.getNearestDefinedNonZeroAncestorSizeX();
	                    offsetY += 0.5 * element.getNearestDefinedNonZeroAncestorSizeY();
	                }
	                else {
	                    offsetX += element.originX * element.getNearestDefinedNonZeroAncestorSizeX();
	                    offsetY += element.originY * element.getNearestDefinedNonZeroAncestorSizeY();
	                }
	            }
	            if (offsetX !== 0) {
	                timelineProperties['offset.x'] = { 0: { value: offsetX } };
	                needsRerender = true;
	            }
	            if (offsetY !== 0) {
	                timelineProperties['offset.y'] = { 0: { value: offsetY } };
	                needsRerender = true;
	            }
	            delete timelineProperties['align.x'];
	            delete timelineProperties['align.y'];
	            delete timelineProperties['align.z'];
	            delete timelineProperties['mount.x'];
	            delete timelineProperties['mount.y'];
	            delete timelineProperties['mount.z'];
	        });
	    }
	    component.eachEventHandler(function (eventSelector, eventName, _a) {
	        var handler = _a.handler;
	        if (!handler) {
	            console.warn("Unable to migrate event handler for " + eventSelector + " " + eventName + " in " + component.$id);
	            return;
	        }
	        var rfo = handler.__rfo || functionToRFO_1.default(handler).__function;
	        var params = rfo.params;
	        var body = rfo.body;
	        var changed = false;
	        if (requiresUpgrade(coreVersion, "3.2.23" /* TimelineDefaultFrames */)) {
	            (['.seek(', '.gotoAndPlay(', '.gotoAndStop(']).forEach(function (methodSignature) {
	                for (var cursor = 0; cursor < body.length; ++cursor) {
	                    if (body.substring(cursor, cursor + methodSignature.length) !== methodSignature) {
	                        continue;
	                    }
	                    changed = true;
	                    // We have matched e.g. this.getDefaultTimeline().seek( at the string index of ".seek(".
	                    // Using the assumption that the method arguments do not contain string arguments with parentheses inside,
	                    // we can apply a simple parenthesis-balancing algorithm here.
	                    cursor += methodSignature.length;
	                    var openParens = 1;
	                    while (openParens > 0 && cursor < body.length) {
	                        if (body[cursor] === '(') {
	                            openParens++;
	                        }
	                        else if (body[cursor] === ')') {
	                            openParens--;
	                        }
	                        ++cursor;
	                    }
	                    // Essentially, replace .seek(foo) with .seek(foo, 'ms').
	                    body = body.slice(0, cursor - 1) + ", 'ms')" + body.slice(cursor);
	                }
	            });
	        }
	        if (params.length < 4) {
	            params = ['component', 'element', 'target', 'event'];
	            changed = true;
	        }
	        if (changed) {
	            bytecode.eventHandlers[eventSelector][eventName].handler = reifyRFO_1.default(__assign({}, rfo, { params: params,
	                body: body }));
	        }
	    });
	    if (needsRerender) {
	        component.clearCaches();
	        component.markForFullFlush();
	    }
	    // Ensure the bytecode metadata core version is recent.
	    bytecode.metadata.core = version;
	};
	//# sourceMappingURL=Migration.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var api_1 = __webpack_require__(58);
	var Interpolate_1 = __webpack_require__(57);
	var StateTransitionManager = /** @class */ (function () {
	    function StateTransitionManager(component) {
	        this.component = component;
	        // Store running state transitions
	        this.transitions = {};
	        this.clock = this.component.getClock();
	        this.states = this.component.state;
	    }
	    /**
	     * Create a new state transition.
	     */
	    StateTransitionManager.prototype.setState = function (transitionEnd, parameter) {
	        var _a, _b, _c, _d;
	        // If not a transition, execute it right away
	        if (!parameter) {
	            for (var key in transitionEnd) {
	                delete this.transitions[key];
	            }
	            for (var key in transitionEnd) {
	                var from = this.states[key];
	                var to = transitionEnd[key];
	                if (from !== to) {
	                    this.component.callHook('state:change', {
	                        from: from,
	                        to: to,
	                        state: key,
	                    });
	                }
	            }
	            this.setStates(transitionEnd);
	            return;
	        }
	        // Get current time
	        var currentTime = this.clock.getTime();
	        // Set default values than assign parameters
	        var transitionParameter = { duration: 0, curve: api_1.Curve.Linear, queue: false };
	        Object.assign(transitionParameter, parameter);
	        // Copy current states as transition start (needed to calculate interpolation)
	        for (var key in transitionEnd) {
	            // Ignore state if it doesn't pre exist
	            if (key in this.states) {
	                var from = this.states[key];
	                var to = transitionEnd[key];
	                // queued transitions are add into queue
	                // If parameter.queue is true, it is a queued setState
	                // If state transition for key is not created, process like a queued SetState
	                if (transitionParameter.queue && this.transitions[key]) {
	                    if (from !== to) {
	                        this.component.callHook('state:change', {
	                            from: from,
	                            to: to,
	                            queued: true,
	                            state: key,
	                            duration: transitionParameter.duration,
	                        });
	                    }
	                    this.transitions[key].push({
	                        transitionParameter: transitionParameter,
	                        transitionEnd: (_a = {}, _a[key] = to, _a),
	                        transitionStart: (_b = {}, _b[key] = from, _b),
	                        startTime: currentTime,
	                        endTime: currentTime + transitionParameter.duration,
	                        duration: transitionParameter.duration,
	                    });
	                    // non queued transitions are overwrite transition queue
	                }
	                else {
	                    if (from !== to) {
	                        this.component.callHook('state:change', {
	                            from: from,
	                            to: to,
	                            started: true,
	                            state: key,
	                            duration: transitionParameter.duration,
	                        });
	                    }
	                    this.transitions[key] = [{
	                            transitionParameter: transitionParameter,
	                            transitionEnd: (_c = {}, _c[key] = to, _c),
	                            transitionStart: (_d = {}, _d[key] = from, _d),
	                            startTime: currentTime,
	                            endTime: currentTime + transitionParameter.duration,
	                            duration: transitionParameter.duration,
	                        }];
	                }
	            }
	        }
	        // Make sure state is update on setState call
	        this.tickStateTransitions();
	    };
	    // We technically could call HaikuComponent::setStates, but passing only
	    // state parameters instead whole HaikuComponent to contructor make this class
	    // less coupled
	    StateTransitionManager.prototype.setStates = function (states) {
	        for (var key in states) {
	            this.states[key] = states[key];
	        }
	    };
	    StateTransitionManager.prototype.isExpired = function (transition, currentTime) {
	        return this.clock.getTime() >= transition.endTime;
	    };
	    /**
	     * Should be called on every tick. It cleans expired state transitions
	     * and execute interpolation of running state transitions.
	     */
	    StateTransitionManager.prototype.tickStateTransitions = function () {
	        var _a;
	        var currentTime = this.clock.getTime();
	        var interpolatedStates = {};
	        // For each state, process state transition queue
	        for (var stateName in this.transitions) {
	            // On queued states, only first transition is processed, other transitions are in queue.
	            if (this.transitions[stateName].length > 0) {
	                var transition = this.transitions[stateName][0];
	                if (this.isExpired(transition, currentTime)) {
	                    this.component.callHook('state:change', {
	                        finished: true,
	                        state: stateName,
	                        to: transition.transitionEnd[stateName],
	                        duration: transition.duration,
	                    });
	                    // If expired, assign transitionEnd.
	                    // NOTE: In the future, with custom transition function implemented calculating
	                    // interpolation at endTime will be necessary (eg. a user defined curve that at
	                    // endTime isn't 100%, but let's say 60%)
	                    Object.assign(interpolatedStates, transition.transitionEnd);
	                    // Remove expired transition.
	                    this.transitions[stateName].splice(0, 1);
	                    // Update next queued state transition or delete empty transition vector for performance reasons
	                    if (this.transitions[stateName].length > 0) {
	                        this.component.callHook('state:change', {
	                            started: true,
	                            state: stateName,
	                            to: this.transitions[stateName][0].transitionEnd[stateName],
	                        });
	                        this.transitions[stateName][0].transitionStart = (_a = {}, _a[stateName] = interpolatedStates[stateName], _a);
	                        this.transitions[stateName][0].startTime = currentTime;
	                        this.transitions[stateName][0].endTime = currentTime + this.transitions[stateName][0].duration;
	                    }
	                    else {
	                        delete this.transitions[stateName];
	                    }
	                }
	                else {
	                    // Calculate interpolated states.
	                    Object.assign(interpolatedStates, Interpolate_1.interpolate(currentTime, transition.transitionParameter.curve, transition.startTime, transition.endTime, transition.transitionStart, transition.transitionEnd));
	                }
	            }
	        }
	        this.setStates(interpolatedStates);
	    };
	    /**
	     * Delete every running transition
	     */
	    StateTransitionManager.prototype.deleteAllStateTransitions = function () {
	        this.transitions = {};
	    };
	    Object.defineProperty(StateTransitionManager.prototype, "numQueuedTransitions", {
	        get: function () {
	            var numQueuedTransition = 0;
	            for (var stateName in this.transitions) {
	                numQueuedTransition += this.transitions[stateName].length;
	            }
	            return numQueuedTransition;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return StateTransitionManager;
	}());
	exports.default = StateTransitionManager;
	//# sourceMappingURL=StateTransitionManager.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var KeyframeUtils_1 = __webpack_require__(59);
	var Interpolate_1 = __webpack_require__(57);
	// 0:    { value: { ... } }
	// 2500: { value: { ... } }
	// 5000: { value: { ... } }
	var getKeyframesList = function (sorted, nowValue) {
	    for (var i = 0; i < sorted.length; i++) {
	        var j = i + 1;
	        var current = sorted[i];
	        var next = sorted[j];
	        if (current <= nowValue) {
	            if (next > nowValue) {
	                return [current, next];
	            }
	            if (j >= sorted.length) {
	                return [current];
	            }
	        }
	    }
	};
	exports.calculateValue = function (keyframeGroup, nowValue, sortedKeyframes) {
	    if (!sortedKeyframes) {
	        // tslint:disable-next-line:no-parameter-reassignment
	        sortedKeyframes = KeyframeUtils_1.getSortedKeyframes(keyframeGroup);
	    }
	    var keyframesList = getKeyframesList(sortedKeyframes, nowValue);
	    if (!keyframesList || keyframesList.length < 1) {
	        return;
	    }
	    var currentKeyframe = keyframesList[0];
	    var currentTransition = keyframeGroup[currentKeyframe];
	    var nextKeyframe = keyframesList[1];
	    var nextTransition = keyframeGroup[nextKeyframe];
	    var finalValue = getTransitionValue(currentKeyframe, currentTransition, nextKeyframe, nextTransition, nowValue);
	    return finalValue;
	};
	var getTransitionValue = function (currentKeyframe, currentTransition, nextKeyframe, nextTransition, nowValue) {
	    var currentValue = currentTransition.value;
	    if (!currentTransition.curve) {
	        return currentValue;
	    } // No curve indicates immediate transition
	    if (!nextTransition) {
	        return currentValue;
	    } // We have gone past the final transition
	    var finalValue = Interpolate_1.interpolate(nowValue, currentTransition.curve, currentKeyframe, nextKeyframe, currentValue, nextTransition.value);
	    return finalValue;
	};
	//# sourceMappingURL=Transitions.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuContext_1 = __webpack_require__(108);
	var dom_1 = __webpack_require__(150);
	var pkg = __webpack_require__(18);
	var VERSION = pkg.version;
	/**
	 * Example ways in which the export of this module is invoked:
	 *
	 * // via embed snippet
	 * window.HaikuPlayer['2.0.125'](require('./code/main/code.js')) // #LEGACY
	 * window.HaikuCore['2.0.125'](require('./code/main/code.js'))
	 *
	 * // via module require
	 * var HaikuDOMAdapter = require('@haiku/core/dom')
	 * module.exports = HaikuDOMAdapter(require('./code/main/code.js'))
	 */
	/**
	 * @function HaikuDOMAdapter
	 * @description Given a bytecode object, return a factory function which can create a DOM-playable component.
	 */
	// tslint:disable-next-line:variable-name
	var HaikuDOMAdapter = function (bytecode, config, safeWindow) {
	    if (!config) {
	        // tslint:disable-next-line:no-parameter-reassignment
	        config = {};
	    }
	    if (!safeWindow) {
	        if (typeof window !== 'undefined') {
	            // tslint:disable-next-line:no-parameter-reassignment
	            safeWindow = window;
	        }
	    }
	    return HaikuContext_1.default.createComponentFactory(dom_1.default, bytecode, config, // Note: Full config object, of which options is one property!
	    safeWindow);
	};
	HaikuDOMAdapter.defineOnWindow = function () {
	    // Allow multiple instances of different versions to exist on the same page
	    if (typeof window !== 'undefined') {
	        if (!window.HaikuResolve) {
	            var haikuResolutions_1 = {};
	            window.HaikuResolve = function (playerVersion) {
	                if (haikuResolutions_1[playerVersion]) {
	                    return haikuResolutions_1[playerVersion];
	                }
	                var matches = playerVersion.match(/^(\d+)\.(\d+)\.(\d+)$/).map(Number);
	                if (!matches) {
	                    return;
	                }
	                var _ = matches[0], major = matches[1], minor = matches[2], patch = matches[3];
	                var compatibleVersions = Object.keys(window.HaikuCore)
	                    .map(function (semver) { return semver.split('.').map(Number); })
	                    .filter(function (semverParts) {
	                    if (semverParts.length !== 3 || semverParts[0] !== major) {
	                        return false;
	                    }
	                    return semverParts[1] >= minor && ((semverParts[1] > minor) ? true : semverParts[2] >= patch);
	                });
	                if (compatibleVersions.length === 0) {
	                    return;
	                }
	                compatibleVersions.sort(function (_a, _b) {
	                    var __ = _a[0], aMinor = _a[1], aPatch = _a[2];
	                    var ___ = _b[0], bMinor = _b[1], bPatch = _b[2];
	                    if (aMinor < bMinor) {
	                        return -1;
	                    }
	                    if (aMinor > bMinor) {
	                        return 1;
	                    }
	                    return aPatch < bPatch ? -1 : 1;
	                });
	                return haikuResolutions_1[playerVersion] =
	                    window.HaikuCore[compatibleVersions[compatibleVersions.length - 1].join('.')];
	            };
	        }
	        if (!window.HaikuCore) {
	            window.HaikuCore = {};
	        }
	        window.HaikuCore[VERSION] = HaikuDOMAdapter;
	    }
	};
	HaikuDOMAdapter.defineOnWindow();
	exports.default = HaikuDOMAdapter;
	//# sourceMappingURL=HaikuDOMAdapter.js.map

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuDOMAdapter_1 = __webpack_require__(115);
	exports.default = HaikuDOMAdapter_1.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// tslint:disable-next-line:variable-name
	var EventsDict = {};
	var eventsList = [
	    'onAbort',
	    'onAnimationEnd',
	    'onAnimationIteration',
	    'onAnimationStart',
	    'onBlur',
	    'onCanPlay',
	    'onCanPlayThrough',
	    'onChange',
	    'onClick',
	    'onCompositionEnd',
	    'onCompositionStart',
	    'onCompositionUpdate',
	    'onContextMenu',
	    'onCopy',
	    'onCut',
	    'onDoubleClick',
	    'onDrag',
	    'onDragEnd',
	    'onDragEnter',
	    'onDragExit',
	    'onDragLeave',
	    'onDragOver',
	    'onDragStart',
	    'onDrop',
	    'onDurationChange',
	    'onEmptied',
	    'onEncrypted',
	    'onEnded',
	    'onError',
	    'onFocus',
	    'onInput',
	    'onKeyDown',
	    'onKeyPress',
	    'onKeyUp',
	    'onLoad',
	    'onLoadedData',
	    'onLoadedMetadata',
	    'onLoadStart',
	    'onMouseDown',
	    'onMouseEnter',
	    'onMouseLeave',
	    'onMouseMove',
	    'onMouseOut',
	    'onMouseOver',
	    'onMouseUp',
	    'onPaste',
	    'onPause',
	    'onPlay',
	    'onPlaying',
	    'onProgress',
	    'onRateChange',
	    'onScroll',
	    'onSeeked',
	    'onSeeking',
	    'onSelect',
	    'onStalled',
	    'onSubmit',
	    'onSuspend',
	    'onTimeUpdate',
	    'onTouchCancel',
	    'onTouchEnd',
	    'onTouchMove',
	    'onTouchStart',
	    'onTransitionEnd',
	    'onVolumeChange',
	    'onWaiting',
	    'onWheel',
	];
	for (var i = 0; i < eventsList.length; i++) {
	    var name_1 = eventsList[i];
	    EventsDict[name_1] = 'func';
	    EventsDict[name_1 + 'Capture'] = 'func';
	}
	exports.default = EventsDict;
	//# sourceMappingURL=EventsDict.js.map

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(26);
	var Config_1 = __webpack_require__(27);
	var getParsedProperty_1 = __webpack_require__(126);
	var StringUtils_1 = __webpack_require__(122);
	var EventsDict_1 = __webpack_require__(117);
	var DEFAULT_HOST_ELEMENT_TAG_NAME = 'div';
	// tslint:disable-next-line:function-name
	function HaikuReactDOMAdapter(haikuComponentFactory, optionalRawBytecode) {
	    var HaikuReactComponentInternal = /** @class */ (function (_super) {
	        __extends(HaikuReactComponentInternal, _super);
	        function HaikuReactComponentInternal(props) {
	            var _this = _super.call(this, props) || this;
	            _this.state = {
	                // This random id is used to give us a hook to query the DOM for our mount element,
	                // even in cases where React mysteriously decides not to pass us its ref.
	                randomId: 'haiku-reactroot-' + StringUtils_1.randomString(24),
	            };
	            return _this;
	        }
	        HaikuReactComponentInternal.prototype.componentWillReceiveProps = function (nextPropsRaw) {
	            if (this.haiku) {
	                var haikuConfig = this.buildHaikuCompatibleConfigFromRawProps(nextPropsRaw);
	                this.haiku.assignConfig(haikuConfig);
	            }
	        };
	        HaikuReactComponentInternal.prototype.componentWillUnmount = function () {
	            if (this.haiku) {
	                this.haiku.callUnmount();
	            }
	        };
	        HaikuReactComponentInternal.prototype.componentDidMount = function () {
	            this.attemptMount();
	        };
	        HaikuReactComponentInternal.prototype.attemptMount = function () {
	            if (this.mount) {
	                this.createContext(this.props);
	            }
	        };
	        HaikuReactComponentInternal.prototype.buildHaikuCompatibleConfigFromRawProps = function (rawProps) {
	            // Note that these vanities are called _after_ an initial render,
	            // i.e., after this.mount is supposed to have been attached.
	            var haikuConfig = {
	                ref: this.mount,
	                vanities: {
	                    'controlFlow.placeholder': function _controlFlowPlaceholderReactVanity(element, surrogate, value, context, timeline, receiver, sender) {
	                        visit(this.mount, function (node) {
	                            var flexId = flexIdIfSame(element, node);
	                            if (flexId) {
	                                if (element.__memory.placeholder.surrogate !== surrogate) {
	                                    if (typeof surrogate.type === 'string' ||
	                                        (typeof surrogate.type === 'function' && surrogate.type.isHaikuAdapter)) {
	                                        // What *should happen* in the DOM renderer is:
	                                        // this new swapped DOM element will be updated (not replaced!)
	                                        // with the attributes of the virtual element at the same position
	                                        var div = document.createElement('div');
	                                        node.parentNode.replaceChild(div, node);
	                                        // tslint:disable-next-line:no-parameter-reassignment
	                                        node = div;
	                                    }
	                                    node.style.visibility = 'hidden';
	                                    ReactDOM.render(surrogate, node);
	                                    window.requestAnimationFrame(function () {
	                                        element.__memory.placeholder.surrogate = surrogate;
	                                        node.style.visibility = 'visible';
	                                    });
	                                    sender.markHorizonElement(element);
	                                    sender.markForFullFlush();
	                                }
	                            }
	                        });
	                    }.bind(this),
	                },
	            };
	            // It's assumed that anything the user wants to pass into the Haiku engine should be
	            // assigned among the whitelisted properties
	            if (rawProps) {
	                for (var verboseKeyName in rawProps) {
	                    // We already should have subscribed at the React host element level;
	                    // we don't pass in otherwise we can end up with multiple events fired
	                    if (EventsDict_1.default[verboseKeyName]) {
	                        continue;
	                    }
	                    haikuConfig = __assign({}, haikuConfig, getParsedProperty_1.default(rawProps, verboseKeyName));
	                }
	            }
	            return haikuConfig;
	        };
	        HaikuReactComponentInternal.prototype.createContext = function (rawProps) {
	            var haikuConfig = this.buildHaikuCompatibleConfigFromRawProps(rawProps);
	            var haikuAdapter;
	            if (rawProps.haikuAdapter) {
	                if (rawProps.haikuCode) {
	                    haikuAdapter = rawProps.haikuAdapter(rawProps.haikuCode);
	                }
	                else if (optionalRawBytecode) {
	                    haikuAdapter = rawProps.haikuAdapter(optionalRawBytecode);
	                }
	                else {
	                    throw new Error('A Haiku code object is required if you supply a Haiku adapter');
	                }
	            }
	            else {
	                // Otherwise default to the adapter which was initialized in the wrapper module
	                haikuAdapter = haikuComponentFactory;
	            }
	            if (!haikuAdapter) {
	                throw new Error('A Haiku adapter is required');
	            }
	            // Reuse existing mounted component if one exists
	            if (!this.haiku) {
	                this.haiku = haikuAdapter(// eslint-disable-line
	                this.mount, haikuConfig);
	            }
	            else {
	                // If the component already exists, update its options and make sure it remounts.
	                // This action is important if we are in e.g. React Router.
	                //
	                // Important: Note that we should NOT call remount if we just initialized the instance (i.e. stanza above)
	                // because we'll end up pausing the timelines before the first mount, resulting in a blank context.
	                this.haiku.callRemount(haikuConfig);
	            }
	        };
	        HaikuReactComponentInternal.prototype.buildHostElementPropsFromRawProps = function (rawProps) {
	            var _this = this;
	            var propsForReactHostElement = {};
	            var _loop_1 = function (key) {
	                if (willReactProbablyHandleProp(rawProps[key], key)) {
	                    if (EventsDict_1.default[key]) {
	                        // We wrap it because listeners expect to receive the Haiku component
	                        // instance as an argument; and for convenience we provide the native
	                        // event in addition to it and React's proxy
	                        propsForReactHostElement[key] = function (proxy) {
	                            return rawProps[key].call(_this, proxy, proxy && proxy.nativeEvent, _this.haiku);
	                        };
	                    }
	                    else {
	                        propsForReactHostElement[key] = rawProps[key];
	                    }
	                }
	            };
	            for (var key in rawProps) {
	                _loop_1(key);
	            }
	            // Style objects are excluded above, but we definitely want it if provided
	            var stylesForHostElement = rawProps.style || {};
	            // Merge our basic host props with some defaults we want to assign
	            return __assign({ id: this.state.randomId, style: __assign({ position: 'relative', margin: 0, padding: 0, border: 0, width: '100%', height: '100%', transform: 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)' }, stylesForHostElement) }, propsForReactHostElement);
	        };
	        HaikuReactComponentInternal.prototype.assignMountFromRef = function (element) {
	            this.mount = element;
	        };
	        HaikuReactComponentInternal.prototype.render = function () {
	            var _this = this;
	            var hostElementProps = this.buildHostElementPropsFromRawProps(this.props);
	            // Having this ref assigned like this is critical to the adapter working,
	            // so we override it despite what the host element props might say
	            hostElementProps.ref = function (element) {
	                _this.assignMountFromRef(element);
	            };
	            return React.createElement(hostElementProps.tagName || DEFAULT_HOST_ELEMENT_TAG_NAME, hostElementProps);
	        };
	        HaikuReactComponentInternal.React = React;
	        HaikuReactComponentInternal.ReactDOM = ReactDOM;
	        // This setting is required to do proper setup for placeholder/inject vanities
	        HaikuReactComponentInternal.isHaikuAdapter = true;
	        return HaikuReactComponentInternal;
	    }(React.Component));
	    return HaikuReactComponentInternal;
	}
	exports.default = HaikuReactDOMAdapter;
	function willReactProbablyHandleProp(prop, key) {
	    // Exclude any 'complex' properties like objects
	    if (prop && typeof prop === 'object') {
	        return false;
	    }
	    // Assume functions, which are usually event listeners, are handled by Haiku
	    if (typeof prop === 'function') {
	        if (EventsDict_1.default[key]) {
	            return true;
	        }
	        return false;
	    }
	    // Exclude props we know target Haiku config
	    return !Config_1.DEFAULTS.hasOwnProperty(key);
	}
	function visit(el, visitor) {
	    if (el) {
	        visitor(el);
	        if (el.children) {
	            for (var i = 0; i < el.children.length; i++) {
	                visit(el.children[i], visitor);
	            }
	        }
	    }
	}
	function flexIdIfSame(virtual, dom) {
	    if (virtual.attributes) {
	        if (virtual.attributes['haiku-id']) {
	            if (dom.getAttribute('haiku-id') === virtual.attributes['haiku-id']) {
	                return virtual.attributes['haiku-id'];
	            }
	        }
	        if (virtual.attributes.id) {
	            if (dom.getAttribute('id') === virtual.attributes.id) {
	                return virtual.attributes.id;
	            }
	        }
	    }
	    return null;
	}
	//# sourceMappingURL=HaikuReactDOMAdapter.js.map

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuReactDOMAdapter_1 = __webpack_require__(118);
	exports.default = HaikuReactDOMAdapter_1.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var color_string_1 = __webpack_require__(160);
	var STRING = 'string';
	var OBJECT = 'object';
	function parseString(str) {
	    if (!str) {
	        return null;
	    }
	    if (typeof str === OBJECT || (typeof str === STRING && str.trim().slice(0, 3) === 'url')) {
	        return str;
	    }
	    return color_string_1.get(String(str));
	}
	function generateString(desc) {
	    if (typeof desc === STRING) {
	        return desc;
	    }
	    if (!desc) {
	        return 'none';
	    }
	    return color_string_1.to(desc.model, desc.value);
	}
	exports.default = {
	    parseString: parseString,
	    generateString: generateString,
	};
	//# sourceMappingURL=ColorUtils.js.map

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:max-line-length */
	Object.defineProperty(exports, "__esModule", { value: true });
	var SVGPathReversal_1 = __webpack_require__(206);
	var SVGPoints_1 = __webpack_require__(60);
	exports.splitSegmentInSVGPoints = function (points, pt1Index, pt2Index, t) {
	    if (pt2Index === points.length) {
	        // tslint:disable-next-line
	        pt2Index = 0;
	    }
	    var h1;
	    var h2;
	    if (points[pt2Index].curve) {
	        h1 = { x: points[pt2Index].curve.x1, y: points[pt2Index].curve.y1 };
	        h2 = { x: points[pt2Index].curve.x2, y: points[pt2Index].curve.y2 };
	    }
	    else {
	        h1 = points[pt1Index];
	        h2 = points[pt2Index];
	    }
	    var newPts = exports.cubicBezierSplit(t, points[pt1Index], h1, h2, points[pt2Index]);
	    if (points[pt2Index].curve) {
	        points[pt2Index].curve.x1 = newPts[1][1].x;
	        points[pt2Index].curve.y1 = newPts[1][1].y;
	        points[pt2Index].curve.x2 = newPts[1][2].x;
	        points[pt2Index].curve.y2 = newPts[1][2].y;
	    }
	    var newCurve = null;
	    if (points[pt2Index].curve) {
	        newCurve = {
	            type: 'cubic',
	            x1: newPts[0][1].x,
	            y1: newPts[0][1].y,
	            x2: newPts[0][2].x,
	            y2: newPts[0][2].y,
	        };
	    }
	    var newPoint = {
	        x: newPts[0][3].x,
	        y: newPts[0][3].y,
	        curve: newCurve,
	    };
	    points.splice(pt2Index, 0, newPoint);
	};
	// NOTE: See Bezier curve splitting here: https://pomax.github.io/bezierinfo/#matrixsplit
	exports.cubicBezierSplit = function (t, anchor1, handle1, handle2, anchor2) {
	    var cubicSegmentMatrix1 = [
	        1,
	        0,
	        0,
	        0,
	        -(t - 1),
	        t,
	        0,
	        0,
	        Math.pow(t - 1, 2),
	        -2 * t * (t - 1),
	        t * t,
	        0,
	        -Math.pow(t - 1, 3),
	        3 * t * Math.pow(t - 1, 2),
	        -3 * t * t * (t - 1),
	        t * t * t,
	    ];
	    var x1 = exports.mat4_multiply_vec4(cubicSegmentMatrix1, { x: anchor1.x, y: handle1.x, z: handle2.x, w: anchor2.x });
	    var y1 = exports.mat4_multiply_vec4(cubicSegmentMatrix1, { x: anchor1.y, y: handle1.y, z: handle2.y, w: anchor2.y });
	    var cubicSegmentMatrix2 = [
	        -Math.pow(t - 1, 3),
	        3 * t * Math.pow(t - 1, 2),
	        -3 * t * t * (t - 1),
	        t * t * t,
	        0,
	        Math.pow(t - 1, 2),
	        -2 * t * (t - 1),
	        t * t,
	        0,
	        0,
	        -(t - 1),
	        t,
	        0,
	        0,
	        0,
	        1,
	    ];
	    var x2 = exports.mat4_multiply_vec4(cubicSegmentMatrix2, { x: anchor1.x, y: handle1.x, z: handle2.x, w: anchor2.x });
	    var y2 = exports.mat4_multiply_vec4(cubicSegmentMatrix2, { x: anchor1.y, y: handle1.y, z: handle2.y, w: anchor2.y });
	    return [
	        [{ x: x1.x, y: y1.x }, { x: x1.y, y: y1.y }, { x: x1.z, y: y1.z }, { x: x1.w, y: y1.w }],
	        [{ x: x2.x, y: y2.x }, { x: x2.y, y: y2.y }, { x: x2.z, y: y2.z }, { x: x2.w, y: y2.w }],
	    ];
	};
	exports.distance = function (a, b) {
	    return Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
	};
	// tslint:disable-next-line:variable-name
	exports.mat4_multiply_vec4 = function (m, v) {
	    return {
	        x: v.x * m[0] + v.y * m[1] + v.z * m[2] + v.w * m[3],
	        y: v.x * m[4] + v.y * m[5] + v.z * m[6] + v.w * m[7],
	        z: v.x * m[8] + v.y * m[9] + v.z * m[10] + v.w * m[11],
	        w: v.x * m[12] + v.y * m[13] + v.z * m[14] + v.w * m[15],
	    };
	};
	exports.polygonArea = function (points) {
	    var area = 0;
	    var a;
	    var b = points[points.length - 1];
	    for (var i = 0; i < points.length; i++) {
	        a = b;
	        b = points[i];
	        area += a.y * b.x - a.x * b.y;
	    }
	    return area / 2;
	};
	exports.polygonLength = function (points) {
	    var perimeter = 0;
	    var a;
	    var b = points[points.length - 1];
	    for (var i = 0; i < points.length; i++) {
	        a = b;
	        b = points[i];
	        perimeter += exports.distance(a, b);
	    }
	    return perimeter;
	};
	exports.distributeTotalVertices = function (path, totalVertices) {
	    var pointsToAdd = totalVertices - path.length;
	    if (pointsToAdd <= 0) {
	        return;
	    }
	    // Find the length of every segment (approximate)
	    // NOTE: This computes distance across the vertices, not along the actual bezier curve.
	    // A possible improvement would be finding true distance along the curve, but at a much
	    // higher computational cost.
	    var segments = [];
	    for (var i = 0; i < path.length; i++) {
	        segments.push({
	            index: i,
	            length: exports.distance(path[i], path[(i + 1) % path.length]),
	            splits: 0,
	        });
	    }
	    var addedPoints = 0;
	    while (addedPoints < pointsToAdd) {
	        // Sort by length, accounting for number of splits
	        segments.sort(function (a, b) { return (a.length / (a.splits || 1) - b.length / (b.splits || 1)); });
	        // Split the longest segment again
	        segments[segments.length - 1].splits++;
	        addedPoints++;
	    }
	    // Apply the splits
	    segments.sort(function (a, b) { return (a.index - b.index); });
	    var inserted = 0;
	    for (var i = 0; i < segments.length; i++) {
	        while (segments[i].splits > 0) {
	            // NOTE: This splits at linear values for t
	            // A possible improvement would be finding truly equidistant points along the curve
	            // at much higher computational cost.
	            exports.splitSegmentInSVGPoints(path, i + inserted, (i + inserted + 1) % path.length, 1 / (segments[i].splits + 1));
	            inserted++;
	            segments[i].splits--;
	        }
	    }
	};
	exports.rotatePathForSmallestDistance = function (source, dest) {
	    if (source.length !== dest.length) {
	        throw new Error('Mismatched source and destination length.');
	    }
	    var moveToPopped = false;
	    if (source[0].moveTo && dest[0].moveTo) {
	        source.shift();
	        dest.shift();
	        moveToPopped = true;
	    }
	    var smallestOffset = 0;
	    var minDistance = Infinity;
	    for (var rotationOffset = 0; rotationOffset < source.length; rotationOffset++) {
	        var distanceSum = 0;
	        for (var i = 0; i < source.length; i++) {
	            var dist = exports.distance(source[i], dest[(rotationOffset + i) % dest.length]);
	            distanceSum += dist;
	        }
	        if (distanceSum < minDistance) {
	            minDistance = distanceSum;
	            smallestOffset = rotationOffset;
	        }
	    }
	    if (smallestOffset === 0) {
	        if (moveToPopped) {
	            source.unshift({
	                x: source[source.length - 1].x,
	                y: source[source.length - 1].y,
	                moveTo: true,
	            });
	            dest.unshift({
	                x: dest[dest.length - 1].x,
	                y: dest[dest.length - 1].y,
	                moveTo: true,
	            });
	        }
	        return;
	    }
	    var closed = dest[dest.length - 1].closed;
	    var spliced = dest.splice(0, smallestOffset);
	    dest.splice.apply(dest, [source.length, 0].concat(spliced));
	    // Clean up
	    if (closed) {
	        dest[dest.length - 1].closed = true;
	    }
	    if (moveToPopped) {
	        source.unshift({
	            x: source[source.length - 1].x,
	            y: source[source.length - 1].y,
	            moveTo: true,
	        });
	        dest.unshift({
	            x: dest[dest.length - 1].x,
	            y: dest[dest.length - 1].y,
	            moveTo: true,
	        });
	    }
	    for (var i = 0; i < dest.length; i++) {
	        if (i < dest.length - 1 && dest[i].closed) {
	            delete dest[i].closed;
	        }
	        if (i > 0 && dest[i].moveTo) {
	            delete dest[i].moveTo;
	        }
	    }
	};
	exports.ensurePathClockwise = function (path) {
	    if (exports.polygonArea(path) > 0) {
	        var reversed = SVGPathReversal_1.reverseNormalizedPath(SVGPathReversal_1.normalizePath(SVGPoints_1.default.pointsToPath(path)));
	        path.splice(0, path.length);
	        var reversedPoints = SVGPoints_1.default.pathToPoints(reversed);
	        for (var i = 0; i < reversedPoints.length; i++) {
	            path.push(reversedPoints[i]);
	        }
	    }
	};
	exports.normalizePointCurves = function (path) {
	    for (var i = 1; i < path.length; i++) {
	        if (path[i].curve) {
	            // Convert quadratic to cubic bezier
	            if (path[i].curve.type === 'quadratic') {
	                var newCurve = {
	                    type: 'cubic',
	                };
	                newCurve.x1 = path[i - 1].x + 2 / 3 * (path[i].curve.x1 - path[i - 1].x);
	                newCurve.y1 = path[i - 1].y + 2 / 3 * (path[i].curve.y1 - path[i - 1].y);
	                newCurve.x2 = path[i].x + 2 / 3 * (path[i].curve.x1 - path[i].x);
	                newCurve.y2 = path[i].y + 2 / 3 * (path[i].curve.y2 - path[i].y);
	                path[i].curve = newCurve;
	            }
	            else if (path[i].curve.type === 'arc') {
	                console.warn('Paths with arcs are not yet supported.');
	            }
	            continue;
	        }
	        path[i].curve = {
	            type: 'cubic',
	            x1: path[i - 1].x,
	            y1: path[i - 1].y,
	            x2: path[i].x,
	            y2: path[i].y,
	        };
	    }
	};
	exports.isMultiShape = function (path) {
	    for (var i = 0; i < path.length; i++) {
	        if (path[i].closed && i < path.length - 1) {
	            return true;
	        }
	    }
	    return false;
	};
	exports.synchronizePathStructure = function () {
	    var paths = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        paths[_i] = arguments[_i];
	    }
	    // Multi-shape not yet supported for magic-morph
	    if (paths.some(exports.isMultiShape)) {
	        return;
	    }
	    var maxVerts = Math.max.apply(Math, paths.map(function (path) { return path.length; }));
	    var validPaths = paths.filter(function (path) { return path.length; });
	    validPaths.forEach(function (path) {
	        exports.ensurePathClockwise(path);
	        exports.distributeTotalVertices(path, maxVerts);
	        exports.normalizePointCurves(path);
	    });
	    for (var i = 0; i < validPaths.length - 1; i++) {
	        exports.rotatePathForSmallestDistance(validPaths[i], validPaths[i + 1]);
	    }
	};
	//# sourceMappingURL=PathUtils.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Quick-and-dirty way to generate unique DOM-friendly ids on the fly...
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ALPHABET = 'abcdefghijklmnopqrstuvwxyz';
	exports.randomString = function (len) {
	    var str = '';
	    while (str.length < len) {
	        str += exports.ALPHABET[Math.floor(Math.random() * exports.ALPHABET.length)];
	    }
	    return str;
	};
	//# sourceMappingURL=StringUtils.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2017. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Simple semver comparitor function for semvers.
	 *
	 * Used for determining if a semver a = x.y.z is less than, greater than, or equal to a semver b = x'.y'.z'. Returns 1
	 * if a > b, -1 if a < b, or 0 if they are equal.
	 *
	 * @param {string} a
	 * @param {string} b
	 * @returns {number}
	 */
	var compareSemver = function (a, b) {
	    var semverA = a.split('.');
	    var semverB = b.split('.');
	    if (semverA.length !== 3 || semverB.length !== 3) {
	        throw new Error("Invalid semver comparison: " + a + ", " + b);
	    }
	    for (var i = 0; i < 3; ++i) {
	        if (semverA[i] < semverB[i]) {
	            return -1;
	        }
	        if (semverA[i] > semverB[i]) {
	            return 1;
	        }
	    }
	    return 0;
	};
	exports.default = compareSemver;
	//# sourceMappingURL=compareSemver.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function generateLogger() {
	    var CONSOLE_ERRORS = {};
	    return function consoleErrorOnce(err) {
	        var str = err && err.message.toString();
	        if (!CONSOLE_ERRORS[str]) {
	            CONSOLE_ERRORS[str] = true;
	            console.error(err);
	        }
	    };
	}
	exports.default = generateLogger();
	//# sourceMappingURL=consoleErrorOnce.js.map

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = (function (name, actions, mspf) {
	    var max = 0;
	    if (!actions) {
	        return max;
	    }
	    for (var selector in actions) {
	        for (var eventName in actions[selector]) {
	            var _a = eventName.split(':'), _ = _a[0], // always "timeline"
	            timelineNameOfListener = _a[1], frameKeyOfListener = _a[2];
	            // Skip non-frame-listener events
	            if (!timelineNameOfListener || !frameKeyOfListener) {
	                continue;
	            }
	            // Skip frame listeners for timelines other than us
	            if (timelineNameOfListener !== name) {
	                continue;
	            }
	            var frameOfListener = Number(frameKeyOfListener);
	            var timeOfListener = frameOfListener * mspf;
	            if (timeOfListener > max) {
	                max = timeOfListener;
	            }
	        }
	    }
	    return max;
	});
	//# sourceMappingURL=getActionsMaxTime.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var HAIKU_CONFIG_PROPS_RENAME_MAPPING = {
	    haikuOptions: 'options',
	    haikuStates: 'states',
	    haikuInitialStates: 'states',
	    haikuEventHandlers: 'eventHandlers',
	    haikuTimelines: 'timelines',
	    haikuVanities: 'vanities',
	};
	/**
	 * Parses a specific property specified by `verboseKeyName` from the `props`
	 * object, renaming and merging legacy props as necessary.
	 * This method is mainly used by the React and Vue adapters.
	 * @param props
	 * @param verboseKeyName
	 * @returns {Object}
	 */
	var getParsedProperty = function (props, verboseKeyName) {
	    var result = {};
	    var haikuConfigRemappedKey = HAIKU_CONFIG_PROPS_RENAME_MAPPING[verboseKeyName];
	    var haikuConfigFinalKey = haikuConfigRemappedKey || verboseKeyName;
	    // Special case: Options used to be a separate object, so if we see this legacy
	    // format, just merge it in with the root level of the new options
	    if (haikuConfigFinalKey === 'options') {
	        for (var optionsSubKey in props[verboseKeyName]) {
	            result[optionsSubKey] = props[verboseKeyName][optionsSubKey];
	        }
	    }
	    else {
	        result[haikuConfigFinalKey] = props[verboseKeyName];
	    }
	    return result;
	};
	exports.default = getParsedProperty;
	//# sourceMappingURL=getParsedProperty.js.map

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function getTimelineMaxTime(descriptor) {
	    var max = 0;
	    for (var selector in descriptor) {
	        var group = descriptor[selector];
	        for (var output in group) {
	            var keyframes = group[output];
	            if (typeof keyframes !== 'object') {
	                // In case this is run before migrations, continue (non-object keyframes means only 0-keyframe).
	                continue;
	            }
	            var keys = Object.keys(keyframes);
	            for (var i = 0; i < keys.length; i++) {
	                var key = parseInt(keys[i], 10);
	                if (key > max) {
	                    max = key;
	                }
	            }
	        }
	    }
	    return max;
	}
	exports.default = getTimelineMaxTime;
	//# sourceMappingURL=getTimelineMaxTime.js.map

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @method isMutableProperty
	 * @description Mechanism to determine if a property is mutated within the timeline.
	 */
	function isMutableProperty(property, propertyName) {
	    // For now, we can use a "naive" set of sufficient (but not necessary) conditions for immutability of a property:
	    //   1. Has exactly one keyframe.
	    //   2. The keyframe is "0".
	    //   3. The value at keyframe "0" is not a function (and so it cannot be mutated by changes in the state container).
	    // Although there is a more complete definition of immutability, this is enough to identify a property which is
	    // "likely mutable".
	    return Object.keys(property).length !== 1
	        || !property.hasOwnProperty('0')
	        || typeof property[0].value === 'function'
	        || /^controlFlow/.test(propertyName);
	}
	exports.default = isMutableProperty;
	//# sourceMappingURL=isMutableProperty.js.map

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Layout3D_1 = __webpack_require__(14);
	var migrateAutoSizing = function (propertyGroup) {
	    migrateAutoSizingForProperty(propertyGroup, 'sizeAbsolute.x');
	    migrateAutoSizingForProperty(propertyGroup, 'sizeAbsolute.y');
	};
	var migrateAutoSizingForProperty = function (propertyGroup, propertyName) {
	    if (propertyGroup[propertyName]) {
	        for (var keyframeMs in propertyGroup[propertyName]) {
	            if (propertyGroup[propertyName][keyframeMs].value === true) {
	                propertyGroup[propertyName][keyframeMs].value = Layout3D_1.AUTO_SIZING_TOKEN;
	            }
	        }
	    }
	};
	exports.default = migrateAutoSizing;
	//# sourceMappingURL=migrateAutoSizing.js.map

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function parseCssValueString(str, optionalPropertyHint) {
	    if (typeof str === 'number') {
	        return {
	            value: str,
	            unit: null,
	        };
	    }
	    if (str === null || str === undefined) {
	        return {
	            value: null,
	            unit: null,
	        };
	    }
	    var num;
	    var nmatch = str.match(/([+-]?[\d|.]+)/);
	    if (nmatch) {
	        num = Number(nmatch[0]);
	    }
	    else {
	        num = 0;
	    }
	    var unit;
	    var smatch = str.match(/(em|px|%|turn|deg|in)/);
	    if (smatch) {
	        unit = smatch[0];
	    }
	    else {
	        if (optionalPropertyHint && optionalPropertyHint.match(/rotate/)) {
	            unit = 'deg';
	        }
	        else {
	            unit = null;
	        }
	    }
	    return {
	        unit: unit,
	        value: num,
	    };
	}
	exports.default = parseCssValueString;
	//# sourceMappingURL=parseCssValueString.js.map

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Returns true iff a transform value is "essentially" a specified basis int.
	 */
	exports.transformValueIsEssentiallyInt = function (transformValue, basis) { return Math.abs(transformValue - basis) < 1e-6; };
	//# sourceMappingURL=transformValueIsEssentiallyInt.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * This file contains modified code from https://github.com/famous/engine
	 *
	 * The original code was released under the MIT license.
	 *
	 * MIT License (MIT)
	 *
	 * Copyright (c) 2015 Famous Industries Inc.
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 */
	var transformValueIsEssentiallyInt_1 = __webpack_require__(131);
	var Layout3D_1 = __webpack_require__(14);
	var TRANSFORM_ZERO = '0';
	var TRANSFORM_COMMA = ',';
	var simplifyTransform = function (transform) { return transformValueIsEssentiallyInt_1.transformValueIsEssentiallyInt(transform, 0) ? TRANSFORM_ZERO : transform; };
	function formatTransform(transform, format) {
	    if (format === Layout3D_1.default.FORMATS.TWO) {
	        // Example: matrix(1,0,0,0,0,1)
	        // 2d matrix is: matrix(scaleX(),skewY(),skewX(),scaleY(),translateX(),translateY())
	        // Modify via: matrix(a,b,c,d,tx,ty) <= matrix3d(a,b,0,0,c,d,0,0,0,0,1,0,tx,ty,0,1)
	        return "matrix(" + [
	            transform[0],
	            transform[1],
	            transform[4],
	            transform[5],
	            transform[12],
	            transform[13],
	        ].map(simplifyTransform).join(TRANSFORM_COMMA) + ")";
	    }
	    // Example: matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,716,243,0,1)
	    return "matrix3d(" + transform.map(simplifyTransform).join(TRANSFORM_COMMA) + ")";
	}
	exports.default = formatTransform;
	//# sourceMappingURL=formatTransform.js.map

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function scopeOfElement(mana) {
	    if (mana.__memory.scope) {
	        return mana.__memory.scope;
	    }
	    if (mana.__memory && mana.__memory.parent) {
	        return scopeOfElement(mana.__memory.parent);
	    }
	    return null;
	}
	exports.default = scopeOfElement;
	//# sourceMappingURL=scopeOfElement.js.map

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReservedWords_1 = __webpack_require__(135);
	var WRAP_PREFIX = '_$';
	var WRAP_SUFFIX = '$_';
	var VALIDITY_REGEX = /(^[^a-zA-Z_\$])|([^a-zA-Z_\$0-9])/g;
	function charReplacer(c) {
	    return WRAP_PREFIX + c.charCodeAt(0) + WRAP_SUFFIX;
	}
	function isInt(value) {
	    return !isNaN(parseInt(value, 10)) && parseInt(value, 10) === parseFloat(value);
	}
	/**
	 * @function toIdentifier
	 * @description Converts arbitrary text into a valid JavaScript identifier.
	 * This operation should be reversible.
	 */
	function toIdentifier(str) {
	    var out = str;
	    out = out.replace(VALIDITY_REGEX, charReplacer);
	    if (ReservedWords_1.default.WORDS[out]) {
	        return "" + WRAP_PREFIX + out + WRAP_SUFFIX;
	    }
	    return out;
	}
	exports.toIdentifier = toIdentifier;
	/**
	 * @function toText
	 * @description Inverse of toIdentifier
	 */
	function toText(str) {
	    return str.replace(/_\$([a-zA-Z_0-9]+)\$_/g, function (full) {
	        var part = full.slice(2, full.length - 2);
	        // Ignore JavaScript keywords that we may have wrapped
	        if (isInt(part)) {
	            return String.fromCharCode(parseInt(part, 10));
	        }
	        return part;
	    });
	}
	exports.toText = toText;
	//# sourceMappingURL=JavaScriptIdentifier.js.map

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Just a dictionary of all JavaScript reserved words (current and future).
	 * This is used during code generation to ensure that neither element attributes
	 * nor user-defined states collide with known keywords which will cause problems
	 * with codegen and runtime exceptions.
	 */
	/* tslint:disable */
	var WORDS = {
	    'enum': true,
	    'function': true,
	    'implements': true,
	    'with': true,
	    'abstract': true,
	    'arguments': true,
	    'await': true,
	    'boolean': true,
	    'break': true,
	    'byte': true,
	    'case': true,
	    'catch': true,
	    'char': true,
	    'class': true,
	    'const': true,
	    'continue': true,
	    'debugger': true,
	    'default': true,
	    'delete': true,
	    'do': true,
	    'double': true,
	    'else': true,
	    'eval': true,
	    'export': true,
	    'extends': true,
	    'false': true,
	    'final': true,
	    'finally': true,
	    'float': true,
	    'for': true,
	    'goto': true,
	    'if': true,
	    'import': true,
	    'in': true,
	    'instanceof': true,
	    'int': true,
	    'interface': true,
	    'let': true,
	    'long': true,
	    'native': true,
	    'new': true,
	    'null': true,
	    'package': true,
	    'private': true,
	    'protected': true,
	    'public': true,
	    'return': true,
	    'short': true,
	    'static': true,
	    'super': true,
	    'switch': true,
	    'synchronized': true,
	    'this': true,
	    'throw': true,
	    'throws': true,
	    'transient': true,
	    'true': true,
	    'try': true,
	    'typeof': true,
	    'undefined': true,
	    'var': true,
	    'void': true,
	    'volatile': true,
	    'while': true,
	    'yield': true,
	};
	/* tslint:enable */
	var isReserved = function (word) {
	    return WORDS[word];
	};
	exports.default = {
	    isReserved: isReserved,
	    WORDS: WORDS,
	};
	//# sourceMappingURL=ReservedWords.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var marshalParams_1 = __webpack_require__(137);
	function functionSpecificationToFunction(name, params, body, type) {
	    if (type === void 0) { type = 'FunctionExpression'; }
	    var fn;
	    if (type === 'ArrowFunctionExpression') {
	        // tslint:disable-next-line:no-function-constructor-with-string-args
	        fn = new Function('\n' +
	            'return ' +
	            (name || '') +
	            '(' +
	            marshalParams_1.default(params) +
	            ') => {\n' +
	            '  ' +
	            (body || '') +
	            '\n' +
	            '}\n')();
	    }
	    else {
	        // tslint:disable-next-line:no-function-constructor-with-string-args
	        fn = new Function('\n' +
	            'return function ' +
	            (name || '') +
	            '(' +
	            marshalParams_1.default(params) +
	            ') {\n' +
	            '  ' +
	            (body || '') +
	            '\n' +
	            '}\n')();
	    }
	    return fn;
	}
	exports.default = functionSpecificationToFunction;
	//# sourceMappingURL=functionSpecificationToFunction.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var JavaScriptIdentifier_1 = __webpack_require__(134);
	var data = {
	    baddies: 0,
	};
	function arrayParamToString(param) {
	    var pieces = [];
	    for (var i = 0; i < param.length; i++) {
	        pieces.push(stringifyParam(param[i], null));
	    }
	    return '[ ' + pieces.join(', ') + ' ]';
	}
	function objectParamToString(param) {
	    var pieces = [];
	    // Special case, an object that describes a rest parameter
	    if (param.__rest) {
	        return '...' + param.__rest;
	    }
	    for (var key in param) {
	        pieces.push(stringifyParam(param[key], key));
	    }
	    return '{ ' + pieces.join(', ') + ' }';
	}
	function stringifyParam(param, key) {
	    if (param && typeof param === 'string') {
	        return JavaScriptIdentifier_1.toIdentifier(param);
	    }
	    if (param && Array.isArray(param)) {
	        // Let `a: []` be a signal that we only want to access 'a'
	        if (param.length < 1) {
	            return key;
	        }
	        if (key) {
	            // e.g.: a, a: [...] <~ To allow reference to the destructure root
	            return key + ', ' + key + ': ' + arrayParamToString(param);
	        }
	        return arrayParamToString(param);
	    }
	    if (param && typeof param === 'object') {
	        // Let `a: {}` be a signal that we only want to access 'a'
	        if (Object.keys(param).length < 1) {
	            return key;
	        }
	        if (key) {
	            // e.g. a, a: { ... } <~ To allow reference to the destructure root
	            return key + ', ' + key + ': ' + objectParamToString(param);
	        }
	        return objectParamToString(param);
	    }
	    // In case we get something we just can't handle, create something unique and noticeably ugly.
	    return '__' + data.baddies++ + '__';
	}
	function marshalParams(params) {
	    return params
	        .map(function (param) {
	        // Need wrap function to avoid passing the index (key) to stringifyParam, which uses that to detect something
	        return stringifyParam(param, null);
	    })
	        .join(', ');
	}
	exports.default = marshalParams;
	//# sourceMappingURL=marshalParams.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var functionSpecificationToFunction_1 = __webpack_require__(136);
	var inject_1 = __webpack_require__(64);
	function reifyRFO(rfo) {
	    var fn = functionSpecificationToFunction_1.default(rfo.name || '', rfo.params, rfo.body, rfo.type);
	    // Upstream can signal that this function needs to become 'injected'
	    // in order to function properly using this flag
	    if (rfo.injectee) {
	        inject_1.default.apply(null, [fn].concat(rfo.params));
	    }
	    return fn;
	}
	exports.default = reifyRFO;
	//# sourceMappingURL=reifyRFO.js.map

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    }
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuBase_1 = __webpack_require__(13);
	var HaikuComponent_1 = __webpack_require__(56);
	var assign_1 = __webpack_require__(20);
	var applyLayout_1 = __webpack_require__(140);
	var assignAttributes_1 = __webpack_require__(141);
	var createRightClickMenu_1 = __webpack_require__(144);
	var createSvgElement_1 = __webpack_require__(145);
	var createTextNode_1 = __webpack_require__(65);
	var getElementSize_1 = __webpack_require__(146);
	var getLocalDomEventPosition_1 = __webpack_require__(147);
	var getTypeAsString_1 = __webpack_require__(148);
	var isBlankString_1 = __webpack_require__(151);
	var isTextNode_1 = __webpack_require__(66);
	var normalizeName_1 = __webpack_require__(155);
	var removeElement_1 = __webpack_require__(156);
	var replaceElementWithText_1 = __webpack_require__(157);
	var isNil = function (v) {
	    return v === undefined || v === null;
	};
	var connectTarget = function (virtualNode, domElement) {
	    if (virtualNode && typeof virtualNode === 'object') {
	        // This normally happens in HaikuComponent.hydrateNode, but we might be operating
	        // as a thin-renderer where no hydration has occurred; so do the bootstrapping here.
	        if (!virtualNode.__memory) {
	            virtualNode.__memory = {};
	        }
	        // A virtual node can have multiple targets in the DOM due to an implementation
	        // detail in the Haiku editing environment; FIXME
	        if (!virtualNode.__memory.targets) {
	            virtualNode.__memory.targets = [];
	        }
	        if (virtualNode.__memory.targets.indexOf(domElement) === -1) {
	            virtualNode.__memory.targets.push(domElement);
	        }
	    }
	};
	// tslint:disable:variable-name
	var HaikuDOMRenderer = /** @class */ (function (_super) {
	    __extends(HaikuDOMRenderer, _super);
	    function HaikuDOMRenderer(mount, config) {
	        var _this = _super.call(this) || this;
	        _this.shouldListenerReceiveEvent = function (name, rewritten, event, match, mount) {
	            if (name === 'hover' || name === 'unhover') {
	                return event.target === match;
	            }
	            if (name === 'keyup' || name === 'keydown' || name === 'keypress') {
	                // See not about keyboard handling in HaikuDOMRenderer#decideMountElement
	                if (mount === _this.getWindow()) {
	                    return true;
	                }
	            }
	            // Since we subscribe to events from the root element, we rewrite these as 'mouseover' and 'mouseout'
	            // so we can adequately capture "bubbled" enters/leaves to meet the 99% expectation of users. Then
	            // we mimic the bubbling logic here so the semantics align with normal DOM semantics
	            if (name === 'mouseenter' || name === 'mouseleave') {
	                return (match === event.target &&
	                    ( // Don't fire if the user's mouse went from inside the child into the target
	                    !match.contains ||
	                        !match.contains(event.relatedTarget)));
	            }
	            return (match === event.target ||
	                (match.contains && match.contains(event.target)));
	        };
	        _this.mount = mount;
	        _this.user = {
	            mouse: {
	                x: 0,
	                y: 0,
	                down: 0,
	                buttons: [0, 0, 0],
	            },
	            keys: {},
	            touches: [],
	            mouches: [],
	        };
	        _this.config = config;
	        _this.shouldCreateContainer = true;
	        // Ensure we don't conflict with existing content in the mount
	        _this.clear();
	        return _this;
	    }
	    HaikuDOMRenderer.prototype.clear = function () {
	        if (this.mount) {
	            while (this.mount.firstChild) {
	                this.mount.removeChild(this.mount.firstChild);
	            }
	        }
	    };
	    HaikuDOMRenderer.prototype.getMountForComponent = function (component) {
	        // The component without a host is the root component, and uses this node.
	        if (!component.host) {
	            return this.mount;
	        }
	        return component.target && component.target.parentNode;
	    };
	    HaikuDOMRenderer.prototype.render = function (virtualContainer, virtualTree, component) {
	        return HaikuDOMRenderer.renderTree(
	        // The injected mount is for the case that the caller wants to render into a node
	        // other than the root node of the context, for example calling render on a subcomponent
	        this.getMountForComponent(component), virtualContainer, [virtualTree], component, false, // isPatchOperation
	        false);
	    };
	    HaikuDOMRenderer.prototype.patch = function (component, deltas) {
	        // The component upstream may use an empty value to indicate a no-op
	        if (!deltas || Object.keys(deltas).length < 1) {
	            return;
	        }
	        for (var compositeId in deltas) {
	            var virtualElement = deltas[compositeId];
	            var parentVirtualElement = virtualElement.__memory && virtualElement.__memory.parent;
	            var domTargets = virtualElement.__memory && virtualElement.__memory.targets;
	            if (!domTargets) {
	                continue;
	            }
	            for (var i = 0; i < domTargets.length; i++) {
	                var domTarget = domTargets[i];
	                if (!domTarget.parentNode) {
	                    continue;
	                }
	                HaikuDOMRenderer.updateElement(domTarget, // DOM node
	                virtualElement, // mana node
	                domTarget.parentNode, // DOM node
	                parentVirtualElement, // mana node
	                component, true);
	            }
	        }
	    };
	    HaikuDOMRenderer.prototype.menuize = function (component) {
	        return createRightClickMenu_1.default(this.mount, component);
	    };
	    HaikuDOMRenderer.prototype.mixpanel = function (mixpanelToken, component) {
	        return mixpanelInit(mixpanelToken, component);
	    };
	    HaikuDOMRenderer.prototype.hasSizing = function () {
	        return this.config && this.config.sizing && this.config.sizing !== 'normal';
	    };
	    HaikuDOMRenderer.prototype.getZoom = function () {
	        return ((this.config && this.config.zoom) || 1.0);
	    };
	    HaikuDOMRenderer.prototype.getPan = function () {
	        return {
	            x: (this.config && this.config.pan && this.config.pan.x) || 0,
	            y: (this.config && this.config.pan && this.config.pan.y) || 0,
	        };
	    };
	    HaikuDOMRenderer.prototype.createContainer = function (out) {
	        if (out === void 0) { out = {}; }
	        var size;
	        if (this.mount) {
	            size = getElementSize_1.default(this.mount);
	        }
	        else {
	            console.warn('[haiku dom renderer] mount empty; using fallback size');
	            size = { x: 1, y: 1 };
	        }
	        out.layout = {
	            computed: {
	                size: size,
	            },
	        };
	        if (!this.hasSizing() || !this.config.alwaysComputeSizing) {
	            this.shouldCreateContainer = false;
	        }
	        return out;
	    };
	    HaikuDOMRenderer.prototype.getDocument = function () {
	        return this.mount.ownerDocument;
	    };
	    HaikuDOMRenderer.prototype.getWindow = function () {
	        var doc = this.getDocument();
	        return doc.defaultView || doc.parentWindow;
	    };
	    HaikuDOMRenderer.prototype.initialize = function () {
	        var _this = this;
	        var user = this.user;
	        var setMouse = function (mouseEvent) {
	            // Since the mount itself might be subject to sizing styles that we cannot
	            // use to calculate appropriately, use the top element i.e. the 'artboard'
	            var topElement = _this.mount.childNodes[0];
	            if (topElement) {
	                var pos = getLocalDomEventPosition_1.default(mouseEvent, topElement);
	                user.mouse.x = pos.x;
	                user.mouse.y = pos.y;
	            }
	        };
	        var setTouches = function (touchEvent) {
	            user.touches.splice(0);
	            // Since the mount itself might be subject to sizing styles that we cannot
	            // use to calculate appropriately, use the top element i.e. the 'artboard'
	            var topElement = _this.mount.childNodes[0];
	            if (topElement) {
	                for (var i = 0; i < touchEvent.touches.length; i++) {
	                    var touch = touchEvent.touches[i];
	                    var pos = getLocalDomEventPosition_1.default(touch, topElement);
	                    user.touches.push(pos);
	                }
	            }
	        };
	        var setMouches = function () {
	            user.mouches.splice(0);
	            // Only treat a mouse like a touch if it is down.
	            if (user.mouse.down) {
	                user.mouches.push(user.mouse);
	            }
	            user.mouches.push.apply(user.mouches, user.touches);
	        };
	        var clearKey = function () {
	            for (var which in user.keys) {
	                user.keys[which] = 0;
	            }
	        };
	        var clearMouse = function () {
	            user.mouse.down = 0;
	            user.touches.splice(0);
	            for (var i = 0; i < user.mouse.buttons.length; i++) {
	                user.mouse.buttons[i] = 0;
	            }
	        };
	        var clearMouch = function () {
	            user.mouches.splice(0);
	        };
	        var clearTouch = function () {
	            user.touches.splice(0);
	        };
	        var doc = this.getDocument();
	        var win = this.getWindow();
	        this.mount.addEventListener('mousedown', function (mouseEvent) {
	            ++user.mouse.down;
	            ++user.mouse.buttons[mouseEvent.button];
	            setMouse(mouseEvent);
	            setMouches();
	        });
	        this.mount.addEventListener('mouseup', function (mouseEvent) {
	            clearMouse();
	            clearMouch();
	            setMouches();
	        });
	        var lastMoveTarget;
	        // NOTE: if there are perf or interop issues that arise from
	        //       attaching event listeners directly to host window,
	        //       could expose a haikuOption for reverting to "attach to mount" behavior
	        win.addEventListener('mousemove', function (mouseEvent) {
	            setMouse(mouseEvent);
	            setMouches();
	            if (lastMoveTarget !== mouseEvent.target) {
	                lastMoveTarget = mouseEvent.target;
	                var moveElement = void 0;
	                // If the move has taken us outside of our component, use the mount
	                if (_this.mount.contains(mouseEvent.target)) {
	                    moveElement = _this.getHaikuElementFromTarget(mouseEvent.target);
	                }
	                else {
	                    moveElement = _this.getHaikuElementFromTarget(_this.mount);
	                }
	                if (moveElement) {
	                    moveElement.triggerHover(mouseEvent);
	                }
	            }
	        });
	        win.addEventListener('mouseenter', function (mouseEvent) {
	            clearMouse();
	            clearMouch();
	        });
	        win.addEventListener('mouseleave', function (mouseEvent) {
	            clearMouse();
	            clearMouch();
	        });
	        this.mount.addEventListener('wheel', function (mouseEvent) {
	            setMouse(mouseEvent);
	            setMouches();
	        }, {
	            passive: true,
	        });
	        doc.addEventListener('keydown', function (keyEvent) {
	            if (user.keys[keyEvent.which] === undefined) {
	                user.keys[keyEvent.which] = 0;
	            }
	            ++user.keys[keyEvent.which];
	        });
	        doc.addEventListener('keyup', function (keyEvent) {
	            if (user.keys[keyEvent.which] === undefined) {
	                user.keys[keyEvent.which] = 0;
	            }
	            // Known Mac "feature" where keyup never fires while meta key (91) is down
	            // When right-click menu is toggled we don't get all mouseup events
	            if (keyEvent.which === 91 || keyEvent.which === 17) {
	                clearKey();
	            }
	            user.keys[keyEvent.which] = 0;
	        });
	        // If there's any sizing mode that requires computation of container size
	        // and alwaysComputeSizing is *disabled*, make an "overriding" assumption
	        // that we probably want to recompute the container when media queries change.
	        if (this.hasSizing() && !this.config.alwaysComputeSizing) {
	            win.addEventListener('resize', function () {
	                _this.shouldCreateContainer = true;
	            });
	            win.addEventListener('orientationchange', function () {
	                _this.shouldCreateContainer = true;
	            });
	        }
	        win.addEventListener('blur', function (blurEvent) {
	            clearKey();
	            clearMouse();
	            clearTouch();
	            clearMouch();
	        });
	        win.addEventListener('focus', function (blurEvent) {
	            clearKey();
	            clearMouse();
	            clearTouch();
	            clearMouch();
	        });
	        win.addEventListener('touchstart', function (touchEvent) {
	            setTouches(touchEvent);
	            setMouches();
	        }, {
	            passive: true,
	        });
	        win.addEventListener('touchend', function (touchEvent) {
	            clearTouch();
	            clearMouch();
	        });
	        win.addEventListener('touchmove', function (touchEvent) {
	            setTouches(touchEvent);
	            setMouches();
	        }, {
	            passive: true,
	        });
	        win.addEventListener('touchenter', function (touchEvent) {
	            clearTouch();
	            clearMouch();
	        });
	        win.addEventListener('touchleave', function (touchEvent) {
	            clearTouch();
	            clearMouch();
	        });
	    };
	    HaikuDOMRenderer.prototype.decideMountElement = function (component, selector, name) {
	        // For keyboard events, if subscribed to the component, and if the component is the runtime root,
	        // we automatically attach its handler to window, as this is the 98%-case desired behavior
	        if (name === 'keyup' || name === 'keydown' || name === 'keypress') {
	            if (!component.host && "haiku:" + component.getComponentId() === selector) {
	                var win = this.getWindow();
	                return win;
	            }
	        }
	        // Otherwise, fallthrough and assume we want to listen to our own mount element
	        return this.mount;
	    };
	    HaikuDOMRenderer.prototype.mountEventListener = function (component, selector, name, listener) {
	        var _this = this;
	        var rewritten = name;
	        if (name === 'mouseenter') {
	            rewritten = 'mouseover';
	        }
	        else if (name === 'mouseleave') {
	            rewritten = 'mouseout';
	        }
	        // Convert haiku:* selectors into proper attribute selectors
	        var query = selector;
	        if (selector.slice(0, 6) === 'haiku:') {
	            query = "[haiku-id=\"" + selector.slice(6) + "\"]";
	        }
	        var mount = this.decideMountElement(component, selector, name);
	        // Since elements inside out tree may be added or removed at will, event listener
	        // management (i.e. cleanup and re-registration) becomes a problem. Rather than solve
	        // that tangle, we register listeners on our mount element, which is assumed to
	        // remain through the lifespan of the component, and then delegate the events as
	        // appropriate per their respective specifications.
	        mount.addEventListener(rewritten, function (domEvent) {
	            // If no explicit selector/target for the event, just fire the listener
	            if (!selector || selector === HaikuBase_1.GLOBAL_LISTENER_KEY ||
	                !domEvent || !domEvent.target) {
	                listener(null, _this.wrapEvent(name, domEvent, null, component));
	                return;
	            }
	            // If no queryable node has been rendered, we can't perform a match
	            if (!component.target || !component.target.parentNode) {
	                return;
	            }
	            // If the event originated from the element or its descendants
	            var match = component.target.parentNode.querySelector(query);
	            if (match) {
	                if (_this.shouldListenerReceiveEvent(name, rewritten, domEvent, match, mount)) {
	                    listener(_this.getHaikuElementFromTarget(match), domEvent.target, _this.wrapEvent(name, domEvent, match, component));
	                    return;
	                }
	            }
	        });
	    };
	    HaikuDOMRenderer.prototype.getHaikuElementFromTarget = function (target) {
	        return (target &&
	            target.haiku &&
	            target.haiku.element &&
	            target.haiku.element.__memory &&
	            target.haiku.element.__memory.element);
	    };
	    /**
	     * @description An opportunity to return an event aligned with our own API semantics.
	     * Keep in mind that the three elements involved here may be different:
	     *   this.mount - the host node for the component, the node we actually attach listeners to.
	     *   event.target - the element on which the event actually originated
	     *   elementListenedTo - the element that the user is listening to the event on
	     */
	    HaikuDOMRenderer.prototype.wrapEvent = function (eventName, nativeEvent, elementListenedTo, hostComponent) {
	        return nativeEvent;
	    };
	    HaikuDOMRenderer.prototype.getUser = function () {
	        var zoom = this.getZoom();
	        var pan = this.getPan();
	        return {
	            zoom: zoom,
	            pan: pan,
	            mouse: {
	                x: (this.user.mouse.x) / zoom,
	                y: (this.user.mouse.y) / zoom,
	                z: 0,
	                down: this.user.mouse.down,
	                buttons: this.user.mouse.buttons.slice(),
	            },
	            keys: __assign({}, this.user.keys),
	            touches: this.user.touches.slice(),
	            mouches: this.user.mouches.slice(),
	        };
	    };
	    HaikuDOMRenderer.createTagNode = function (domElement, virtualElement, parentVirtualElement, component) {
	        var tagName = normalizeName_1.default(getTypeAsString_1.default(virtualElement));
	        var compositeId = HaikuComponent_1.getNodeCompositeId(virtualElement);
	        var newDomElement;
	        if (SVG_ELEMENT_NAMES[tagName]) {
	            // SVG
	            newDomElement = createSvgElement_1.default(domElement, tagName);
	        }
	        else {
	            // Normal DOM
	            newDomElement = domElement.ownerDocument.createElement(tagName);
	        }
	        // This didn't happen in renderTree because the element didn't exist yet.
	        if (!newDomElement.haiku) {
	            newDomElement.haiku = {
	                // This is used to detect whether the element's host component has changed.
	                // Don't remove this without understanding the effect on Haiku.app.
	                component: component,
	                explicitStyles: {},
	            };
	        }
	        component.subcacheEnsure(compositeId);
	        var incomingKey = virtualElement.key ||
	            (virtualElement.attributes && virtualElement.attributes.key);
	        if (incomingKey !== undefined && incomingKey !== null) {
	            newDomElement.haiku.key = incomingKey;
	        }
	        // updateElement recurses down into setAttributes, etc.
	        HaikuDOMRenderer.updateElement(newDomElement, virtualElement, domElement, parentVirtualElement, component, null);
	        return newDomElement;
	    };
	    HaikuDOMRenderer.appendChild = function (alreadyChildElement, virtualElement, parentDomElement, parentVirtualElement, component) {
	        var domElementToInsert = isTextNode_1.default(virtualElement)
	            ? createTextNode_1.default(parentDomElement, virtualElement)
	            : HaikuDOMRenderer.createTagNode(parentDomElement, virtualElement, parentVirtualElement, component);
	        applyLayout_1.default(domElementToInsert, virtualElement, component);
	        parentDomElement.appendChild(domElementToInsert);
	        return domElementToInsert;
	    };
	    HaikuDOMRenderer.replaceElement = function (domElement, virtualElement, parentDomNode, parentVirtualElement, component) {
	        var compositeId = HaikuComponent_1.getNodeCompositeId(virtualElement);
	        component.subcacheClear(compositeId);
	        var newElement = isTextNode_1.default(virtualElement)
	            ? createTextNode_1.default(domElement, virtualElement)
	            : HaikuDOMRenderer.createTagNode(domElement, virtualElement, parentVirtualElement, component);
	        applyLayout_1.default(newElement, virtualElement, component);
	        parentDomNode.replaceChild(newElement, domElement);
	        return newElement;
	    };
	    HaikuDOMRenderer.updateElement = function (domElement, virtualElement, parentNode, parentVirtualElement, component, isPatchOperation) {
	        var compositeId = HaikuComponent_1.getNodeCompositeId(virtualElement);
	        // If a text node, go straight to 'replace' since we don't know the tag name
	        if (isTextNode_1.default(virtualElement)) {
	            replaceElementWithText_1.default(domElement, virtualElement, component);
	            return virtualElement;
	        }
	        if (!domElement.haiku) {
	            domElement.haiku = {
	                // This is used to detect whether the element's host component has changed.
	                // Don't remove this without understanding the effect on Haiku.app.
	                component: component,
	                explicitStyles: {},
	            };
	        }
	        component.subcacheEnsure(compositeId);
	        if (!domElement.haiku.element) {
	            // Must clone so we get a correct picture of differences in attributes between runs, e.g. for detecting attribute
	            // removals
	            domElement.haiku.element = HaikuDOMRenderer.cloneVirtualElement(virtualElement);
	        }
	        var domTagName = domElement.tagName.toLowerCase().trim();
	        var elName = normalizeName_1.default(getTypeAsString_1.default(virtualElement));
	        var virtualElementTagName = elName.toLowerCase().trim();
	        var incomingKey = virtualElement.key || (virtualElement.attributes && virtualElement.attributes.key);
	        var existingKey = domElement.haiku && domElement.haiku.key;
	        var isKeyDifferent = incomingKey !== null && incomingKey !== undefined && incomingKey !== existingKey;
	        // For so-called 'horizon' elements, we assume that we've ceded control to another renderer,
	        // so the most we want to do is update the attributes and layout properties, but leave the rest alone
	        if (!component.isHorizonElement(virtualElement)) {
	            if (domTagName !== virtualElementTagName) {
	                return HaikuDOMRenderer.replaceElement(domElement, virtualElement, parentNode, parentVirtualElement, component);
	            }
	            if (isKeyDifferent) {
	                return HaikuDOMRenderer.replaceElement(domElement, virtualElement, parentNode, parentVirtualElement, component);
	            }
	        }
	        if (virtualElement.attributes && typeof virtualElement.attributes === 'object') {
	            assignAttributes_1.default(domElement, virtualElement, component, isPatchOperation);
	        }
	        applyLayout_1.default(domElement, virtualElement, component);
	        if (incomingKey !== undefined && incomingKey !== null) {
	            domElement.haiku.key = incomingKey;
	        }
	        var instance = (virtualElement &&
	            virtualElement.__memory &&
	            virtualElement.__memory.instance) || component;
	        var children = (virtualElement.__memory && virtualElement.__memory.children) || virtualElement.children;
	        if (Array.isArray(children)) {
	            // For performance, we don't render children during a patch operation, except in the case
	            // that we have some text content, which we (hack) need to always assume needs an update.
	            // TODO: Fix this hack and make smarter
	            var doSkipChildren = (isPatchOperation &&
	                children[0] instanceof Object);
	            HaikuDOMRenderer.renderTree(domElement, virtualElement, children, instance, isPatchOperation, doSkipChildren);
	        }
	        else if (!children) {
	            // In case of falsy virtual children, we still need to remove elements that were already there
	            HaikuDOMRenderer.renderTree(domElement, virtualElement, [], instance, isPatchOperation, null);
	        }
	        return domElement;
	    };
	    HaikuDOMRenderer.renderTree = function (domElement, virtualElement, virtualChildren, component, isPatchOperation, doSkipChildren) {
	        connectTarget(virtualElement, domElement);
	        var compositeId = HaikuComponent_1.getNodeCompositeId(virtualElement);
	        if (!domElement.haiku) {
	            domElement.haiku = {
	                // This is used to detect whether the element's host component has changed.
	                // Don't remove this without understanding the effect on Haiku.app.
	                component: component,
	                explicitStyles: {},
	            };
	        }
	        domElement.haiku.virtual = virtualElement;
	        // Must clone so we get a correct picture of differences in attributes
	        // between runs, e.g. for detecting attribute removals
	        domElement.haiku.element = HaikuDOMRenderer.cloneVirtualElement(virtualElement);
	        component.subcacheEnsure(compositeId);
	        if (!Array.isArray(virtualChildren)) {
	            return domElement;
	        }
	        // For so-called 'horizon' elements, we assume that we've ceded control to another renderer,
	        // so the most we want to do is update the attributes and layout properties, but leave the rest alone
	        if (component.isHorizonElement(virtualElement)) {
	            return domElement;
	        }
	        // During patch renders we don't want to drill down and update children as
	        // we're just going to end up doing a lot of unnecessary DOM writes
	        if (doSkipChildren) {
	            return domElement;
	        }
	        while (virtualChildren.length > 0 && isBlankString_1.default(virtualChildren[0])) {
	            virtualChildren.shift();
	        }
	        // Store a copy of the array here, otherwise we can hit a race where as we remove
	        // elements from the DOM, the childNodes array gets shifted and the indices get offset, leading
	        // to removals not occurring properly
	        var domChildNodes = [];
	        for (var k = 0; k < domElement.childNodes.length; k++) {
	            domChildNodes[k] = domElement.childNodes[k];
	        }
	        var max = virtualChildren.length;
	        if (max < domChildNodes.length) {
	            max = domChildNodes.length;
	        }
	        for (var i = 0; i < max; i++) {
	            var virtualChild = virtualChildren[i];
	            var domChild = domChildNodes[i];
	            if (isNil(virtualChild) && !domChild) {
	                // empty
	            }
	            else if (isNil(virtualChild) && domChild) {
	                removeElement_1.default(domChild, compositeId, component);
	            }
	            else {
	                if (!domChild) {
	                    var insertedElement = HaikuDOMRenderer.appendChild(null, virtualChild, domElement, virtualElement, component);
	                    connectTarget(virtualChild, insertedElement);
	                }
	                else {
	                    // Circumstances in which we want to completely *replace* the element:
	                    // - We see that our cached target element is not the one at this location
	                    // - We see that the DOM id doesn't match the incoming one
	                    // - we see that the haiku-id doesn't match the incoming one.
	                    // If we now have an element that is different, we need to trigger a full re-render
	                    // of itself and all of its children, because e.g. url(#...) references will retain pointers to
	                    // old elements and this is the only way to clear the DOM to get a correct render.
	                    var shouldReplace = HaikuDOMRenderer.shouldElementBeReplaced(domChild, virtualChild, component);
	                    if (shouldReplace) {
	                        var newElement = HaikuDOMRenderer.replaceElement(domChild, virtualChild, domElement, virtualElement, component);
	                        connectTarget(virtualChild, newElement);
	                    }
	                    else {
	                        HaikuDOMRenderer.updateElement(domChild, virtualChild, domElement, virtualElement, component, isPatchOperation);
	                        connectTarget(virtualChild, domChild);
	                    }
	                }
	            }
	        }
	        return domElement;
	    };
	    HaikuDOMRenderer.shouldElementBeReplaced = function (domElement, virtualElement, component) {
	        if (domElement.haiku) {
	            var compositeIdNew = HaikuComponent_1.getNodeCompositeId(virtualElement);
	            var compositeIdOld = HaikuComponent_1.getNodeCompositeId(domElement.haiku.element);
	            if (compositeIdNew !== compositeIdOld) {
	                return true;
	            }
	            if (domElement.haiku.component) {
	                // If the element carried at this node has a different host component,
	                // we should do a full replacement, since the cache of the two instances
	                // are different and may result in different (cached) rendering output
	                if (domElement.haiku.component !== component) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    HaikuDOMRenderer.cloneAttributes = function (attributes) {
	        if (!attributes) {
	            return {};
	        }
	        var clone = {};
	        for (var key in attributes) {
	            clone[key] = attributes[key];
	        }
	        return clone;
	    };
	    HaikuDOMRenderer.cloneVirtualElement = function (virtualElement) {
	        return {
	            elementName: virtualElement.elementName,
	            attributes: HaikuDOMRenderer.cloneAttributes(virtualElement.attributes),
	            children: (virtualElement.__memory && virtualElement.__memory.children) || virtualElement.children,
	            __memory: virtualElement.__memory,
	        };
	    };
	    HaikuDOMRenderer.__name__ = 'HaikuDOMRenderer';
	    return HaikuDOMRenderer;
	}(HaikuBase_1.default));
	exports.default = HaikuDOMRenderer;
	var SVG_ELEMENT_NAMES = {
	    a: true,
	    altGlyph: true,
	    altGlyphDef: true,
	    altGlyphItem: true,
	    animate: true,
	    animateColor: true,
	    animateMotion: true,
	    animateTransform: true,
	    circle: true,
	    clipPath: true,
	    'color-profile': true,
	    cursor: true,
	    defs: true,
	    desc: true,
	    discard: true,
	    ellipse: true,
	    feBlend: true,
	    feColorMatrix: true,
	    feComponentTransfer: true,
	    feComposite: true,
	    feConvolveMatrix: true,
	    feDiffuseLighting: true,
	    feDisplacementMap: true,
	    feDistantLight: true,
	    feFlood: true,
	    feFuncA: true,
	    feFuncB: true,
	    feFuncG: true,
	    feFuncR: true,
	    feGaussianBlur: true,
	    feImage: true,
	    feMerge: true,
	    feMergeNode: true,
	    feMorphology: true,
	    feOffset: true,
	    fePointLight: true,
	    feSpecularLighting: true,
	    feSpotLight: true,
	    feTile: true,
	    feTurbulence: true,
	    filter: true,
	    font: true,
	    'font-face': true,
	    'font-face-format': true,
	    'font-face-name': true,
	    'font-face-src': true,
	    'font-face-uri': true,
	    foreignObject: true,
	    g: true,
	    glyph: true,
	    glyphRef: true,
	    hkern: true,
	    image: true,
	    line: true,
	    linearGradient: true,
	    marker: true,
	    mask: true,
	    metadata: true,
	    'missing-glyph': true,
	    mpath: true,
	    path: true,
	    pattern: true,
	    polygon: true,
	    polyline: true,
	    radialGradient: true,
	    rect: true,
	    script: true,
	    set: true,
	    stop: true,
	    style: true,
	    svg: true,
	    switch: true,
	    symbol: true,
	    text: true,
	    textPath: true,
	    title: true,
	    tref: true,
	    tspan: true,
	    use: true,
	    view: true,
	    vkern: true,
	};
	/* tslint:disable */
	var mixpanelSnippetInjector = new Function("\n  (function(e,a){if(!a.__SV){var b=window;try{var c,l,i,j=b.location,g=j.hash;c=function(a,b){return(l=a.match(RegExp(b+\"=([^&]*)\")))?l[1]:null};g&&c(g,\"state\")&&(i=JSON.parse(decodeURIComponent(c(g,\"state\"))),\"mpeditor\"===i.action&&(b.sessionStorage.setItem(\"_mpcehash\",g),history.replaceState(i.desiredHash||\"\",e.title,j.pathname+j.search)))}catch(m){}var k,h;window['mixpanel']=a;a._i=[];a.init=function(b,c,f){function e(b,a){var c=a.split(\".\");2==c.length&&(b=b[c[0]],a=c[1]);b[a]=function(){b.push([a].concat(Array.prototype.slice.call(arguments,\n  0)))}}var d=a;\"undefined\"!==typeof f?d=a[f]=[]:f=\"mixpanel\";d.people=d.people||[];d.toString=function(b){var a=\"mixpanel\";\"mixpanel\"!==f&&(a+=\".\"+f);b||(a+=\" (stub)\");return a};d.people.toString=function(){return d.toString(1)+\".people (stub)\"};k=\"disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user\".split(\" \");\n  for(h=0;h<k.length;h++)e(d,k[h]);a._i.push([b,c,f])};a.__SV=1.2;}})(document,window.mixpanel||[]);\n");
	var mixpanelInit = function (mixpanelToken, component) {
	    // Only initialize Mixpanel if we're running in the browser
	    if (typeof window !== 'undefined') {
	        // Don't initialize multiple times if multiple components are on the page
	        if (!window.mixpanel) {
	            mixpanelSnippetInjector();
	            var head = document.getElementsByTagName('head')[0];
	            var script = document.createElement('script');
	            script.async = true;
	            script.type = 'text/javascript';
	            script.src = 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';
	            head.appendChild(script);
	            window.mixpanel.init(mixpanelToken, { ip: false });
	        }
	        var metadata = (component.bytecode && component.bytecode.metadata) || {};
	        window.mixpanel.track('component:initialize', assign_1.default({
	            platform: 'dom',
	        }, metadata));
	    }
	};
	//# sourceMappingURL=HaikuDOMRenderer.js.map

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var applyCssLayout_1 = __webpack_require__(62);
	var modernizr_1 = __webpack_require__(203);
	var getWindowsBrowserVersion_1 = __webpack_require__(149);
	var isEdge_1 = __webpack_require__(152);
	var isIE_1 = __webpack_require__(153);
	var isMobile_1 = __webpack_require__(154);
	var isTextNode_1 = __webpack_require__(66);
	var safeWindow = typeof window !== 'undefined' && window;
	var PLATFORM_INFO = {
	    hasWindow: !!safeWindow,
	    isMobile: isMobile_1.default(safeWindow),
	    isIE: isIE_1.default(safeWindow),
	    isEdge: isEdge_1.default(safeWindow),
	    windowsBrowserVersion: getWindowsBrowserVersion_1.default(safeWindow),
	    hasPreserve3d: modernizr_1.default.hasPreserve3d(safeWindow),
	};
	function applyLayout(domElement, virtualElement, component) {
	    if (isTextNode_1.default(virtualElement)) {
	        return domElement;
	    }
	    if (virtualElement.layout) {
	        var computedLayout = virtualElement.layout.computed;
	        // No computed layout means the el is not shown
	        if (!computedLayout) {
	            if (domElement.style.display !== 'none') {
	                domElement.style.display = 'none';
	            }
	        }
	        else {
	            if (domElement.style.display !== 'block') {
	                domElement.style.display = 'block';
	            }
	            component.config.platform = PLATFORM_INFO;
	            applyCssLayout_1.default(domElement, virtualElement, virtualElement.layout, computedLayout, component);
	        }
	    }
	    return domElement;
	}
	exports.default = applyLayout;
	//# sourceMappingURL=applyLayout.js.map

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assignClass_1 = __webpack_require__(142);
	var assignStyle_1 = __webpack_require__(143);
	var STYLE = 'style';
	var OBJECT = 'object';
	var CLASS = 'class';
	var CLASS_NAME = 'className';
	var NS = 'http://www.w3.org/1999/xlink';
	var XLINK_HREF = 'xlink:href';
	var setAttribute = function (domElement, virtualElement, key, val) {
	    if (key === XLINK_HREF) {
	        var p0 = domElement.getAttributeNS(NS, key);
	        if (p0 !== val) {
	            domElement.setAttributeNS(NS, key, val);
	        }
	    }
	    else {
	        var p1 = domElement.getAttribute(key);
	        if (p1 !== val) {
	            domElement.setAttribute(key, val);
	        }
	    }
	};
	function assignAttributes(domElement, virtualElement, component, isPatchOperation) {
	    if (!isPatchOperation) {
	        // Remove any attributes from the previous run that aren't present this time around
	        if (domElement.haiku && domElement.haiku.element) {
	            for (var oldKey in domElement.haiku.element.attributes) {
	                var oldValue = domElement.haiku.element.attributes[oldKey];
	                var newValue = virtualElement.attributes[oldKey];
	                if (oldKey !== STYLE) {
	                    // Removal of old styles is handled downstream; see assignStyle()
	                    if (newValue === null || newValue === undefined || oldValue !== newValue) {
	                        domElement.removeAttribute(oldKey);
	                    }
	                }
	            }
	        }
	    }
	    for (var key in virtualElement.attributes) {
	        var anotherNewValue = virtualElement.attributes[key];
	        if (key === STYLE &&
	            anotherNewValue &&
	            typeof anotherNewValue === OBJECT) {
	            if (Object.keys(anotherNewValue).length > 0) {
	                assignStyle_1.default(domElement, anotherNewValue, component, isPatchOperation);
	            }
	            continue;
	        }
	        if ((key === CLASS || key === CLASS_NAME) && anotherNewValue) {
	            assignClass_1.default(domElement, anotherNewValue);
	            continue;
	        }
	        // It's (almost?) never beneficial to write `NaN` to a DOM attribute here;
	        // this is a very hot path, and the result is a deluge of not-catchable errors.
	        if (Number.isNaN(anotherNewValue)) {
	            continue;
	        }
	        setAttribute(domElement, virtualElement, key, anotherNewValue);
	    }
	    return domElement;
	}
	exports.default = assignAttributes;
	//# sourceMappingURL=assignAttributes.js.map

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function assignClass(domElement, className) {
	    if (domElement.className !== className) {
	        domElement.setAttribute('class', className);
	    }
	    return domElement;
	}
	exports.default = assignClass;
	//# sourceMappingURL=assignClass.js.map

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function assignStyle(domElement, style, component, isPatchOperation) {
	    if (!isPatchOperation) {
	        // If we have an element from a previous run, remove any old styles that aren't part of the new one
	        if (domElement.haiku &&
	            domElement.haiku.element &&
	            domElement.haiku.element.attributes &&
	            domElement.haiku.element.attributes.style) {
	            for (var oldStyleKey in domElement.haiku.element.attributes.style) {
	                var newStyleValue = style[oldStyleKey];
	                if (newStyleValue === null || newStyleValue === undefined) {
	                    domElement.style.removeProperty(oldStyleKey);
	                }
	            }
	        }
	    }
	    for (var key in style) {
	        var newProp = style[key];
	        var previousProp = domElement.haiku.explicitStyles[key];
	        if (previousProp !== newProp) {
	            domElement.haiku.explicitStyles[key] = style[key];
	            domElement.style[key] = style[key];
	        }
	    }
	    return domElement;
	}
	exports.default = assignStyle;
	//# sourceMappingURL=assignStyle.js.map

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var MENU_GLOBAL_ID = 'haiku-right-click-menu';
	var WIDTH = 167;
	/* tslint:disable */
	var haikuIcon = '' +
	    '<svg style="transform:translateY(3px);margin-right:3px;" width="13px" height="13px" viewBox="0 0 9 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
	    '    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
	    '        <g id="menu" transform="translate(-9.000000, -50.000000)" fill-rule="nonzero" fill="#899497">' +
	    '            <g id="favicon" transform="translate(9.000000, 50.000000)">' +
	    '                <path d="M5.74649098,4.70558699 L5.74649098,5.7788098 C5.74649098,5.91256161 5.63820821,6.02098888 5.50463465,6.02098888 C5.46594093,6.02098888 5.42936949,6.0118902 5.39693775,5.99571295 C5.39186133,5.99396865 5.38680829,5.99204493 5.38178599,5.98993877 L2.13374851,4.62783436 C2.06585827,4.62681598 2.00074372,4.59703732 1.95556434,4.54557114 C1.89645814,4.50141795 1.85818531,4.43085101 1.85818531,4.35133305 L1.85818531,1.57454768 C1.85079926,1.56515108 1.8440022,1.55516354 1.83787126,1.54461783 L1.68370002,1.48221012 L0.983781643,1.19888682 L0.983781643,7.82711613 L1.85818531,8.18107016 L1.85818531,5.95344076 C1.85818531,5.94997543 1.858258,5.94652709 1.85840193,5.9430972 C1.85672094,5.90820764 1.86258618,5.87240498 1.87695925,5.83803981 C1.92855792,5.7146704 2.07026431,5.65654454 2.19346932,5.70821207 L5.45803735,7.07733924 L5.52116709,7.10578612 C5.64702981,7.11429403 5.74649098,7.21922045 5.74649098,7.34740828 L5.74649098,7.82711613 L6.61247795,8.17766313 L6.62089465,8.18107016 L6.62089465,4.31849373 L5.74649098,4.70558699 Z M5.26277832,4.81941585 L3.49887951,4.07970322 L2.78717926,4.37673832 L5.26277832,5.41491119 L5.26277832,4.81941585 Z M2.34189798,6.29557771 L2.34189798,8.21792436 L3.21630165,7.86397033 L3.21630165,6.66226962 L2.34189798,6.29557771 Z M2.10489107,8.84091277 C2.10327842,8.84094453 2.10166189,8.84096049 2.10004164,8.84096049 C2.03531005,8.84096049 1.97651801,8.81549628 1.93311099,8.77402594 L1.68370002,8.67306569 L0.701593132,8.27551396 C0.587217854,8.25628853 0.500068976,8.15667879 0.500068976,8.03668718 L0.500068976,8.02395302 C0.499977217,8.01997372 0.499976799,8.01598483 0.500068976,8.01198924 L0.500068976,0.83309739 C0.499984517,0.829434725 0.499977444,0.825763881 0.500048734,0.822087163 C0.499977444,0.818410445 0.499984517,0.814739601 0.500068976,0.811076936 L0.500068976,0.808477267 C0.500068976,0.734695385 0.533019284,0.66861973 0.584988773,0.624200019 C0.607223642,0.603893466 0.633376716,0.587129584 0.662911804,0.575173935 L2.00126808,0.0334143141 C2.06884262,-0.00448997495 2.15253254,-0.011953956 2.22949057,0.0203769852 L3.48533098,0.547969766 C3.4886593,0.547833737 3.49200497,0.54776506 3.49536665,0.54776506 C3.62894021,0.54776506 3.73722298,0.656192325 3.73722298,0.789944134 L3.73722298,0.821385651 C3.73731302,0.82532856 3.73731342,0.829280598 3.73722298,0.833238872 L3.73722298,2.40767185 L5.26277832,1.79239207 L5.26277832,0.83309739 C5.26269386,0.829434725 5.26268678,0.825763881 5.26275807,0.822087163 C5.26268678,0.818410445 5.26269386,0.814739601 5.26277832,0.811076936 L5.26277832,0.789944134 C5.26277832,0.660231597 5.36461961,0.55433711 5.49260447,0.548059437 L6.76397742,0.0334143141 C6.83155196,-0.00448997495 6.91524188,-0.011953956 6.99219991,0.0203769852 L8.30051205,0.570013732 C8.41385044,0.590099999 8.49993232,0.689222468 8.49993232,0.808477267 L8.49993232,0.821385589 C8.50002236,0.825328562 8.50002276,0.829280602 8.49993232,0.833238878 L8.49993232,8.03668718 C8.49993232,8.12601922 8.45162927,8.20405443 8.37974945,8.24603352 C8.3570412,8.26726508 8.33012837,8.28475773 8.2996029,8.29711428 L6.99757749,8.82416735 C6.91291064,8.85844005 6.82080599,8.84496071 6.75103698,8.79637735 L6.41724228,8.661259 L5.42562114,8.25985596 C5.34756383,8.22825877 5.29312904,8.1630773 5.27221467,8.08767347 C5.26662904,8.06827265 5.26340051,8.04787145 5.26285962,8.02680084 C5.26269203,8.02187767 5.26266414,8.01693859 5.26277832,8.01198924 L5.26277832,7.52049562 L5.25953529,7.51903428 L5.26277832,7.51181809 L5.26277832,7.52048475 L3.70001431,6.86512047 L3.70001431,8.03470119 C3.70001431,8.04191065 3.69969971,8.04904653 3.6990835,8.05609582 C3.69873979,8.1589341 3.63726868,8.25619133 3.53617314,8.29711428 L2.23486815,8.82387573 C2.19216118,8.84116329 2.14756179,8.84630123 2.10489107,8.84091277 Z M7.10460732,8.21821598 L8.01621965,7.84920008 L8.01621965,1.21243815 L7.10460732,1.58145405 L7.10460732,2.39098426 C7.10460732,2.46741667 7.06924708,2.53557924 7.0140137,2.5799642 C6.98940081,2.61105066 6.95679973,2.63650623 6.91764171,2.65284921 L4.12647169,3.81777145 L5.37396115,4.34092148 L6.74176427,3.73540324 C6.86393122,3.68132067 7.00675126,3.73664611 7.06076176,3.85897608 C7.06205348,3.86190175 7.06328271,3.86483924 7.06445002,3.86778706 C7.08982637,3.90609857 7.10460732,3.95205809 7.10460732,4.00147448 L7.10460732,8.21821598 Z M6.62089465,1.57454768 C6.6135086,1.56515108 6.60671153,1.55516354 6.6005806,1.54461783 L6.44640936,1.48221012 L5.74649098,1.19888682 L5.74649098,1.76114471 L6.62089465,2.11509874 L6.62089465,1.57454768 Z M2.34189798,4.03783399 L3.25351031,3.65736362 L3.25351031,1.21243815 L2.34189798,1.58145405 L2.34189798,4.03783399 Z M3.73722298,2.92984272 L3.73722298,3.45548138 L6.10302085,2.46809239 L5.50003848,2.22400828 C5.49794123,2.22315933 5.49586104,2.22228613 5.49379809,2.22138914 L3.73722298,2.92984272 Z M6.20555471,0.822087163 L6.64164504,0.998614246 L6.89809383,1.10242338 L7.57200867,0.829626174 L6.89232837,0.544084781 L6.20555471,0.822087163 Z M1.44284537,0.822087163 L1.8789357,0.998614246 L2.13538449,1.10242338 L2.80929933,0.829626174 L2.12961903,0.544084781 L1.44284537,0.822087163 Z" id="Combined-Shape"></path>' +
	    '            </g>' +
	    '        </g>' +
	    '    </g>' +
	    '</svg>';
	var sharePageIcon = '' +
	    '<svg style="transform:translate(-1px, 3px);margin-right:1px;" width="14px" height="14px" viewBox="0 0 11 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
	    '  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
	    '      <g id="menu" transform="translate(-8.000000, -32.000000)">' +
	    '          <g id="0884-focus" transform="translate(8.500000, 32.000000)">' +
	    '              <rect id="Rectangle-3" fill="#899497" x="4.72222222" y="0" width="1" height="1.66666667" rx="0.5"></rect>' +
	    '              <rect id="Rectangle-3-Copy" fill="#899497" x="4.72222222" y="8.33333333" width="1" height="1.66666667" rx="0.5"></rect>' +
	    '              <g id="Group" transform="translate(5.000000, 5.555556) rotate(90.000000) translate(-5.000000, -5.555556) translate(3.888889, 0.555556)" fill="#899497">' +
	    '                  <rect id="Rectangle-3-Copy-3" x="0.277777778" y="0" width="1" height="1.66666667" rx="0.5"></rect>' +
	    '                  <rect id="Rectangle-3-Copy-2" x="0.277777778" y="8.33333333" width="1" height="1.66666667" rx="0.5"></rect>' +
	    '              </g>' +
	    '              <circle id="Oval" stroke="#899497" stroke-width="0.66" cx="5" cy="5" r="3.33333333"></circle>' +
	    '              <circle id="Oval-2" fill="#899497" cx="5" cy="5" r="1.11111111"></circle>' +
	    '          </g>' +
	    '      </g>' +
	    '  </g>' +
	    '</svg>';
	var forkIcon = '' +
	    '<svg style="margin-right:5px;transform:translate(1px,3px);" width="11px" height="13px" viewBox="0 0 11 14" xmlns="http://www.w3.org/2000/svg">' +
	    '    <g fill="#899497" fill-rule="evenodd">' +
	    '        <path d="M1.764 2.506c.544 0 .964-.394.964-.853 0-.46-.42-.853-.964-.853S.8 1.194.8 1.653c0 .459.42.853.964.853zm0 .8C.79 3.306 0 2.566 0 1.653S.79 0 1.764 0s1.764.74 1.764 1.653-.79 1.653-1.764 1.653zm7.472-.8c.544 0 .964-.394.964-.853 0-.46-.42-.853-.964-.853s-.964.394-.964.853c0 .459.42.853.964.853zm0 .8c-.974 0-1.764-.74-1.764-1.653S8.262 0 9.236 0 11 .74 11 1.653s-.79 1.653-1.764 1.653zM1.764 13.2c.544 0 .964-.394.964-.853 0-.459-.42-.853-.964-.853s-.964.394-.964.853c0 .46.42.853.964.853zm0 .8C.79 14 0 13.26 0 12.347s.79-1.653 1.764-1.653 1.764.74 1.764 1.653S2.738 14 1.764 14z"/>' +
	    '        <path d="M9.636 3.028h-.8v-.421h.8v1.497c0 2.241-1.525 2.711-5.326 2.711-1.307 0-2.01.707-2.193 2.252l-.795-.094c.229-1.928 1.253-2.958 2.988-2.958 3.34 0 4.526-.365 4.526-1.911V2.61c0-.003 0-.003.8-.004v.422z"/>' +
	    '        <path d="M1.33 3h.8v8h-.8z"/>' +
	    '    </g>' +
	    '</svg>';
	/* tslint:enable */
	// Haiku servers will substitute the _actual_ full string in any js file,
	// so it's split into pieces here to avoid that build step
	var SUBSTITUTION_STRING = 'HAIKU' + '_' + 'SHARE' + '_' + 'UUID';
	function setBoxShadow(el, color) {
	    el.style['-webkit-box-shadow'] = '0 1px 4px 0 ' + color;
	    el.style['-moz-box-shadow'] = '0 1px 4px 0 ' + color;
	    el.style['box-shadow'] = '0 1px 4px 0 ' + color;
	}
	function px(num) {
	    return num + 'px';
	}
	function findOrCreateMenuElement(doc) {
	    var menu = doc.getElementById(MENU_GLOBAL_ID);
	    if (menu) {
	        return menu;
	    }
	    menu = doc.createElement('div');
	    menu.setAttribute('id', MENU_GLOBAL_ID);
	    menu.style.position = 'absolute';
	    menu.style.zIndex = 2147483647;
	    setBoxShadow(menu, 'rgba(10,2,21,0.25)');
	    menu.style.borderRadius = px(3);
	    menu.style.display = 'none';
	    menu.style.backgroundColor = 'rgba(255,255,255,0.95)';
	    menu.style.overflow = 'hidden';
	    menu.style.cursor = 'default';
	    menu.style.fontFamily = 'Helvetica, Arial, sans-serif';
	    menu.style.fontWeight = 'Bold';
	    menu.style.fontSize = px(10);
	    menu.style.padding = '0 0 7px';
	    menu.style.color = 'black';
	    menu.style.margin = '0';
	    menu.style.boxSizing = 'content-box';
	    menu.style.textDecoration = 'none';
	    menu.style.fontStyle = 'none';
	    doc.body.appendChild(menu);
	    return menu;
	}
	function truncate(str, len) {
	    if (str.length > len) {
	        return str.slice(0, len - 3) + '...';
	    }
	    return str;
	}
	function createRightClickMenu(domElement, component) {
	    var doc = domElement.ownerDocument;
	    var menu = findOrCreateMenuElement(doc);
	    var escaper = doc.createElement('textarea');
	    var metadata = component.bytecode && component.bytecode.metadata;
	    var isPublic = false;
	    var isForkable = false;
	    if (metadata && metadata.project && metadata.organization && window && window.fetch) {
	        try {
	            window.fetch("https://inkstone-edge.haiku.ai/v0/community/" + metadata.organization + "/" + metadata.project + "/metadata")
	                .then(function (response) { return response.json(); })
	                .then(function (responseJson) {
	                isPublic = responseJson.IsPublic;
	                isForkable = responseJson.IsForkable;
	            });
	        }
	        catch (e) {
	            // ...noop. We were unable to determine forkability.
	        }
	    }
	    function escapeHTML(html) {
	        escaper.textContent = html;
	        return escaper.innerHTML.replace(/[><,{}[\]"']/gi, '');
	    }
	    // revealMenu(100,100) // Uncomment me to render the menu while testing
	    function revealMenu(mx, my) {
	        var lines = [];
	        var titleLine = null;
	        /* tslint:disable */
	        if (metadata && metadata.project) {
	            var who = truncate(escapeHTML(metadata.project), 25);
	            var org = '';
	            if (metadata.organization) {
	                org = truncate(escapeHTML(metadata.organization), 11);
	                who = '"' + who + '" <span style="font-weight:normal;">by</span> ' + org;
	            }
	            var byline = who;
	            titleLine =
	                '<p style="margin:0;margin-bottom:4px;padding:12px 13px 7px;line-height:12px;text-align:center;border-bottom:1px solid rgba(140,140,140,.14);">' +
	                    byline +
	                    '</p>';
	        }
	        if (isPublic && metadata && metadata.uuid && metadata.uuid !== SUBSTITUTION_STRING) {
	            lines.push('<a onMouseOver="this.style.backgroundColor=\'rgba(140,140,140,.07)\'" onMouseOut="this.style.backgroundColor=\'transparent\'" style="display:block;color:black;text-decoration:none;padding: 5px 13px;line-height:12px;" href="https://share.haiku.ai/' +
	                escapeHTML(metadata.uuid) +
	                '" target="_blank">' +
	                sharePageIcon +
	                ' View on Haiku Community</a>');
	        }
	        if (isForkable) {
	            lines.push('<a onMouseOver="this.style.backgroundColor=\'rgba(140,140,140,.07)\'" onMouseOut="this.style.backgroundColor=\'transparent\'" style="display:block;color:black;text-decoration:none;padding: 5px 13px;line-height:12px;" href="https://share.haiku.ai/u/' +
	                escapeHTML(metadata.organization + "/" + metadata.project + "/fork") +
	                '" target="_blank">' +
	                forkIcon +
	                ' Fork this component</a>');
	        }
	        lines.push('<a onMouseOver="this.style.backgroundColor=\'rgba(140,140,140,.07)\'" onMouseOut="this.style.backgroundColor=\'transparent\'" style="display:block;color:black;text-decoration:none;padding: 5px 13px;line-height:12px;" href="https://www.haiku.ai" target="_blank">' +
	            haikuIcon +
	            '  Crafted in Haiku</a>');
	        /* tslint:enable */
	        if (lines.length < 1) {
	            return undefined;
	        }
	        menu.style.width = 'auto';
	        menu.style.minWidth = WIDTH;
	        menu.style.height = 'auto';
	        menu.style.top = px(my);
	        menu.style.left = px(mx);
	        menu.style.pointerEvents = 'auto';
	        menu.style.display = 'block';
	        menu.innerHTML = titleLine ? titleLine + lines.join('\n') : lines.join('\n');
	    }
	    function hideMenu(nativeEvent) {
	        if (nativeEvent.button === 2 || nativeEvent.ctrlKey) {
	            // Firefox treats contextmenu mouseups as clicks for some reason. This short-circuits that behavior.
	            return;
	        }
	        menu.style.width = px(0);
	        menu.style.minWidth = px(0);
	        menu.style.height = px(0);
	        menu.style.top = px(0);
	        menu.style.left = px(0);
	        menu.style.pointerEvents = 'none';
	        menu.style.display = 'none';
	    }
	    domElement.addEventListener('contextmenu', function (contextmenuEvent) {
	        contextmenuEvent.preventDefault();
	        var mx = contextmenuEvent.pageX;
	        var my = contextmenuEvent.pageY;
	        if (component.mixpanel) {
	            component.mixpanel.track('component:contextmenu');
	        }
	        revealMenu(mx, my);
	    });
	    doc.addEventListener('click', hideMenu);
	}
	exports.default = createRightClickMenu;
	//# sourceMappingURL=createRightClickMenu.js.map

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
	function createSvgElement(domElement, tagName) {
	    return domElement.ownerDocument.createElementNS(SVG_NAMESPACE, tagName);
	}
	exports.default = createSvgElement;
	//# sourceMappingURL=createSvgElement.js.map

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function getElementSize(domElement) {
	    // Get fractional size when on DOM
	    if (domElement.getBoundingClientRect instanceof Function) {
	        var rect = domElement.getBoundingClientRect();
	        return { x: rect.width, y: rect.height };
	    }
	    // Fallback to rounded offsetWidth/offsetHeight
	    if (domElement.offsetWidth !== undefined) {
	        return { x: domElement.offsetWidth, y: domElement.offsetHeight };
	    }
	    return { x: 1, y: 1 };
	}
	exports.default = getElementSize;
	//# sourceMappingURL=getElementSize.js.map

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var getDomEventPosition = function (event, doc) {
	    var x = -1;
	    var y = -1;
	    if (event.hasOwnProperty('pageX')) {
	        x = event.pageX;
	        y = event.pageY;
	    }
	    else if (event.clientX || event.clientY) {
	        x = event.clientX + doc.body.scrollLeft + doc.documentElement.scrollLeft;
	        y = event.clientY + doc.body.scrollTop + doc.documentElement.scrollTop;
	    }
	    return {
	        x: ~~x,
	        y: ~~y,
	    };
	};
	exports.default = (function (event, domElement) {
	    var doc = domElement.ownerDocument;
	    var viewPosition = getDomEventPosition(event, doc);
	    var elementRect = domElement.getBoundingClientRect();
	    var x = viewPosition.x - elementRect.left;
	    var y = viewPosition.y - elementRect.top;
	    if (domElement.offsetWidth !== elementRect.width) {
	        x *= domElement.offsetWidth / elementRect.width;
	    }
	    if (domElement.offsetHeight !== elementRect.height) {
	        y *= domElement.offsetHeight / elementRect.height;
	    }
	    return {
	        x: x,
	        y: y,
	        pageX: viewPosition.x,
	        pageY: viewPosition.y,
	    };
	});
	//# sourceMappingURL=getLocalDomEventPosition.js.map

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var STRING = 'string';
	var FUNCTION = 'function';
	var OBJECT = 'object';
	function getType(virtualElement) {
	    var typeValue = virtualElement.elementName;
	    if (typeValue && typeValue.default) {
	        return typeValue.default;
	    }
	    return typeValue;
	}
	function thingToTagName(thing) {
	    if (typeof thing === STRING && thing.length > 0) {
	        return thing;
	    }
	    if (typeof thing === FUNCTION) {
	        return fnToTagName(thing);
	    }
	    if (thing && typeof thing === OBJECT) {
	        return objToTagName(thing);
	    }
	    warnOnce('Got blank/malformed virtual element object; falling back to <div>');
	    return 'div';
	}
	function objToTagName(obj) {
	    // if (obj.name) return obj.name
	    // if (obj.metadata && obj.metadata.name) return obj.metadata.name
	    // _warnOnce('Got blank/malformed virtual element object; falling back to <div>')
	    return 'div';
	}
	function fnToTagName(fn) {
	    if (fn.name) {
	        return fn.name;
	    }
	    if (fn.displayName) {
	        return fn.displayName;
	    }
	    if (fn.constructor) {
	        if (fn.constructor.name !== 'Function') {
	            return fn.constructor.name;
	        }
	    }
	}
	function getTypeAsString(virtualElement) {
	    var typeValue = getType(virtualElement);
	    typeValue = thingToTagName(typeValue);
	    if (!typeValue) {
	        throw new Error('Node has no discernable name');
	    }
	    return typeValue;
	}
	exports.default = getTypeAsString;
	var warnings = {};
	function warnOnce(warning) {
	    if (warnings[warning]) {
	        return void 0;
	    }
	    warnings[warning] = true;
	    console.warn('[haiku core] warning:', warning);
	}
	//# sourceMappingURL=getTypeAsString.js.map

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function getWindowsBrowser(window) {
	    var rv = -1;
	    if (!window) {
	        return rv;
	    }
	    if (!window.navigator) {
	        return rv;
	    }
	    if (!window.navigator.userAgent) {
	        return rv;
	    }
	    if (!window.navigator.appName) {
	        return rv;
	    }
	    if (window.navigator.appName === 'Microsoft Internet Explorer') {
	        var ua = window.navigator.userAgent;
	        var re = new RegExp('MSIE ([0-9]{1,}[\\.0-9]{0,})');
	        if (re.exec(ua) !== null) {
	            rv = parseFloat(RegExp.$1);
	        }
	    }
	    else if (window.navigator.appName === 'Netscape') {
	        rv = (window.navigator.appVersion.indexOf('Trident') === -1) ? 12 : 11;
	    }
	    return rv;
	}
	exports.default = getWindowsBrowser;
	//# sourceMappingURL=getWindowsBrowserVersion.js.map

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var HaikuDOMRenderer_1 = __webpack_require__(139);
	exports.default = HaikuDOMRenderer_1.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function isBlankString(thing) {
	    return thing === '';
	}
	exports.default = isBlankString;
	//# sourceMappingURL=isBlankString.js.map

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function isEdge(window) {
	    if (!window) {
	        return false;
	    }
	    if (!window.navigator) {
	        return false;
	    }
	    if (!window.navigator.userAgent) {
	        return false;
	    }
	    return /Edge\/\d./i.test(window.navigator.userAgent);
	}
	exports.default = isEdge;
	//# sourceMappingURL=isEdge.js.map

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function isIE(window) {
	    if (!window) {
	        return false;
	    }
	    if (!window.navigator) {
	        return false;
	    }
	    if (!window.navigator.userAgent) {
	        return false;
	    }
	    return (window.navigator.userAgent.indexOf('MSIE') !== -1 ||
	        navigator.appVersion.indexOf('Trident') > 0);
	}
	exports.default = isIE;
	//# sourceMappingURL=isIE.js.map

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function isMobile(window) {
	    if (!window) {
	        return false;
	    }
	    if (!window.navigator) {
	        return false;
	    }
	    if (!window.navigator.userAgent) {
	        return false;
	    }
	    return /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
	}
	exports.default = isMobile;
	//# sourceMappingURL=isMobile.js.map

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function normalizeName(tagName) {
	    if (tagName[0] === tagName[0].toUpperCase()) {
	        return tagName + '-component';
	    }
	    return tagName;
	}
	exports.default = normalizeName;
	//# sourceMappingURL=normalizeName.js.map

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function removeElement(domElement, compositeId, component) {
	    component.subcacheClear(compositeId);
	    domElement.parentNode.removeChild(domElement);
	    return domElement;
	}
	exports.default = removeElement;
	//# sourceMappingURL=removeElement.js.map

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) Haiku 2016-2018. All rights reserved.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var createTextNode_1 = __webpack_require__(65);
	function replaceElementWithText(domElement, textContent, component) {
	    if (domElement) {
	        if (domElement.textContent !== textContent) {
	            var parentNode = domElement.parentNode;
	            var textNode = createTextNode_1.default(domElement, textContent);
	            parentNode.replaceChild(textNode, domElement);
	        }
	    }
	    return domElement;
	}
	exports.default = replaceElementWithText;
	//# sourceMappingURL=replaceElementWithText.js.map

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) 2014-2016, Jon Schlinkert
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function uniq(arr) {
	    var len = arr.length;
	    var i = -1;
	    while (i++ < len) {
	        var j = i + 1;
	        for (; j < arr.length; ++j) {
	            if (arr[i] === arr[j]) {
	                arr.splice(j--, 1);
	            }
	        }
	    }
	    return arr;
	}
	function immutable(arr) {
	    var arrayLength = arr.length;
	    var newArray = new Array(arrayLength);
	    for (var i = 0; i < arrayLength; i++) {
	        newArray[i] = arr[i];
	    }
	    return uniq(newArray);
	}
	exports.default = {
	    uniq: uniq,
	    immutable: immutable,
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) 2015 Dmitry Ivanov
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    aliceblue: [240, 248, 255],
	    antiquewhite: [250, 235, 215],
	    aqua: [0, 255, 255],
	    aquamarine: [127, 255, 212],
	    azure: [240, 255, 255],
	    beige: [245, 245, 220],
	    bisque: [255, 228, 196],
	    black: [0, 0, 0],
	    blanchedalmond: [255, 235, 205],
	    blue: [0, 0, 255],
	    blueviolet: [138, 43, 226],
	    brown: [165, 42, 42],
	    burlywood: [222, 184, 135],
	    cadetblue: [95, 158, 160],
	    chartreuse: [127, 255, 0],
	    chocolate: [210, 105, 30],
	    coral: [255, 127, 80],
	    cornflowerblue: [100, 149, 237],
	    cornsilk: [255, 248, 220],
	    crimson: [220, 20, 60],
	    cyan: [0, 255, 255],
	    darkblue: [0, 0, 139],
	    darkcyan: [0, 139, 139],
	    darkgoldenrod: [184, 134, 11],
	    darkgray: [169, 169, 169],
	    darkgreen: [0, 100, 0],
	    darkgrey: [169, 169, 169],
	    darkkhaki: [189, 183, 107],
	    darkmagenta: [139, 0, 139],
	    darkolivegreen: [85, 107, 47],
	    darkorange: [255, 140, 0],
	    darkorchid: [153, 50, 204],
	    darkred: [139, 0, 0],
	    darksalmon: [233, 150, 122],
	    darkseagreen: [143, 188, 143],
	    darkslateblue: [72, 61, 139],
	    darkslategray: [47, 79, 79],
	    darkslategrey: [47, 79, 79],
	    darkturquoise: [0, 206, 209],
	    darkviolet: [148, 0, 211],
	    deeppink: [255, 20, 147],
	    deepskyblue: [0, 191, 255],
	    dimgray: [105, 105, 105],
	    dimgrey: [105, 105, 105],
	    dodgerblue: [30, 144, 255],
	    firebrick: [178, 34, 34],
	    floralwhite: [255, 250, 240],
	    forestgreen: [34, 139, 34],
	    fuchsia: [255, 0, 255],
	    gainsboro: [220, 220, 220],
	    ghostwhite: [248, 248, 255],
	    gold: [255, 215, 0],
	    goldenrod: [218, 165, 32],
	    gray: [128, 128, 128],
	    green: [0, 128, 0],
	    greenyellow: [173, 255, 47],
	    grey: [128, 128, 128],
	    honeydew: [240, 255, 240],
	    hotpink: [255, 105, 180],
	    indianred: [205, 92, 92],
	    indigo: [75, 0, 130],
	    ivory: [255, 255, 240],
	    khaki: [240, 230, 140],
	    lavender: [230, 230, 250],
	    lavenderblush: [255, 240, 245],
	    lawngreen: [124, 252, 0],
	    lemonchiffon: [255, 250, 205],
	    lightblue: [173, 216, 230],
	    lightcoral: [240, 128, 128],
	    lightcyan: [224, 255, 255],
	    lightgoldenrodyellow: [250, 250, 210],
	    lightgray: [211, 211, 211],
	    lightgreen: [144, 238, 144],
	    lightgrey: [211, 211, 211],
	    lightpink: [255, 182, 193],
	    lightsalmon: [255, 160, 122],
	    lightseagreen: [32, 178, 170],
	    lightskyblue: [135, 206, 250],
	    lightslategray: [119, 136, 153],
	    lightslategrey: [119, 136, 153],
	    lightsteelblue: [176, 196, 222],
	    lightyellow: [255, 255, 224],
	    lime: [0, 255, 0],
	    limegreen: [50, 205, 50],
	    linen: [250, 240, 230],
	    magenta: [255, 0, 255],
	    maroon: [128, 0, 0],
	    mediumaquamarine: [102, 205, 170],
	    mediumblue: [0, 0, 205],
	    mediumorchid: [186, 85, 211],
	    mediumpurple: [147, 112, 219],
	    mediumseagreen: [60, 179, 113],
	    mediumslateblue: [123, 104, 238],
	    mediumspringgreen: [0, 250, 154],
	    mediumturquoise: [72, 209, 204],
	    mediumvioletred: [199, 21, 133],
	    midnightblue: [25, 25, 112],
	    mintcream: [245, 255, 250],
	    mistyrose: [255, 228, 225],
	    moccasin: [255, 228, 181],
	    navajowhite: [255, 222, 173],
	    navy: [0, 0, 128],
	    oldlace: [253, 245, 230],
	    olive: [128, 128, 0],
	    olivedrab: [107, 142, 35],
	    orange: [255, 165, 0],
	    orangered: [255, 69, 0],
	    orchid: [218, 112, 214],
	    palegoldenrod: [238, 232, 170],
	    palegreen: [152, 251, 152],
	    paleturquoise: [175, 238, 238],
	    palevioletred: [219, 112, 147],
	    papayawhip: [255, 239, 213],
	    peachpuff: [255, 218, 185],
	    peru: [205, 133, 63],
	    pink: [255, 192, 203],
	    plum: [221, 160, 221],
	    powderblue: [176, 224, 230],
	    purple: [128, 0, 128],
	    rebeccapurple: [102, 51, 153],
	    red: [255, 0, 0],
	    rosybrown: [188, 143, 143],
	    royalblue: [65, 105, 225],
	    saddlebrown: [139, 69, 19],
	    salmon: [250, 128, 114],
	    sandybrown: [244, 164, 96],
	    seagreen: [46, 139, 87],
	    seashell: [255, 245, 238],
	    sienna: [160, 82, 45],
	    silver: [192, 192, 192],
	    skyblue: [135, 206, 235],
	    slateblue: [106, 90, 205],
	    slategray: [112, 128, 144],
	    slategrey: [112, 128, 144],
	    snow: [255, 250, 250],
	    springgreen: [0, 255, 127],
	    steelblue: [70, 130, 180],
	    tan: [210, 180, 140],
	    teal: [0, 128, 128],
	    thistle: [216, 191, 216],
	    tomato: [255, 99, 71],
	    turquoise: [64, 224, 208],
	    violet: [238, 130, 238],
	    wheat: [245, 222, 179],
	    white: [255, 255, 255],
	    whitesmoke: [245, 245, 245],
	    yellow: [255, 255, 0],
	    yellowgreen: [154, 205, 50],
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) 2011 Heather Arthur <fayearthur@gmail.com>
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var color_names_1 = __webpack_require__(159);
	var reverseNames = {};
	// create a list of reverse color names
	for (var name_1 in color_names_1.default) {
	    if (color_names_1.default.hasOwnProperty(name_1)) {
	        reverseNames[color_names_1.default[name_1]] = name_1;
	    }
	}
	exports.get = function (string) {
	    var prefix = string.substring(0, 3).toLowerCase();
	    var val;
	    var model;
	    switch (prefix) {
	        case 'hsl':
	            val = getHsl(string);
	            model = 'hsl';
	            break;
	        case 'hwb':
	            val = getHwb(string);
	            model = 'hwb';
	            break;
	        default:
	            val = getRgb(string);
	            model = 'rgb';
	            break;
	    }
	    if (!val) {
	        return null;
	    }
	    return {
	        model: model,
	        value: val,
	    };
	};
	var getRgb = function (string) {
	    if (!string) {
	        return null;
	    }
	    var abbr = /^#([a-f0-9]{3,4})$/i;
	    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
	    var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d.]+)\s*)?\)$/;
	    var per = /^rgba?\(\s*([+-]?[\d.]+)%\s*,\s*([+-]?[\d.]+)%\s*,\s*([+-]?[\d.]+)%\s*(?:,\s*([+-]?[\d.]+)\s*)?\)$/;
	    var keyword = /(\D+)/;
	    var rgb = [0, 0, 0, 1];
	    var match;
	    var i;
	    var hexAlpha;
	    var hexMatch = string.match(hex);
	    var abbrMatch = string.match(abbr);
	    var rgbaMatch = string.match(rgba);
	    var perMatch = string.match(per);
	    var keywordMatch = string.match(keyword);
	    if (hexMatch) {
	        match = hexMatch;
	        hexAlpha = match[2];
	        match = match[1];
	        for (i = 0; i < 3; i++) {
	            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
	            var i2 = i * 2;
	            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
	        }
	        if (hexAlpha) {
	            rgb[3] = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
	        }
	    }
	    else if (abbrMatch) {
	        match = abbrMatch;
	        match = match[1];
	        hexAlpha = match[3];
	        for (i = 0; i < 3; i++) {
	            rgb[i] = parseInt(match[i] + match[i], 16);
	        }
	        if (hexAlpha) {
	            rgb[3] = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
	        }
	    }
	    else if (rgbaMatch) {
	        match = rgbaMatch;
	        for (i = 0; i < 3; i++) {
	            rgb[i] = parseInt(match[i + 1], 0);
	        }
	        if (match[4]) {
	            rgb[3] = parseFloat(match[4]);
	        }
	    }
	    else if (perMatch) {
	        match = perMatch;
	        for (i = 0; i < 3; i++) {
	            rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	        }
	        if (match[4]) {
	            rgb[3] = parseFloat(match[4]);
	        }
	    }
	    else if (keywordMatch) {
	        match = keywordMatch;
	        if (match[1] === 'transparent') {
	            return [0, 0, 0, 0];
	        }
	        rgb = color_names_1.default[match[1]];
	        if (!rgb) {
	            return null;
	        }
	        rgb[3] = 1;
	        return rgb;
	    }
	    else {
	        return null;
	    }
	    for (i = 0; i < 3; i++) {
	        rgb[i] = clamp(rgb[i], 0, 255);
	    }
	    rgb[3] = clamp(rgb[3], 0, 1);
	    return rgb;
	};
	var getHsl = function (string) {
	    if (!string) {
	        return null;
	    }
	    var hsl = /^hsla?\(\s*([+-]?\d*[.]?\d+)(?:deg)?\s*,\s*([+-]?[\d.]+)%\s*,\s*([+-]?[\d.]+)%\s*(?:,\s*([+-]?[\d.]+)\s*)?\)$/;
	    var match = string.match(hsl);
	    if (match) {
	        var alpha = parseFloat(match[4]);
	        var h = (parseFloat(match[1]) % 360 + 360) % 360;
	        var s = clamp(parseFloat(match[2]), 0, 100);
	        var l = clamp(parseFloat(match[3]), 0, 100);
	        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
	        return [h, s, l, a];
	    }
	    return null;
	};
	var getHwb = function (string) {
	    if (!string) {
	        return null;
	    }
	    var hwb = /^hwb\(\s*([+-]?\d*[.]?\d+)(?:deg)?\s*,\s*([+-]?[\d.]+)%\s*,\s*([+-]?[\d.]+)%\s*(?:,\s*([+-]?[\d.]+)\s*)?\)$/;
	    var match = string.match(hwb);
	    if (match) {
	        var alpha = parseFloat(match[4]);
	        var h = (parseFloat(match[1]) % 360 + 360) % 360;
	        var w = clamp(parseFloat(match[2]), 0, 100);
	        var b = clamp(parseFloat(match[3]), 0, 100);
	        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
	        return [h, w, b, a];
	    }
	    return null;
	};
	exports.to = function (model, rgba) {
	    switch (model) {
	        case 'hex':
	            return ('#' +
	                hexDouble(rgba[0]) +
	                hexDouble(rgba[1]) +
	                hexDouble(rgba[2]) +
	                (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : ''));
	        case 'rgb':
	            return rgba.length < 4 || rgba[3] === 1
	                ? 'rgb(' +
	                    Math.round(rgba[0]) +
	                    ', ' +
	                    Math.round(rgba[1]) +
	                    ', ' +
	                    Math.round(rgba[2]) +
	                    ')'
	                : 'rgba(' +
	                    Math.round(rgba[0]) +
	                    ', ' +
	                    Math.round(rgba[1]) +
	                    ', ' +
	                    Math.round(rgba[2]) +
	                    ', ' +
	                    rgba[3] +
	                    ')';
	        case 'hsl':
	            return rgba.length < 4 || rgba[3] === 1
	                ? 'hsl(' + rgba[0] + ', ' + rgba[1] + '%, ' + rgba[2] + '%)'
	                : 'hsla(' +
	                    rgba[0] +
	                    ', ' +
	                    rgba[1] +
	                    '%, ' +
	                    rgba[2] +
	                    '%, ' +
	                    rgba[3] +
	                    ')';
	        case 'hwb':
	            // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	            // (hwb have alpha optional & 1 is default value)
	            var a = '';
	            if (rgba.length >= 4 && rgba[3] !== 1) {
	                a = ', ' + rgba[3];
	            }
	            return 'hwb(' + rgba[0] + ', ' + rgba[1] + '%, ' + rgba[2] + '%' + a + ')';
	    }
	};
	var clamp = function (num, min, max) { return Math.min(Math.max(min, num), max); };
	var hexDouble = function (num) {
	    var str = num.toString(16).toUpperCase();
	    return str.length < 2 ? '0' + str : str;
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Inverts a mat4
	 *
	 * @param {mat4} out the receiving matrix
	 * @param {mat4} a the source matrix
	 * @returns {mat4} out
	 */
	function invert(out, a) {
	    var a00 = a[0];
	    var a01 = a[1];
	    var a02 = a[2];
	    var a03 = a[3];
	    var a10 = a[4];
	    var a11 = a[5];
	    var a12 = a[6];
	    var a13 = a[7];
	    var a20 = a[8];
	    var a21 = a[9];
	    var a22 = a[10];
	    var a23 = a[11];
	    var a30 = a[12];
	    var a31 = a[13];
	    var a32 = a[14];
	    var a33 = a[15];
	    var b00 = a00 * a11 - a01 * a10;
	    var b01 = a00 * a12 - a02 * a10;
	    var b02 = a00 * a13 - a03 * a10;
	    var b03 = a01 * a12 - a02 * a11;
	    var b04 = a01 * a13 - a03 * a11;
	    var b05 = a02 * a13 - a03 * a12;
	    var b06 = a20 * a31 - a21 * a30;
	    var b07 = a20 * a32 - a22 * a30;
	    var b08 = a20 * a33 - a23 * a30;
	    var b09 = a21 * a32 - a22 * a31;
	    var b10 = a21 * a33 - a23 * a31;
	    var b11 = a22 * a33 - a23 * a32;
	    // Calculate the determinant
	    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	    if (!det) {
	        return null;
	    }
	    det = 1.0 / det;
	    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
	    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
	    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
	    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
	    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
	    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
	    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
	    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
	    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
	    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
	    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
	    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
	    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
	    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
	    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
	    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
	    return out;
	}
	exports.default = invert;
	//# sourceMappingURL=invert.js.map

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.ease = internal_1.cubicBezier(.25, .1, .25, .1);
	//# sourceMappingURL=ease.js.map

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeIn = internal_1.cubicBezier(.42, 0, 1, 1);
	//# sourceMappingURL=easeIn.js.map

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInBack = function (x) { return internal_1.c3 * x * x * x - internal_1.c1 * x * x; };
	//# sourceMappingURL=easeInBack.js.map

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var easeOutBounce_1 = __webpack_require__(32);
	exports.easeInBounce = function (x) { return 1 - easeOutBounce_1.easeOutBounce(1 - x); };
	//# sourceMappingURL=easeInBounce.js.map

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInCirc = function (x) { return 1 - internal_1.sqrt(1 - (x * x)); };
	//# sourceMappingURL=easeInCirc.js.map

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.easeInCubic = function (x) { return x * x * x; };
	//# sourceMappingURL=easeInCubic.js.map

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInElastic = function (n) {
	    return !n || n === 1 ? n : -1 * internal_1.sin((n - 1.1) * internal_1.tau * 2.5) * internal_1.pow(2, 10 * (n - 1));
	};
	//# sourceMappingURL=easeInElastic.js.map

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInExpo = function (x) { return x === 0 ? 0 : internal_1.pow(2, 10 * x - 10); };
	//# sourceMappingURL=easeInExpo.js.map

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInOut = internal_1.cubicBezier(.42, 0, .58, 1);
	//# sourceMappingURL=easeInOut.js.map

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInOutBack = function (x) { return x < 0.5
	    ? (internal_1.pow(2 * x, 2) * ((internal_1.c2 + 1) * 2 * x - internal_1.c2)) / 2
	    : (internal_1.pow(2 * x - 2, 2) * ((internal_1.c2 + 1) * (x * 2 - 2) + internal_1.c2) + 2) / 2; };
	//# sourceMappingURL=easeInOutBack.js.map

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var easeOutBounce_1 = __webpack_require__(32);
	exports.easeInOutBounce = function (x) { return x < 0.5
	    ? (1 - easeOutBounce_1.easeOutBounce(1 - 2 * x)) / 2
	    : (1 + easeOutBounce_1.easeOutBounce(2 * x - 1)) / 2; };
	//# sourceMappingURL=easeInOutBounce.js.map

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInOutCirc = function (x) { return x < 0.5
	    ? (1 - internal_1.sqrt(1 - internal_1.pow(2 * x, 2))) / 2
	    : (internal_1.sqrt(1 - internal_1.pow(-2 * x + 2, 2)) + 1) / 2; };
	//# sourceMappingURL=easeInOutCirc.js.map

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInOutCubic = function (x) { return x < 0.5
	    ? 4 * x * x * x
	    : 1 - internal_1.pow(-2 * x + 2, 3) / 2; };
	//# sourceMappingURL=easeInOutCubic.js.map

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInOutElastic = function (n) {
	    if (!n || n === 1) {
	        return n;
	    }
	    n *= 2;
	    if (n < 1) {
	        return -0.5 * (internal_1.pow(2, 10 * (n - 1)) * internal_1.sin((n - 1.1) * internal_1.tau / .4));
	    }
	    return internal_1.pow(2, -10 * (n - 1)) * internal_1.sin((n - 1.1) * internal_1.tau / .4) * .5 + 1;
	};
	//# sourceMappingURL=easeInOutElastic.js.map

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInOutExpo = function (x) { return x === 0
	    ? 0 : x === 1
	    ? 1 : x < 0.5
	    ? internal_1.pow(2, 20 * x - 10) / 2
	    : (2 - internal_1.pow(2, -20 * x + 10)) / 2; };
	//# sourceMappingURL=easeInOutExpo.js.map

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInOutQuad = function (x) { return x < 0.5 ? 2 * x * x : 1 - internal_1.pow(-2 * x + 2, 2) / 2; };
	//# sourceMappingURL=easeInOutQuad.js.map

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInOutQuart = function (x) { return x < 0.5
	    ? 8 * x * x * x * x
	    : 1 - internal_1.pow(-2 * x + 2, 4) / 2; };
	//# sourceMappingURL=easeInOutQuart.js.map

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInOutQuint = function (x) { return x < 0.5
	    ? 16 * x * x * x * x * x
	    : 1 - internal_1.pow(-2 * x + 2, 5) / 2; };
	//# sourceMappingURL=easeInOutQuint.js.map

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInOutSine = function (x) { return -(internal_1.cos(internal_1.pi * x) - 1) / 2; };
	//# sourceMappingURL=easeInOutSine.js.map

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.easeInQuad = function (x) { return x * x; };
	//# sourceMappingURL=easeInQuad.js.map

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.easeInQuart = function (x) { return x * x * x * x; };
	//# sourceMappingURL=easeInQuart.js.map

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.easeInQuint = function (x) { return x * x * x * x * x; };
	//# sourceMappingURL=easeInQuint.js.map

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeInSine = function (x) { return 1 - internal_1.cos(x * internal_1.pi / 2); };
	//# sourceMappingURL=easeInSine.js.map

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeOut = internal_1.cubicBezier(0, 0, .58, 1);
	//# sourceMappingURL=easeOut.js.map

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeOutBack = function (x) { return 1 + internal_1.c3 * internal_1.pow(x - 1, 3) + internal_1.c1 * internal_1.pow(x - 1, 2); };
	//# sourceMappingURL=easeOutBack.js.map

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeOutCirc = function (x) { return internal_1.sqrt(1 - ((x - 1) * (x - 1))); };
	//# sourceMappingURL=easeOutCirc.js.map

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeOutCubic = function (x) { return 1 - internal_1.pow(1 - x, 3); };
	//# sourceMappingURL=easeOutCubic.js.map

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeOutElastic = function (n) {
	    if (!n || n === 1) {
	        return n;
	    }
	    var s, a = 0.1, p = 0.4;
	    if (!a || a < 1) {
	        a = 1;
	        s = p / 4;
	    }
	    else {
	        s = p * Math.asin(1 / a) / internal_1.tau;
	    }
	    return (a * internal_1.pow(2, -10 * n) * internal_1.sin((n - s) * (internal_1.tau) / p) + 1);
	};
	//# sourceMappingURL=easeOutElastic.js.map

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeOutExpo = function (x) { return x === 1 ? 1 : 1 - internal_1.pow(2, -10 * x); };
	//# sourceMappingURL=easeOutExpo.js.map

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.easeOutQuad = function (x) { return 1 - (1 - x) * (1 - x); };
	//# sourceMappingURL=easeOutQuad.js.map

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeOutQuart = function (x) { return 1 - internal_1.pow(1 - x, 4); };
	//# sourceMappingURL=easeOutQuart.js.map

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeOutQuint = function (x) { return 1 - internal_1.pow(1 - x, 5); };
	//# sourceMappingURL=easeOutQuint.js.map

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.easeOutSine = function (x) { return internal_1.sin(x * internal_1.pi / 2); };
	//# sourceMappingURL=easeOutSine.js.map

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(162));
	__export(__webpack_require__(163));
	__export(__webpack_require__(164));
	__export(__webpack_require__(165));
	__export(__webpack_require__(166));
	__export(__webpack_require__(167));
	__export(__webpack_require__(168));
	__export(__webpack_require__(169));
	__export(__webpack_require__(170));
	__export(__webpack_require__(171));
	__export(__webpack_require__(172));
	__export(__webpack_require__(173));
	__export(__webpack_require__(174));
	__export(__webpack_require__(175));
	__export(__webpack_require__(176));
	__export(__webpack_require__(177));
	__export(__webpack_require__(178));
	__export(__webpack_require__(179));
	__export(__webpack_require__(180));
	__export(__webpack_require__(181));
	__export(__webpack_require__(182));
	__export(__webpack_require__(183));
	__export(__webpack_require__(184));
	__export(__webpack_require__(185));
	__export(__webpack_require__(186));
	__export(__webpack_require__(32));
	__export(__webpack_require__(187));
	__export(__webpack_require__(188));
	__export(__webpack_require__(189));
	__export(__webpack_require__(190));
	__export(__webpack_require__(191));
	__export(__webpack_require__(192));
	__export(__webpack_require__(193));
	__export(__webpack_require__(194));
	__export(__webpack_require__(196));
	__export(__webpack_require__(197));
	__export(__webpack_require__(198));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Animations change at a constant speed
	 */
	exports.linear = function (x) { return x; };
	//# sourceMappingURL=linear.js.map

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.stepEnd = internal_1.steps(1, 0);
	//# sourceMappingURL=stepEnd.js.map

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var internal_1 = __webpack_require__(1);
	exports.stepStart = internal_1.steps(1, 1);
	//# sourceMappingURL=stepStart.js.map

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var css = __webpack_require__(68);
	exports.css = css;
	var curves = __webpack_require__(195);
	var internal_1 = __webpack_require__(1);
	exports.cubicBezier = internal_1.cubicBezier;
	exports.frames = internal_1.frames;
	exports.steps = internal_1.steps;
	exports.default = curves;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var math_1 = __webpack_require__(33);
	var constants_1 = __webpack_require__(67);
	var bezier = function (n1, n2, t) {
	    return 3 * n1 * (1 - t) * (1 - t) * t + 3 * n2 * (1 - t) * t * t + t * t * t;
	};
	exports.cubicBezier = function (p0, p1, p2, p3) {
	    if (p0 < 0 || p0 > 1 || p2 < 0 || p2 > 1) {
	        return function (x) { return x; };
	    }
	    return function (x) {
	        if (x === 0 || x === 1) {
	            return x;
	        }
	        var start = 0;
	        var end = 1;
	        var limit = 19;
	        do {
	            var mid = (start + end) * .5;
	            var xEst = bezier(p0, p2, mid);
	            if (math_1.abs(x - xEst) < constants_1.epsilon) {
	                return bezier(p1, p3, mid);
	            }
	            if (xEst < x) {
	                start = mid;
	            }
	            else {
	                end = mid;
	            }
	        } while (--limit);
	        // limit is reached
	        return x;
	    };
	};
	//# sourceMappingURL=cubicBezier.js.map

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var math_1 = __webpack_require__(33);
	exports.frames = function (n) {
	    var q = 1 / (n - 1);
	    return function (x) {
	        var o = math_1.floor(x * n) * q;
	        return x >= 0 && o < 0 ? 0 : x <= 1 && o > 1 ? 1 : o;
	    };
	};
	//# sourceMappingURL=frames.js.map

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) justanimate
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.steps = function (count, pos) {
	    var q = count / 1;
	    var p = pos === 'end'
	        ? 0 : pos === 'start'
	        ? 1 : pos || 0;
	    return function (x) { return x >= 1 ? 1 : (p * q + x) - (p * q + x) % q; };
	};
	//# sourceMappingURL=steps.js.map

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Note: Only the source of
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/css/transformstylepreserve3d.js
	 *
	 * The MIT License
	 *
	 * Copyright (c) 2016 Modernizr
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function hasPreserve3d(window) {
	    if (!window) {
	        return false;
	    }
	    if (!window.document) {
	        return false;
	    }
	    var outerAnchor;
	    var innerAnchor;
	    var CSS = window.CSS;
	    var result = false;
	    var tmp;
	    if (CSS && CSS.supports && CSS.supports('(transform-style: preserve-3d)')) {
	        return true;
	    }
	    outerAnchor = window.document.createElement('a');
	    innerAnchor = window.document.createElement('a');
	    outerAnchor.style.cssText =
	        'display: block; transform-style: preserve-3d; transform-origin: right; transform: rotateY(40deg);';
	    innerAnchor.style.cssText =
	        'display: block; width: 9px; height: 1px; background: #000; transform-origin: right; transform: rotateY(40deg);';
	    outerAnchor.appendChild(innerAnchor);
	    window.document.documentElement.appendChild(outerAnchor);
	    tmp = innerAnchor.getBoundingClientRect();
	    window.document.documentElement.removeChild(outerAnchor);
	    result = tmp.width && tmp.width < 4;
	    return result;
	}
	exports.default = {
	    hasPreserve3d: hasPreserve3d,
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	/**
	 * The MIT License
	 *
	 * Copyright (c) 2013 Braveg1rl
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable */
	// Generated by CoffeeScript 1.7.1
	var getNanoSeconds, hrtime, loadTime;
	var invoke;
	if (typeof performance !== 'undefined' &&
	    performance !== null &&
	    performance.now) {
	    invoke = function () {
	        return performance.now();
	    };
	}
	else if (typeof process !== 'undefined' &&
	    process !== null &&
	    process.hrtime) {
	    invoke = function () {
	        return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function () {
	        var hr;
	        hr = hrtime();
	        return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	}
	else if (Date.now) {
	    invoke = function () {
	        return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	}
	else {
	    invoke = function () {
	        return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	}
	function now() {
	    return invoke();
	}
	exports.default = now;
	//# sourceMappingURL=index.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)))

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	/* tslint:disable */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The MIT License
	 *
	 * Copyright (c) 2017 Chris Dickinson
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
	 * software and associated documentation files (the "Software"), to deal in the Software
	 * without restriction, including without limitation the rights to use, copy, modify, merge,
	 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all copies
	 * or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
	 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
	 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	 * OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	var performance_now_1 = __webpack_require__(204);
	var root = typeof window === 'undefined' ? global : window;
	var vendors = ['moz', 'webkit'];
	var suffix = 'AnimationFrame';
	var raf;
	var caf;
	if (typeof window !== 'undefined') {
	    raf = window['request' + suffix];
	    caf = window['cancel' + suffix] || window['cancelRequest' + suffix];
	    for (var i = 0; !raf && i < vendors.length; i++) {
	        raf = window[vendors[i] + 'Request' + suffix];
	        caf =
	            window[vendors[i] + 'Cancel' + suffix] ||
	                window[vendors[i] + 'CancelRequest' + suffix];
	    }
	    // Some versions of FF have rAF but not cAF
	    if (!raf || !caf) {
	        var last_1 = 0, id_1 = 0, queue_1 = [], frameDuration_1 = 1000 / 60;
	        raf = function (callback) {
	            if (queue_1.length === 0) {
	                var _now = performance_now_1.default(), next = Math.max(0, frameDuration_1 - (_now - last_1));
	                last_1 = next + _now;
	                setTimeout(function () {
	                    var cp = queue_1.slice(0);
	                    // Clear queue here to prevent
	                    // callbacks from appending listeners
	                    // to the current frame's queue
	                    queue_1.length = 0;
	                    for (var i = 0; i < cp.length; i++) {
	                        if (!cp[i].cancelled) {
	                            try {
	                                cp[i].callback(last_1);
	                            }
	                            catch (e) {
	                                setTimeout(function () {
	                                    throw e;
	                                }, 0);
	                            }
	                        }
	                    }
	                }, Math.round(next));
	            }
	            queue_1.push({
	                handle: ++id_1,
	                callback: callback,
	                cancelled: false,
	            });
	            return id_1;
	        };
	        caf = function (handle) {
	            for (var i = 0; i < queue_1.length; i++) {
	                if (queue_1[i].handle === handle) {
	                    queue_1[i].cancelled = true;
	                }
	            }
	        };
	    }
	}
	else {
	    // Turn raf and caf into noops outside of the web.
	    // This should help with leaked handles/isomorphic rendering.
	    raf = caf = function () { };
	}
	function rafCall(fn) {
	    // Wrap in a new function to prevent
	    // `cancel` potentially being assigned
	    // to the native rAF function
	    return raf.call(root, fn);
	}
	function cafCall() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return caf.apply(root, args);
	}
	exports.default = {
	    request: rafCall,
	    cancel: cafCall,
	};
	//# sourceMappingURL=index.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * https://github.com/Pomax/svg-to-something
	 *
	 * This code is in the public domain, except in jurisdictions that do
	 * not recognise the public domain, where this code is MIT licensed.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Normalise an SVG path to absolute coordinates
	 * and full commands, rather than relative coordinates
	 * and/or shortcut commands.
	 */
	exports.normalizePath = function (d) {
	    // preprocess "d" so that we have spaces between values
	    // tslint:disable-next-line:no-parameter-reassignment
	    d = d.replace(/,/g, ' ') // replace commas with spaces
	        .replace(/-/g, ' - ') // add spacing around minus signs
	        .replace(/-\s+/g, '-') // remove spacing to the right of minus signs.
	        .replace(/([a-zA-Z])/g, ' $1 ');
	    // set up the variables used in this function
	    var instructions = d.replace(/([a-zA-Z])\s?/g, '|$1').split('|');
	    var instructionLength = instructions.length;
	    var i;
	    var instruction;
	    var op;
	    var lop;
	    var args = [];
	    var alen;
	    var a;
	    var sx = 0;
	    var sy = 0;
	    var x = 0;
	    var y = 0;
	    var cx = 0;
	    var cy = 0;
	    var cx2 = 0;
	    var cy2 = 0;
	    var normalized = '';
	    // we run through the instruction list starting at 1, not 0,
	    // because we split up "|M x y ...." so the first element will
	    // always be an empty string. By design.
	    for (i = 1; i < instructionLength; i++) {
	        // which instruction is this?
	        instruction = instructions[i];
	        op = instruction.substring(0, 1);
	        lop = op.toLowerCase();
	        // what are the arguments? note that we need to convert
	        // all strings into numbers, or + will do silly things.
	        args = instruction.replace(op, '').trim().split(' ');
	        args = args.filter(function (v) { return (v !== ''); }).map(parseFloat);
	        alen = args.length;
	        // we could use a switch, but elaborate code in a "case" with
	        // fallthrough is just horrid to read. So let's use ifthen
	        // statements instead.
	        // moveto command (plus possible lineto)
	        if (lop === 'm') {
	            normalized += 'M ';
	            if (op === 'm') {
	                x += args[0];
	                y += args[1];
	            }
	            else {
	                x = args[0];
	                y = args[1];
	            }
	            // records start position, for dealing
	            // with the shape close operator ('Z')
	            sx = x;
	            sy = y;
	            normalized += x + ' ' + y + ' ';
	            if (alen > 2) {
	                for (a = 0; a < alen; a += 2) {
	                    if (op === 'm') {
	                        x += args[a];
	                        y += args[a + 1];
	                    }
	                    else {
	                        x = args[a];
	                        y = args[a + 1];
	                    }
	                    normalized += 'L ' + x + ' ' + y + ' ';
	                }
	            }
	            // lineto commands
	        }
	        else if (lop === 'l') {
	            for (a = 0; a < alen; a += 2) {
	                if (op === 'l') {
	                    x += args[a];
	                    y += args[a + 1];
	                }
	                else {
	                    x = args[a];
	                    y = args[a + 1];
	                }
	                normalized += 'L ' + x + ' ' + y + ' ';
	            }
	        }
	        else if (lop === 'h') {
	            for (a = 0; a < alen; a++) {
	                if (op === 'h') {
	                    x += args[a];
	                }
	                else {
	                    x = args[a];
	                }
	                normalized += 'L ' + x + ' ' + y + ' ';
	            }
	        }
	        else if (lop === 'v') {
	            for (a = 0; a < alen; a++) {
	                if (op === 'v') {
	                    y += args[a];
	                }
	                else {
	                    y = args[a];
	                }
	                normalized += 'L ' + x + ' ' + y + ' ';
	            }
	            // quadratic curveto commands
	        }
	        else if (lop === 'q') {
	            for (a = 0; a < alen; a += 4) {
	                if (op === 'q') {
	                    cx = x + args[a];
	                    cy = y + args[a + 1];
	                    x += args[a + 2];
	                    y += args[a + 3];
	                }
	                else {
	                    cx = args[a];
	                    cy = args[a + 1];
	                    x = args[a + 2];
	                    y = args[a + 3];
	                }
	                normalized += 'Q ' + cx + ' ' + cy + ' ' + x + ' ' + y + ' ';
	            }
	        }
	        else if (lop === 't') {
	            for (a = 0; a < alen; a += 2) {
	                // reflect previous cx/cy over x/y
	                cx = x + (x - cx);
	                cy = y + (y - cy);
	                // then get real end point
	                if (op === 't') {
	                    x += args[a];
	                    y += args[a + 1];
	                }
	                else {
	                    x = args[a];
	                    y = args[a + 1];
	                }
	                normalized += 'Q ' + cx + ' ' + cy + ' ' + x + ' ' + y + ' ';
	            }
	        }
	        else if (lop === 'c') {
	            for (a = 0; a < alen; a += 6) {
	                if (op === 'c') {
	                    cx = x + args[a];
	                    cy = y + args[a + 1];
	                    cx2 = x + args[a + 2];
	                    cy2 = y + args[a + 3];
	                    x += args[a + 4];
	                    y += args[a + 5];
	                }
	                else {
	                    cx = args[a];
	                    cy = args[a + 1];
	                    cx2 = args[a + 2];
	                    cy2 = args[a + 3];
	                    x = args[a + 4];
	                    y = args[a + 5];
	                }
	                normalized += 'C ' + cx + ' ' + cy + ' ' + cx2 + ' ' + cy2 + ' ' + x + ' ' + y + ' ';
	            }
	        }
	        else if (lop === 's') {
	            for (a = 0; a < alen; a += 4) {
	                // reflect previous cx2/cy2 over x/y
	                cx = x + (x - cx2);
	                cy = y + (y - cy2);
	                // then get real control and end point
	                if (op === 's') {
	                    cx2 = x + args[a];
	                    cy2 = y + args[a + 1];
	                    x += args[a + 2];
	                    y += args[a + 3];
	                }
	                else {
	                    cx2 = args[a];
	                    cy2 = args[a + 1];
	                    x = args[a + 2];
	                    y = args[a + 3];
	                }
	                normalized += 'C ' + cx + ' ' + cy + ' ' + cx2 + ' ' + cy2 + ' ' + x + ' ' + y + ' ';
	            }
	        }
	        else if (lop === 'z') {
	            normalized += 'Z ';
	            // not unimportant: path closing changes the current x/y coordinate
	            x = sx;
	            y = sy;
	        }
	    }
	    return normalized.trim();
	};
	/**
	 * Reverse an SVG path.
	 * As long as the input path is normalised, this is actually really
	 * simple to do. As all pathing commands are symmetrical, meaning
	 * that they render the same when you reverse the coordinate order,
	 * the grand trick here is to reverse the path (making sure to keep
	 * coordinates ordered pairwise) and shift the operators left by
	 * one or two coordinate pairs depending on the operator:
	 *
	 *   - Z disappears,
	 *   - M becomes Z,
	 *   - L moves to 2 spots earlier (skipping one coordinate),
	 *   - Q moves to 2 spots earlier (skipping one coordinate),
	 *   - C moves to 4 spots earlier (skipping two coordinates),
	 *   - the path start must become M.
	 */
	exports.reverseNormalizedPath = function (normalized) {
	    var terms = normalized.split(' ');
	    var tlen = terms.length;
	    var tlen1 = tlen - 1;
	    var t;
	    var reversed = [];
	    var x;
	    var y;
	    var pair;
	    var pairs;
	    var shift;
	    var matcher = new RegExp('[MLCQZ]', '');
	    for (t = 0; t < tlen; t++) {
	        var term = terms[t];
	        // Is this an operator? If it is, run through its
	        // argument list, which we know is fixed length.
	        if (matcher.test(term)) {
	            // how many coordinate pairs do we need to read,
	            // and by how many pairs should this operator be
	            // shifted left?
	            if (term === 'C') {
	                pairs = 3;
	                shift = 2;
	            }
	            else if (term === 'Q') {
	                pairs = 2;
	                shift = 1;
	            }
	            else if (term === 'L') {
	                pairs = 1;
	                shift = 1;
	            }
	            else if (term === 'M') {
	                pairs = 1;
	                shift = 0;
	            }
	            else /*if (term === 'Z')*/ {
	                reversed.push('M');
	                continue;
	            }
	            // do the argument reading and operator shifting
	            if (pairs === shift) {
	                reversed.push(term);
	            }
	            for (pair = 0; pair < pairs; pair++) {
	                if (pair === shift) {
	                    reversed.push(term);
	                }
	                x = terms[++t];
	                y = terms[++t];
	                reversed.push(y);
	                reversed.push(x);
	            }
	        }
	        else {
	            var pre = terms.slice(Math.max(t - 3, 0), 3).join(' ');
	            var post = terms.slice(t + 1, Math.min(t + 4, tlen1)).join(' ');
	            var range = pre + ' [' + term + '] ' + post;
	            throw new Error(('Error while trying to reverse normalized SVG path, at position ' + t + ' (' + range + ').\n' +
	                'Either the path is not normalised, or it\'s malformed.'));
	        }
	    }
	    // generating the reversed path string involves
	    // running through our transformed terms in reverse.
	    var revstring = '';
	    var rlen1 = reversed.length - 1;
	    var r;
	    for (r = rlen1; r > 0; r--) {
	        revstring += reversed[r] + ' ';
	    }
	    revstring += 'Z';
	    revstring = revstring.replace(/M M/g, 'Z M');
	    return revstring;
	};
	//# sourceMappingURL=SVGPathReversal.js.map

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 *
	 * Internet Systems Consortium license (ISC)
	 *
	 * Copyright (c) 2016 Colin Meinke
	 *
	 * Permission to use, copy, modify, and/or distribute this software for any purpose
	 * with or without fee is hereby granted, provided that the above copyright notice
	 * and this permission notice appear in all copies.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	 * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
	 * FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT,
	 * OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE,
	 * DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
	 * ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var toPath_1 = __webpack_require__(208);
	var toPoints_1 = __webpack_require__(69);
	exports.default = {
	    toPath: toPath_1.default,
	    toPoints: toPoints_1.default,
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 *
	 * Internet Systems Consortium license (ISC)
	 *
	 * Copyright (c) 2016 Colin Meinke
	 *
	 * Permission to use, copy, modify, and/or distribute this software for any purpose
	 * with or without fee is hereby granted, provided that the above copyright notice
	 * and this permission notice appear in all copies.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	 * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
	 * FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT,
	 * OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE,
	 * DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
	 * ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var toPoints_1 = __webpack_require__(69);
	function pointsToD(p) {
	    var d = '';
	    var i = 0;
	    var firstPoint;
	    for (var _i = 0, p_1 = p; _i < p_1.length; _i++) {
	        var point = p_1[_i];
	        var curve = point.curve, moveTo_1 = point.moveTo, x = point.x, y = point.y;
	        var isFirstPoint = i === 0 || moveTo_1;
	        var isLastPoint = i === p.length - 1 || p[i + 1].moveTo;
	        var prevPoint = i === 0 ? null : p[i - 1];
	        if (isFirstPoint) {
	            firstPoint = point;
	            if (!isLastPoint) {
	                d += "M" + x + "," + y;
	            }
	        }
	        else if (curve) {
	            switch (curve.type) {
	                case 'arc':
	                    var _a = point.curve, _b = _a.largeArcFlag, largeArcFlag = _b === void 0 ? 0 : _b, rx = _a.rx, ry = _a.ry, _c = _a.sweepFlag, sweepFlag = _c === void 0 ? 0 : _c, _d = _a.xAxisRotation, xAxisRotation = _d === void 0 ? 0 : _d;
	                    d += "A" + rx + "," + ry + "," + xAxisRotation + "," + largeArcFlag + "," + sweepFlag + "," + x + "," + y;
	                    break;
	                case 'cubic':
	                    var _e = point.curve, cx1 = _e.x1, cy1 = _e.y1, cx2 = _e.x2, cy2 = _e.y2;
	                    d += "C" + cx1 + "," + cy1 + "," + cx2 + "," + cy2 + "," + x + "," + y;
	                    break;
	                case 'quadratic':
	                    var _f = point.curve, qx1 = _f.x1, qy1 = _f.y1;
	                    d += "Q" + qx1 + "," + qy1 + "," + x + "," + y;
	                    break;
	            }
	            if (isLastPoint && x === firstPoint.x && y === firstPoint.y) {
	                d += 'Z';
	            }
	        }
	        else if (isLastPoint && x === firstPoint.x && y === firstPoint.y) {
	            d += 'Z';
	        }
	        else if (x !== prevPoint.x && y !== prevPoint.y) {
	            d += "L" + x + "," + y;
	        }
	        else if (x !== prevPoint.x) {
	            d += "H" + x;
	        }
	        else if (y !== prevPoint.y) {
	            d += "V" + y;
	        }
	        i++;
	    }
	    return d;
	}
	function toPath(s) {
	    var points = Array.isArray(s) ? s : toPoints_1.default(s);
	    return pointsToD(points);
	}
	exports.default = toPath;
	//# sourceMappingURL=toPath.js.map

/***/ }),
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(317),
	    isArguments = __webpack_require__(375),
	    isArray = __webpack_require__(86),
	    isBuffer = __webpack_require__(234),
	    isIndex = __webpack_require__(230),
	    isTypedArray = __webpack_require__(377);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 222 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(226);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(222),
	    isArray = __webpack_require__(86);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(19);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(231);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(222),
	    getPrototype = __webpack_require__(228),
	    getSymbols = __webpack_require__(84),
	    stubArray = __webpack_require__(238);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 231 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 232 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(11),
	    stubFalse = __webpack_require__(379);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)(module)))

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(36),
	    isObject = __webpack_require__(16);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 236 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(221),
	    baseKeysIn = __webpack_require__(314),
	    isArrayLike = __webpack_require__(50);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 238 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	module.exports = {
	  EVENT_END_DELAY: 100,
	  DEFAULT_THROTTLE_RATE: 50
	};


/***/ }),
/* 245 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	/* global navigator, parseFloat */
	'use strict';
	
	var leIE8 = false; // less then or equal to IE8
	
	if (typeof navigator !== 'undefined') {
	    var matches = navigator.userAgent.match(/MSIE (\d+\.\d+)/);
	    if (matches) {
	        leIE8 = parseFloat(matches[1], 10) < 9;
	    }
	}
	
	module.exports = leIE8;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	var _assign = __webpack_require__(371);
	var globalVars = __webpack_require__(39);
	
	var defaultEventOption = {
	    capture: false,
	    passive: false
	};
	
	/**
	 * Cross-browser addEventListener.
	 * @method listen
	 * @param {Object} target - The target to add event listener.
	 * @param {String} eventType - The event type.
	 * @param {Function} handler - The event handler.
	 * @param {Object} handler - The options object that specifies characteristics about the event listener.
	 * @return {Object} The object to be able to remove the handler.
	 */
	function listen(target, eventType, handler, options) {
	    var add = 'addEventListener';
	    var _remove = 'removeEventListener';
	    var eventOptions = globalVars.supportPassiveEvent ? _assign({}, defaultEventOption, options) : false;
	
	    if (!target.addEventListener && target.attachEvent) {
	        add = 'attachEvent';
	        _remove = 'detachEvent';
	        eventType = 'on' + eventType;
	    }
	    target[add](eventType, handler, eventOptions);
	
	    return {
	        remove: function remove() {
	            target[_remove](eventType, handler);
	        }
	    };
	}
	
	module.exports = listen;


/***/ }),
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @api private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {Mixed} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Boolean} exists Only check if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {Mixed} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	         listeners.fn === fn
	      && (!once || listeners.once)
	      && (!context || listeners.context === context)
	    ) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	           listeners[i].fn !== fn
	        || (once && !listeners[i].once)
	        || (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {String|Symbol} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ }),
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(19),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(336),
	    hashDelete = __webpack_require__(337),
	    hashGet = __webpack_require__(338),
	    hashHas = __webpack_require__(339),
	    hashSet = __webpack_require__(340);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(352),
	    mapCacheDelete = __webpack_require__(353),
	    mapCacheGet = __webpack_require__(354),
	    mapCacheHas = __webpack_require__(355),
	    mapCacheSet = __webpack_require__(356);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(19),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(19),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(45),
	    stackClear = __webpack_require__(366),
	    stackDelete = __webpack_require__(367),
	    stackGet = __webpack_require__(368),
	    stackHas = __webpack_require__(369),
	    stackSet = __webpack_require__(370);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(11);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(19),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 301 */
/***/ (function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ }),
/* 302 */
/***/ (function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ }),
/* 303 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 304 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(37),
	    keys = __webpack_require__(52);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(37),
	    keysIn = __webpack_require__(237);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(298),
	    arrayEach = __webpack_require__(304),
	    assignValue = __webpack_require__(82),
	    baseAssign = __webpack_require__(306),
	    baseAssignIn = __webpack_require__(307),
	    cloneBuffer = __webpack_require__(319),
	    copyArray = __webpack_require__(326),
	    copySymbols = __webpack_require__(327),
	    copySymbolsIn = __webpack_require__(328),
	    getAllKeys = __webpack_require__(331),
	    getAllKeysIn = __webpack_require__(332),
	    getTag = __webpack_require__(334),
	    initCloneArray = __webpack_require__(341),
	    initCloneByTag = __webpack_require__(342),
	    initCloneObject = __webpack_require__(343),
	    isArray = __webpack_require__(86),
	    isBuffer = __webpack_require__(234),
	    isObject = __webpack_require__(16),
	    keys = __webpack_require__(52);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(16);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(36),
	    isObjectLike = __webpack_require__(51);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(235),
	    isMasked = __webpack_require__(346),
	    isObject = __webpack_require__(16),
	    toSource = __webpack_require__(232);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(36),
	    isLength = __webpack_require__(236),
	    isObjectLike = __webpack_require__(51);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(48),
	    nativeKeys = __webpack_require__(358);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(16),
	    isPrototype = __webpack_require__(48),
	    nativeKeysIn = __webpack_require__(359);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(233),
	    overRest = __webpack_require__(362),
	    setToString = __webpack_require__(364);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(373),
	    defineProperty = __webpack_require__(226),
	    identity = __webpack_require__(233);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(11);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)(module)))

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(83);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(301),
	    arrayReduce = __webpack_require__(223),
	    mapToArray = __webpack_require__(357);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(302),
	    arrayReduce = __webpack_require__(223),
	    setToArray = __webpack_require__(363);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(81);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(83);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 326 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(37),
	    getSymbols = __webpack_require__(84);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(37),
	    getSymbolsIn = __webpack_require__(229);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(11);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(315),
	    isIterateeCall = __webpack_require__(344);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(225),
	    getSymbols = __webpack_require__(84),
	    keys = __webpack_require__(52);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(225),
	    getSymbolsIn = __webpack_require__(229),
	    keysIn = __webpack_require__(237);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(81);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(293),
	    Map = __webpack_require__(80),
	    Promise = __webpack_require__(296),
	    Set = __webpack_require__(297),
	    WeakMap = __webpack_require__(300),
	    baseGetTag = __webpack_require__(36),
	    toSource = __webpack_require__(232);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(49);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(49);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(49);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(49);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 341 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(83),
	    cloneDataView = __webpack_require__(320),
	    cloneMap = __webpack_require__(321),
	    cloneRegExp = __webpack_require__(322),
	    cloneSet = __webpack_require__(323),
	    cloneSymbol = __webpack_require__(324),
	    cloneTypedArray = __webpack_require__(325);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(309),
	    getPrototype = __webpack_require__(228),
	    isPrototype = __webpack_require__(48);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(85),
	    isArrayLike = __webpack_require__(50),
	    isIndex = __webpack_require__(230),
	    isObject = __webpack_require__(16);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 345 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(329);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 347 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(46);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(46);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(46);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(46);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(294),
	    ListCache = __webpack_require__(45),
	    Map = __webpack_require__(80);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(47);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(47);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(47);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(47);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 357 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(231);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(227);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)(module)))

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(303);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 363 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(316),
	    shortOut = __webpack_require__(365);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 365 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(45);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 367 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(45),
	    Map = __webpack_require__(80),
	    MapCache = __webpack_require__(295);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(82),
	    copyObject = __webpack_require__(37),
	    createAssigner = __webpack_require__(330),
	    isArrayLike = __webpack_require__(50),
	    isPrototype = __webpack_require__(48),
	    keys = __webpack_require__(52);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(308);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = clone;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(16),
	    now = __webpack_require__(378),
	    toNumber = __webpack_require__(381);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(310),
	    isObjectLike = __webpack_require__(51);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(36),
	    isObjectLike = __webpack_require__(51);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(312),
	    baseUnary = __webpack_require__(318),
	    nodeUtil = __webpack_require__(360);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(11);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 379 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(374),
	    isObject = __webpack_require__(16);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(16),
	    isSymbol = __webpack_require__(376);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75)))

/***/ }),
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(382)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(220);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ }),
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(264);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(426);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(427);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(424);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(93);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(210);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(425);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(209);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(211);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _throttle = __webpack_require__(409);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isEqualArray(a, b) {
	  return a.length === b.length && a.every(function (item, index) {
	    return item === b[index];
	  });
	}
	
	var Scrollspy = function (_React$Component) {
	  (0, _inherits3.default)(Scrollspy, _React$Component);
	  (0, _createClass3.default)(Scrollspy, null, [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        items: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	        currentClassName: _propTypes2.default.string.isRequired,
	        scrolledPastClassName: _propTypes2.default.string,
	        style: _propTypes2.default.object,
	        componentTag: _propTypes2.default.string,
	        offset: _propTypes2.default.number,
	        rootEl: _propTypes2.default.string,
	        onUpdate: _propTypes2.default.func
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        items: [],
	        currentClassName: '',
	        style: {},
	        componentTag: 'ul',
	        offset: 0,
	        onUpdate: function onUpdate() {}
	      };
	    }
	  }]);
	
	  function Scrollspy(props) {
	    (0, _classCallCheck3.default)(this, Scrollspy);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Scrollspy.__proto__ || (0, _getPrototypeOf2.default)(Scrollspy)).call(this, props));
	
	    _this.state = {
	      targetItems: [],
	      inViewState: [],
	      isScrolledPast: []
	
	      // manually bind as ES6 does not apply this
	      // auto binding as React.createClass does
	    };_this._handleSpy = _this._handleSpy.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Scrollspy, [{
	    key: '_initSpyTarget',
	    value: function _initSpyTarget(items) {
	      var targetItems = items.map(function (item) {
	
	        return document.getElementById(item);
	      });
	
	      return targetItems;
	    }
	
	    // https://github.com/makotot/react-scrollspy/pull/45
	
	  }, {
	    key: '_fillArray',
	    value: function _fillArray(array, val) {
	      var newArray = [];
	
	      for (var i = 0, max = array.length; i < max; i++) {
	        newArray[i] = val;
	      }
	
	      return newArray;
	    }
	  }, {
	    key: '_isScrolled',
	    value: function _isScrolled() {
	      return this._getScrollDimension().scrollTop > 0;
	    }
	  }, {
	    key: '_getScrollDimension',
	    value: function _getScrollDimension() {
	      var doc = document;
	      var rootEl = this.props.rootEl;
	
	      var scrollTop = rootEl ? doc.querySelector(rootEl).scrollTop : doc.documentElement.scrollTop || doc.body.parentNode.scrollTop || doc.body.scrollTop;
	      var scrollHeight = rootEl ? doc.querySelector(rootEl).scrollHeight : doc.documentElement.scrollHeight || doc.body.parentNode.scrollHeight || doc.body.scrollHeight;
	
	      return {
	        scrollTop: scrollTop,
	        scrollHeight: scrollHeight
	      };
	    }
	  }, {
	    key: '_getElemsViewState',
	    value: function _getElemsViewState(targets) {
	      var elemsInView = [];
	      var elemsOutView = [];
	      var viewStatusList = [];
	
	      var targetItems = targets ? targets : this.state.targetItems;
	
	      var hasInViewAlready = false;
	
	      for (var i = 0, max = targetItems.length; i < max; i++) {
	        var currentContent = targetItems[i];
	        var isInView = hasInViewAlready ? false : this._isInView(currentContent);
	
	        if (isInView) {
	          hasInViewAlready = true;
	          elemsInView.push(currentContent);
	        } else {
	          elemsOutView.push(currentContent);
	        }
	
	        var isLastItem = i === max - 1;
	        var isScrolled = this._isScrolled();
	
	        // https://github.com/makotot/react-scrollspy/pull/26#issue-167413769
	        var isLastShortItemAtBottom = this._isAtBottom() && this._isInView(currentContent) && !isInView && isLastItem && isScrolled;
	
	        if (isLastShortItemAtBottom) {
	          elemsOutView.pop();
	          elemsOutView.push.apply(elemsOutView, (0, _toConsumableArray3.default)(elemsInView));
	          elemsInView = [currentContent];
	          viewStatusList = this._fillArray(viewStatusList, false);
	          isInView = true;
	        }
	
	        viewStatusList.push(isInView);
	      }
	
	      return {
	        inView: elemsInView,
	        outView: elemsOutView,
	        viewStatusList: viewStatusList,
	        scrolledPast: this.props.scrolledPastClassName && this._getScrolledPast(viewStatusList)
	      };
	    }
	  }, {
	    key: '_isInView',
	    value: function _isInView(el) {
	      if (!el) {
	        return false;
	      }
	
	      var _props = this.props,
	          rootEl = _props.rootEl,
	          offset = _props.offset;
	
	      var rootRect = void 0;
	
	      if (rootEl) {
	        rootRect = document.querySelector(rootEl).getBoundingClientRect();
	      }
	
	      var rect = el.getBoundingClientRect();
	      var winH = rootEl ? rootRect.height : window.innerHeight;
	
	      var _getScrollDimension2 = this._getScrollDimension(),
	          scrollTop = _getScrollDimension2.scrollTop;
	
	      var scrollBottom = scrollTop + winH;
	      var elTop = rootEl ? rect.top + scrollTop - rootRect.top + offset : rect.top + scrollTop + offset;
	      var elBottom = elTop + el.offsetHeight;
	
	      return elTop < scrollBottom && elBottom > scrollTop;
	    }
	  }, {
	    key: '_isAtBottom',
	    value: function _isAtBottom() {
	      var rootEl = this.props.rootEl;
	
	      var _getScrollDimension3 = this._getScrollDimension(),
	          scrollTop = _getScrollDimension3.scrollTop,
	          scrollHeight = _getScrollDimension3.scrollHeight;
	
	      var winH = rootEl ? document.querySelector(rootEl).getBoundingClientRect().height : window.innerHeight;
	      var scrolledToBottom = scrollTop + winH >= scrollHeight;
	
	      return scrolledToBottom;
	    }
	  }, {
	    key: '_getScrolledPast',
	    value: function _getScrolledPast(viewStatusList) {
	      if (!viewStatusList.some(function (item) {
	        return item;
	      })) {
	        return viewStatusList;
	      }
	
	      var hasFoundInView = false;
	
	      var scrolledPastItems = viewStatusList.map(function (item) {
	        if (item && !hasFoundInView) {
	          hasFoundInView = true;
	
	          return false;
	        }
	
	        return !hasFoundInView;
	      });
	
	      return scrolledPastItems;
	    }
	  }, {
	    key: '_spy',
	    value: function _spy(targets) {
	      var _this2 = this;
	
	      var elemensViewState = this._getElemsViewState(targets);
	      var currentStatuses = this.state.inViewState;
	
	      this.setState({
	        inViewState: elemensViewState.viewStatusList,
	        isScrolledPast: elemensViewState.scrolledPast
	      }, function () {
	        _this2._update(currentStatuses);
	      });
	    }
	  }, {
	    key: '_update',
	    value: function _update(prevStatuses) {
	      if (isEqualArray(this.state.inViewState, prevStatuses)) {
	        return;
	      }
	
	      this.props.onUpdate(this.state.targetItems[this.state.inViewState.indexOf(true)]);
	    }
	  }, {
	    key: '_handleSpy',
	    value: function _handleSpy() {
	      (0, _throttle2.default)(this._spy(), 100);
	    }
	  }, {
	    key: '_initFromProps',
	    value: function _initFromProps() {
	      var targetItems = this._initSpyTarget(this.props.items);
	
	      this.setState({
	        targetItems: targetItems
	      });
	
	      this._spy(targetItems);
	    }
	  }, {
	    key: 'offEvent',
	    value: function offEvent() {
	      var el = this.props.rootEl ? document.querySelector(this.props.rootEl) : window;
	
	      el.removeEventListener('scroll', this._handleSpy);
	    }
	  }, {
	    key: 'onEvent',
	    value: function onEvent() {
	      var el = this.props.rootEl ? document.querySelector(this.props.rootEl) : window;
	
	      el.addEventListener('scroll', this._handleSpy);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._initFromProps();
	      this.onEvent();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.offEvent();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this._initFromProps();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var Tag = this.props.componentTag;
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          scrolledPastClassName = _props2.scrolledPastClassName,
	          style = _props2.style;
	
	      var counter = 0;
	      var items = _react2.default.Children.map(children, function (child, idx) {
	        var _classNames;
	
	        if (!child) {
	          return null;
	        }
	
	        var ChildTag = child.type;
	        var isScrolledPast = scrolledPastClassName && _this3.state.isScrolledPast[idx];
	        var childClass = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, '' + child.props.className, child.props.className), (0, _defineProperty3.default)(_classNames, '' + _this3.props.currentClassName, _this3.state.inViewState[idx]), (0, _defineProperty3.default)(_classNames, '' + _this3.props.scrolledPastClassName, isScrolledPast), _classNames));
	
	        return _react2.default.createElement(
	          ChildTag,
	          (0, _extends3.default)({}, child.props, { className: childClass, key: counter++ }),
	          child.props.children
	        );
	      });
	
	      var itemClass = (0, _classnames2.default)((0, _defineProperty3.default)({}, '' + className, className));
	
	      return _react2.default.createElement(
	        Tag,
	        { className: itemClass, style: style },
	        items
	      );
	    }
	  }]);
	  return Scrollspy;
	}(_react2.default.Component);
	
	exports.default = Scrollspy;

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var throttle = function throttle(fn) {
	  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	
	  var last = void 0;
	  var timer = void 0;
	
	  return function () {
	    var now = +new Date();
	    var timePassed = !!last && now < last + threshold;
	
	    if (timePassed) {
	      clearTimeout(timer);
	
	      timer = setTimeout(function () {
	        last = now;
	        fn();
	      }, threshold);
	    } else {
	      last = now;
	      fn();
	    }
	  };
	};
	
	exports.default = throttle;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	/* global window, document */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _subscribeUiEvent = __webpack_require__(419);
	
	var _classnames = __webpack_require__(211);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAddonsShallowCompare = __webpack_require__(387);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	// constants
	var STATUS_ORIGINAL = 0; // The default status, locating at the original position.
	var STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.
	var STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.
	
	var TRANSFORM_PROP = 'transform';
	
	// global variable for all instances
	var doc;
	var docBody;
	var docEl;
	var canEnableTransforms = true; // Use transform by default, so no Sticky on lower-end browser when no Modernizr
	var M;
	var scrollDelta = 0;
	var win;
	var winHeight = -1;
	
	var Sticky = (function (_Component) {
	    _inherits(Sticky, _Component);
	
	    function Sticky(props, context) {
	        _classCallCheck(this, Sticky);
	
	        _get(Object.getPrototypeOf(Sticky.prototype), 'constructor', this).call(this, props, context);
	        this.handleResize = this.handleResize.bind(this);
	        this.handleScroll = this.handleScroll.bind(this);
	        this.handleScrollStart = this.handleScrollStart.bind(this);
	        this.delta = 0;
	        this.stickyTop = 0;
	        this.stickyBottom = 0;
	        this.frozen = false;
	        this.skipNextScrollEvent = false;
	        this.scrollTop = -1;
	
	        this.bottomBoundaryTarget;
	        this.topTarget;
	        this.subscribers;
	
	        this.state = {
	            top: 0, // A top offset from viewport top where Sticky sticks to when scrolling up
	            bottom: 0, // A bottom offset from viewport top where Sticky sticks to when scrolling down
	            width: 0, // Sticky width
	            height: 0, // Sticky height
	            x: 0, // The original x of Sticky
	            y: 0, // The original y of Sticky
	            topBoundary: 0, // The top boundary on document
	            bottomBoundary: Infinity, // The bottom boundary on document
	            status: STATUS_ORIGINAL, // The Sticky status
	            pos: 0, // Real y-axis offset for rendering position-fixed and position-relative
	            activated: false // once browser info is available after mounted, it becomes true to avoid checksum error
	        };
	    }
	
	    _createClass(Sticky, [{
	        key: 'getTargetHeight',
	        value: function getTargetHeight(target) {
	            return target && target.offsetHeight || 0;
	        }
	    }, {
	        key: 'getTopPosition',
	        value: function getTopPosition(top) {
	            // TODO, topTarget is for current layout, may remove
	            // a top argument can be provided to override reading from the props
	            top = top || this.props.top || this.props.topTarget || 0;
	            if (typeof top === 'string') {
	                if (!this.topTarget) {
	                    this.topTarget = doc.querySelector(top);
	                }
	                top = this.getTargetHeight(this.topTarget);
	            }
	            return top;
	        }
	    }, {
	        key: 'getTargetBottom',
	        value: function getTargetBottom(target) {
	            if (!target) {
	                return -1;
	            }
	            var rect = target.getBoundingClientRect();
	            return this.scrollTop + rect.bottom;
	        }
	    }, {
	        key: 'getBottomBoundary',
	        value: function getBottomBoundary(bottomBoundary) {
	            // a bottomBoundary can be provided to avoid reading from the props
	            var boundary = bottomBoundary || this.props.bottomBoundary;
	
	            // TODO, bottomBoundary was an object, depricate it later.
	            if (typeof boundary === 'object') {
	                boundary = boundary.value || boundary.target || 0;
	            }
	
	            if (typeof boundary === 'string') {
	                if (!this.bottomBoundaryTarget) {
	                    this.bottomBoundaryTarget = doc.querySelector(boundary);
	                }
	                boundary = this.getTargetBottom(this.bottomBoundaryTarget);
	            }
	            return boundary && boundary > 0 ? boundary : Infinity;
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            this.setState({
	                status: STATUS_ORIGINAL,
	                pos: 0
	            });
	        }
	    }, {
	        key: 'release',
	        value: function release(pos) {
	            this.setState({
	                status: STATUS_RELEASED,
	                pos: pos - this.state.y
	            });
	        }
	    }, {
	        key: 'fix',
	        value: function fix(pos) {
	            this.setState({
	                status: STATUS_FIXED,
	                pos: pos
	            });
	        }
	
	        /**
	         * Update the initial position, width, and height. It should update whenever children change.
	         * @param {Object} options optional top and bottomBoundary new values
	         */
	    }, {
	        key: 'updateInitialDimension',
	        value: function updateInitialDimension(options) {
	            options = options || {};
	
	            var _refs = this.refs;
	            var outer = _refs.outer;
	            var inner = _refs.inner;
	
	            var outerRect = outer.getBoundingClientRect();
	            var innerRect = inner.getBoundingClientRect();
	
	            var width = outerRect.width || outerRect.right - outerRect.left;
	            var height = innerRect.height || innerRect.bottom - innerRect.top;;
	            var outerY = outerRect.top + this.scrollTop;
	
	            this.setState({
	                top: this.getTopPosition(options.top),
	                bottom: Math.min(this.state.top + height, winHeight),
	                width: width,
	                height: height,
	                x: outerRect.left,
	                y: outerY,
	                bottomBoundary: this.getBottomBoundary(options.bottomBoundary),
	                topBoundary: outerY
	            });
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e, ae) {
	            if (this.props.shouldFreeze()) {
	                return;
	            }
	
	            winHeight = ae.resize.height;
	            this.updateInitialDimension();
	            this.update();
	        }
	    }, {
	        key: 'handleScrollStart',
	        value: function handleScrollStart(e, ae) {
	            this.frozen = this.props.shouldFreeze();
	
	            if (this.frozen) {
	                return;
	            }
	
	            if (this.scrollTop === ae.scroll.top) {
	                // Scroll position hasn't changed,
	                // do nothing
	                this.skipNextScrollEvent = true;
	            } else {
	                this.scrollTop = ae.scroll.top;
	                this.updateInitialDimension();
	            }
	        }
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll(e, ae) {
	            // Scroll doesn't need to be handled
	            if (this.skipNextScrollEvent) {
	                this.skipNextScrollEvent = false;
	                return;
	            }
	
	            scrollDelta = ae.scroll.delta;
	            this.scrollTop = ae.scroll.top;
	            this.update();
	        }
	
	        /**
	         * Update Sticky position.
	         */
	    }, {
	        key: 'update',
	        value: function update() {
	            var disabled = !this.props.enabled || this.state.bottomBoundary - this.state.topBoundary <= this.state.height || this.state.width === 0 && this.state.height === 0;
	
	            if (disabled) {
	                if (this.state.status !== STATUS_ORIGINAL) {
	                    this.reset();
	                }
	                return;
	            }
	
	            var delta = scrollDelta;
	            // "top" and "bottom" are the positions that this.state.top and this.state.bottom project
	            // on document from viewport.
	            var top = this.scrollTop + this.state.top;
	            var bottom = this.scrollTop + this.state.bottom;
	
	            // There are 2 principles to make sure Sticky won't get wrong so much:
	            // 1. Reset Sticky to the original postion when "top" <= topBoundary
	            // 2. Release Sticky to the bottom boundary when "bottom" >= bottomBoundary
	            if (top <= this.state.topBoundary) {
	                // #1
	                this.reset();
	            } else if (bottom >= this.state.bottomBoundary) {
	                // #2
	                this.stickyBottom = this.state.bottomBoundary;
	                this.stickyTop = this.stickyBottom - this.state.height;
	                this.release(this.stickyTop);
	            } else {
	                if (this.state.height > winHeight - this.state.top) {
	                    // In this case, Sticky is higher then viewport minus top offset
	                    switch (this.state.status) {
	                        case STATUS_ORIGINAL:
	                            this.release(this.state.y);
	                            this.stickyTop = this.state.y;
	                            this.stickyBottom = this.stickyTop + this.state.height;
	                        // Commentting out "break" is on purpose, because there is a chance to transit to FIXED
	                        // from ORIGINAL when calling window.scrollTo().
	                        // break;
	                        case STATUS_RELEASED:
	                            // If "top" and "bottom" are inbetween stickyTop and stickyBottom, then Sticky is in
	                            // RELEASE status. Otherwise, it changes to FIXED status, and its bottom sticks to
	                            // viewport bottom when scrolling down, or its top sticks to viewport top when scrolling up.
	                            this.stickyBottom = this.stickyTop + this.state.height;
	                            if (delta > 0 && bottom > this.stickyBottom) {
	                                this.fix(this.state.bottom - this.state.height);
	                            } else if (delta < 0 && top < this.stickyTop) {
	                                this.fix(this.state.top);
	                            }
	                            break;
	                        case STATUS_FIXED:
	                            var toRelease = true;
	                            var pos = this.state.pos;
	                            var height = this.state.height;
	                            // In regular cases, when Sticky is in FIXED status,
	                            // 1. it's top will stick to the screen top,
	                            // 2. it's bottom will stick to the screen bottom,
	                            // 3. if not the cases above, then it's height gets changed
	                            if (delta > 0 && pos === this.state.top) {
	                                // case 1, and scrolling down
	                                this.stickyTop = top - delta;
	                                this.stickyBottom = this.stickyTop + height;
	                            } else if (delta < 0 && pos === this.state.bottom - height) {
	                                // case 2, and scrolling up
	                                this.stickyBottom = bottom - delta;
	                                this.stickyTop = this.stickyBottom - height;
	                            } else if (pos !== this.state.bottom - height && pos !== this.state.top) {
	                                // case 3
	                                // This case only happens when Sticky's bottom sticks to the screen bottom and
	                                // its height gets changed. Sticky should be in RELEASE status and update its
	                                // sticky bottom by calculating how much height it changed.
	                                var deltaHeight = pos + height - this.state.bottom;
	                                this.stickyBottom = bottom - delta + deltaHeight;
	                                this.stickyTop = this.stickyBottom - height;
	                            } else {
	                                toRelease = false;
	                            }
	
	                            if (toRelease) {
	                                this.release(this.stickyTop);
	                            }
	                            break;
	                    }
	                } else {
	                    // In this case, Sticky is shorter then viewport minus top offset
	                    // and will always fix to the top offset of viewport
	                    this.fix(this.state.top);
	                }
	            }
	            this.delta = delta;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.updateInitialDimension(nextProps);
	            this.update();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            var _this = this;
	
	            if (prevState.status !== this.state.status && this.props.onStateChange) {
	                this.props.onStateChange({ status: this.state.status });
	            }
	            // if the props for enabling are toggled, then trigger the update or reset depending on the current props
	            if (prevProps.enabled !== this.props.enabled) {
	                if (this.props.enabled) {
	                    this.setState({ activated: true }, function () {
	                        _this.updateInitialDimension();
	                        _this.update();
	                    });
	                } else {
	                    this.setState({ activated: false }, function () {
	                        _this.reset();
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var subscribers = this.subscribers || [];
	            for (var i = subscribers.length - 1; i >= 0; i--) {
	                this.subscribers[i].unsubscribe();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // Only initialize the globals if this is the first
	            // time this component type has been mounted
	            if (!win) {
	                win = window;
	                doc = document;
	                docEl = doc.documentElement;
	                docBody = doc.body;
	                winHeight = win.innerHeight || docEl.clientHeight;
	                M = window.Modernizr;
	                // No Sticky on lower-end browser when no Modernizr
	                if (M && M.prefixed) {
	                    canEnableTransforms = M.csstransforms3d;
	                    TRANSFORM_PROP = M.prefixed('transform');
	                }
	            }
	
	            // when mount, the scrollTop is not necessary on the top
	            this.scrollTop = docBody.scrollTop + docEl.scrollTop;
	
	            if (this.props.enabled) {
	                this.setState({ activated: true });
	                this.updateInitialDimension();
	                this.update();
	            }
	            // bind the listeners regardless if initially enabled - allows the component to toggle sticky functionality
	            this.subscribers = [(0, _subscribeUiEvent.subscribe)('scrollStart', this.handleScrollStart.bind(this), { useRAF: true }), (0, _subscribeUiEvent.subscribe)('scroll', this.handleScroll.bind(this), { useRAF: true, enableScrollInfo: true }), (0, _subscribeUiEvent.subscribe)('resize', this.handleResize.bind(this), { enableResizeInfo: true })];
	        }
	    }, {
	        key: 'translate',
	        value: function translate(style, pos) {
	            var enableTransforms = canEnableTransforms && this.props.enableTransforms;
	            if (enableTransforms && this.state.activated) {
	                style[TRANSFORM_PROP] = 'translate3d(0,' + pos + 'px,0)';
	            } else {
	                style.top = pos + 'px';
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return !this.props.shouldFreeze() && (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            // TODO, "overflow: auto" prevents collapse, need a good way to get children height
	            var innerStyle = {
	                position: this.state.status === STATUS_FIXED ? 'fixed' : 'relative',
	                top: this.state.status === STATUS_FIXED ? '0px' : '',
	                zIndex: this.props.innerZ
	            };
	            var outerStyle = {};
	
	            // always use translate3d to enhance the performance
	            this.translate(innerStyle, this.state.pos);
	            if (this.state.status !== STATUS_ORIGINAL) {
	                innerStyle.width = this.state.width + 'px';
	                outerStyle.height = this.state.height + 'px';
	            }
	
	            var outerClasses = (0, _classnames2['default'])('sticky-outer-wrapper', this.props.className, (_classNames = {}, _defineProperty(_classNames, this.props.activeClass, this.state.status === STATUS_FIXED), _defineProperty(_classNames, this.props.releasedClass, this.state.status === STATUS_RELEASED), _classNames));
	
	            return _react2['default'].createElement(
	                'div',
	                { ref: 'outer', className: outerClasses, style: outerStyle },
	                _react2['default'].createElement(
	                    'div',
	                    { ref: 'inner', className: 'sticky-inner-wrapper', style: innerStyle },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return Sticky;
	})(_react.Component);
	
	Sticky.displayName = 'Sticky';
	
	Sticky.defaultProps = {
	    shouldFreeze: function shouldFreeze() {
	        return false;
	    },
	    enabled: true,
	    top: 0,
	    bottomBoundary: 0,
	    enableTransforms: true,
	    activeClass: 'active',
	    releasedClass: 'released',
	    onStateChange: null
	};
	
	/**
	 * @param {Bool} enabled A switch to enable or disable Sticky.
	 * @param {String/Number} top A top offset px for Sticky. Could be a selector representing a node
	 *        whose height should serve as the top offset.
	 * @param {String/Number} bottomBoundary A bottom boundary px on document where Sticky will stop.
	 *        Could be a selector representing a node whose bottom should serve as the bottom boudary.
	 */
	Sticky.propTypes = {
	    enabled: _propTypes2['default'].bool,
	    top: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	    bottomBoundary: _propTypes2['default'].oneOfType([_propTypes2['default'].object, // TODO, may remove
	    _propTypes2['default'].string, _propTypes2['default'].number]),
	    enableTransforms: _propTypes2['default'].bool,
	    activeClass: _propTypes2['default'].string,
	    releasedClass: _propTypes2['default'].string,
	    onStateChange: _propTypes2['default'].func,
	    shouldFreeze: _propTypes2['default'].func,
	    innerZ: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])
	};
	
	Sticky.STATUS_ORIGINAL = STATUS_ORIGINAL;
	Sticky.STATUS_RELEASED = STATUS_RELEASED;
	Sticky.STATUS_FIXED = STATUS_FIXED;
	
	module.exports = Sticky;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(410);


/***/ }),
/* 412 */,
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	/* global window, document */
	
	'use strict';
	
	var globalVars = __webpack_require__(39);
	var resize = {
	    width: 0,
	    height: 0
	};
	var scroll = {
	    delta: 0,
	    top: 0
	};
	var touch = {
	    axisIntention: '',
	    startX: 0,
	    startY: 0,
	    deltaX: 0,
	    deltaY: 0
	};
	
	var INTENTION_THRESHOLD = 5;
	
	/**
	 * ArgmentedEvent will hold some global information, such like window scroll postion,
	 * so that those information is only calculated once.
	 * @param {Object} option - The option for SyntheticEvent
	 */
	function ArgmentedEvent(option) {
	    option = option || {};
	    var mainType = (option.mainType || '').toLowerCase();
	    var subType = (option.subType || '').toLowerCase();
	
	    this.mainType = mainType;
	    this.subType = subType;
	    this.type = mainType + subType.charAt(0).toUpperCase() + subType.slice(1) || '';
	    this.scroll = scroll;
	    this.resize = resize;
	    this.touch = touch;
	}
	
	ArgmentedEvent.prototype = {
	    getXY: function getXY(touch) {
	        var t = { x: 0, y: 0 };
	        var docBody = document.body;
	        var docEl = document.documentElement;
	
	        if (touch.pageX || touch.pageY) {
	            t.x = touch.pageX;
	            t.y = touch.pageY;
	        } else {
	            t.x = touch.clientX + docBody.scrollLeft + docEl.scrollLeft;
	            t.y = touch.clientY + docBody.scrollTop + docEl.scrollTop;
	        }
	
	        return t;
	    },
	
	    update: function update(e) {
	        var mainType = this.mainType;
	        var subType = this.subType;
	        var docEl = document.documentElement;
	
	        if (globalVars.enableScrollInfo && (mainType === 'scroll' || mainType === 'touchmove')) {
	            var top = docEl.scrollTop + document.body.scrollTop;
	            // Prevent delta from being 0
	            if (top !== this.scroll.top) {
	                this.scroll.delta = top - this.scroll.top;
	                this.scroll.top = top;
	            }
	        }
	        if (globalVars.enableResizeInfo && mainType === 'resize') {
	            this.resize.width = window.innerWidth || docEl.clientWidth;
	            this.resize.height = window.innerHeight || docEl.clientHeight;
	        }
	        if (globalVars.enableTouchInfo && e.touches && (mainType === 'touchstart' || mainType === 'touchmove' || mainType === 'touchend')) {
	            var pos;
	            var absX;
	            var absY;
	            if (mainType === 'touchstart' || subType === 'start') {
	                pos = this.getXY(e.touches[0]);
	                this.touch.axisIntention = '';
	                this.touch.startX = pos.x;
	                this.touch.startY = pos.y;
	                this.touch.deltaX = 0;
	                this.touch.deltaY = 0;
	            } else if (mainType === 'touchmove') {
	                pos = this.getXY(e.touches[0]);
	                this.touch.deltaX = pos.x - this.touch.startX;
	                this.touch.deltaY = pos.y - this.touch.startY;
	                if (this.touch.axisIntention === '') {
	                    absX = Math.abs(this.touch.deltaX);
	                    absY = Math.abs(this.touch.deltaY);
	                    if (absX > INTENTION_THRESHOLD && absX >= absY) {
	                        this.touch.axisIntention = 'x';
	                    } else if (absY > INTENTION_THRESHOLD && absY > absX) {
	                        this.touch.axisIntention = 'y';
	                    }
	                }
	            }
	        }
	    }
	};
	
	module.exports = ArgmentedEvent;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var rAF = __webpack_require__(386);
	var getTime = Date.now || /* istanbul ignore next */function () {
	    return new Date().getTime();
	};
	function rAFThrottle(func, throttle) {
	    var context;
	    var args;
	    var last = 0;
	    var requestId = 0;
	
	    throttle = throttle || 15;
	
	    var later = function later() {
	        var now = getTime();
	        var remaining = throttle - (now - last);
	
	        if (remaining <= 0) {
	            last = now;
	            requestId = 0;
	            func.apply(context, args);
	        } else {
	            requestId = rAF(later);
	        }
	    };
	
	    return function throttledFunc() {
	        context = this;
	        args = arguments;
	
	        if (!requestId) {
	            requestId = rAF(later);
	        }
	    };
	}
	
	module.exports = rAFThrottle;


/***/ }),
/* 415 */
/***/ (function(module, exports) {

	'use strict';
	
	var passiveSupported = false;
	
	if (typeof window !== 'undefined') {
	  try {
	    var options = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        passiveSupported = true;
	      }
	    });
	
	    window.addEventListener('test', null, options);
	  } catch (err) {}
	}
	
	module.exports = passiveSupported;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	/* global window, document, setTimeout */
	'use strict';
	
	var _clone = __webpack_require__(372);
	var _throttle = __webpack_require__(380);
	var AugmentedEvent = __webpack_require__(413);
	var globalVars = __webpack_require__(39);
	var connections = globalVars.connections;
	var EE = globalVars.EE;
	var leIE8 = __webpack_require__(245);
	var listen = __webpack_require__(246);
	var listeners = globalVars.listeners;
	var rAFThrottle = __webpack_require__(414);
	var removers = globalVars.removers;
	var subscriptions = globalVars.subscriptions;
	
	// constants
	var EVENT_END_DELAY = __webpack_require__(244).EVENT_END_DELAY;
	
	// global variables
	var doc;
	var win;
	var body;
	var hashId = 0;
	
	if (typeof window !== 'undefined') {
	    win = window;
	    doc = win.document || document;
	    body = doc.body;
	}
	
	function getHash(domNode) {
	    return domNode.id || 'target-id-' + hashId++;
	}
	
	/**
	 * Connect a throttled event to a throttled main event, and return an event remover.
	 * The number of connections to a throttled main event will be kept. If all throttled events
	 * are removed, then remove throttled main event.
	 * @method connectThrottle
	 * @param {String} throttledEvent - A throttled event
	 * @param {Function} cb - Callback function
	 * @param {Object} ctx - The "this"
	 * @param {String} throttledMainEvent - A throttled main event
	 * @return {Object} An event remover
	 */
	function connectThrottle(throttledEvent, cb, ctx, throttledMainEvent) {
	    EE.on(throttledEvent, cb, ctx);
	    throttledMainEvent = throttledMainEvent || throttledEvent;
	    connections[throttledMainEvent] = (connections[throttledMainEvent] || 0) + 1;
	    return {
	        _type: throttledEvent,
	        _cb: cb,
	        _ctx: ctx,
	        unsubscribe: function unsubscribe() {
	            if (!this._type) {
	                return;
	            }
	
	            EE.removeListener(throttledEvent, cb, ctx);
	            connections[throttledMainEvent]--;
	            if (connections[throttledMainEvent] === 0) {
	                listeners[throttledMainEvent].remove();
	                listeners[throttledMainEvent] = undefined;
	            }
	
	            this._type = undefined;
	            this._cb = undefined;
	            this._ctx = undefined;
	
	            // remove the remover from removers array
	            for (var i = removers.length - 1; i >= 0; i--) {
	                var remover = removers[i];
	                if (remover === this) {
	                    removers.splice(i, 1);
	                    break;
	                }
	            }
	        }
	    };
	}
	
	/**
	 * Connect to event, event start and event end.
	 * @method connectContinuousEvent
	 * @param {Object} target - The target of a main event, window or document.
	 * @param {String} mainEvent - A browser event, like scroll or resize.
	 * @param {String} event - A subscribe event.
	 * @param {Object} eventOptions - An options pass to event listener
	 */
	function connectContinuousEvent(target, mainEvent, event, eventOptions) {
	    return function throttleEvent(throttleRate, cb, options) {
	        var context = options.context;
	        var domTarget = options.target;
	        var domId = domTarget && getHash(domTarget);
	        var targetPart = domId ? ':' + domId : '';
	
	        var throttledStartEvent = mainEvent + 'Start:' + throttleRate + targetPart;
	        var throttledEndEvent = mainEvent + 'End:' + throttleRate + targetPart;
	        var throttledMainEvent = mainEvent + ':' + throttleRate + targetPart;
	        var throttledEvent = event + ':' + throttleRate + targetPart;
	
	        var remover = connectThrottle(throttledEvent, cb, context, throttledMainEvent);
	        removers.push(remover);
	
	        if (listeners[throttledMainEvent]) {
	            return remover;
	        }
	
	        var ae = {
	            start: new AugmentedEvent({ mainType: mainEvent, subType: 'start' }), // start
	            main: new AugmentedEvent({ mainType: mainEvent }), // main
	            end: new AugmentedEvent({ mainType: mainEvent, subType: 'end' }) };
	
	        // No throttle for throttleRate = 0
	        // end
	        if (throttleRate === 'raf') {
	            throttleRate = 16; // Set as a number for setTimeout later.
	            handler = rAFThrottle(handler);
	        } else if (throttleRate > 0) {
	            handler = _throttle(handler, throttleRate);
	        }
	
	        var timer;
	        function endCallback(e) {
	            ae.end.update(e);
	            EE.emit(throttledEndEvent, e, ae.end);
	            timer = null;
	        }
	        function handler(e) {
	            if (!timer) {
	                ae.start.update(e);
	                EE.emit(throttledStartEvent, e, ae.start);
	            }
	            clearTimeout(timer);
	
	            ae.main.update(e);
	            EE.emit(throttledMainEvent, e, ae.main);
	            if (!leIE8) {
	                timer = setTimeout(endCallback.bind(null, e), throttleRate + EVENT_END_DELAY);
	            } else {
	                // For browser less then and equal to IE8, event object need to be cloned for setTimeout.
	                e = _clone(e);
	                timer = setTimeout(function eventEndDelay() {
	                    endCallback(e);
	                }, throttleRate + EVENT_END_DELAY);
	            }
	        }
	
	        listeners[throttledMainEvent] = listen(domTarget || target, mainEvent, handler, eventOptions);
	        return remover;
	    };
	}
	
	function connectDiscreteEvent(target, event) {
	    return function throttleEvent(throttleRate, cb, options) {
	        var context = options.context;
	        var domTarget = options.target;
	        var domId = domTarget && getHash(domTarget);
	
	        // no throttling for discrete event
	        var throttledEvent = event + ':0' + (domId ? ':' + domId : '');
	
	        var remover = connectThrottle(throttledEvent, cb, context);
	        removers.push(remover);
	
	        if (listeners[throttledEvent]) {
	            return remover;
	        }
	
	        var ae = new AugmentedEvent({ mainType: event });
	
	        function handler(e) {
	            ae.update(e);
	            EE.emit(throttledEvent, e, ae);
	        }
	
	        listeners[throttledEvent] = listen(domTarget || target, event, handler);
	        return remover;
	    };
	}
	
	module.exports = {
	    scrollStart: connectContinuousEvent(win, 'scroll', 'scrollStart'),
	    scrollEnd: connectContinuousEvent(win, 'scroll', 'scrollEnd'),
	    scroll: connectContinuousEvent(win, 'scroll', 'scroll'),
	    resizeStart: connectContinuousEvent(win, 'resize', 'resizeStart'),
	    resizeEnd: connectContinuousEvent(win, 'resize', 'resizeEnd'),
	    resize: connectContinuousEvent(win, 'resize', 'resize'),
	    visibilitychange: connectDiscreteEvent(doc, 'visibilitychange'),
	    touchmoveStart: connectContinuousEvent(body, 'touchmove', 'touchmoveStart'),
	    touchmoveEnd: connectContinuousEvent(body, 'touchmove', 'touchmoveEnd'),
	    touchmove: connectContinuousEvent(body, 'touchmove', 'touchmove'),
	    touchstart: connectDiscreteEvent(body, 'touchstart'),
	    touchend: connectDiscreteEvent(body, 'touchend')
	};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var globalVars = __webpack_require__(39);
	var leIE8 = __webpack_require__(245); // less then or equal to IE8
	var mainEventConnectors = __webpack_require__(416);
	
	// constants
	var DEFAULT_THROTTLE_RATE = __webpack_require__(244).DEFAULT_THROTTLE_RATE;
	
	/**
	 * Subscribe to UI events.
	 * @method subscribe
	 * @param {String} type - The type of event.
	 * @param {Function} cb - The callback function.
	 * @param {Object} options.context - The caller.
	 * @param {Number} options.throttleRate - The amount of time for throttling.
	 * @param {Boolean} options.useRAF - Use rAF for throttling if true.
	 * @param {Object} options.eventOptions - Option to pass to event listener
	 * @return {Object} The object with unsubscribe function.
	 */
	function subscribe(type, cb, options) {
	    options = options || {};
	
	    var useRAF = options.useRAF || false;
	    var throttleRate = parseInt(options.throttleRate, 10);
	    var eventOptions = options.eventOptions;
	
	    if (isNaN(throttleRate)) {
	        throttleRate = DEFAULT_THROTTLE_RATE;
	    }
	
	    if (useRAF) {
	        throttleRate = 'raf';
	    }
	
	    // turn off throttle if the browser is IE8 or less, because window.event will be reset
	    // when using any delayed function, i.g., setTimeout, or rAF.
	    if (leIE8) {
	        throttleRate = 0;
	    }
	
	    // once those variables enabled, then never disabled.
	    globalVars.enableScrollInfo = globalVars.enableScrollInfo || options.enableScrollInfo || false;
	    globalVars.enableResizeInfo = globalVars.enableResizeInfo || options.enableResizeInfo || false;
	    globalVars.enableTouchInfo = globalVars.enableTouchInfo || options.enableTouchInfo || false;
	
	    return mainEventConnectors[type](throttleRate, cb, options, eventOptions);
	}
	
	module.exports = subscribe;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var removers = __webpack_require__(39).removers;
	
	/**
	 * Unsubscribe to UI events.
	 * @method unsubscribe
	 * @param {String} type - The type of event.
	 * @param {Function} cb - The callback function.
	 */
	function unsubscribe(type, cb, options) {
	    var remover;
	    for (var i = removers.length - 1; i >= 0; i--) {
	        remover = removers[i];
	        if (remover._cb === cb && remover._type.indexOf(type) >= 0) {
	            remover.unsubscribe();
	            removers.splice(i, 1);
	        }
	    }
	}
	
	module.exports = unsubscribe;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	function warn() {
	    if (false) {
	        console.warn('Warning: the function is client-side only, does not work on server side');
	    }
	}
	
	if (typeof window !== 'undefined') {
	    module.exports = {
	        listen: __webpack_require__(246),
	        subscribe: __webpack_require__(417),
	        unsubscribe: __webpack_require__(418)
	    };
	} else {
	    module.exports = {
	        listen: warn,
	        subscribe: warn,
	        unsubscribe: warn
	    };
	}


/***/ }),
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(15);
	module.exports = {
	  metadata: {
	    version: "0.0.1",
	    username: "taylor+taylor@haiku.ai",
	    organization: "taylor",
	    project: "LearnPage",
	    branch: "master",
	    folder: "/Users/taylorpoe/.haiku/projects/taylor/LearnPage",
	    uuid: "cda19af0-c606-42a6-8d4b-27dc22f4ae19",
	    root: "https://cdn.haiku.ai/fcc9dcae-e947-46b4-93c1-3d8124b73118/2052390f1eca947b5c1e3efd709218e226c7eefe/",
	    core: "4.3.5",
	    title: "Arrowdash",
	    type: "haiku",
	    relpath: "code/arrowdash/code.js"
	  },
	  options: {},
	  states: {},
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:Arrowdash-e72cd93e18a71f9b": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "visible",
	        "style.overflowY": "visible",
	        "sizeAbsolute.x": 258.106,
	        "sizeAbsolute.y": 291.943,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:Path-60652c76dc5f9ec8": {
	        "style.overflow": "visible",
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "translation.x": 227.166,
	        "translation.y": 30.133,
	        "rotation.z": 0.646,
	        "sizeAbsolute.x": 19.423049926757812,
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 26.059940338134766,
	        "sizeMode.y": 1,
	        "style.zIndex": 1,
	        opacity: {
	          "0": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "500": { value: 1, edited: true },
	          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "2000": { value: 0, edited: true }
	        }
	      },
	      "haiku:Group-8748b5bb49f93b29": {
	        fill: "#CD3172",
	        fillRule: "nonzero",
	        stroke: "none",
	        strokeWidth: 1,
	        "translation.x": -198.486,
	        "translation.y": -4.067
	      },
	      "haiku:Path-a1d869dd88b4b504": {
	        d:
	          "M199.203541,11.0051858 C197.857265,8.9161277 198.459409,6.13123897 200.548467,4.78496276 C202.637525,3.43868654 205.422414,4.04083025 206.76869,6.12988837 C210.508208,11.9326134 214.020659,17.6818933 217.305962,23.377857 C218.547678,25.5307076 217.809057,28.2825473 215.656206,29.5242629 C213.503356,30.7659786 210.751516,30.0273579 209.5098,27.8745073 C206.299315,22.3082606 202.863922,16.6851106 199.203541,11.0051858 Z"
	      },
	      "haiku:Path-f8f297ce674db868": {
	        "style.overflow": "visible",
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "translation.x": 221.075,
	        "translation.y": 69.626,
	        "rotation.z": 0.646,
	        "sizeAbsolute.x": 17.398025512695312,
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 27.16429901123047,
	        "sizeMode.y": 1,
	        "style.zIndex": 2,
	        opacity: {
	          "0": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "167": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "667": { value: 1, edited: true },
	          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "2000": { value: 0, edited: true }
	        }
	      },
	      "haiku:Group-3132f97d4984760e": {
	        fill: "#CD3172",
	        fillRule: "nonzero",
	        stroke: "none",
	        strokeWidth: 1,
	        "translation.x": -193.414,
	        "translation.y": -43.015
	      },
	      "haiku:Path-79395535d5f4f7c2": {
	        d:
	          "M193.894502,49.5368616 C192.778365,47.3163073 193.673672,44.6113844 195.894226,43.4952472 C198.114781,42.37911 200.819704,43.2744169 201.935841,45.4949711 C205.057716,51.7059403 207.89868,57.8515737 210.458504,63.9320265 C211.422818,66.2225991 210.347672,68.8612057 208.0571,69.8255192 C205.766527,70.7898327 203.12792,69.7146873 202.163607,67.4241146 C199.683188,61.5322751 196.926896,55.5698057 193.894502,49.5368616 Z"
	      },
	      "haiku:Path-93f1f90287353930": {
	        "style.overflow": "visible",
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "translation.x": 209.69,
	        "translation.y": 107.903,
	        "rotation.z": 0.646,
	        "sizeAbsolute.x": 14.419998168945312,
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 28.258346557617188,
	        "sizeMode.y": 1,
	        "style.zIndex": 3,
	        opacity: {
	          "0": { value: 0, edited: true },
	          "333": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "833": { value: 1, edited: true },
	          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "2000": { value: 0, edited: true }
	        }
	      },
	      "haiku:Group-e7a5dbccf52145c1": {
	        fill: "#CD3172",
	        fillRule: "nonzero",
	        stroke: "none",
	        strokeWidth: 1,
	        "translation.x": -183.523,
	        "translation.y": -80.752
	      },
	      "haiku:Path-55118633ca044b3b": {
	        d:
	          "M183.751966,86.6662364 C182.971509,84.3066792 184.251622,81.7611947 186.61118,80.9807378 C188.970737,80.2002809 191.516221,81.4803946 192.296678,83.8399519 C194.490728,90.4732269 196.334347,97.025892 197.827003,103.497925 C198.385526,105.919635 196.875115,108.33559 194.453406,108.894113 C192.031697,109.452636 189.615741,107.942226 189.057218,105.520516 C187.627955,99.3233526 185.859715,93.0385999 183.751966,86.6662364 Z"
	      },
	      "haiku:Path-13bcd8713b5e7674": {
	        "style.overflow": "visible",
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "translation.x": 191.435,
	        "translation.y": 143.347,
	        "rotation.z": 0.646,
	        "sizeAbsolute.x": 10.178497314453125,
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 28.96497344970703,
	        "sizeMode.y": 1,
	        "style.zIndex": 4,
	        opacity: {
	          "0": { value: 0, edited: true },
	          "500": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "1000": { value: 1, edited: true },
	          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "2000": { value: 0, edited: true }
	        }
	      },
	      "haiku:Group-af8c47b2b1abf461": {
	        fill: "#CD3172",
	        fillRule: "nonzero",
	        stroke: "none",
	        strokeWidth: 1,
	        "translation.x": -167.393,
	        "translation.y": -115.851
	      },
	      "haiku:Path-c1c62f321466b7fc": {
	        d:
	          "M167.425388,120.88565 C167.1304,118.417937 168.891741,116.178326 171.359454,115.883338 C173.827167,115.58835 176.066778,117.349692 176.361766,119.817404 C177.190991,126.754267 177.594177,133.592654 177.570641,140.331765 C177.561962,142.817031 175.540219,144.824701 173.054953,144.816022 C170.569687,144.807342 168.562016,142.7856 168.570696,140.300334 C168.592936,133.932256 168.211394,127.460961 167.425388,120.88565 Z"
	      },
	      "haiku:Path-3cdd876549eb0f94": {
	        "style.overflow": "visible",
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "translation.x": 165.22900000000004,
	        "translation.y": 173.343,
	        "rotation.z": 0.646,
	        "sizeAbsolute.x": 13.124710083007812,
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 28.575820922851562,
	        "sizeMode.y": 1,
	        "style.zIndex": 5,
	        opacity: {
	          "0": { value: 0, edited: true },
	          "667": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "1167": { value: 1, edited: true },
	          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "2000": { value: 0, edited: true }
	        }
	      },
	      "haiku:Group-83a4fc5b82362c3b": {
	        fill: "#CD3172",
	        fillRule: "nonzero",
	        stroke: "none",
	        strokeWidth: 1,
	        "translation.x": -139.716,
	        "translation.y": -146.05
	      },
	      "haiku:Path-5dabc8970735ef05": {
	        d:
	          "M143.882345,149.93262 C144.223715,147.470895 146.496072,145.752007 148.957797,146.093377 C151.419522,146.434748 153.13841,148.707105 152.79704,151.16883 C151.848086,158.012027 150.430424,164.742446 148.544275,171.358562 C147.862908,173.748617 145.373029,175.133783 142.982974,174.452417 C140.592919,173.77105 139.207753,171.281171 139.88912,168.891116 C141.660009,162.679301 142.99101,156.360311 143.882345,149.93262 Z"
	      },
	      "haiku:Path-8a9bccbb6044d26b": {
	        "style.overflow": "visible",
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "translation.x": 131.885,
	        "translation.y": 195.149,
	        "rotation.z": 0.646,
	        "sizeAbsolute.x": 18.250587463378906,
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 26.73309326171875,
	        "sizeMode.y": 1,
	        "style.zIndex": 6,
	        opacity: {
	          "0": { value: 0, edited: true },
	          "833": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "1333": { value: 1, edited: true },
	          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "2000": { value: 0, edited: true }
	        }
	      },
	      "haiku:Group-d351e36ff15c214f": {
	        fill: "#CD3172",
	        fillRule: "nonzero",
	        stroke: "none",
	        strokeWidth: 1,
	        "translation.x": -103.809,
	        "translation.y": -168.786
	      },
	      "haiku:Path-fd54228b30350188": {
	        d:
	          "M113.441518,171.470284 C114.444968,169.196584 117.101623,168.166843 119.375323,169.170293 C121.649023,170.173743 122.678764,172.830398 121.675314,175.104098 C118.942415,181.296526 115.770379,187.377788 112.160207,193.347228 C110.874081,195.473846 108.107505,196.155199 105.980888,194.869072 C103.85427,193.582946 103.172917,190.81637 104.459044,188.689752 C107.871507,183.047225 110.865331,177.307621 113.441518,171.470284 Z"
	      },
	      "haiku:Path-9a45b9ee4bf487a8": {
	        "style.overflow": "visible",
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "translation.x": 94.21299999999997,
	        "translation.y": 207.897,
	        "rotation.z": 0.646,
	        "sizeAbsolute.x": 22.019973754882812,
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 24.179794311523438,
	        "sizeMode.y": 1,
	        "style.zIndex": 7,
	        opacity: {
	          "0": { value: 0, edited: true },
	          "1000": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "1500": { value: 1, edited: true },
	          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "2000": { value: 0, edited: true }
	        }
	      },
	      "haiku:Group-7e65fc0f633a7fc1": {
	        fill: "#CD3172",
	        fillRule: "nonzero",
	        stroke: "none",
	        strokeWidth: 1,
	        "translation.x": -64.249,
	        "translation.y": -182.82
	      },
	      "haiku:Path-d11d01bc04da8ac1": {
	        d:
	          "M78.208585,184.568314 C79.7283684,182.601876 82.55451,182.23979 84.5209489,183.759573 C86.4873878,185.279356 86.8494736,188.105498 85.3296902,190.071937 C81.2586172,195.339475 76.8215557,200.512595 72.019107,205.59146 C70.3115752,207.397272 67.463447,207.476944 65.6576345,205.769413 C63.851822,204.061881 63.7721497,201.213753 65.4796814,199.40794 C70.0796047,194.543258 74.3223721,189.596663 78.208585,184.568314 Z"
	      },
	      "haiku:Path-ae4eb18a5cbd508d": {
	        "style.overflow": "visible",
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "translation.x": 54.583,
	        "translation.y": 212.96,
	        "rotation.z": 0.646,
	        "sizeAbsolute.x": 24.411561965942383,
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 21.746826171875,
	        "sizeMode.y": 1,
	        "style.zIndex": 8,
	        opacity: {
	          "0": { value: 0, edited: true },
	          "1167": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "1667": { value: 1, edited: true },
	          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "2000": { value: 0, edited: true }
	        }
	      },
	      "haiku:Group-082c35a5f79d2de7": {
	        fill: "#CD3172",
	        fillRule: "nonzero",
	        stroke: "none",
	        strokeWidth: 1,
	        "translation.x": -23.418,
	        "translation.y": -189.108
	      },
	      "haiku:Path-373b05fb6f412364": {
	        d:
	          "M40.3351287,190.248973 C42.190096,188.594972 45.034677,188.757887 46.6886781,190.612854 C48.3426792,192.467822 48.1797639,195.312403 46.3247966,196.966404 C41.397696,201.359705 36.177006,205.677698 30.6629111,209.920643 C28.6932476,211.436245 25.8678818,211.068155 24.3522798,209.098492 C22.8366778,207.128828 23.2047674,204.303462 25.1744308,202.787861 C30.5187631,198.675544 35.5722676,194.495828 40.3351287,190.248973 Z"
	      },
	      "haiku:Path-11-2e2ccc326e1baecc": {
	        "style.overflow": "visible",
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "translation.x": 33.60900000000001,
	        "translation.y": 216.593,
	        "sizeAbsolute.x": 27.758468627929688,
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 43.424530029296875,
	        "sizeMode.y": 1,
	        "style.zIndex": 9,
	        opacity: {
	          "0": { value: 0, edited: true },
	          "1333": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "2000": { value: 0, edited: true }
	        }
	      },
	      "haiku:Group-2217f927b1e0b723": {
	        fill: "#CD3172",
	        fillRule: "nonzero",
	        stroke: "none",
	        strokeWidth: 1,
	        "translation.x": -0.73,
	        "translation.y": -181.881
	      },
	      "haiku:Path-11-c4a19a0963173cff": {
	        d:
	          "M26.9390993,217.408031 C28.8153728,219.037823 29.0151857,221.88005 27.3853939,223.756324 C25.7556022,225.632597 22.9133747,225.83241 21.0371012,224.202619 L2.27875024,207.908509 C0.369530245,206.250099 0.201397282,203.344544 1.90658322,201.476983 L18.4605574,183.346663 C20.1363178,181.511329 22.9826221,181.38197 24.817956,183.05773 C26.65329,184.73349 26.7826499,187.579795 25.1068895,189.415129 L11.6632489,204.138934 L26.9390993,217.408031 Z"
	      },
	      "haiku:Mano1-8103f561afdd73ef": {
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 285,
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 75,
	        "sizeMode.y": 1,
	        "translation.x": {
	          "0": { edited: true, value: -63.84, curve: "easeInOutQuad" },
	          "1833": { value: -75.718, curve: "easeInOutQuad", edited: true }
	        },
	        "translation.y": {
	          "0": { edited: true, value: 10.334, curve: "easeInOutQuad" },
	          "1833": {
	            value: -74.67952165692964,
	            curve: "easeInOutQuad",
	            edited: true
	          }
	        },
	        "style.zIndex": 10,
	        "origin.x": 0.067,
	        "origin.y": -0.516,
	        "scale.x": 1,
	        "scale.y": 1,
	        "rotation.z": {
	          "0": { value: -0.235, edited: true, curve: "easeInOutQuad" },
	          "1833": { value: 1.116 }
	        }
	      },
	      "haiku:Page-1-c250526c8fa7b2d9": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Artboard-d02bbbfffec2dc50": {
	        "translation.x": -39,
	        "translation.y": -109
	      },
	      "haiku:Mano1-83a1d4013fe6c21f": {
	        "translation.x": 39.438,
	        "translation.y": 107
	      },
	      "haiku:Path-3-fb0432425f07ffff": {
	        d:
	          "M236.789241,17.4 L261.999163,30.6667764 C264.050493,31.7985582 264.60466,33.1983618 263.661663,34.8661872 C262.718666,36.5340126 260.6651,36.7813411 257.500967,35.6081727 C251.142111,32.2321903 245.973066,30.0244031 241.993834,28.984811 C238.014601,27.945219 233.979441,27.7483675 229.888355,28.3942566 C236.566504,30.8932916 241.392927,33.0506018 244.367623,34.8661872 C248.829668,37.5895654 249.086944,37.9298867 252.508178,42.2001082 C255.929411,46.4703297 258.132886,47.8032458 258.839914,49.6749306 C259.546943,51.5466154 259.501,53.3341586 256.855689,53.7090758 C254.210377,54.0839931 252.837531,53.0537013 250.139493,51.0308713 C247.441455,49.0080414 246.5402,46.1265428 244.873525,44.8837552 C243.762407,44.0552302 238.445934,40.1282571 228.924105,33.102836 L226.085386,34.8661872 C235.67538,44.2703523 241.38847,49.7876597 243.224655,51.4181094 C245.978933,53.8637841 248.073037,54.9730498 249.106265,55.7958232 C250.139493,56.6185966 250.433014,58.5102077 249.106265,59.2900028 C247.779516,60.0697979 246.398719,59.7297154 244.873525,59.2900028 C243.856728,58.996861 237.594016,55.191914 226.085386,47.8751616 L210.544413,29.4943636 L236.789241,17.4 Z",
	        fill: "#E99631"
	      },
	      "haiku:Path-2-66309a96afaea21d": {
	        d:
	          "M0.499054691,77 L0.499054691,26.2775233 C114.966576,37.1917821 174.293004,42.6489115 178.478338,42.6489115 C182.663671,42.6489115 187.941801,40.0965589 194.312726,34.9918538 C201.417436,24.9416367 206.704685,18.6281072 210.174472,16.0512654 C211.129513,15.3420028 213.763082,15.0541298 215.143391,14.4473917 C217.555126,13.3872738 221.802879,11.9241889 227.88665,10.0581372 C229.614195,9.35271239 231.333334,9 233.044066,9 C234.754799,9 236.354532,9.35271239 237.843267,10.0581372 C240.776161,11.4297868 242.732099,12.3628127 243.711079,12.8572148 C245.179551,13.5988179 246.345073,13.988021 247.912415,15.14323 C249.479757,16.298439 250.590427,17.8037851 251.490067,18.475758 C252.389707,19.1477309 257.636531,22.9841756 258.192363,24.4673554 C258.748195,25.9505352 258.003926,28.3652562 253.897103,27.8654167 C249.790279,27.3655772 247.285671,24.5463728 245.627276,23.77343 C244.52168,23.2581348 241.92701,22.1919273 237.843267,20.5748075 C235.236812,19.9622846 232.546464,20.1362042 229.772225,21.0965662 C226.997985,22.0569282 223.491626,23.7839139 219.253148,26.2775233 C214.501076,29.8112018 213.131157,32.3921299 215.143391,34.0203076 C217.155626,35.6484853 220.359811,40.2367906 224.755948,47.7852235 C219.845196,53.0474053 215.867391,56.5298765 212.822532,58.2326372 C208.255244,60.7867783 205.570239,60.7294671 199.05721,62.1565976 C192.544181,63.5837281 186.834103,63.7221185 183.135053,63.7221185 C147.390093,65.5737946 86.5114263,69.9997551 0.499054691,77 Z",
	        fill: "#FFE754"
	      },
	      "haiku:Pencil1-3e503f81150fc53b": {
	        "translation.x": 191.978,
	        "translation.y": 47.974,
	        "rotation.x": 3.142,
	        "rotation.z": 3.176,
	        "scale.x": -1,
	        "scale.y": -1,
	        "scale.z": -1
	      },
	      "haiku:Rectangle-c30b16e4c7eb8913": {
	        d:
	          "M35.2955666,-17.3381608 L46.0918819,-17.3302589 L46.1502574,62.3299656 C46.1522001,64.9809317 44.0047423,67.1315391 41.3537762,67.1334818 C41.3514327,67.1334835 41.3490891,67.1334835 41.3467456,67.1334818 L40.150438,67.1326062 C37.5022171,67.1306679 35.3558931,64.9843458 35.3539525,62.3361249 L35.3192022,14.9152996 L35.2955666,-17.3381608 Z",
	        fill: "#212D31",
	        "translation.x": 46.078,
	        "translation.y": -22.532,
	        "rotation.z": 1.134
	      },
	      "haiku:Path-4-d2005f89a2182b83": {
	        d:
	          "M81.1974106,11.9255479 L76.6532951,2.16201042 L87.6935995,0.333474493 C89.9266368,-0.197511259 91.2268562,-0.0943873382 91.5942576,0.642846256 C91.961659,1.38007985 91.4835345,2.38690396 90.1598839,3.66331858 L81.1974106,11.9255479 Z",
	        fill: "#CD3172"
	      },
	      "haiku:Path-2-Copy-4c5f971dff1d9c88": {
	        d:
	          "M214.623924,34.4521427 C217.642275,36.8944092 224.269833,32.627067 225.580766,31.6843698 C226.8917,30.7416726 228.553636,29.1466396 230.925357,27.6379647 C233.297079,26.1292899 233.911964,25.6286175 235.47909,24.8991905 C237.046216,24.1697634 241.465168,22.3567587 244.453848,24.205265 C247.442527,26.0537713 246.253621,30.9093753 243.941409,33.03346 C241.629197,35.1575447 240.14144,36.3123325 234.460584,39.9127207 C230.673347,42.3129795 227.265312,45.0810921 224.23648,48.2170585 C216.026314,37.5825452 212.822129,32.9942399 214.623924,34.4521427 Z",
	        fill: "#FFE754"
	      }
	    },
	    "Mano1-8103f561afdd73ef": {}
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Arrowdash-e72cd93e18a71f9b",
	      "haiku-title": "Arrowdash"
	    },
	    children: [
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Mano1-8103f561afdd73ef",
	          "haiku-title": "mano1",
	          "haiku-source": "designs/LearnPage.sketch.contents/slices/mano1.svg"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-c250526c8fa7b2d9", id: "Page-1" },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "Artboard-d02bbbfffec2dc50",
	                  id: "Artboard"
	                },
	                children: [
	                  {
	                    elementName: "g",
	                    attributes: {
	                      "haiku-id": "Mano1-83a1d4013fe6c21f",
	                      id: "mano1"
	                    },
	                    children: [
	                      {
	                        elementName: "path",
	                        attributes: {
	                          "haiku-id": "Path-3-fb0432425f07ffff",
	                          id: "Path-3"
	                        },
	                        children: []
	                      },
	                      {
	                        elementName: "path",
	                        attributes: {
	                          "haiku-id": "Path-2-66309a96afaea21d",
	                          id: "Path-2"
	                        },
	                        children: []
	                      },
	                      {
	                        elementName: "g",
	                        attributes: {
	                          "haiku-id": "Pencil1-3e503f81150fc53b",
	                          id: "pencil1"
	                        },
	                        children: [
	                          {
	                            elementName: "path",
	                            attributes: {
	                              "haiku-id": "Rectangle-c30b16e4c7eb8913",
	                              id: "Rectangle"
	                            },
	                            children: []
	                          },
	                          {
	                            elementName: "path",
	                            attributes: {
	                              "haiku-id": "Path-4-d2005f89a2182b83",
	                              id: "Path-4"
	                            },
	                            children: []
	                          }
	                        ]
	                      },
	                      {
	                        elementName: "path",
	                        attributes: {
	                          "haiku-id": "Path-2-Copy-4c5f971dff1d9c88",
	                          id: "Path-2-Copy"
	                        },
	                        children: []
	                      }
	                    ]
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Path-11-2e2ccc326e1baecc",
	          "haiku-title": "Path-11",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path-11"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Group-2217f927b1e0b723" },
	            children: [
	              {
	                elementName: "path",
	                attributes: {
	                  "haiku-id": "Path-11-c4a19a0963173cff",
	                  id: "Path-11"
	                },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Path-ae4eb18a5cbd508d",
	          "haiku-title": "Path",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Group-082c35a5f79d2de7" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "Path-373b05fb6f412364", id: "Path" },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Path-9a45b9ee4bf487a8",
	          "haiku-title": "Path",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Group-7e65fc0f633a7fc1" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "Path-d11d01bc04da8ac1", id: "Path" },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Path-8a9bccbb6044d26b",
	          "haiku-title": "Path",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Group-d351e36ff15c214f" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "Path-fd54228b30350188", id: "Path" },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Path-3cdd876549eb0f94",
	          "haiku-title": "Path",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Group-83a4fc5b82362c3b" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "Path-5dabc8970735ef05", id: "Path" },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Path-13bcd8713b5e7674",
	          "haiku-title": "Path",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Group-af8c47b2b1abf461" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "Path-c1c62f321466b7fc", id: "Path" },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Path-93f1f90287353930",
	          "haiku-title": "Path",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Group-e7a5dbccf52145c1" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "Path-55118633ca044b3b", id: "Path" },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Path-f8f297ce674db868",
	          "haiku-title": "Path",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Group-3132f97d4984760e" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "Path-79395535d5f4f7c2", id: "Path" },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Path-60652c76dc5f9ec8",
	          "haiku-title": "Path",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Group-8748b5bb49f93b29" },
	            children: [
	              {
	                elementName: "path",
	                attributes: { "haiku-id": "Path-a1d869dd88b4b504", id: "Path" },
	                children: []
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(15);
	var _code_scribble_code = __webpack_require__(533);
	var _code_zigzag_code = __webpack_require__(534);
	var _code_arrowdash_code = __webpack_require__(529);
	module.exports = {
	  metadata: {
	    version: "0.0.1",
	    username: "taylor+taylor@haiku.ai",
	    organization: "taylor",
	    project: "LearnPage",
	    branch: "master",
	    folder: "/Users/taylorpoe/.haiku/projects/taylor/LearnPage",
	    uuid: "cda19af0-c606-42a6-8d4b-27dc22f4ae19",
	    root: "https://cdn.haiku.ai/fcc9dcae-e947-46b4-93c1-3d8124b73118/2052390f1eca947b5c1e3efd709218e226c7eefe/",
	    core: "4.3.5",
	    title: "Main",
	    type: "haiku",
	    relpath: "code/main/code.js"
	  },
	  options: {},
	  states: {},
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:Main-03757d2ca1026e0a": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "hidden",
	        "style.overflowY": "hidden",
	        "sizeAbsolute.x": 900,
	        "sizeAbsolute.y": 350,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1,
	        "style.backgroundColor": { "0": { value: "#FFB2D1", edited: true } }
	      },
	      "haiku:Learn-c13098b4ca3d36bf": {
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 498,
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 73,
	        "sizeMode.y": 1,
	        "translation.x": 450,
	        "translation.y": 175,
	        "style.zIndex": 4
	      },
	      "haiku:Arrowdash-9546ba400be29339": {
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "sizeAbsolute.y": "auto",
	        "translation.x": 129.053,
	        "translation.y": 145.9715,
	        "origin.x": 0.5,
	        "origin.y": 0.5,
	        "style.zIndex": 1
	      },
	      "haiku:Zigzag-3cc7eba9094ad34e": {
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "sizeAbsolute.y": "auto",
	        "translation.x": 471.89200000000005,
	        "translation.y": 176,
	        "origin.x": 0.5,
	        "origin.y": 0.5,
	        "style.zIndex": 2
	      },
	      "haiku:Scribble-6c92ac9953fe3bcc": {
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeAbsolute.x": "auto",
	        "sizeAbsolute.y": "auto",
	        "translation.x": 710.9819677734375,
	        "translation.y": 233.199,
	        "origin.x": 0.5,
	        "origin.y": 0.5,
	        "style.zIndex": 3
	      },
	      "haiku:Page-1-5e4c8fd190602908": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Artboard-d9352d87e107b4e8": {
	        fill: "#177191",
	        "translation.x": -201,
	        "translation.y": -139
	      },
	      "haiku:Learn-76034be0f6415534": {
	        d:
	          "M201,209.1 L201,142.9 C201,141.9 201.791878,141 202.880711,141 L209.413706,141 C210.403553,141 211.294416,141.9 211.294416,142.9 L211.294416,201.7 L238.119289,201.7 C239.208122,201.7 240,202.6 240,203.6 L240,209.1 C240,210.1 239.208122,211 238.119289,211 L202.880711,211 C201.791878,211 201,210.1 201,209.1 Z M300,209.1 L300,142.9 C300,141.9 300.803653,141 301.908676,141 L342.091324,141 C343.196347,141 344,141.9 344,142.9 L344,148.5 C344,149.5 343.196347,150.4 342.091324,150.4 L310.347032,150.4 L310.347032,170.8 L337.16895,170.8 C338.173516,170.8 339.077626,171.7 339.077626,172.7 L339.077626,178.3 C339.077626,179.4 338.173516,180.2 337.16895,180.2 L310.347032,180.2 L310.347032,201.7 L342.091324,201.7 C343.196347,201.7 344,202.6 344,203.6 L344,209.1 C344,210.1 343.196347,211 342.091324,211 L301.908676,211 C300.803653,211 300,210.1 300,209.1 Z M400.900345,210 C399.400362,210 398.600371,208.7 399.200364,207.4 L429.900023,140.1 C430.20002,139.5 431.10001,139 431.600004,139 L432.599993,139 C433.099988,139 433.999978,139.5 434.299974,140.1 L464.799636,207.4 C465.399629,208.7 464.599638,210 463.099655,210 L456.799725,210 C455.599738,210 454.899746,209.4 454.49975,208.5 L448.299819,194.8 L415.600182,194.8 C413.600204,199.4 411.500228,203.9 409.50025,208.5 C409.200253,209.2 408.400262,210 407.200275,210 L400.900345,210 Z M420,186 L445,186 L432.7,159 L432.2,159 L420,186 Z M524,209.1 L524,142.9 C524,141.9 524.801572,141 525.903733,141 L553.157171,141 C565.180747,141 575,150.5 575,162.4 C575,171.6 568.888016,179.2 560.170923,182.7 L573.897839,208.1 C574.599214,209.4 573.897839,211 572.194499,211 L564.379175,211 C563.577603,211 562.976424,210.5 562.776031,210.1 L549.449902,183.6 L534.320236,183.6 L534.320236,209.1 C534.320236,210.1 533.418468,211 532.416503,211 L525.903733,211 C524.801572,211 524,210.1 524,209.1 Z M535,174 L552.8,174 C559.3,174 565,168.567901 565,161.753086 C565,155.333333 559.3,150 552.8,150 L535,150 L535,174 Z M641,209.1 L641,141.8 C641,140.8 641.898451,140 642.89673,140 L645.392427,140 L688.717728,190.2 C688.717728,190.2 688.817556,190.2 688.817556,190.2 L688.817556,142.9 C688.817556,141.9 689.616179,141 690.714286,141 L697.10327,141 C698.101549,141 699,141.9 699,142.9 L699,210.2 C699,211.2 698.101549,212 697.10327,212 L694.507745,212 L651.182444,160.4 C651.182444,160.4 651.082616,160.4 651.082616,160.4 L651.082616,209.1 C651.082616,210.1 650.283993,211 649.185886,211 L642.89673,211 C641.898451,211 641,210.1 641,209.1 Z"
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: { "haiku-id": "Main-03757d2ca1026e0a", "haiku-title": "Main" },
	    children: [
	      {
	        elementName: _code_scribble_code,
	        attributes: {
	          "haiku-id": "Scribble-6c92ac9953fe3bcc",
	          "haiku-var": "_code_scribble_code",
	          "haiku-title": "Scribble",
	          "haiku-source": "./code/scribble/code.js"
	        },
	        children: []
	      },
	      {
	        elementName: _code_zigzag_code,
	        attributes: {
	          "haiku-id": "Zigzag-3cc7eba9094ad34e",
	          "haiku-var": "_code_zigzag_code",
	          "haiku-title": "Zigzag",
	          "haiku-source": "./code/zigzag/code.js"
	        },
	        children: []
	      },
	      {
	        elementName: _code_arrowdash_code,
	        attributes: {
	          "haiku-id": "Arrowdash-9546ba400be29339",
	          "haiku-var": "_code_arrowdash_code",
	          "haiku-title": "Arrowdash",
	          "haiku-source": "./code/arrowdash/code.js"
	        },
	        children: []
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Learn-c13098b4ca3d36bf",
	          "haiku-title": "Learn",
	          "haiku-source": "designs/LearnPage.sketch.contents/slices/Learn.svg"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-5e4c8fd190602908", id: "Page-1" },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "Artboard-d9352d87e107b4e8",
	                  id: "Artboard"
	                },
	                children: [
	                  {
	                    elementName: "path",
	                    attributes: {
	                      "haiku-id": "Learn-76034be0f6415534",
	                      id: "Learn"
	                    },
	                    children: []
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	var HaikuDOMAdapter = __webpack_require__(76)
	module.exports = HaikuDOMAdapter(__webpack_require__(530))

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(3) // Installed as a peer dependency of '@haiku/core'
	var ReactDOM = __webpack_require__(26) // Installed as a peer dependency of '@haiku/core'
	var HaikuReactAdapter = __webpack_require__(77)
	var HaikuReactComponent = HaikuReactAdapter(__webpack_require__(531))
	if (HaikuReactComponent.default) HaikuReactComponent = HaikuReactComponent.default
	module.exports = HaikuReactComponent

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(15);
	module.exports = {
	  metadata: {
	    version: "0.0.1",
	    username: "taylor+taylor@haiku.ai",
	    organization: "taylor",
	    project: "LearnPage",
	    branch: "master",
	    folder: "/Users/taylorpoe/.haiku/projects/taylor/LearnPage",
	    uuid: "cda19af0-c606-42a6-8d4b-27dc22f4ae19",
	    root: "https://cdn.haiku.ai/fcc9dcae-e947-46b4-93c1-3d8124b73118/2052390f1eca947b5c1e3efd709218e226c7eefe/",
	    core: "4.3.5",
	    title: "Scribble",
	    type: "haiku",
	    relpath: "code/scribble/code.js"
	  },
	  options: {},
	  states: {},
	  eventHandlers: {
	    "haiku:Scribble-faa2b40b6ef909a1": {},
	    "haiku:Hand2-Copy-d9d38a6f939b06b8": {},
	    "haiku:Path-10-5bae576acdfe96d7": {}
	  },
	  timelines: {
	    Default: {
	      "haiku:Hand2-Copy-d01b5a9f402436b5": {
	        "translation.x": 585,
	        "translation.y": 92
	      },
	      "haiku:Hand2-Copy-d9d38a6f939b06b8": {
	        "style.position": "absolute",
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 294,
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 239,
	        "sizeMode.y": 1,
	        "translation.x": {
	          "1633": { value: 410.59, curve: "easeInOutQuad", edited: true },
	          "0": { value: 479.17999999999995, edited: true },
	          "750": { value: 435.18, curve: "easeInOutQuad", edited: true },
	          "900": { value: 454.18, curve: "easeInOutQuad", edited: true },
	          "1383": { value: 392.59, curve: "easeInOutQuad", edited: true },
	          "417": {
	            value: 479.17999999999995,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "2083": { value: 343.14, curve: "easeInOutQuad", edited: true },
	          "2317": { value: 345.14, curve: "easeInOutQuad", edited: true },
	          "2750": { value: 283.18, curve: "easeInOutQuad", edited: true },
	          "3000": { value: 269.14, curve: "easeInOutQuad", edited: true },
	          "3167": { value: 258.1400146484375 }
	        },
	        "translation.y": {
	          "1633": { value: 263, edited: true, curve: "linear" },
	          "0": { value: 143.5, edited: true },
	          "750": { value: 175, edited: true, curve: "linear" },
	          "900": { value: 184, edited: true, curve: "linear" },
	          "1383": { value: 230.5, edited: true, curve: "linear" },
	          "417": { value: 143.5, edited: true, curve: "linear" },
	          "2083": { value: 281.5, edited: true, curve: "linear" },
	          "2317": { value: 314.5, edited: true, curve: "linear" },
	          "2683": { value: 316.5, edited: true, curve: "linear" },
	          "3000": { value: 350, edited: true, curve: "linear" },
	          "3167": { value: 497.4, edited: true }
	        },
	        "style.zIndex": 2,
	        "scale.x": {
	          "0": { value: 1, edited: true },
	          "2917": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "3000": { value: 1.2, edited: true }
	        },
	        "scale.y": {
	          "0": { value: 1, edited: true },
	          "2917": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "3000": { value: 1.2, edited: true }
	        }
	      },
	      "haiku:Path-10-5bae576acdfe96d7": {
	        "style.position": "absolute",
	        "sizeAbsolute.y": 219,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 231,
	        "style.margin": "0",
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "translation.x": 226.73,
	        "translation.y": 143.5,
	        "style.zIndex": 1,
	        opacity: {
	          "0": { value: 1, edited: true },
	          "3167": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "3333": { value: 0, edited: true }
	        }
	      },
	      "haiku:Page-1-f622d71c86e8e69f": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd",
	        strokeLinecap: "round",
	        strokeLinejoin: "round"
	      },
	      "haiku:Path-10-36bfd0ee39801d4d": {
	        d:
	          "M5,214.168586 C9.47530441,197.768109 14.3336474,173.329147 32.2603352,166.707631 C50.1870229,160.086116 67.4564032,193.973336 79.4801236,179.244169 C91.503844,164.515002 69.2200426,147.934605 85.7321776,134.866361 C102.244313,121.798117 127.640132,151.533713 142.530773,138.692514 C157.421414,125.851316 117.979481,106.111842 130.255127,85.7673356 C142.530773,65.4228289 176.426669,65.4228289 187.179389,54.6330381 C197.93211,43.8432472 170.441857,42.6684197 175.369598,29.3126303 C178.654758,20.4087707 195.531559,12.3045606 226,5",
	        stroke: "#CD3172",
	        strokeWidth: 9,
	        fill: "none",
	        strokeDashoffset: {
	          "0": { value: 1100, curve: "linear" },
	          "3000": { value: 1600 }
	        },
	        strokeDasharray: 800
	      },
	      "haiku:Page-1-5189b02adcf1301a": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Artboard-18c16a31eadc32cb": {
	        "translation.x": -586,
	        "translation.y": -110
	      },
	      "haiku:Scribble-faa2b40b6ef909a1": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": "visible",
	        "style.overflowY": "visible",
	        "sizeAbsolute.x": 479.18,
	        "sizeAbsolute.y": 350,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:Hand2-49cd3cfa3f340bfb": {
	        "translation.x": 11.187,
	        "translation.y": 18.042
	      },
	      "haiku:Path-7-f535be7f6eff559c": {
	        d:
	          "M43.070761,22.2517483 L19.3773171,23.5371098 C16.1466243,23.6521348 13.53429,24.1139469 11.5403141,24.922546 C9.5463383,25.731145 7.79327415,27.0395937 6.2811217,28.847892 L0.619722461,37.743024 C-0.679693256,40.2898051 0.0643233443,41.5631957 2.85177226,41.5631957 C5.63922118,41.5631957 7.56528621,41.0154938 8.62996735,39.9200901 C11.5375776,35.7323222 15.2591001,33.0215024 19.7945349,31.7876309 C24.3299697,30.5537593 29.0921118,29.9368235 34.0809612,29.9368235 C29.1114958,31.1706951 25.4701584,32.7378852 23.156949,34.6383939 C20.8437396,36.5389025 18.823377,42.204826 17.0958611,51.6361643 C16.5143886,55.3019181 17.1093564,57.3613513 18.8807646,57.8144642 C20.6521727,58.267577 22.0775675,57.1720984 23.156949,54.5280285 L31.8279532,41.1205843 L48.4343097,39.9200901 L43.070761,22.2517483 Z",
	        fill: "#FFB150"
	      },
	      "haiku:Path-5-fab35352238b65fd": {
	        d:
	          "M283.758623,176.146436 L283.758623,238.958042 C173.565355,161.473222 112.38906,116.922985 100.229739,105.307331 C88.0704177,93.6916759 79.5150559,86.9093111 74.5636533,84.9602361 C63.5724495,80.915726 55.1287733,77.082847 49.2326249,73.4615991 C43.3364765,69.8403511 38.3100944,65.4003005 34.1534786,60.1414472 L39.4883224,39.8551695 C42.2141343,38.5215542 43.5770402,36.203494 43.5770402,32.900989 C43.5770402,27.9472315 42.8391405,27.515133 38.5407431,23.0141272 C35.6751448,20.0134566 32.2735814,17.9892827 28.3360529,16.9416055 C26.6379222,17.9122816 25.0322134,19.0759099 23.5189263,20.4324907 C21.2489956,22.4673618 20.3863868,23.7377954 18.4087315,24.5052667 C16.4310761,25.272738 12.6510849,25.039073 10.2778518,24.1809199 C7.9046188,23.3227668 8.27746016,21.6286276 8.70640553,21.0305591 C9.13535089,20.4324907 11.1463003,19.982757 13.1617126,17.9089251 C15.177125,15.8350931 17.1040959,12.9432974 17.1813753,12.8469149 C20.404532,8.82700584 20.6072294,7.18619047 23.1884374,4.31651297 C25.8315331,1.37803124 25.7028038,0.687112677 28.3360529,0.111821423 C30.0915523,-0.27170608 32.0306942,0.331339528 34.1534786,1.92095825 C36.3854968,2.72404167 39.2542555,4.32357966 42.7597547,6.71957222 C48.0180035,10.3135611 49.9031245,10.9544595 52.691478,11.6457133 C55.4798315,12.3369671 58.3249854,12.3369671 61.5311712,13.8156213 C64.737357,15.2942755 65.4368041,18.6297745 72.620611,34.2491852 C79.8044179,49.8685959 81.3837026,52.4680937 84.4990633,55.7914872 C87.6144239,59.1148808 90.6595484,56.9626805 94.3528447,58.9185871 C98.0461409,60.8744936 97.8216352,63.6601428 120.7514,77.7500242 C136.03791,87.1432784 190.373651,119.942083 283.758623,176.146436 Z",
	        fill: "#FFE754"
	      },
	      "haiku:Path-6-b9eba74649a6a9c5": {
	        d:
	          "M33.9630967,59.9745056 L13.6330939,47.0757842 C11.8737317,45.9676502 10.6963157,44.8834667 10.1008458,43.8232336 C9.505376,42.7630006 9.3181752,41.4174863 9.53924346,39.7866906 C9.91364505,37.6547395 9.75256756,36.1647692 9.05601099,35.3167796 C6.85339893,33.2665231 6.08572192,30.7671808 6.00089686,29.064517 C5.91607181,27.3618532 6.41928098,25.2769175 9.53924346,24.7354073 C11.6192184,24.3744004 13.6198625,25.2654903 15.5411757,27.4086769 C17.8100904,30.0591508 20.3634225,32.5789896 23.2011719,34.9681934 C27.457796,38.551999 28.3879047,39.2788162 32.6723031,40.2024418 C35.5285687,40.8181922 38.3351939,40.338471 41.0921787,38.7632784 L36.8418644,63.4206293 L33.9630967,59.9745056 Z",
	        fill: "#FFE754"
	      },
	      "haiku:Pencil2-18230b8bb090349f": {
	        "translation.x": 73.666,
	        "translation.y": 94.83,
	        "rotation.z": 3.805
	      },
	      "haiku:Rectangle-a3ce5ae58e727258": {
	        d:
	          "M35.2855206,-17.3239136 L46.1037449,-17.3090082 L46.213857,62.4245479 C46.2175179,65.0755122 44.0714546,67.2275111 41.4204903,67.2311721 C41.4160762,67.2311782 41.4116621,67.2311782 41.4072481,67.2311721 L40.1890512,67.2294937 C37.5432568,67.2258483 35.3993231,65.0819214 35.3956692,62.436127 L35.3301046,14.9599238 L35.2855206,-17.3239136 Z",
	        fill: "#212D31",
	        "translation.x": 46.144,
	        "translation.y": -22.524,
	        "rotation.z": 1.134
	      },
	      "haiku:Path-4-d081db2951e171fe": {
	        d:
	          "M81.24931,11.9533464 L76.7022901,2.16705007 L87.7496512,0.334251823 C89.9841158,-0.197971658 91.2851662,-0.0946073553 91.6528025,0.644344732 C92.0204387,1.38329682 91.5420085,2.39246784 90.2175119,3.67185779 L81.24931,11.9533464 Z",
	        fill: "#CD3172"
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Scribble-faa2b40b6ef909a1",
	      "haiku-title": "Scribble"
	    },
	    children: [
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Path-10-5bae576acdfe96d7",
	          "haiku-title": "Path 10",
	          "haiku-source": "designs/LearnPage.sketch.contents/slices/Path 10.svg"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-f622d71c86e8e69f", id: "Page-1" },
	            children: [
	              {
	                elementName: "path",
	                attributes: {
	                  "haiku-id": "Path-10-36bfd0ee39801d4d",
	                  id: "Path-10"
	                },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Hand2-Copy-d9d38a6f939b06b8",
	          "haiku-title": "hand2 copy",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/hand2 copy.svg"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-5189b02adcf1301a", id: "Page-1" },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "Artboard-18c16a31eadc32cb",
	                  id: "Artboard"
	                },
	                children: [
	                  {
	                    elementName: "g",
	                    attributes: {
	                      "haiku-id": "Hand2-Copy-d01b5a9f402436b5",
	                      id: "hand2-copy"
	                    },
	                    children: [
	                      {
	                        elementName: "g",
	                        attributes: {
	                          "haiku-id": "Hand2-49cd3cfa3f340bfb",
	                          id: "hand2"
	                        },
	                        children: [
	                          {
	                            elementName: "path",
	                            attributes: {
	                              "haiku-id": "Path-7-f535be7f6eff559c",
	                              id: "Path-7"
	                            },
	                            children: []
	                          },
	                          {
	                            elementName: "path",
	                            attributes: {
	                              "haiku-id": "Path-5-fab35352238b65fd",
	                              id: "Path-5"
	                            },
	                            children: []
	                          },
	                          {
	                            elementName: "path",
	                            attributes: {
	                              "haiku-id": "Path-6-b9eba74649a6a9c5",
	                              id: "Path-6"
	                            },
	                            children: []
	                          }
	                        ]
	                      },
	                      {
	                        elementName: "g",
	                        attributes: {
	                          "haiku-id": "Pencil2-18230b8bb090349f",
	                          id: "pencil2"
	                        },
	                        children: [
	                          {
	                            elementName: "path",
	                            attributes: {
	                              "haiku-id": "Rectangle-a3ce5ae58e727258",
	                              id: "Rectangle"
	                            },
	                            children: []
	                          },
	                          {
	                            elementName: "path",
	                            attributes: {
	                              "haiku-id": "Path-4-d081db2951e171fe",
	                              id: "Path-4"
	                            },
	                            children: []
	                          }
	                        ]
	                      }
	                    ]
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	var Haiku = __webpack_require__(15);
	module.exports = {
	  metadata: {
	    username: "tina@haiku.ai",
	    uuid: "0ec10928-5d38-48ef-b092-5397182df866",
	    organization: "Tina",
	    project: "LearnPage",
	    branch: "master",
	    folder: "/Users/agustina/.haiku/projects/Tina/LearnPage",
	    version: "0.0.3",
	    root: "https://cdn.haiku.ai/7ccc2013-ef9a-4bd4-bc8c-0eed8a54e5d2/5e5d5bf397e9484a10a7c76d03d78211b8c2fa7f/",
	    core: "4.3.5",
	    title: "Zigzag",
	    type: "haiku",
	    relpath: "code/zigzag/code.js"
	  },
	  options: {},
	  states: {},
	  eventHandlers: {},
	  timelines: {
	    Default: {
	      "haiku:Rectangle-b6882ed2d7651795": {
	        "sizeAbsolute.x": 9,
	        "rotation.z": 0.541,
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "translation.x": {
	          "0": {
	            value: 576.2175043009057,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "500": { value: 556.937, edited: true }
	        },
	        "translation.y": {
	          "0": {
	            value: 72.1992476535478,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "500": { value: 104.103, edited: true }
	        },
	        "style.position": "absolute",
	        "style.overflow": "visible",
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 75,
	        "sizeMode.y": 1,
	        "style.zIndex": 1,
	        "scale.x": 1.021,
	        "scale.y": {
	          "0": { value: 0.006, edited: true, curve: "easeInOutQuad" },
	          "500": { value: 1, curve: "easeInOutQuad", edited: true }
	        },
	        opacity: {
	          "0": { value: 1, edited: true },
	          "2833": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "3000": { value: 0, edited: true }
	        }
	      },
	      "haiku:Rectangle-Copy-3-b6e457f5865961c2": {
	        x: 37.6100213,
	        y: 71.8208402,
	        width: 9,
	        height: 128,
	        rx: 4.5
	      },
	      "haiku:Group-a94a9e23c29874d8": {
	        fill: "#CD3172",
	        stroke: "none",
	        strokeWidth: 1,
	        fillRule: "evenodd",
	        "translation.x": -289.671,
	        "translation.y": 3.039
	      },
	      "haiku:Rectangle-a4bba94ae83341bf": {
	        x: 289.671181,
	        y: -3.03855489,
	        width: 9,
	        height: 75,
	        rx: 4.5
	      },
	      "haiku:Rectangle-Copy-e41acb479d44d8bd": {
	        "style.position": "absolute",
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "translation.x": {
	          "0": {
	            value: 543.9794116828646,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "500": {
	            value: 539.7097469594667,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "1083": { value: 508.029, edited: true }
	        },
	        "translation.y": {
	          "0": {
	            value: 135.9699916833669,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "500": {
	            value: 132.32299666259908,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "1083": { value: 106.873, edited: true }
	        },
	        "rotation.z": 5.393,
	        "sizeAbsolute.x": 9,
	        "style.overflow": "visible",
	        "sizeAbsolute.y": 91,
	        "sizeMode.y": 1,
	        "style.zIndex": 2,
	        "scale.y": {
	          "0": { value: -0.017, edited: true, curve: "easeInOutQuad" },
	          "500": { value: 0.107, edited: true, curve: "easeInOutQuad" },
	          "1083": { value: 1, edited: true }
	        },
	        "scale.x": {
	          "0": { value: -1.002, edited: true, curve: "easeInOutQuad" },
	          "500": { value: 0.969 }
	        },
	        "rotation.x": 3.142,
	        "scale.z": -1,
	        opacity: {
	          "0": { value: 0, edited: true },
	          "500": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "517": { value: 1, edited: true },
	          "2833": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "3000": { value: 0, edited: true }
	        }
	      },
	      "haiku:Group-38e05b604020069d": {
	        fill: "#CD3172",
	        stroke: "none",
	        strokeWidth: 1,
	        fillRule: "evenodd",
	        "translation.x": -240.692,
	        "translation.y": 8.369
	      },
	      "haiku:Rectangle-Copy-bab689546f4f2afe": {
	        x: 240.692083,
	        y: -8.36876538,
	        width: 9,
	        height: 91,
	        rx: 4.5
	      },
	      "haiku:Rectangle-Copy-2-f4da62dbf5b504e1": {
	        "style.position": "absolute",
	        "sizeMode.x": 1,
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "translation.x": {
	          "0": {
	            value: 477.90296108362406,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "1083": {
	            value: 475.99264317059755,
	            curve: "easeInOutQuad",
	            edited: true
	          },
	          "1917": { value: 408.219, edited: true }
	        },
	        "translation.y": {
	          "0": {
	            value: 77.62214398886388,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "1083": {
	            value: 80.57156873831501,
	            curve: "easeInOutQuad",
	            edited: true
	          },
	          "1917": { value: 166.852, edited: true }
	        },
	        "rotation.z": 0.663,
	        "sizeAbsolute.x": 9,
	        "style.overflow": "visible",
	        "sizeAbsolute.y": 227,
	        "sizeMode.y": 1,
	        "style.zIndex": 3,
	        "scale.y": {
	          "0": { value: 0.002, edited: true, curve: "easeInOutQuad" },
	          "1083": { value: 0.033, curve: "easeInOutQuad", edited: true },
	          "1917": { value: 1, edited: true }
	        },
	        "scale.x": {
	          "0": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "1083": { value: 1.07 }
	        },
	        "rotation.x": { "0": { value: 0, edited: true }, "1083": { value: 0 } },
	        "scale.z": { "0": { value: 1, edited: true }, "1083": { value: 1 } },
	        opacity: {
	          "0": { value: 0, edited: true },
	          "1083": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "1100": { value: 1, edited: true },
	          "2833": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "3000": { value: 0, edited: true }
	        }
	      },
	      "haiku:Group-0a1d765af70cc326": {
	        fill: "#CD3172",
	        stroke: "none",
	        strokeWidth: 1,
	        fillRule: "evenodd",
	        "translation.x": -140.924,
	        "translation.y": 16.29
	      },
	      "haiku:Rectangle-Copy-2-8869d66e15e6d966": {
	        x: 140.923626,
	        y: -16.2903028,
	        width: 9,
	        height: 227,
	        rx: 4.5
	      },
	      "haiku:Rectangle-Copy-3-0642f7addbaff76e": {
	        "style.position": "absolute",
	        "sizeAbsolute.x": 9,
	        "style.margin": "0",
	        "style.padding": "0",
	        "style.border": "0",
	        "translation.x": {
	          "0": {
	            edited: true,
	            value: 343.9483070326498,
	            curve: "easeInOutQuad"
	          },
	          "1917": {
	            value: 341.1600322332426,
	            curve: "easeInOutQuad",
	            edited: true
	          },
	          "2583": { value: 304.882, edited: true }
	        },
	        "translation.y": {
	          "0": {
	            edited: true,
	            value: 255.83495592402147,
	            curve: "easeInOutQuad"
	          },
	          "1917": {
	            value: 253.58846591040125,
	            curve: "easeInOutQuad",
	            edited: true
	          },
	          "2583": { value: 205.454, edited: true }
	        },
	        "rotation.z": 2.496,
	        "style.overflow": "visible",
	        "sizeMode.x": 1,
	        "sizeAbsolute.y": 127.99999237060547,
	        "sizeMode.y": 1,
	        "style.zIndex": 4,
	        "scale.y": {
	          "0": { value: 0.004, edited: true, curve: "easeInOutQuad" },
	          "1917": { value: 0.058, curve: "easeInOutQuad", edited: true },
	          "2583": { value: 1, edited: true }
	        },
	        "scale.x": {
	          "0": { value: 0.802, edited: true, curve: "easeInOutQuad" },
	          "1917": { value: 0.997 }
	        },
	        opacity: {
	          "0": { value: 0, edited: true },
	          "1917": { value: 0, edited: true, curve: "easeInOutQuad" },
	          "1933": { value: 1, edited: true },
	          "2833": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "3000": { value: 0, edited: true }
	        }
	      },
	      "haiku:Group-5a5deb87f9ce2813": {
	        fill: "#CD3172",
	        stroke: "none",
	        strokeWidth: 1,
	        fillRule: "evenodd",
	        "translation.x": -37.61,
	        "translation.y": -71.821
	      },
	      "haiku:Zigzag-9602d6081741bb40": {
	        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
	        "style.position": "relative",
	        "style.overflowX": { "0": { value: "hidden", edited: true } },
	        "style.overflowY": { "0": { value: "hidden", edited: true } },
	        "sizeAbsolute.x": 616.11,
	        "sizeAbsolute.y": 350,
	        "sizeMode.x": 1,
	        "sizeMode.y": 1,
	        "sizeMode.z": 1
	      },
	      "haiku:Hand3-Copy-dc115316fd57b733": {
	        "sizeAbsolute.y": 260,
	        "sizeMode.x": 1,
	        "style.padding": "0",
	        "style.border": "0",
	        "sizeAbsolute.x": 72,
	        "style.margin": "0",
	        "style.position": "absolute",
	        "sizeMode.y": 1,
	        "translation.x": {
	          "0": {
	            value: 530.0889999999999,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "500": { value: 495.041, edited: true, curve: "easeInOutQuad" },
	          "1083": { value: 440, edited: true, curve: "easeInOutQuad" },
	          "1917": { value: 297.412, edited: true, curve: "easeInOutQuad" },
	          "2583": { value: 241.236, edited: true, curve: "linear" },
	          "2750": { value: 108.236 }
	        },
	        "translation.y": {
	          "0": {
	            value: -52.37785339355469,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "500": {
	            value: 5.970001220703125,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "1083": {
	            value: -60.35975646972656,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "1917": {
	            value: 123.45904541015625,
	            edited: true,
	            curve: "easeInOutQuad"
	          },
	          "2583": { value: 21.135025024414062, edited: true, curve: "linear" },
	          "2750": { value: -156 }
	        },
	        "style.zIndex": 5,
	        "scale.x": {
	          "0": { value: 1, edited: true },
	          "2533": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "2583": { value: 1.2, edited: true }
	        },
	        "scale.y": {
	          "0": { value: 1, edited: true },
	          "2533": { value: 1, edited: true, curve: "easeInOutQuad" },
	          "2583": { value: 1.2, edited: true }
	        }
	      },
	      "haiku:Page-1-b183996931d99194": {
	        stroke: "none",
	        strokeWidth: 1,
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      "haiku:Artboard-ed450bcb81b86f09": {
	        "translation.x": -414,
	        "translation.y": -35
	      },
	      "haiku:Hand3-Copy-ef19e9f7c94ebd1e": {
	        "translation.x": 414,
	        "translation.y": 35
	      },
	      "haiku:Path-9-4b6a6ca1a07cc080": {
	        d:
	          "M39.3854167,222.782925 C41.8095682,223.717565 43.9126285,223.717565 45.6945977,222.782925 C47.4765668,221.848285 48.9072494,219.994842 49.9866453,217.222597 C51.7783901,212.70853 53.6650639,210.77419 55.6466668,211.419578 C57.6282696,212.064966 58.3122666,214.377781 57.6986579,218.358023 C57.0131832,224.269159 56.1482713,227.787196 55.1039223,228.912132 C54.0595733,230.037068 50.9231317,232.260705 45.6945977,235.583043 C55.0746311,234.065823 60.8325231,233.151071 62.9682738,232.838787 C66.1718997,232.370361 68.3344814,232.867475 68.8314389,234.912372 C69.3283964,236.957268 67.747062,237.843563 65.8072309,239.112687 C64.5140102,239.95877 56.9283789,242.688497 43.0503369,247.301869 L39.3854167,222.782925 Z",
	        fill: "#FFB150"
	      },
	      "haiku:Path-8-27bc8c3e0603df4e": {
	        d:
	          "M0.764717332,0.900110587 C5.03958184,26.2139532 26.0041046,141.834322 26.9439641,151.390145 C27.6510443,156.665964 26.8808707,157.980698 27.3477175,162.064161 C27.8145642,166.147624 29.1011262,167.484833 29.1011262,169.62329 C29.1011262,171.761746 28.8916093,174.823895 25.1929701,185.91231 C21.4943309,197.000726 18.2225875,202.280207 16.7226852,206.055401 C15.2227829,209.830595 13.4796524,211.02146 13.4796524,214.519154 C13.4796524,218.016847 15.9695619,219.435076 16.4529037,221.252374 C16.7751315,222.463906 16.7751315,225.62089 16.4529037,230.723325 C16.5219435,232.242887 16.7553132,233.379195 17.1530126,234.132249 C17.5507121,234.885303 18.4948112,235.70319 19.9853101,236.585911 L29.1011262,242.118693 L30.4839933,246.868274 C30.940598,248.6227 31.6632433,249.963635 32.6519289,250.891077 C33.6406146,251.81852 34.6992728,252.148548 35.8279037,251.881161 L43.6915397,240.552292 C42.0830224,236.492925 41.3068764,233.025619 41.3631016,230.150373 C41.4474395,225.837503 43.0781521,221.921504 44.088634,220.245685 C45.0991159,218.569866 49.0810142,213.476985 51.8882682,214.210085 C53.7597709,214.698818 59.2778439,214.03659 68.442487,212.223401 C68.2509922,208.140237 68.0357145,205.358891 67.7966537,203.879363 C67.5316218,202.239102 62.4929254,185.973182 58.9017554,171.794349 C57.6340299,166.789054 59.932177,98.5747279 59.932177,81 C59.932177,69.2835147 59.6111363,42.5835516 58.9690549,0.900110587 C29.4856585,0.900110587 10.0842127,0.900110587 0.764717332,0.900110587 Z",
	        fill: "#FFE754"
	      },
	      "haiku:Pencil3-c577740af2e09316": {
	        "translation.x": 63.61,
	        "translation.y": 162.538,
	        "rotation.z": 1.484
	      },
	      "haiku:Rectangle-e79e8e62dd284967": {
	        d:
	          "M37.4316383,-18.3512276 L48.9846906,-18.314377 L49.2649883,69.0914794 C49.269579,70.5229941 48.1128285,71.6871875 46.6813138,71.6917782 C46.6757872,71.6917959 46.6702606,71.691796 46.664734,71.6917783 L40.2957613,71.6714633 C38.870717,71.6669179 37.7166122,70.5128328 37.7120423,69.0877886 L37.541863,16.0204138 L37.4316383,-18.3512276 Z",
	        fill: "#212D31",
	        "translation.x": 49.2,
	        "translation.y": -23.888,
	        "rotation.z": 1.134
	      },
	      "haiku:Path-4-074e1fe063b47118": {
	        d:
	          "M86.286679,12.811054 L81.4151558,2.41912722 L93.2509246,0.472905215 C95.6448543,-0.0922552186 97.0387556,0.0175058431 97.4326287,0.8021884 C97.8265017,1.58687096 97.3139278,2.6584951 95.894907,4.01706082 L86.286679,12.811054 Z",
	        fill: "#CD3172"
	      },
	      "haiku:Path-8-Copy-2186ed13cac5145b": {
	        d:
	          "M16.7951161,206.173555 C15.2952138,209.948749 13.5520833,211.139614 13.5520833,214.637307 C13.5520833,218.135001 16.0419928,219.55323 16.5253346,221.370528 C16.8475624,222.58206 16.8475624,225.739044 16.5253346,230.841479 C16.5943744,232.361041 16.8277441,233.497349 17.2254435,234.250403 C17.623143,235.003457 18.5672421,235.821344 20.057741,236.704065 L29.1735571,242.236847 L30.5564242,246.986428 C31.0130289,248.740854 31.7356742,250.081789 32.7243598,251.009231 C33.7130455,251.936674 34.7717037,252.266701 35.9003346,251.999315 C44.2670346,251.339259 50.9622063,251.339259 55.9858495,251.999315 C58.9829439,252.393103 61.9365096,252.738387 61.9365096,249.495894 C61.9365096,247.149371 60.2826228,245.055014 56.9748493,243.212825 L43.7639706,240.670445 C42.1554533,236.611079 41.3793073,233.143772 41.4355325,230.268526 C41.5198704,225.955657 18.2950184,202.39836 16.7951161,206.173555 Z",
	        fill: "#FFE754"
	      },
	      "haiku:Path-8-Copy-2-bf7f2bf1bdc52959": {
	        d:
	          "M51.9481442,214.095199 C54.7553982,214.828299 56.2459671,217.798009 57.3098599,222.860909 C58.0191218,226.236176 58.1146739,230.772881 57.5965163,236.471026 C57.6011588,241.715201 59.0436383,244.337289 61.9239546,244.337289 C66.2444292,244.337289 66.5432087,238.030437 67.1998692,236.142764 C67.6376428,234.884316 68.7433721,233.039541 70.5170571,230.60844 C71.4500758,229.632963 71.9165852,228.408904 71.9165852,226.936263 C71.9165852,225.463622 70.7785111,220.521039 68.5023629,212.108515 C68.3108682,208.025352 68.0955904,205.244006 67.8565296,203.764478 C67.4979384,201.545185 49.1408901,213.362099 51.9481442,214.095199 Z",
	        fill: "#FFE754"
	      }
	    }
	  },
	  template: {
	    elementName: "div",
	    attributes: {
	      "haiku-id": "Zigzag-9602d6081741bb40",
	      "haiku-title": "Zigzag"
	    },
	    children: [
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Hand3-Copy-dc115316fd57b733",
	          "haiku-title": "hand3 copy",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/hand3 copy.svg"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Page-1-b183996931d99194", id: "Page-1" },
	            children: [
	              {
	                elementName: "g",
	                attributes: {
	                  "haiku-id": "Artboard-ed450bcb81b86f09",
	                  id: "Artboard"
	                },
	                children: [
	                  {
	                    elementName: "g",
	                    attributes: {
	                      "haiku-id": "Hand3-Copy-ef19e9f7c94ebd1e",
	                      id: "hand3-copy"
	                    },
	                    children: [
	                      {
	                        elementName: "path",
	                        attributes: {
	                          "haiku-id": "Path-9-4b6a6ca1a07cc080",
	                          id: "Path-9"
	                        },
	                        children: []
	                      },
	                      {
	                        elementName: "path",
	                        attributes: {
	                          "haiku-id": "Path-8-27bc8c3e0603df4e",
	                          id: "Path-8"
	                        },
	                        children: []
	                      },
	                      {
	                        elementName: "g",
	                        attributes: {
	                          "haiku-id": "Pencil3-c577740af2e09316",
	                          id: "pencil3"
	                        },
	                        children: [
	                          {
	                            elementName: "path",
	                            attributes: {
	                              "haiku-id": "Rectangle-e79e8e62dd284967",
	                              id: "Rectangle"
	                            },
	                            children: []
	                          },
	                          {
	                            elementName: "path",
	                            attributes: {
	                              "haiku-id": "Path-4-074e1fe063b47118",
	                              id: "Path-4"
	                            },
	                            children: []
	                          }
	                        ]
	                      },
	                      {
	                        elementName: "path",
	                        attributes: {
	                          "haiku-id": "Path-8-Copy-2186ed13cac5145b",
	                          id: "Path-8-Copy"
	                        },
	                        children: []
	                      },
	                      {
	                        elementName: "path",
	                        attributes: {
	                          "haiku-id": "Path-8-Copy-2-bf7f2bf1bdc52959",
	                          id: "Path-8-Copy-2"
	                        },
	                        children: []
	                      }
	                    ]
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Rectangle-Copy-3-0642f7addbaff76e",
	          "haiku-title": "Rectangle-Copy-3",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/zigzag.svg#undefined"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Group-5a5deb87f9ce2813" },
	            children: [
	              {
	                elementName: "rect",
	                attributes: {
	                  "haiku-id": "Rectangle-Copy-3-b6e457f5865961c2",
	                  "haiku-title": "Rectangle-Copy-3"
	                },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Rectangle-Copy-2-f4da62dbf5b504e1",
	          "haiku-title": "Rectangle-Copy-2",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/zigzag.svg#undefined"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Group-0a1d765af70cc326" },
	            children: [
	              {
	                elementName: "rect",
	                attributes: {
	                  "haiku-id": "Rectangle-Copy-2-8869d66e15e6d966",
	                  "haiku-title": "Rectangle-Copy-2"
	                },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Rectangle-Copy-e41acb479d44d8bd",
	          "haiku-title": "Rectangle-Copy",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/zigzag.svg#undefined"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Group-38e05b604020069d" },
	            children: [
	              {
	                elementName: "rect",
	                attributes: {
	                  "haiku-id": "Rectangle-Copy-bab689546f4f2afe",
	                  "haiku-title": "Rectangle-Copy"
	                },
	                children: []
	              }
	            ]
	          }
	        ]
	      },
	      {
	        elementName: "svg",
	        attributes: {
	          version: "1.1",
	          xmlns: "http://www.w3.org/2000/svg",
	          "xmlns:xlink": "http://www.w3.org/1999/xlink",
	          "haiku-id": "Rectangle-b6882ed2d7651795",
	          "haiku-title": "Rectangle",
	          "haiku-source":
	            "designs/LearnPage.sketch.contents/slices/zigzag.svg#undefined"
	        },
	        children: [
	          {
	            elementName: "g",
	            attributes: { "haiku-id": "Group-a94a9e23c29874d8" },
	            children: [
	              {
	                elementName: "rect",
	                attributes: {
	                  "haiku-id": "Rectangle-a4bba94ae83341bf",
	                  "haiku-title": "Rectangle"
	                },
	                children: []
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  }
	};


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	// By default, a react-dom module is exported; see code/main/* for other options
	module.exports = __webpack_require__(532)

/***/ }),
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(23);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _navbar = __webpack_require__(44);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _mobileContent = __webpack_require__(70);
	
	var _mobileContent2 = _interopRequireDefault(_mobileContent);
	
	var _formsShared = __webpack_require__(91);
	
	var _btnsShared = __webpack_require__(90);
	
	var _palette = __webpack_require__(17);
	
	var _palette2 = _interopRequireDefault(_palette);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _mobileDetect = __webpack_require__(87);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	var _reactScrollspy = __webpack_require__(408);
	
	var _reactScrollspy2 = _interopRequireDefault(_reactScrollspy);
	
	var _reactStickynode = __webpack_require__(411);
	
	var _reactStickynode2 = _interopRequireDefault(_reactStickynode);
	
	var _react3 = __webpack_require__(535);
	
	var _react4 = _interopRequireDefault(_react3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var md = typeof window !== 'undefined' ? new _mobileDetect2.default(window.navigator.userAgent) : { mobile: function mobile() {
	    return false;
	  } };
	var isMobile = md.mobile();
	
	var STYLES = _extends((_extends2 = {
	  featuresNavWrap: {
	    width: 320,
	    height: '100%',
	    marginLeft: 50,
	    marginRight: 50
	  },
	  featuresContentWrap: {
	    width: '70%',
	    height: '100%',
	    paddingRight: 12,
	    '@media screen and (max-width: 1115px)': {
	      width: '90%',
	      paddingLeft: 10,
	      paddingRight: 10
	    }
	  },
	  link: {
	    color: _palette2.default.LIGHTEST_BLUE,
	    textDecoration: 'none'
	  },
	  sideNavigationWrap: {
	    paddingTop: 35
	  },
	  sideNavigation: {
	    paddingLeft: 0,
	    marginTop: 20,
	    borderRadius: 8,
	    overflow: 'hidden',
	    boxShadow: '0 20px 150px 0 rgba(0,0,0,.5)',
	    backgroundColor: _palette2.default.COAL
	  },
	  sideNavigationLink: {
	    width: 'auto',
	    display: 'block',
	    height: '100%',
	    padding: '1em 1em 1em 25px',
	    textTransform: 'uppercase',
	    textDecoration: 'none'
	  },
	  sideNavigationTitle: {
	    backgroundColor: _palette2.default.COAL,
	    color: _palette2.default.SUNSTONE,
	    paddingTop: 10,
	    paddingLeft: 25,
	    paddingBottom: 5
	  },
	  pageSection: {
	    paddingTop: 35,
	    marginBottom: 50
	  },
	  contentWrap: {
	    maxWidth: 1440,
	    position: 'relative',
	    display: 'flex',
	    justifyContent: 'center',
	    marginTop: 80,
	    marginBottom: 30
	  },
	  learnContentWrap: {
	    width: '100%',
	    height: '100%',
	    paddingLeft: 50,
	    paddingRight: 50,
	    color: _palette2.default.SUNSTONE,
	    '@media screen and (max-width: 1115px)': {
	      width: '90%',
	      paddingLeft: 10,
	      paddingRight: 10
	    }
	  },
	  flexGrid: {
	    display: 'flex',
	    alignContent: 'flex-start',
	    flexWrap: 'wrap',
	    '@media screen and (max-width: 1115px)': {
	      display: 'block'
	    }
	  },
	  flexGridTut: {
	    width: '30%',
	    borderRadius: 8,
	    overflow: 'hidden',
	    boxShadow: '0 20px 150px 0 rgba(0,0,0,.5)',
	    backgroundColor: _palette2.default.COAL,
	    marginTop: 20,
	    marginBottom: 40,
	    marginRight: '3%',
	    '@media screen and (max-width: 1115px)': {
	      width: '100%',
	      marginTop: 30,
	      marginBottom: 90
	    }
	  },
	  flexGridTutSpacer: {
	    width: '30%',
	    borderRadius: 8,
	    overflow: 'hidden',
	    marginTop: 20,
	    marginBottom: 40
	  },
	  flexGridBelow: {
	    width: '48%',
	    overflow: 'hidden',
	    marginTop: 20,
	    marginBottom: 40,
	    paddingRight: 30,
	    '@media screen and (max-width: 1115px)': {
	      width: '100%',
	      marginTop: 30,
	      marginBottom: 90,
	      paddingRight: 0
	    }
	  },
	  flexGridContent: {
	    padding: '0 20px 20px'
	  }
	}, _extends2['link'] = {
	  color: '#43C4D1',
	  textDecoration: 'none'
	}, _extends2.featureImage = {
	  backgroundColor: 'rgb(250,250,250)',
	  minHeight: 160,
	  objectPosition: 'center',
	  objectFit: 'cover',
	  border: '1px solid #232d30'
	}, _extends2.h2 = {
	  '@media screen and (min-width: 1115px)': {
	    fontSize: 38
	  }
	}, _extends2.h3 = {
	  color: _palette2.default.SUNSTONE,
	  fontSize: 37,
	  letterSpacing: .5,
	  lineHeight: '40px',
	  wordWrap: 'break-word',
	  fontFamily: 'brandon-grotesque',
	  textTransform: 'uppercase',
	  paddingTop: 15,
	  margin: '0 0 12px'
	}, _extends2.h3Alt = {
	  color: _palette2.default.LIGHT_BLUE,
	  minHeight: '2em',
	  fontSize: 18,
	  letterSpacing: .5,
	  lineHeight: '22px',
	  wordWrap: 'break-word',
	  fontFamily: 'brandon-grotesque',
	  textTransform: 'uppercase',
	  paddingTop: 12,
	  margin: 0
	}, _extends2.subtitle = {
	  color: _palette2.default.ROCK,
	  fontSize: 15,
	  marginTop: 5,
	  fontWeight: 300,
	  lineHeight: '22px'
	}, _extends2.pageSubtitle = {
	  color: _palette2.default.ROCK,
	  fontSize: '1.5em',
	  marginTop: 5,
	  lineHeight: 1.22
	}, _extends2.subsectionTitle = {
	  marginTop: 80
	}, _extends2.type = {
	  color: _palette2.default.SUNSTONE,
	  fontWeight: 600,
	  marginTop: 6,
	  fontSize: 12,
	  textTransform: 'uppercase'
	}, _extends2.credit = {
	  fontWeight: 600,
	  color: _palette2.default.SUNSTONE,
	  fontSize: 12
	}, _extends2.dev = {
	  border: '2px solid ' + _palette2.default.LIGHT_BLUE
	}, _extends2.sectionWrap = {
	  fontSize: 18,
	  textAlign: 'left',
	  '@media screen and (max-width: 1115px)': {
	    textAlign: 'center'
	  }
	}, _extends2.sectionTitle = {
	  marginTop: 60,
	  textAlign: 'left',
	  '@media screen and (max-width: 1115px)': {
	    textAlign: 'center'
	  },
	  '@media screen and (min-width: 1115px)': {
	    fontSize: 38
	  }
	}, _extends2.centerBtnOnMobile = {
	  left: 160,
	  '@media screen and (max-width: 1115px)': {
	    left: '50%'
	  }
	}, _extends2.hideOnMobile = {
	  '@media screen and (max-width: 700px)': {
	    display: 'none'
	  }
	}, _extends2.hideOnTablet = {
	  '@media screen and (max-width: 1115px)': {
	    display: 'none'
	  }
	}, _extends2.kuWrap = {
	  width: 'calc(100% - 40px)',
	  height: 400,
	  marginTop: 40,
	  '@media screen and (max-width: 1115px)': {
	    width: '100%'
	  },
	  '@media screen and (max-width: 700px)': {
	    height: 200
	  }
	}, _extends2), _formsShared.FORM_STYLES, _btnsShared.BTN_STYLES);
	
	var SECTIONS = [{
	  title: "An Overview of Haiku",
	  id: "overview",
	  boxes: [{
	    link: "https://www.youtube.com/watch?v=B8iZlkRrwS4",
	    img: __webpack_require__(1029),
	    title: "Introducing Haiku",
	    format: "Video",
	    subtitle: "Create dynamic, cross-platform UIs using design tools, code, or both."
	  }, {
	    link: "https://www.youtube.com/watch?v=_rd8XHnk2Cg",
	    img: __webpack_require__(1056),
	    title: "Workflow with Haiku",
	    format: "Video",
	    subtitle: "Design assets with Sketch, animate them with Haiku, and include them in any web app—then keep iterating."
	  }, {
	    link: "/blog/motion-design-for-the-web-ios-android-with-haiku",
	    img: __webpack_require__(1035),
	    title: "Getting started with motion design",
	    format: "Blog post",
	    subtitle: "Learn the basics of motion design and get started with Haiku."
	  }, {
	    link: "https://www.youtube.com/watch?v=Gs5YG_uf5UQ",
	    img: __webpack_require__(1033),
	    title: "Getting started with animation in Haiku",
	    format: "Video",
	    subtitle: "Learn the basics of motion design and get started with Haiku."
	  }, {
	    link: "/blog/figma-haiku-integration-delivering-motion",
	    img: __webpack_require__(1020),
	    title: "Getting started with Figma & Haiku",
	    format: "Blog post",
	    subtitle: "How to integrate and use Figma projects in Haiku."
	  }, {
	    link: "https://www.youtube.com/watch?v=QFZ9y3XeXxs",
	    img: __webpack_require__(1027),
	    title: "Haiku.ai Review",
	    format: "Video",
	    subtitle: "Export Sketch Animations to native iOS & Android Code!",
	    author: "By: Maex"
	  }]
	}, {
	  title: "Getting started with your drawing tools",
	  id: "drawing",
	  boxes: [{
	    link: "https://help.haiku.ai/troubleshooting-and-help/importing-designs-from-sketch",
	    img: __webpack_require__(1047),
	    title: "Importing designs from Sketch",
	    format: "Help doc",
	    subtitle: "How to bring assets designed in Sketch into Haiku and troubleshooting common issues."
	  }, {
	    link: "https://help.haiku.ai/troubleshooting-and-help/importing-designs-from-figma",
	    img: __webpack_require__(1022),
	    title: "Importing designs from Figma",
	    format: "Help doc",
	    subtitle: "How to bring assets designed in Figma into Haiku and troubleshooting common issues."
	  }, {
	    link: "https://help.haiku.ai/troubleshooting-and-help/importing-designs-from-adobe-illustrator",
	    img: __webpack_require__(1005),
	    title: "Importing designs from Adobe Illustrator",
	    format: "Help doc",
	    subtitle: "How to bring assets designed in Illustrator into Haiku and troubleshooting common issues."
	  }, {
	    link: "https://help.haiku.ai/troubleshooting-and-help/importing-svgs-to-haiku",
	    img: __webpack_require__(1028),
	    title: "Importing SVG's to Haiku",
	    format: "Help doc",
	    subtitle: "What if I don't use Sketch / Figma / Illustrator?"
	  }]
	}, {
	  title: "Fundamentals",
	  id: "fundamentals",
	  boxes: [{
	    link: "https://help.haiku.ai/fundamentals/haiku-glossary",
	    img: __webpack_require__(1025),
	    title: "Haiku Glossary",
	    format: "Help doc",
	    subtitle: "Understand the terms and naming conventions used in the Haiku app."
	  }, {
	    link: "https://help.haiku.ai/troubleshooting-and-help/how-to-start-a-new-project",
	    img: __webpack_require__(1036),
	    title: "How to start a new project",
	    format: "Help doc",
	    subtitle: "Different ways to create a new Haiku project."
	  }, {
	    link: "https://help.haiku.ai/fundamentals/forking-haiku-projects",
	    img: __webpack_require__(1023),
	    title: "Forking Haiku Projects",
	    format: "Help doc",
	    subtitle: "Forks are a unique copy of a project, which doesn't affect the original project. "
	  }, {
	    link: "https://help.haiku.ai/fundamentals/public-vs-private-projects",
	    img: __webpack_require__(1041),
	    title: "Public vs private projects",
	    format: "Help doc",
	    subtitle: "When you create a Haiku project, you can decide if you want it to be public or private."
	  }, {
	    link: "https://help.haiku.ai/fundamentals/add-a-keyframe",
	    img: __webpack_require__(1014),
	    title: "Add a keyframe",
	    format: "Help doc",
	    subtitle: "You can add keyframes to the timeline in three ways."
	  }, {
	    link: "https://help.haiku.ai/fundamentals/adding-transitions",
	    img: __webpack_require__(1015),
	    title: "Adding transitions",
	    format: "Help doc",
	    subtitle: "In the animation world, transitions are known as tweens."
	  }, {
	    link: "https://help.haiku.ai/troubleshooting-and-help/selecting-slices-in-haiku",
	    img: __webpack_require__(1045),
	    title: "Selecting slices in Haiku",
	    format: "Help doc",
	    subtitle: "How can I select an object in the canvas?"
	  }, {
	    link: "https://www.youtube.com/watch?v=as_ogKd-Lbg",
	    img: __webpack_require__(1054),
	    title: "Group/Ungroup in Haiku",
	    format: "Video",
	    subtitle: "Maintain the original position of your slices with Ungroup."
	  }, {
	    link: "https://help.haiku.ai/troubleshooting-and-help/align-slices",
	    img: __webpack_require__(1006),
	    title: "Align slices",
	    format: "Help doc",
	    subtitle: "How can I align elements in Haiku?"
	  }, {
	    link: "https://help.haiku.ai/troubleshooting-and-help/reorganizing-layers-in-haiku",
	    img: __webpack_require__(1037),
	    title: "Reorganizing layers in Haiku",
	    format: "Help doc",
	    subtitle: "How can I change the order of my layers / slices / elements / shapes?"
	  }, {
	    link: "https://help.haiku.ai/fundamentals/zooming-in-and-out",
	    img: __webpack_require__(1057),
	    title: "Zooming in and out",
	    format: "Help doc",
	    subtitle: "You have a couple of options to Zoom in and out of both the timeline and the stage."
	  }, {
	    link: "https://help.haiku.ai/troubleshooting-and-help/setting-the-origin-point-on-elements",
	    img: __webpack_require__(1039),
	    title: "Setting the origin point on elements",
	    format: "Help doc",
	    subtitle: "How can I change the origin point for scaling or rotating an element?"
	  }, {
	    link: "https://www.youtube.com/watch?v=sPY9MpicN5o",
	    img: __webpack_require__(1038),
	    title: "Haiku: Changing origin (point of rotation)",
	    format: "Video",
	    subtitle: "A quick tutorial on how to change the point of rotation (origin) in Haiku."
	  }, {
	    link: "https://help.haiku.ai/troubleshooting-and-help/stage-sizing",
	    img: __webpack_require__(1049),
	    title: "Stage sizing",
	    format: "Help doc",
	    subtitle: "How can I adjust the size of the stage in Haiku?"
	  }, {
	    link: "https://help.haiku.ai/troubleshooting-and-help/frames-and-miliseconds",
	    img: __webpack_require__(1024),
	    title: "Frames and miliseconds",
	    format: "Help doc",
	    subtitle: "Can I switch from frames to milliseconds in the timeline?"
	  }, {
	    link: "https://help.haiku.ai/troubleshooting-and-help/rotating-slices-in-haiku",
	    img: __webpack_require__(1043),
	    title: "Rotating slices in Haiku",
	    format: "Help doc",
	    subtitle: "How can I rotate my slice / element?"
	  }, {
	    link: "https://help.haiku.ai/troubleshooting-and-help/using-consistent-transform-sizes-on-elements-of-varying-size",
	    img: __webpack_require__(1055),
	    title: "Using consistent transform sizes on elements of varying size.",
	    format: "Help doc",
	    subtitle: "Work with different sized elements easier."
	  }, {
	    link: "https://help.haiku.ai/troubleshooting-and-help/changing-colors-in-haiku",
	    img: __webpack_require__(1009),
	    title: "Changing colors in Haiku",
	    format: "Help doc",
	    subtitle: "Can I change the stage's background color or an asset's color?"
	  }, {
	    link: "https://help.haiku.ai/fundamentals/animating-the-stroke-property-in-haiku",
	    img: __webpack_require__(1004),
	    title: "Animating the stroke property in Haiku",
	    format: "Help doc",
	    subtitle: "Steps to add the stroke property to an element."
	  }, {
	    link: "https://www.youtube.com/watch?v=fHisNZ-j7cc",
	    img: __webpack_require__(1013),
	    title: "Haiku: Intro to Sub-components",
	    format: "Video",
	    subtitle: "A quick tutorial on using sub-components within Haiku."
	  }, {
	    link: "https://help.haiku.ai/fundamentals/subcomponent-playback",
	    img: __webpack_require__(1011),
	    title: "Subcomponent playback",
	    format: "Help doc",
	    subtitle: "Find the “playback” property on the timeline where you instantiated the component."
	  }, {
	    link: "https://help.haiku.ai/fundamentals/component-preview",
	    img: __webpack_require__(1012),
	    title: "Component preview",
	    format: "Help doc",
	    subtitle: "How to preview each component individually and all components together."
	  }, {
	    link: "/blog/understanding-states/",
	    img: __webpack_require__(1053),
	    title: "Understanding States step by step",
	    format: "Blog post",
	    subtitle: "Learn how to create, edit, use and make the most out of States in Haiku."
	  }, {
	    link: "https://help.haiku.ai/fundamentals/how-to-use-the-haiku-code-editor",
	    img: __webpack_require__(1010),
	    title: "How to use the Haiku Code editor",
	    format: "Help doc",
	    subtitle: "How to use the built-in Code Editor or any custom editor."
	  }]
	}, {
	  title: "Creating animations",
	  id: "animation",
	  boxes: [{
	    link: "/blog/curved-paths",
	    img: __webpack_require__(1016),
	    title: "Animating elements along curved paths",
	    format: "Blog post",
	    subtitle: "Vertical curved path with flow effect."
	  }, {
	    link: "https://www.youtube.com/watch?v=NhveVVgR_5Q",
	    img: __webpack_require__(1017),
	    title: "Haiku Tutorial: Animating Elements Along Curved Paths",
	    format: "Video",
	    subtitle: "Horizontal curved path with bounce effect."
	  }, {
	    link: "https://www.youtube.com/watch?v=WBZU0E5Z5hA",
	    img: __webpack_require__(1042),
	    title: "Animating a record player",
	    format: "Video",
	    subtitle: "Haiku Tour/walkthrough + Spinning the record.",
	    author: "By: Anjan Shrestha"
	  }, {
	    link: "https://www.youtube.com/watch?v=_KcEKtj6E4s",
	    img: __webpack_require__(1030),
	    title: "Menu overlay transition Timelapse",
	    format: "Video",
	    subtitle: "Quick tutorial to animate a menu transition.",
	    author: "By: Anjan Shrestha"
	  }, {
	    link: "https://www.youtube.com/watch?v=ejypmuzNgyE",
	    img: __webpack_require__(1007),
	    title: "Animating a Present with Haiku - Timelapse",
	    format: "Video",
	    subtitle: "Using Haiku, you can fine-tune vector animations and then drop them into any web app with a line of code."
	  }, {
	    link: "https://help.haiku.ai/troubleshooting-and-help/motion-blur-in-haiku",
	    img: __webpack_require__(1032),
	    title: "Motion blur in Haiku",
	    format: "Help doc",
	    subtitle: "Can Haiku do motion blurs?"
	  }, {
	    link: "/blog/morphing-intro",
	    img: __webpack_require__(1040),
	    title: "Introduction to Path Morphing",
	    format: "Blog post",
	    subtitle: "Learn how to path morph using Haiku."
	  }, {
	    link: "https://www.youtube.com/watch?v=V9lVf6qcQZ4",
	    img: __webpack_require__(1031),
	    title: "Advanced path morphing",
	    format: "Video",
	    subtitle: "Advanced follow-along tutorial on path morphing."
	  }]
	}, {
	  title: "Adding interactivity",
	  id: "interactivity",
	  boxes: [{
	    link: "/blog/understanding-actions/",
	    img: __webpack_require__(1052),
	    title: "Understanding Actions",
	    format: "Blog post and Video",
	    subtitle: "Understand the two different types of Actions available in Haiku, Frame and Element Actions."
	  }, {
	    link: "/blog/designing-the-real-thing-with-haiku-actions/",
	    img: __webpack_require__(1034),
	    title: "DESIGNING THE REAL THING WITH HAIKU ACTIONS",
	    format: "Blog post",
	    subtitle: "Actions are small snippets of code (JavaScript) with a lot of power. "
	  }, {
	    link: "https://www.youtube.com/watch?v=S376xLw7RUE",
	    img: __webpack_require__(1048),
	    title: "Getting started with interactivity in Haiku",
	    format: "Video",
	    subtitle: "Learn how to add interactivity to your designs for the Web using Actions, States & Expressions in Haiku."
	  }, {
	    link: "https://www.youtube.com/watch?v=8BEO3Lb_Qdg",
	    img: __webpack_require__(1050),
	    title: "Stop and play button interaction",
	    format: "Video",
	    subtitle: "Using states and events to create the stop/play interactions of a media player.",
	    author: "By: Anjan Shrestha"
	  }, {
	    link: "https://www.youtube.com/watch?v=Xb3g8T0JLuY",
	    img: __webpack_require__(1051),
	    title: "How to make a toggle component",
	    format: "Video",
	    subtitle: "Quick tutorial on how to make a simple toggle component using Haiku."
	  }, {
	    link: "/blog/mimicking-the-medium-clap/",
	    img: __webpack_require__(1008),
	    title: "MIMICKING THE MEDIUM CLAP ANIMATION WITH SKETCH AND HAIKU",
	    format: "Blog post",
	    subtitle: "Export to React, after designing in Sketch, and tweaking keyframes in Haiku.",
	    author: "By: Kyle Gill"
	  }, {
	    link: "https://www.youtube.com/watch?v=vFxsDarkAVk",
	    img: __webpack_require__(1018),
	    title: "Creating dynamic instances of an element",
	    format: "Video",
	    subtitle: "Using states and actions to create instances of an element depending on where the user clicks."
	  }, {
	    link: "https://www.youtube.com/watch?v=oKvDywEVynI",
	    img: __webpack_require__(1046),
	    title: "Communicating between components",
	    format: "Video",
	    subtitle: "Learn how to use the send() api to communicate between components."
	  }, {
	    link: "/blog/from-figma-to-react/",
	    img: __webpack_require__(1021),
	    title: "From Figma to React with Haiku",
	    format: "Blog post",
	    subtitle: "Bring your Figma designs to life by easily animating and publishing as React components. "
	  }]
	}, {
	  title: "Using Code",
	  id: "code",
	  boxes: [{
	    link: "/blog/helper-functions/",
	    img: __webpack_require__(1026),
	    title: "Reusing logic with Helpers",
	    format: "Blog post",
	    subtitle: "Helpers allow you to define a function that can be later used in an Expression or an Action."
	  }, {
	    link: "/blog/accessing-summonables-from-actions/",
	    img: __webpack_require__(1003),
	    title: "Accessing Summonables from Actions",
	    format: "Blog post",
	    subtitle: "Summonables are a collection of built-in pieces of dynamic data that you can summon."
	  }, {
	    link: "/blog/handling-mouse-and-touch/",
	    img: __webpack_require__(1044),
	    title: "Handling mouse and touch in Haiku",
	    format: "Blog post",
	    subtitle: "This will allow you to create pieces of UI that react to both touch and mouse interactions. "
	  }, {
	    link: "/blog/progress-bar/",
	    img: __webpack_require__(1019),
	    title: "Progress Bar Tutorial",
	    format: "Docs",
	    subtitle: "Embed a component in a web app, binding it with application logic."
	  }]
	}];
	
	var Learn = function (_Component) {
	  _inherits(Learn, _Component);
	
	  function Learn() {
	    _classCallCheck(this, Learn);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Learn.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'style',
	        null,
	        '\n          .isCurrent {\n            background-color: ' + _palette2.default.FATHER_COAL + ';\n            color: ' + _palette2.default.SUNSTONE + '\n          }\n        '
	      ),
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Tutorials, documentation and help | Haiku'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'Learn Haiku with these tutorials - get up and running and learn advanced techniques, dig into documentation and get help.' }),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Tutorials, documentation and help | Haiku' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'Learn Haiku with these tutorials - get up and running and learn advanced techniques, dig into documentation and get help.' })
	      ),
	      _react2.default.createElement(_navbar2.default, { location: 'learn' }),
	      _react2.default.createElement(
	        'div',
	        { style: {
	            margin: '0 auto',
	            width: '100%',
	            maxWidth: 1440
	          } },
	        _react2.default.createElement(
	          'div',
	          { id: 'stickyTarget' },
	          _react2.default.createElement(
	            'div',
	            { style: STYLES.contentWrap },
	            _react2.default.createElement(
	              'div',
	              { style: [STYLES.featuresNavWrap, STYLES.hideOnTablet] },
	              _react2.default.createElement(
	                _reactStickynode2.default,
	                { bottomBoundary: '#stickyTarget' },
	                _react2.default.createElement(
	                  'div',
	                  { style: STYLES.sideNavigationWrap },
	                  _react2.default.createElement(
	                    _reactScrollspy2.default,
	                    { style: STYLES.sideNavigation, items: ['overview', 'drawing', 'fundamentals', 'animation', 'interactivity', 'code'], currentClassName: 'isCurrent' },
	                    _react2.default.createElement(
	                      'a',
	                      { style: STYLES.sideNavigationLink, href: '#overview' },
	                      'An Overview'
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      { style: STYLES.sideNavigationLink, href: '#drawing' },
	                      'Drawing Tools'
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      { style: STYLES.sideNavigationLink, href: '#fundamentals' },
	                      'Fundamentals'
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      { style: STYLES.sideNavigationLink, href: '#animation' },
	                      'Animation'
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      { style: STYLES.sideNavigationLink, href: '#interactivity' },
	                      'Interactivity'
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      { style: STYLES.sideNavigationLink, href: '#code' },
	                      'Using code'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: STYLES.featuresContentWrap },
	              _react2.default.createElement(
	                'div',
	                { style: STYLES.kuWrap },
	                _react2.default.createElement(_react4.default, { loop: true, sizing: 'contain', contextMenu: 'disabled' })
	              ),
	              SECTIONS.map(function (section) {
	                return _react2.default.createElement(
	                  'section',
	                  { id: section.id, key: section.id, ref: function ref(el) {
	                      return section.id = el;
	                    }, style: STYLES.pageSection },
	                  _react2.default.createElement(
	                    'h3',
	                    { style: STYLES.h3 },
	                    section.title
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: STYLES.flexGrid },
	                    section.boxes.map(function (box) {
	                      return _react2.default.createElement(
	                        'div',
	                        { style: STYLES.flexGridTut, key: box.title },
	                        _react2.default.createElement(
	                          'a',
	                          { target: '_blank', href: box.link },
	                          _react2.default.createElement('img', { style: STYLES.featureImage, src: box.img, alt: box.title }),
	                          _react2.default.createElement(
	                            'div',
	                            { style: STYLES.flexGridContent },
	                            _react2.default.createElement(
	                              'h3',
	                              { style: STYLES.h3Alt },
	                              box.title
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { style: STYLES.type },
	                              box.format
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { style: STYLES.subtitle },
	                              box.subtitle
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { style: STYLES.credit },
	                              box.author
	                            )
	                          )
	                        )
	                      );
	                    })
	                  )
	                );
	              })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: [STYLES.contentWrap, STYLES.learnContentWrap] },
	        _react2.default.createElement(
	          'div',
	          { style: STYLES.flexGrid },
	          _react2.default.createElement(
	            'div',
	            { style: STYLES.flexGridBelow },
	            _react2.default.createElement(
	              'h2',
	              { style: STYLES.sectionTitle },
	              'DOCS'
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: STYLES.sectionWrap },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Reference and technical documentation on Haiku for Mac and Haiku Core API\'s.'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'https://docs.haiku.ai/' },
	                _react2.default.createElement(
	                  'div',
	                  { key: 'cta7', style: [STYLES.centerBtnOnMobile, STYLES.btn, STYLES.cta, { textAlign: 'center', width: 220, marginTop: 20, display: 'inline-block' }, isMobile ? { padding: '14px 24px 13px', width: 'inherit' } : undefined] },
	                  'View Docs'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: STYLES.flexGridBelow },
	            _react2.default.createElement(
	              'h2',
	              { style: STYLES.sectionTitle },
	              'HELP'
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: STYLES.sectionWrap },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Advice and answers on common issues, frequently asked questions, and tips and tricks.'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'https://help.haiku.ai' },
	                _react2.default.createElement(
	                  'div',
	                  { key: 'cta8', style: [STYLES.centerBtnOnMobile, STYLES.btn, STYLES.cta, { textAlign: 'center', width: 220, marginTop: 20, display: 'inline-block' }, isMobile ? { padding: '14px 24px 13px', width: 'inherit' } : undefined] },
	                  'View Help'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_mobileContent2.default, null)
	    );
	  };
	
	  return Learn;
	}(_react.Component);
	
	exports.default = (0, _radium2.default)(Learn);
	module.exports = exports['default'];

/***/ }),
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/accessing-summonables.a223d2f6.png";

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/add-stroke.1d7c41f2.jpg";

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ai-haiku.ef0ac07b.jpg";

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/align.a42daaac.jpg";

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/celebrate.4498dbee.jpg";

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/change-color.632821f5.jpg";

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/code-editor.73c1fdf1.jpg";

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/component-playback.cf2906db.jpg";

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/components.8e150aea.jpg";

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/create-keyframe.983dc838.jpg";

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/create-tween.b75ffdf7.jpg";

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/curved-paths.b6f1f039.jpg";

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAEeA7IDAREAAhEBAxEB/8QAGwABAAEFAQAAAAAAAAAAAAAAAAYCAwQFBwj/xAAyEAEAAQMCBgEDAwIGAwAAAAAAAgEEBQMRBgcVVZPREhMhMRQiQQhhFyMzQlJxJDKB/8QAGwEBAAIDAQEAAAAAAAAAAAAAAAEDAgQFBgf/xAAvEQEAAQMDAwMBCAIDAAAAAAAAAQIREgMEIQUxQSJRYfATFDKBkaGxwQYVUrLh/9oADAMBAAIRAxEAPwDzFp6cNKEdLShSMI02pSn8Psz6AqQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMOeHxmpOU52cKylWta1+/5TeU3lmIQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3mtwLxxb2GtlNbg3OadpbwrPVuJ4/WjpacafzKfx2pT+9WrG+2tVUUU6lN58ZQyxnzDRtpiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAk/LngHKcyOJtPh3Ga2lbxjpSubq51a/tt9CNaUlPbfeVd5UpSNPzWtN60pvWml1DfafTtCdbU59vmfZlRTNc2hNOIuXHJ/l1l73A8b8ccSZbI6E9KM7TD47Tt66FJQ+e9dTVlKM6VpKH4rvTf8V++3F2fUeo9VojV2+lFNE35qqv2m3GNqo89/2831UUaU2mefr34Sfhq/8A6fbPh7IcfXHK+908Xj7/AEsbj53V7K71b64npylqQloSn9OPwjtLeVa0rvTavyps0d1R1nVro2mhrxNUxMzxaKYibR6rXm88cR+3KY+zi9VUfUq+YfMLj7gG1tcpy2t+GMfwdmtSuvjsrhcRpQrq12rSujrxnSVI6tKU2rvSla/D+NpRjl03YaW91Jo3+VWpTFpiqqe9+9Noi9PzlNr9p4qlqV4R6P4OL+bnMblxw1w5Z3md1L3ivNyjm8rG+0qT0tCzrSkNK0+nWFKQpOMd5RjWMoypL/luoo6Ls+p7mudGmPs6fTHM+96qrxM3qi/py4mJjvFMwmNSaKb1d/q35e//AKhPFvBeB4v4fuOZvK+1rp22htPO4Gkvlq4qdfzq6dP99vXatd6Up8fvXalKSjp9vbbyvp+tTsd7Veqr8FX/AC7RbmeJj9/mZiasKqPtKftKPHf4+vr45g77XAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAdptOGuKuF+SOjj+HeHcte5zmBON1eSsbaerW2xmn/p6dfpylSktSs6S/H3jKUa0/DzGrvdDcdQmnWrimNLteYiZqnz6u+P8xExe9l9NExTeI7/X7pVwvy35jcacM6vBPOHB3Glb2cNTXxHENzr6c7uy1a1p/kyp8t9XTl/xrt+Nt/tD4cnd9T2vS6qdx02rKe1VMRMRVHNp7RETHbiPm3e91NE6t4r4WeZXLvgSxwuB4Ty3NfD4S14TtPpVtoWk7m71dfXrGepq10o6lZRpOtYSpGm9I0rWu+222HQerb7X1tTXja1TGpPE3tTEU3iIicbcdr3544v3y1tLTiIjPsq5O5PlNY53/DDCZPiLibQz2319PI2OhHFautCFNSuvHSnvOEqfTrT/AOU3+W0ZUy65t+pV6P3m0adVPN4mrO0za149PN7za3mbRebxpVac1WnmPr80T4v538JZDiHJ5rDcqsDfX13cUhqZHMy1L2OvpacawhKOhKkKaVaxpGv2/im1d/zTpdK6FudHbUaetuKoiIn00+m0zN5i/OUXvafzjhXq61M1TNNMfymFrza4v4W5VXnFme0rTHa3ENf0HC+KsbPRttK10oaXxndUj95S06fL7UlSv7qQ2/bOlac7X/x/bbzqNGjpXmKL1alUzMzVMz+HxET8xbvPmOc6dzVTpzfz2ebHvWkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA79hec+U5ncLS4I4j471eDeILasdfG5y11q2lrdShDauldVjXfT+X3r8o/trWtNo0rGlNTyW86FRobn75p0ZxPFUWiZjmJvTExMfHMTNr883jZp1704S5JzBwHGHDfFl7jeOpXWrlaVpOdzr60tb9VDbaGrHUl95xrSm1K/wBtq7VpWlPQ7DX0NxoxVtotT7cRbzPEdu/99piZoriYnlLuMbiXMjlNjePYU+We4Ppp4bMUrLeetaVl/wCPr/unWv5/ZWtI7zlOVftSP25WlTPTt1Xp0U8V3qp48xbKmLR5iOPHEeZXR67RM8fVv0Y/9PEK6PNXH5udYQtsNZ319d6s5xjHS0Y206VnWtf4+Uo0/tvv+KVbXXIidnVT5m0R8zeJ/pXpTzZpeWHAM+YHEsbC91ZWmDstKV3mMhvGMLS2jTetayl9qVltWlK/fb7yrStI1bHUd5Gz0rxF6p4iPefa3n6jyjTpynuo5n8cQ4+4t18vZY/9BirXS07HFWe0afp7PTptCG0abU+9ZV2++3y2pWtKUR03aVbPRmiub1TN5n3mfPP6fNr+TUmKpvCJugwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAdE4V5qx1MLHgHmhaXWe4W+l9O1nofCl7i5x3+nPQlL/22+VafGVdttqU2j8oy5G46dVGr952k46nn2n4qj5948/PMWxXExaUi4d4Ku+WWfx/FOheaPE3LriTRpir7LW1fo6UrS5p9OdNfetdTRlCdKVr96V3jSNZUrWtKaOtuo3WnOjMTTrU+qI780xeJvP4r2tHnntMRdna038fX6KeDuEclwLxNzTwF/CepTEcKZG3pcxhSkNSOr9P6M67VrSNZwr8qR+Va0/7pU3PU9LdaW2rp4zrotHPvae8R2nibfE+YKdKYv8AESw+MZanKrl3ocsdC609LibPyhf8TV0NSMpaFvt/k2ctqfisa/KVPlvSvy+8ozobOr/da87irnTptFN44q59VVpmeJtMRf8A7UlUfY8OTvStcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABJuX3H+Z5fZXWuLKOleYzIQ+hlMXcR+VvfaFd94SpXelK7VrtLau1a1/isqS095sdPeUY1cTHMTHeJ94+v35WU14vTeK528p9HgTV4ysdGxsslY2MLWmHlOELnfS/0raG1N56VJS/bOMa0pSta1pGtKxp8z33+K9R1N9GlNU1aczfLmY5/FNvebcxe82tzw6WnutONPty8ncQZ3J8T5y+4hzFxLWvMhry19WVa1rSla/7Y71rWkaU2pSm/wBqUpT+H1DabWjZaNOhp/hpi0dv6iOZ7z8zLl11TXOUte2GIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC1a3ELu3hc6dJUjqU3pSX5SLqAAAAAAAAAAAAAAAAAAAAAABDOIchfaGYuNLRvdfThT4bRjqVpSn7afxRZSxqqs1vVcp3K680vabQrzk6rlO5XXml7LQZydVyncrrzS9loM5Oq5TuV15pey0GcnVcp3K680vZaDOTquU7ldeaXstBnJ1XKdyuvNL2Wgzk6rlO5XXml7LQZydVyncrrzS9loM5Oq5TuV15pey0GcnVcp3K680vZaDOTquU7ldeaXstBnJ1XKdyuvNL2Wgzk6rlO5XXml7LQZydVyncrrzS9loM5Oq5TuV15pey0GcnVcp3K680vZaDOTquU7ldeaXstBnJ1XKdyuvNL2Wgzk6rlO5XXml7LQZydVyncrrzS9loM5Oq5TuV15pey0GcnVcp3K680vZaDOTquU7ldeaXstBnJ1XKdyuvNL2Wgzk6rlO5XXml7LQZydVyncrrzS9loM5Oq5TuV15pey0GcnVcp3K680vZaDOTquU7ldeaXstBnJ1XKdyuvNL2Wgzk6rlO5XXml7LQZydVyncrrzS9loM5Oq5TuV15pey0GcnVcp3K680vZaDOTquU7ldeaXstBnJ1XKdyuvNL2Wgzk6rlO5XXml7LQZydVyncrrzS9loM5Oq5TuV15pey0GcnVcp3K680vZaDOTquU7ldeaXstBnJ1XKdyuvNL2Wgzk6rlO5XXml7LQZydVyncrrzS9loM5Oq5TuV15pey0GcnVcp3K680vZaDOTquU7ldeaXstBnJ1XKdyuvNL2Wgzk6rlO5XXml7LQZydVyncrrzS9loM5Oq5TuV15pey0GcnVcp3K680vZaDOTquU7ldeaXstBnJ1XKdyuvNL2Wgzk6rlO5XXml7LQZydVyncrrzS9loM5Oq5TuV15pey0GcnVcp3K680vZaDOTquU7ldeaXstBnJ1XKdyuvNL2Wgzk6rlO5XXml7LQZydVyncrrzS9loM5Oq5TuV15pey0GcnVcp3K680vZaDOTquU7ldeaXstBnJ1XKdyuvNL2Wgzlct8pk5XGnSuRua0rOm9K6svv9/8AstCYqmZdBVLQAAAAAAAAAAAAAAAAAAAAAAAEf1uL7fS1p6X6PUr8JVjv8qffaqzAf//Z"

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dynamic-instances.c6792d29.jpg";

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/embedding_and_publishing.16834f85.jpg";

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/figma-react.99df433e.jpg";

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/figma_haiku.4c318b02.jpg";

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fork-project.08b8067c.jpg";

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/frames.1f9320eb.png";

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/glossary.b1a38167.jpg";

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/haiku-code-mode.219a2a1f.png";

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/haiku-review.5daa5173.jpg";

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/import-svg.f6028373.jpg";

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/introducing.0dcafed2.jpg";

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/morph_advanced.55a15323.jpg";

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/motion-design.cf40e63f.jpg";

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/motion-ship.438aeadb.jpg";

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/motion.bc0e48ae.jpg";

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/new-project.87990bb4.png";

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/organize-slices.23c076ed.jpg";

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/origin-2.9d1600ff.jpg";

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/origin-point.390b69b7.jpg";

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pm_0.e7d6e287.jpg";

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/public-private.b15d27dc.jpg";

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/record-player.f385d7d4.jpg";

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rotate-slices.05c1c559.jpg";

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rotating-cube.ec921bab.jpg";

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/select-slices.b3f510c1.jpg";

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sendit.78c2ab49.png";

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sketch.ebeb451f.jpg";

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stage-sizing.db83b821.png";

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stop-play.bad68611.jpg";

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCADYAsYDAREAAhEBAxEB/8QAHQABAAICAwEBAAAAAAAAAAAAAAUGBAcBAwgCCf/EAEMQAQABAwEDBwkGBAMJAQAAAAABAgMEBQYHERIYITFBUZMIEyJUVmFx0tMUMkKBsdEjkaHBFWLhFiUzQ1JTcpLw8f/EABsBAQACAwEBAAAAAAAAAAAAAAAEBQMGBwIB/8QALhEBAAEDAgUDBAIDAAMAAAAAAAECAwQREgUGFiFREzFSFSJB8BQyIzNhQoGh/9oADAMBAAIRAxEAPwD8qgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIiZnhEcX2KZqnSBK4OzOqZsRXTYm3RP4q+iF1i8Cysn8aQzUWK6/ZM2NhaeicjN/Kmjj+q9s8qR/wCcs9OHP5lmf7E6X/37/wDKE/pTHZP4ceXzXsRp0x/DybtPxpiXyrlSxPsThx5RmVsVmW4mrGu03Yjs6pVWRypXTrNuWGrFqj2QeVp2Xh1TTfsV0THfDXcnht/GmYqhGqomn3YyA8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM3TNKytUveasUTyY6aq56qYT8Hh93Nr20x2e6Lc1zpC76Vs3gabTFU0edvdtdXZ8IdB4bwKziU7q47rG1jU0d5SzYaaKY7QlRED32few+6w+hrAPmkGjrv41jKtzayLVNdM9kwwXca3ep0rhjqt01xpKq63sjyIqydO4zT1zbnrj4d7TeK8txpNywgXsWae9KqV0VUVcmqOEw0i7ars1ba47oThjAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGbpGlXtVyqbFueTT111z1RCw4fgV51yKafZ7t0TXOkNiYGBj6fj02LFHCI657Znvn3up4GBbxLcRTHdbWrUUQyVhH2+7N7OjLzcXCt+cyb1NEdnHrn4Qj5GZaxqdbksdd2m3HdX8vbexRM04mNNfdVXPD+kNVyuarVE6Wo1Q6sz4wj6tt9Qnqs2Y/Kf3VdXNd/wDEMX8ut2WducqJ/j4luqP8szE/3e7fNl2J++l9jLq/Ka0/anTs6qLdVfma57K+r+bYMPmPHyftmdJSbeVTV2lMRVTVHGJieK/ovRcjdTOqTFTllnSY7vSu7S7PW8m1Xm4luIuUxxrpj8Xvj3tU43wanJom5bjugZFjX7qVIqpmmZpqjhMOcV0VW6ttXur3DyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOaKaq6oopjjNU8Ih6opmuqKY/JEatj6FpdvTMKi3HCa645Vcx2y6jwTh0YlqJ/K2x7WylJNi1SkVrmuWtKtTTTMVX6o6I/6ffKk4rxWjBonyi37/pxpHuoebqGTn3pvX7k1VT3uaZvEL2bXurnsq6q5rnWWMgPIAAROnsJ7Qdpr+BXTjZdU3MeZ4dPTNH+nubBwrjVzFrimueyRavTROk+y82rtu9bpuWqoqpqjjEw6VjZFGTRFVErSiqKo7PtJrjWHuVH2t0iMTIjKsxPIu9PwnthzzmThvp1evRCpybWyrWFdaejAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ3ZHT4y8+b9cejYjjH/l2fv+S/4Bh/yL+7wkY9G6pfY6I4Op0RtiIW0dodObl28HGuZNyY4URxiJ7Z7mDLv049qa5eLtcW6dWtNQzbubkV3blc1cZck4jm15l6apnsp66pqnWWMr3gAAAABaNjtXmi7/ht6qeTVxm3M9/c2zlzic2q/RrlLxru2dsrk6NE74WnvDD1fDpztPu2JjjVw5VPxhB4jjRkWJolhv0b6JhrO7R5u5VRPZLkORa9G5NCnl8sL4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvOxePTb02b/J9K7XM8fdHR+7oXKtjS1v0WOHT21WFuFXaU2VY22y5os2sWnt9Of0j+7UeaMmbdnZH5QMyr2pUxztAAAAAAAdmNfqxsi3fo+9bqiqPyZbFybNyK4/D7TOk6tpY16nIx7d6iYmK6YmP5OwcPv+tZipdW6tYdibU9y1vtBj/Z9TvUcOjlS5Tx+x6WVKmvU7a5hGqNiepN0/k37uNuN3+j7V52ZrNOTnWq5v0UX7XIi5Tcqoq5MTbmYj0e2ZdB5f5exuI2d1cd238G4JZzrW6r3W7mi7r/Xdb8a19NsfRWJ4hddK4/7qc0Xdf67rfjWvpnRWJ4g6Vx/+f/Tmi7r/AFzW/HtfTOisTxD70rj/ALqc0Xdf65rfj2vpnRWJ4g6Vx/3U5ou6/wBc1vx7X0zorE8QdK4/7qc0Xdf65rfj2vpnRWJ4g6Vx/wB1OaLuv9c1vx7X0zorE8QdK4/7qc0Xdf65rfj2vpnRWJ4g6Vx/3U5ou6/1zW/HtfTOisTxB0rj/upzRd1/rmt+Pa+mdFYniDpXH/dTmi7r/XNb8e19M6KxPEHSuP8AupzRd1/rmt+Pa+mdFYniDpXH/dTmi7r/AFzW/HtfTOisTxB0rj/upzRd1/rmt+Pa+mdFYniDpXH/AHVC7TeR3szfwq6tlNfy8fKiPQozYprornu5VMRNPx4Sh5nJNmaZmjtP/ETJ5UtxTPpvMG1mymsbG6zkaHreJXj5WNXNFdNX9Jie2Jjpie1zniXDbnDrs0VtLzMS5h3NlaGVqIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2NszR5vRcaO+mZ/nMuocuURRixotcWNKEo2Kr3SZUfbSqf8QimZ6qYhzzmuqfViFXlf3V1qCKAAAAAA2vsF5Om1u8rdFr+9HZDOxc3K0DVKcGvQI6M3MsxjVX7t7Gjj/Gm3RRVVXbpjlRRE1RxiJiAwtn6or0jGqieM+biJ/LodV5fr3YtP/pb4/8ASEg2CfZJlQ9sY/3rXPup/RzXmqNMiFPk/wCyUC1RHe5/JcrmvcxpET+DIy6Y+HnZn+7rnJE/4IdD5Un/ABaNst/bkAAAAAAAAAAAAAA8z+WRoeFGPomv0W6acm5F3HuVRHTVTTyZp4/DlTDnXO2NR6W/8tH5ssUxTFce7yu5S0IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABsTZevl6NYnj0xEx/WXUOXK92NC1xp+yEs2WfZLlTNt7PDMouxHRVRH8+pz7mu1O6K1VlxpXqrDS0QAAAAAB6A2EydsMHyYbOo7AV6pRtFhb08XL0+vS6a6sq3ctaVfr5dvkelxpimap4dkTM9ANpbX7otp94O6PH8oqvY3B2S1fJw7Wp6xplGZiWcXXMa5E8NW06xTc5VuqqaZ89j8mIir07cdNVFO58u8TqtTFmY7SnY92Y7NDug/hY/hQtsKuOq10xMdER+jmvNNe6/EKjJn/JKCaqjvdPkv2arW5jRqqv+bfyrkfDzsx/aXXOSftx41dE5V+2z3bW4x3t930+W4bqfJxjvN9Pk3U+TjHeb6fJup8nGO830+TdT5OMd56lPk3U+TjHeepT5N1Pk4x3m+nybqfJxjvN9Pk3U+TjHeepT5N1Pk4x3nqU+TdT5OMd5vp8m6nycY7zfT5N1Pk4x3nqU+TdT5OMd56lPk3U+SqqmmmquqqIppiZqmZ4RER1zM9jHcyLdqNapeK71FuNapeNPKh3n6btnr+PoehZFN/B0mKrfnqZ9G7cqmOVVHfHRER8OPa5RzdxanJn0aJc45k4jTk1+lQ0W0FqoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC67E5XLwrmNM9Nuvj+U//AJLfOVL+tM21hiV6xtWVvKwQm1eB9r0/ztFMcqzPGfhP/wBDXuO4f8rHmY94QcqjdTrCgTHCZiexyyqJpnSVaPgAAAAA3huM8p3eZub2Xu7Fbu6MLEnL2gxteytQm3xyardm3yasSmuf+Haux6Nzk9NdPoTPJmqKpmDjTlXIoh7op3To2Pvy1nctqmzuzegbttT1LVL2kajqOZi1XtJ+yWdI0nMqpyKNJiquqa8irHyKr/C5yaaOTcmKePW3rg/C7mPc1qjsnWrOktRNsqnbCdPZrTXMj7TqN65E9E1Twcm45e9bKn/iku1bqplgKZjXvZ3fhvO2U0fG0HQtp7uNgYcTTYsxZtzFETVNU9M08euZnp71ricZysKnbansnY/EsjFjbbnskuclvl9sb3gWvlTep8/5JP1zM+Rzkt8ntje8C18p1Pn/ACPrmZ8jnJb5fbG94Fr5TqfP+R9czPkc5LfL7Y3vAtfKdT5/yPrmZ8jnJb5PbG94Fr5TqfP+R9czPkc5LfJ7Y3vAtfKdT5/yPrmZ8jnJb5fbG94Fr5TqfP8AkfXMz5HOS3y+2N7wLXynU+f8j65mfI5yW+T2xveBa+U6nz/kfXMz5HOS3ye2N7wLXynU+f8AI+uZnyOclvl9sb3gWvlOp8/5H1zM+Rzkt8vtje8C18p1Pn/I+uZnyOclvk9sb3gWvlOp8/5H1zM+Rzkt8vtje8C18p1Pn/I+uZnyRG0e+feXtXiTga5tXmX8efvWoqiiir4xTwifzYL/AB/Nv07aqmK7xbLvRpVUpVVVVczVVVMzPXMqWqqap1qlW+7h8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEvsvnxhanRTXVwt3vQn49n9VzwTL/i5Ma+0s1ivbW2G6xari5TFULmJ1hxVTFVM01RExMcJiSqmKqdsvkxExpKhbSaHcwMmb1qnjZrnjTMdnuc349wiqxcm7bjsqL9qbdX/ABBtWYAAAAHNFFdyuKKKZqqqnhER2vdFFVyqKaY7kRqv+zWixpmL5y7Eefu8Jq6Omn3Oj8B4RGLR6lfus8aztjWU02qI0TUbr+dGDp1yrjHKrjkUx8VVxbJjFsTVqi5Neylriuqa65qntlyS7XNyuap/KplwxgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAROncbB2a1iNSw4t3av41mIpq9/dLpHL/ABSL9uLdU91njXt0aSmW2e8Jjrv2LWTaqs3qIqpqjpiWC7apv07KoeKqYrjSVQ1fY+/aqm9gcbtE/h/FH7tG4ly1VEzXYV13Fqp70q5dx71mqabluqJj3NUvYl6xOldKLMTDr4THWjzEx7vhwnuk2z4GbgaPnahVwsWauHbVMcIj81licKyMuftp7MlFuqv2XPRNmsfS+F67MXb/AA+9w6I+H7t34XwCjE0qud6k+zjxR3n3TTaaY2pkRoTMUxNVUxERHGZnqh5uVxTTul8mYiNWv9ptXnUcubduf4Vvopjv97mfMPEv5N306faFTfu+pUhWtI4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADvwc2/gZFORj1zTVT1++O5JxcqvEuRcoeqaponWGw9H1jG1THiu1VEV0x6dPbS6fwri1vMo017rWxeiuEgvImJSA0h9dV/ExsqIjIsUXOHVyqYlFu4lm7/AHiGKq1TV7wwqtnNGqnj9iiPhVV+6FVwTEq77WP+Lb8OyzoelWfu4FqZ/wA0TV+r1RwnFo9qSnHoj8M6KaaY4UxER7lhbsUW/wCsaM8U6DN2eiZiI4zPCIYqqqaO8z2eZmI7qjtNtJFyJwcKr0Px1R+L3fBpXHeNxH+Kyrci/u+2lU5mZnjLRZmZnWUMfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB3YuXkYV2L+NdqorpnjxiWfHybmNXvtzo+01TTOsLfpO2GPfpi1nx5q51cqPuz+zeOGcy01Rsvdk61lfipY7d23eoiu3XTVTPVMTxhtlrKtXoiaZTaa4qfSTrD2Pm6DUN0GsBNWhMsTP1bB06mZyL9MVR+GOmVflcSx8aJmuphrvUUe8qdrO1OTqHGxYjzVrq4RP3vi0XifMNeRrRa9lddyKq+34QMzMzxmWrzM1TrKOPgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAycXUs7Cq5WLk10fCeiUuxnZGN/rqeqa6qfaUtY2z1S3HC7Fu509tPD9F3Z5nybf9o1Z6cquGZG3Vfbgx/wC/+idTzbV+aWT+ZPh13Nucqei3i24+PGXmvm25P9aXmcupH5e1GrZXGPtE26Z6oo6OCryOYMq9rEToxVX66vyiq7ty5PKrrmZlTXb9y9Otc6sUzMvlifAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH//Z"

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/understanding-actions.e2988282.jpg";

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/understanding-states.31cccbeb.jpg";

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ungroup.bc5d5a0b.jpg";

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/varying-size.98b6cd28.jpg";

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/workflow.41615713.jpg";

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/zoom.2c116940.jpg";

/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-learn-js-63dbd2bc5628066ef465.js